export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO-8601 timestamp, with millisecond precision, expressing its timezone offset */
  Timestamp: any;
  /** A date string in YYYY-MM-DD format */
  DateOnlyString: string;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** A date only returning scalar */
  DateOnly: any;
  RatingReviewCursor: any;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: any;
  /** Currently just template id */
  ContactQuarantinedMessageBatchCursor: any;
  GroupConnectionCursor: any;
  GuestListMemberCursor: any;
  GuestTravelInfoCursor: any;
  EventSearchCursor: any;
  LinkRedirectBlockCursor: any;
  Url: any;
  /** Currently link redirect id */
  LinkRedirectCursor: any;
  /**
   * An opaque identifier providing a unique reference to an element within a pagination query.
   * The term for it in the Relay Specification is a "Cursor".
   *   https://relay.dev/graphql/connections.htm#sec-Cursor
   */
  ProductCatalogSearchCursor: any;
  ProductCatalogEntityCursor: any;
  /** An arbitrary-precision decimal value transported as a numeric string. */
  Decimal: any;
  NegativeInt: any;
  /** Currently just template id */
  StationeryTemplateCursor: any;
  /** Represents NULL values */
  Void: any;
};

/** Property Identifier Input. Only one of the fields should be non-null */
export type AccommodationCatalogPropertyIdentifierInput = {
  accommodationPlaceId?: InputMaybe<Scalars['String']>;
  joyPlaceId?: InputMaybe<Scalars['String']>;
};

export enum AccommodationCategory {
  Hotel = 'Hotel',
  Other = 'Other',
  VacationRental = 'VacationRental',
}

export enum ArchivedStatus {
  archivedByCouple = 'archivedByCouple',
  archivedBySystem = 'archivedBySystem',
  archivedByVendor = 'archivedByVendor',
  notArchived = 'notArchived',
}

export enum DateFormat {
  full = 'full',
  long = 'long',
  numerical = 'numerical',
  short = 'short',
}

export enum TimeFormat {
  time = 'time',
  timeWithSeconds = 'timeWithSeconds',
}

export enum TimezoneFormat {
  long = 'long',
  short = 'short',
}

export enum AccommodationPlaceDisplayLocation {
  AccommodationPage = 'AccommodationPage',
  CustomPage = 'CustomPage',
}

export enum AccommodationPlaceRoomBlockStatus {
  active = 'active',
  cancelled = 'cancelled',
}

/** TrackingQueryStringKey */
export enum TrackingQueryStringKey {
  campaignId = 'campaignId',
  clientReference = 'clientReference',
  eventId = 'eventId',
}

export enum TravelOfferProvider {
  hopper = 'hopper',
  nuitee = 'nuitee',
  zh = 'zh',
}

/** RedirectMechanismType */
export enum RedirectMechanismType {
  custom = 'custom',
  joyNativeCheckout = 'joyNativeCheckout',
  partnerHotel = 'partnerHotel',
  partnerSearch = 'partnerSearch',
}

export enum TravelCurrencyCode {
  AED = 'AED',
  AFN = 'AFN',
  ALL = 'ALL',
  AMD = 'AMD',
  ARS = 'ARS',
  AUD = 'AUD',
  AZN = 'AZN',
  BAM = 'BAM',
  BDT = 'BDT',
  BGN = 'BGN',
  BHD = 'BHD',
  BIF = 'BIF',
  BND = 'BND',
  BOB = 'BOB',
  BRL = 'BRL',
  BWP = 'BWP',
  BYN = 'BYN',
  BZD = 'BZD',
  CAD = 'CAD',
  CDF = 'CDF',
  CHF = 'CHF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  CRC = 'CRC',
  CVE = 'CVE',
  CZK = 'CZK',
  DJF = 'DJF',
  DKK = 'DKK',
  DOP = 'DOP',
  DZD = 'DZD',
  EEK = 'EEK',
  EGP = 'EGP',
  ERN = 'ERN',
  ETB = 'ETB',
  EUR = 'EUR',
  GBP = 'GBP',
  GEL = 'GEL',
  GHS = 'GHS',
  GNF = 'GNF',
  GTQ = 'GTQ',
  HKD = 'HKD',
  HNL = 'HNL',
  HRK = 'HRK',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  INR = 'INR',
  IQD = 'IQD',
  IRR = 'IRR',
  ISK = 'ISK',
  JMD = 'JMD',
  JOD = 'JOD',
  JPY = 'JPY',
  KES = 'KES',
  KHR = 'KHR',
  KMF = 'KMF',
  KRW = 'KRW',
  KWD = 'KWD',
  KZT = 'KZT',
  LBP = 'LBP',
  LKR = 'LKR',
  LTL = 'LTL',
  LVL = 'LVL',
  LYD = 'LYD',
  MAD = 'MAD',
  MDL = 'MDL',
  MGA = 'MGA',
  MKD = 'MKD',
  MMK = 'MMK',
  MOP = 'MOP',
  MUR = 'MUR',
  MXN = 'MXN',
  MYR = 'MYR',
  MZN = 'MZN',
  NAD = 'NAD',
  NGN = 'NGN',
  NIO = 'NIO',
  NOK = 'NOK',
  NPR = 'NPR',
  NZD = 'NZD',
  OMR = 'OMR',
  PAB = 'PAB',
  PEN = 'PEN',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  PYG = 'PYG',
  QAR = 'QAR',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  RWF = 'RWF',
  SAR = 'SAR',
  SDG = 'SDG',
  SEK = 'SEK',
  SGD = 'SGD',
  SOS = 'SOS',
  SYP = 'SYP',
  THB = 'THB',
  TND = 'TND',
  TOP = 'TOP',
  TRY = 'TRY',
  TTD = 'TTD',
  TWD = 'TWD',
  TZS = 'TZS',
  UAH = 'UAH',
  UGX = 'UGX',
  USD = 'USD',
  UYU = 'UYU',
  UZS = 'UZS',
  VEF = 'VEF',
  VND = 'VND',
  XAF = 'XAF',
  XOF = 'XOF',
  YER = 'YER',
  ZAR = 'ZAR',
  ZMK = 'ZMK',
  ZWL = 'ZWL',
}

export enum StrikeoutRateProvider {
  booking = 'booking',
  expedia = 'expedia',
  unknown = 'unknown',
}

/** Status of an accommodation place recommendation */
export enum AccommodationPlaceRecommendationStatus {
  abandoned = 'abandoned',
  accepted = 'accepted',
  added = 'added',
  declined = 'declined',
  pending = 'pending',
}

export enum AccommodationPlaceCategory {
  campsite = 'campsite',
  hotel = 'hotel',
  rental = 'rental',
}

export enum DistancesBetweenPointsType {
  DRIVING_DISTANCE = 'DRIVING_DISTANCE',
  GEO_DISTANCE = 'GEO_DISTANCE',
  WALKING_DISTANCE = 'WALKING_DISTANCE',
}

export enum HotelProvider {
  customUrl = 'customUrl',
  googlePlaceUrl = 'googlePlaceUrl',
  hotelWebsiteUrl = 'hotelWebsiteUrl',
  joynativecheckout = 'joynativecheckout',
  nuitee = 'nuitee',
  zh = 'zh',
}

/** AccommodationPlaceType */
export enum AccommodationPlaceType {
  custom = 'custom',
  hotel = 'hotel',
}

export enum EventPageType {
  app = 'app',
  custom = 'custom',
  faq = 'faq',
  guests = 'guests',
  moments = 'moments',
  registry = 'registry',
  rsvp = 'rsvp',
  schedule = 'schedule',
  story = 'story',
  tidbits = 'tidbits',
  travel = 'travel',
  vip = 'vip',
  welcome = 'welcome',
}

export enum EventRSVPAttendanceStatus {
  attending = 'attending',
  noAttendanceQuestion = 'noAttendanceQuestion',
  notAttending = 'notAttending',
  other = 'other',
  unanswered = 'unanswered',
}

export enum MessageDirection {
  GUEST_TO_HOST = 'GUEST_TO_HOST',
  HOST_TO_GUEST = 'HOST_TO_GUEST',
  HOST_TO_VENDOR = 'HOST_TO_VENDOR',
  JOY_INTERNAL = 'JOY_INTERNAL',
  JOY_TO_GUEST = 'JOY_TO_GUEST',
  JOY_TO_HOST = 'JOY_TO_HOST',
  UNKNOWN = 'UNKNOWN',
}

export enum PersonGuestState {
  evicted = 'evicted',
  left = 'left',
  user = 'user',
}

/**
 * Sanitization state of a stored phone number. Returned as a code so clients
 * can map it to localized messaging (e.g. an i18n key) rather than relying on
 * a server-supplied string.
 *
 * - `valid`: parsed successfully; `numberE164` is populated.
 * - `invalid`: parsing failed; `numberE164` is null.
 * - `unknown`: pre-migration row that has not been sanitized yet, or a value
 *   that does not match any known code (defensive fallback). Treat as
 *   not-yet-validated rather than as `valid` or `invalid`.
 */
export enum PhoneNumberSanitizationStatus {
  invalid = 'invalid',
  unknown = 'unknown',
  valid = 'valid',
}

/**
 * The legacy service's derived per-person attendance across the enabled attendance questions,
 * computed from each choice's attendanceType (positional fallback when a question is untagged).
 * Read this instead of interpreting legacyRsvpAnswers or choice order.
 */
export enum LegacyRsvpAttendanceStatus {
  attending = 'attending',
  notAttending = 'notAttending',
  pending = 'pending',
  responded = 'responded',
}

export enum VirtualEventProvider {
  eventlive = 'eventlive',
  googleMeet = 'googleMeet',
  unknown = 'unknown',
  youtube = 'youtube',
  zoom = 'zoom',
}

export enum EventUserStatus {
  admin = 'admin',
  crasher = 'crasher',
  guest = 'guest',
  owner = 'owner',
}

export enum LocationAnchorSource {
  approximated_centroid = 'approximated_centroid',
  event_location = 'event_location',
  event_venue = 'event_venue',
}

/** Origin of an EventPhotoSource entry returned by Event.availablePhotos. */
export enum EventPhotoSourceType {
  /** Event-level photo (Event.photoV2Url). */
  EVENT_PHOTO = 'EVENT_PHOTO',
  /** Photo from the active website header layout (eventDesign.activeWebsiteHeaderPresentationLayout). */
  HEADER_LAYOUT = 'HEADER_LAYOUT',
  /** Photo from the welcome page (native EventPage or PageContainer with slug 'welcome'), respecting visibility. */
  WELCOME_PAGE = 'WELCOME_PAGE',
}

export enum FavoriteType {
  art = 'art',
  font = 'font',
  template = 'template',
}

export enum DesignLayoutType {
  aloha = 'aloha',
  brannan = 'brannan',
}

export enum FontWeight {
  none = 'none',
  uppercase = 'uppercase',
}

export enum Typeface {
  handwriting = 'handwriting',
  monospace = 'monospace',
  sansSerif = 'sansSerif',
  script = 'script',
  serif = 'serif',
}

export enum ThemeVariationType {
  aloha = 'aloha',
  brannan = 'brannan',
  invite = 'invite',
  prints = 'prints',
  savethedate = 'savethedate',
  thumbnail = 'thumbnail',
}

export enum FeatureValueType {
  boolean = 'boolean',
  color = 'color',
  range = 'range',
}

export enum EventDesignPurpose {
  draft = 'draft',
  live = 'live',
}

export enum BrannanNavigation {
  classic = 'classic',
  singlePage = 'singlePage',
}

export enum DesignFeatureType {
  alohaColorPreference = 'alohaColorPreference',
  alohaTextColorPreference = 'alohaTextColorPreference',
  brannanBackgroundTransparency = 'brannanBackgroundTransparency',
  brannanColorPreference = 'brannanColorPreference',
  brannanInnerFrameBorder = 'brannanInnerFrameBorder',
  brannanTextColorPreference = 'brannanTextColorPreference',
}

export enum ColorPointerLocation {
  event = 'event',
  theme = 'theme',
}

export enum Category {
  BUTTONS = 'BUTTONS',
  CAPTION = 'CAPTION',
  DATE = 'DATE',
  EVENT_TITLE = 'EVENT_TITLE',
  HEADING = 'HEADING',
  LOCATION = 'LOCATION',
  NAVIGATION = 'NAVIGATION',
  PAGE_TITLE = 'PAGE_TITLE',
  PARAGRAPH = 'PARAGRAPH',
  SUB_HEADING = 'SUB_HEADING',
}

export enum GuestSiteTargetEnum {
  bliss = 'bliss',
  charm = 'charm',
}

/**
 * Which skin the event's guest-site maps render with.
 *
 * Five DERIVED styles are generated from the event's own website colors; six
 * PRESET styles carry a fixed palette unrelated to them, so they still render
 * when the event design has no usable colors; the two STANDARD styles are
 * Google's own basemap, which keeps Google's own default pin.
 */
export enum EventDesignMapStyle {
  /** Neutral map, light ink on a dark ground */
  BLACK_AND_WHITE_DARK = 'BLACK_AND_WHITE_DARK',
  /** Neutral map, dark ink on a light ground */
  BLACK_AND_WHITE_LIGHT = 'BLACK_AND_WHITE_LIGHT',
  /** A deep field built from the accent, with roads drawn on top as light linework */
  BLUEPRINT = 'BLUEPRINT',
  /** Warm pink ground, deep plum ink, dusty rose accent */
  BLUSH = 'BLUSH',
  /** Label ink at the strongest the event's palette allows, ground flattened back so labels win against it */
  HIGH_CONTRAST = 'HIGH_CONTRAST',
  /** The event's palette with background and font color trading places */
  INVERTED = 'INVERTED',
  /** Deep navy ground, pale blue ink, slate blue accent */
  MIDNIGHT = 'MIDNIGHT',
  /** Water, parks and POI pulled back toward the ground, leaving roads and labels to carry the frame */
  MINIMAL = 'MINIMAL',
  /** The event's palette with every label switched off */
  NO_LABELS = 'NO_LABELS',
  /** Warm cream ground, dark brown ink, tan accent */
  PARCHMENT = 'PARCHMENT',
  /** Cool pale green ground, deep green ink, muted green accent */
  SAGE = 'SAGE',
  /** No styling at all — Google's own basemap and its default pin */
  STANDARD = 'STANDARD',
  /** Google's basemap recolored — green land and parks, blue water, grey roads, no POI or street labels */
  STANDARD_TWO = 'STANDARD_TWO',
}

export type PeopleFindCriteria = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type PeopleFindOptions = {
  allGuestStates?: InputMaybe<Scalars['Boolean']>;
  strategy: PeopleFindStrategy;
};

export enum PeopleFindStrategy {
  fuzzy = 'fuzzy',
  myInvite = 'myInvite',
}

export enum RoomBlockPerks {
  hotelPoints15k = 'hotelPoints15k',
}

export enum LeadState {
  Created = 'Created',
  Exposed = 'Exposed',
  InProgress = 'InProgress',
  Lost = 'Lost',
  Viewed = 'Viewed',
  Won = 'Won',
}

export enum LeadStateV2 {
  ConciergeAssigned = 'ConciergeAssigned',
  Created = 'Created',
  Exposed = 'Exposed',
  InProgress = 'InProgress',
  Lost = 'Lost',
  NewPricingRequested = 'NewPricingRequested',
  OfferAccepted = 'OfferAccepted',
  OfferSent = 'OfferSent',
  PricingReceived = 'PricingReceived',
  PricingRequested = 'PricingRequested',
  Viewed = 'Viewed',
  Won = 'Won',
}

export enum ContactMethods {
  /** @deprecated deprecated, please use meeting */
  calendly = 'calendly',
  email = 'email',
  meeting = 'meeting',
  phoneCall = 'phoneCall',
  sms = 'sms',
}

export enum ReservedRoomBlockStatus {
  active = 'active',
  cancelled = 'cancelled',
  inactive = 'inactive',
  pending = 'pending',
}

/** Which clock times are rendered in; absent on EventInfo means locale-auto. */
export enum ClockFormat {
  twelveHour = 'twelveHour',
  twentyFourHour = 'twentyFourHour',
}

/** How the event date is displayed; 'dateRange' requires endDate. */
export enum DateDisplayType {
  date = 'date',
  dateRange = 'dateRange',
}

/** General information for an Event */
export enum EventType {
  babyRegistry = 'babyRegistry',
  card = 'card',
  general = 'general',
  wedding = 'wedding',
}

export enum QandaType {
  faq = 'faq',
  tidbit = 'tidbit',
}

/**
 * A strategy by which the Client may present Attribute Values to the user for selection.
 *
 * Each is a combination of short-codes.
 *
 * eg. 'image', 'Carousel', 'Multi' =
 *   "Display a Carousel of images from which the User can make multiple selections."
 */
export enum ProductCatalogAttributeSelectionType {
  colorListMulti = 'colorListMulti',
  imageListMulti = 'imageListMulti',
  priceBucket = 'priceBucket',
  priceRange = 'priceRange',
  /** aka. 'titleListMulti' */
  stringListMulti = 'stringListMulti',
}

/**
 * The field within an Attribute Value to be used for presentation by the Client.
 *
 * This Type is similar to GroupDimensionSwatchType.
 */
export enum ProductCatalogAttributeValueType {
  /** The Value should be presented as a swatch of its color hex value */
  color = 'color',
  /** The Value should be presented using its image URL */
  image = 'image',
  price = 'price',
  /** The Value should be presented as a string of text (usually its title) */
  title = 'title',
}

export enum ProductCatalogCollectionType {
  brand = 'brand',
  productFamily = 'productFamily',
  relatedProducts = 'relatedProducts',
}

export enum ProductCatalogDisplayType {
  carousel = 'carousel',
}

export enum ProductCatalogCurationSource {
  expert = 'expert',
  joy = 'joy',
}

export enum PDPSectionType {
  details = 'details',
  gallery = 'gallery',
  highlight = 'highlight',
  productAction = 'productAction',
  productFamilyCollections = 'productFamilyCollections',
  relatedProductCollections = 'relatedProductCollections',
}

/**
 * Supported Dimension swatch types
 * A "swatch" is a visual element representing a Dimension Option; usually it is selectable
 *
 * This Type is similar to ProductCatalogAttributeValueType.
 */
export enum GroupDimensionSwatchType {
  color = 'color',
  image = 'image',
  none = 'none',
}

export enum ProductCatalogAssetType {
  photo = 'photo',
  video = 'video',
}

/** Different types of catalog item tree roots */
export enum CatalogTreeRootInput {
  curations = 'curations',
  /** The default department, category, sub-category hierarchy */
  default = 'default',
  registryStoreRecommendations = 'registryStoreRecommendations',
}

export enum PDPElementType {
  body = 'body',
  heading = 'heading',
  photo = 'photo',
  sectionHeader = 'sectionHeader',
}

export type RatingReviewQueryInput = {
  orderBy?: InputMaybe<RatingReviewOrderBy>;
  searchText?: InputMaybe<Scalars['String']>;
  /**
   * Narrows the results to reviews about this topic, taking the 'key' of a
   * RatingReviewTopic. Matching is semantic rather than literal, so the result
   * is not a subset of the unfiltered page and its total count differs.
   */
  topicKey?: InputMaybe<Scalars['String']>;
};

export enum RatingReviewOrderBy {
  newest = 'newest',
  oldest = 'oldest',
  ratingAsc = 'ratingAsc',
  ratingDesc = 'ratingDesc',
}

export enum RatingReviewAssetType {
  photo = 'photo',
  video = 'video',
}

export type RatingReviewSummaryQueryInput = {
  /** Defaults to 'paragraph'. */
  format?: InputMaybe<RatingReviewSummaryFormat>;
};

export enum RatingReviewSummaryFormat {
  bullet = 'bullet',
  paragraph = 'paragraph',
}

/**
 * The 'Storefront Status' indicates how Merch wants a Catalog Item to behave
 * RE: whether it can be purchased, added to a Registry, found in a search result, etc.
 */
export enum ProductCatalogStorefrontStatus {
  /** This Catalog Item is fully available for search, add-to-Registry, and purchase. */
  available = 'available',
  /** This Catalog Item has a long out-of-stock window, and cannot be purchased today. */
  backordered = 'backordered',
  /** This Catalog Item cannot be purchased today, but can be added to a Registry anticipating future inventory. */
  comingSoon = 'comingSoon',
  /** This Catalog Item can no longer be added to a Registry, but can be purchased if previously added. */
  delisted = 'delisted',
  /** This Catalog Item is no longer available, as a permanent state. */
  discontinued = 'discontinued',
}

export enum ProductCatalogItemTilePresentationType {
  childDetails = 'childDetails',
  parentDetails = 'parentDetails',
}

export enum CustomItemDataType {
  cash = 'cash',
  charity = 'charity',
  gift = 'gift',
}

export enum DonationFundPaymentMethodEnum {
  cashapp = 'cashapp',
  cashOrCheck = 'cashOrCheck',
  joyCredit = 'joyCredit',
  other = 'other',
  paypal = 'paypal',
  venmo = 'venmo',
}

export enum FeePaidByEnum {
  couple = 'couple',
  guest = 'guest',
}

export enum DonationFundPlatformTypeEnum {
  cashapp = 'cashapp',
  cashOrCheck = 'cashOrCheck',
  other = 'other',
  paypal = 'paypal',
  venmo = 'venmo',
}

/**
 * Structured country data is prefered (i.e. the countryCode with
 * the country field set to that countrys name). For freeform country
 * omit the countryCode (null / undefined).
 */
export type ShippingAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  validated?: InputMaybe<Scalars['Boolean']>;
};

export enum LegacyRegistryItemType {
  canned = 'canned',
  custom = 'custom',
  product = 'product',
}

export enum RegistryItemRecommendationStatus {
  skipped = 'skipped',
  swapped = 'swapped',
  unseen = 'unseen',
}

export enum RegistryRecommendationStatus {
  /** The couple has completed viewing and selecting their recommendations */
  completed = 'completed',
  /** registry has recommendations, but couple has not viewed them yet */
  hasRecommendations = 'hasRecommendations',
  /**
   * The couple is in progress viewing and selecting recommendations,
   * but has not viewed the entire selection yet
   */
  inProgress = 'inProgress',
  /** has not started the recommendations process */
  notStarted = 'notStarted',
}

/**
 * Where a registry stands with syncing. Resolved in that order, first match wins --
 * the type question is asked before the timestamps, so a 'linked' registry carrying a
 * 'cannotSyncAt' from creation reads as 'notSyncable' rather than 'failing'.
 */
export enum RegistrySyncState {
  /** A recorded failure that no later success has superseded. */
  failing = 'failing',
  /**
   * We do not sync this kind of registry at all: it has no timer, never reaches
   * Autobot, and will never record an outcome. 'standalone', 'linked', 'adopted'.
   *
   * Not to be confused with 'CheckRegistryUrlResult.canSync', which is Autobot's
   * verdict on a particular URL. A registry whose URL fails that check is 'failing',
   * not 'notSyncable' -- this value is about the kind of registry, not the URL.
   */
  notSyncable = 'notSyncable',
  /**
   * On a timer, but no outcome recorded yet -- neither a success nor a failure.
   * A registry the couple has just added, before its first run completes.
   */
  pending = 'pending',
  /** The most recent recorded outcome was a success. */
  synced = 'synced',
}

export enum RegistryType {
  /** An adopted external registry that was transferred from the transitional registry. */
  adopted = 'adopted',
  /** Simply add a link to any external registry. */
  linked = 'linked',
  /** Internal registry managed in Joy. */
  standalone = 'standalone',
  /** Automatically and periodically import items from an external registry into Joy. */
  synced = 'synced',
  /** Move an external registry into Joy, manage items, and see gift details within Joy. */
  transferred = 'transferred',
}

export enum SafetyRating {
  none = 'none',
  safeOverride = 'safeOverride',
  unsafeRequiresEscalation = 'unsafeRequiresEscalation',
}

/**
 * public: only isPublic schedule rows (DB filter; same set for anyone who can open schedule).
 * all: default — admin sees all items; guest sees public plus invited private.
 */
export enum EventScheduleEventsToInclude {
  all = 'all',
  public = 'public',
}

export enum TravelType {
  booking = 'booking',
  ferry = 'ferry',
  flight = 'flight',
  hotel = 'hotel',
  list = 'list',
  note = 'note',
  rentalCar = 'rentalCar',
  rentalHome = 'rentalHome',
  shuttle = 'shuttle',
  taxi = 'taxi',
  tent = 'tent',
  train = 'train',
}

/**
 * What a choice on the attendance question means. Absent (null) is neutral: a response that is
 * neither attending nor not attending. Readers classify by type when any choice on the question is
 * typed, and fall back to choice order otherwise.
 */
export enum LegacyRsvpChoiceAttendanceType {
  attending = 'attending',
  notAttending = 'notAttending',
}

export enum LegacyRsvpQuestionSubtype {
  advice = 'advice',
  attendance = 'attendance',
  food = 'food',
  honeymoon = 'honeymoon',
  hotel = 'hotel',
  multipleChoice = 'multipleChoice',
  phone = 'phone',
  song = 'song',
  text = 'text',
}

export enum LegacyRsvpQuestionType {
  multipleChoice = 'multipleChoice',
  plainText = 'plainText',
}

/** All possible media approval states, including PENDING (set automatically on guest uploads) */
export enum MediaApprovalStatus {
  /** Approved by an admin */
  APPROVED = 'APPROVED',
  /** Removed from collection */
  DELETED = 'DELETED',
  /** Awaiting admin review */
  PENDING = 'PENDING',
  /** Rejected by an admin */
  REJECTED = 'REJECTED',
}

/** A guest reaction on a media photo. Generic by design — LIKE is the only value today. */
export enum MediaReactionType {
  LIKE = 'LIKE',
}

export enum MagicTokenPermissions {
  upload = 'upload',
  view = 'view',
}

export enum MediaCollectionDisplayMode {
  DEFAULT = 'DEFAULT',
  LIVE_SLIDESHOW = 'LIVE_SLIDESHOW',
}

/**
 * Lifecycle of one photo access window (storage or upload). The two closed states differ
 * in what the client should offer, which is why they are separate values.
 */
export enum PhotoAccessStatus {
  /** Window is open; the matching photo*ExpiresAt says until when. Not blocked. */
  ACTIVE = 'ACTIVE',
  /** The window existed and has passed. Blocked; offer an extension. */
  EXPIRED = 'EXPIRED',
  /** This tier never granted the window (free-tier guest uploads). Blocked; there is nothing to extend — the window comes with a tier purchase. Applies to guest contribution only; hosts are unaffected. */
  NOT_INCLUDED = 'NOT_INCLUDED',
  /** No limit applies: the event is not enrolled in photo monetization (legacy events stay here forever) or no policy is known. Not blocked. */
  UNLIMITED = 'UNLIMITED',
}

export enum MediaCollectionSortField {
  CREATED_AT = 'CREATED_AT',
  MANUAL_ORDER = 'MANUAL_ORDER',
  TAKEN_AT = 'TAKEN_AT',
}

export enum MediaCollectionSortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum ComponentType {
  eventCountdown = 'eventCountdown',
  eventDetails = 'eventDetails',
  eventDisplayName = 'eventDisplayName',
  greetingMessage = 'greetingMessage',
  jsonDataBlob = 'jsonDataBlob',
  mediaGallery = 'mediaGallery',
  photo = 'photo',
  placesMap = 'placesMap',
  rsvpAndUnlockGuestDetailsButton = 'rsvpAndUnlockGuestDetailsButton',
  text = 'text',
  travelMap = 'travelMap',
  video = 'video',
}

export enum EventPlaceType {
  activity = 'activity',
  custom = 'custom',
  restaurant = 'restaurant',
  sight = 'sight',
  transport = 'transport',
  venue = 'venue',
}

export enum PlacesMapPresentation {
  illustrated = 'illustrated',
  standard = 'standard',
}

export enum PointOnMapType {
  venue = 'venue',
}

export enum PageContentType {
  default = 'default',
  userGenerated = 'userGenerated',
}

export enum PhotoXPosition {
  center = 'center',
  left = 'left',
  right = 'right',
}

export enum PhotoYPosition {
  bottom = 'bottom',
  center = 'center',
  top = 'top',
}

/** Tracks the provenance of a PageContainer's note field. */
export enum NoteSource {
  /** Set by system auto-population or publish-time wedding-code update */
  autopop = 'autopop',
  /** Set during event creation */
  createEvent = 'createEvent',
  /** Manually edited by the user */
  user = 'user',
}

/** Single discriminant for the three page kinds; derived from type + contentType. */
export enum PageKind {
  /** Custom page that is not user-created: a system/migrated page (contentType=default) or a legacy persisted custom row with no contentType. */
  systemCustom = 'systemCustom',
  /** Built-in page type (schedule, story, faq, travel, etc.) — not a custom page. */
  systemLegacy = 'systemLegacy',
  /** Custom page created by the user (contentType=userGenerated). */
  userCustom = 'userCustom',
}

export enum EventPageVisibility {
  hidden = 'hidden',
  passwordProtected = 'passwordProtected',
  public = 'public',
  specificGuests = 'specificGuests',
}

/** Options for the 'EventData.payoutAccount' field. */
export type RegistryPayoutAccountOptions = {
  /**
   * Always re-reads the payout account from Stripe rather than using the cached status. Use this
   * right after the Couple edits their bank account, so the returned status reflects the change
   * instead of a stale read. Event owner only -- for anyone else this is silently ignored and the
   * cached read is returned.
   */
  forceRefresh?: InputMaybe<Scalars['Boolean']>;
};

/** Payout methods supported by an external account */
export enum RegistryPayoutAccountExternalAccountPayoutMethod {
  instant = 'instant',
  standard = 'standard',
}

export type RegistryPayoutAccountOnboardingUrlParamsInput = {
  /**
   * Route where user can start onboarding one more time(as it was not possible to load onboardingUrl this time).
   * For example(default value): "/edit/registry/credit-card/setup"
   */
  restartRoute?: InputMaybe<Scalars['String']>;
  /**
   * Route where users should be returned after they either completed onboarding flow or cancelled it.
   * For example(default value): "/edit/registry/manage?setupCreditCard=true"
   */
  returnRoute?: InputMaybe<Scalars['String']>;
};

/** Settings information for an Event */
export enum PrivacyModeType {
  custom = 'custom',
  private = 'private',
  public = 'public',
}

export enum Layout {
  aloha = 'aloha',
  brannan = 'brannan',
  harrison = 'harrison',
  hennepin = 'hennepin',
}

/** Layout variant for the accommodations page. */
export enum AccommodationsPageLayout {
  FLASHLIGHT = 'FLASHLIGHT',
  FULL_WIDTH_PHOTO = 'FULL_WIDTH_PHOTO',
  MAP_AND_HOTEL_TILE = 'MAP_AND_HOTEL_TILE',
  SIDE_BY_SIDE_ELEGANT = 'SIDE_BY_SIDE_ELEGANT',
  SIDE_BY_SIDE_SIMPLE = 'SIDE_BY_SIDE_SIMPLE',
  STYLISH_HOVER = 'STYLISH_HOVER',
  TYPOGRAPHIC = 'TYPOGRAPHIC',
}

export enum EventWebsiteState {
  draft = 'draft',
  published = 'published',
}

export type EventUsersFilter = {
  /**
   * Only supported by 'eventUsersPaginated'; the other EventUser queries reject it
   * rather than silently returning both timeframes.
   */
  timeframe?: InputMaybe<EventUsersTimeframe>;
  types?: InputMaybe<Array<EventType>>;
};

/**
 * Which side of 'now' the Event falls on; keyed off the Event's *finalized* date.
 * An Event with no finalized date is 'upcoming' (it sorts as furthest-future).
 */
export enum EventUsersTimeframe {
  past = 'past',
  upcoming = 'upcoming',
}

export enum FeedMessagePushNotificationTypeEnum {
  marketing = 'marketing',
  registryItemOrdered = 'registryItemOrdered',
  unknown = 'unknown',
}

export enum FeedMessageStatusEnum {
  read = 'read',
  seen = 'seen',
  unknown = 'unknown',
  unread = 'unread',
}

export enum FeedMessageTargetIdentifierType {
  registryItemId = 'registryItemId',
  unknown = 'unknown',
  url = 'url',
}

export enum FeedMessageTypeEnum {
  email = 'email',
  generic = 'generic',
  pushNotification = 'pushNotification',
  test = 'test',
  unknown = 'unknown',
}

export enum VendorTypeEnum {
  catering = 'catering',
  dessert = 'dessert',
  djs = 'djs',
  florist = 'florist',
  makeup = 'makeup',
  misc = 'misc',
  officiants = 'officiants',
  photo = 'photo',
  planners = 'planners',
  rental = 'rental',
  transport = 'transport',
  venue = 'venue',
  video = 'video',
}

export enum MatchStatus {
  connected = 'connected',
  hired = 'hired',
  matched = 'matched',
  saved = 'saved',
  suggested = 'suggested',
}

export enum VendorState {
  alreadyHired = 'alreadyHired',
  interested = 'interested',
  notInterested = 'notInterested',
  started = 'started',
}

export enum MetaTagFilter {
  event = 'event',
  user = 'user',
  vendor = 'vendor',
}

export enum AccommodationCatalogPhotoSubjectType {
  PROPERTY_LOBBY = 'PROPERTY_LOBBY',
  PROPERTY_MAIN_ENTRANCE = 'PROPERTY_MAIN_ENTRANCE',
  PROPERTY_MAIN_PHOTO = 'PROPERTY_MAIN_PHOTO',
  PROPERTY_RESTAURANT = 'PROPERTY_RESTAURANT',
  PROPERTY_UNKNOWN = 'PROPERTY_UNKNOWN',
  ROOM_BATHROOM = 'ROOM_BATHROOM',
  ROOM_BEDS = 'ROOM_BEDS',
  ROOM_UNKNOWN = 'ROOM_UNKNOWN',
}

export enum AccommodationCatalogPropertyType {
  Affittacamere = 'Affittacamere',
  AgritourismProperty = 'AgritourismProperty',
  AllInclusiveProperty = 'AllInclusiveProperty',
  Aparthotel = 'Aparthotel',
  Apartment = 'Apartment',
  BedAndBreakfast = 'BedAndBreakfast',
  Boat = 'Boat',
  Bungalow = 'Bungalow',
  Cabin = 'Cabin',
  Campsite = 'Campsite',
  Chalet = 'Chalet',
  Condo = 'Condo',
  Cottage = 'Cottage',
  CountryHouse = 'CountryHouse',
  Cruise = 'Cruise',
  FarmStay = 'FarmStay',
  GuestAccommodation = 'GuestAccommodation',
  GuestHouse = 'GuestHouse',
  HolidayPark = 'HolidayPark',
  Homes = 'Homes',
  Homestay = 'Homestay',
  Hostel = 'Hostel',
  Hotel = 'Hotel',
  House = 'House',
  Houseboat = 'Houseboat',
  Inn = 'Inn',
  Lodge = 'Lodge',
  MobileHome = 'MobileHome',
  Motel = 'Motel',
  Palace = 'Palace',
  Pension = 'Pension',
  Pousada = 'Pousada',
  PrivateVacationHome = 'PrivateVacationHome',
  Ranch = 'Ranch',
  Residence = 'Residence',
  Resort = 'Resort',
  Riad = 'Riad',
  Ryokan = 'Ryokan',
  Tent = 'Tent',
  Tourist = 'Tourist',
  Unknown = 'Unknown',
  Villa = 'Villa',
}

/** Query for the stored car inventory of a single pickup cell. */
export type InternalActiveCarInventorySnapshotsInput = {
  /** Maximum number of snapshots to return, applied in SQL. Omitted or invalid defaults to 50; anything above 200 is clamped to 200. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Geohash (precision 5) of the search pickup coordinates. */
  pickupAreaKey: Scalars['String'];
  /** Requested search radius in km; only snapshots seen at or inside it match. */
  radiusKmBucket: Scalars['Int'];
};

/** Partner that supplied a car inventory snapshot. */
export enum CarInventorySnapshotProvider {
  CARGAIN = 'CARGAIN',
  EXPEDIA = 'EXPEDIA',
  HERTZ = 'HERTZ',
}

export enum EventPersonStatus {
  active = 'active',
  blocked = 'blocked',
}

export type AdminReservationSearchInput = {
  /** Start of date range filter (defaults to 1 year ago) */
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  /** End of date range filter (defaults to now) */
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  /** When true (default), loads Stripe PaymentIntent data (status, refunds, timeline) per result. Pass false to skip Stripe calls. */
  includeStripeDetails?: InputMaybe<Scalars['Boolean']>;
  /** Number of results to return (1–100, default 20) */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of results to skip (default 0) */
  offset?: InputMaybe<Scalars['Int']>;
  /** Search term — partial match against email, confirmation codes (Joy / ZH / Nuitee / property), guest name, or guest phone. A phone may be typed in any format, with or without the country code (e.g. "+1 (555) 123-4567" or "5551234567"); only its digits are matched, and at least five digits are needed before phones are searched. */
  query: Scalars['String'];
};

export enum AccommodationProviderName {
  BOOKINGCOM = 'BOOKINGCOM',
  EXPEDIA = 'EXPEDIA',
  HOPPER = 'HOPPER',
  HOTELBEDS = 'HOTELBEDS',
  NUITEE = 'NUITEE',
  RESTEL = 'RESTEL',
  UNKNOWN = 'UNKNOWN',
  WEBBEDS = 'WEBBEDS',
  ZENTRUM_HUB = 'ZENTRUM_HUB',
}

export enum ReservationCancelledBy {
  JoySystem = 'JoySystem',
  SuperAdmin = 'SuperAdmin',
  User = 'User',
}

/** Which part of a booking a change touches. */
export enum ReservationModifiableField {
  CHECK_IN_DATE = 'CHECK_IN_DATE',
  CHECK_OUT_DATE = 'CHECK_OUT_DATE',
  HOLDER_EMAIL = 'HOLDER_EMAIL',
  HOLDER_FIRST_NAME = 'HOLDER_FIRST_NAME',
  HOLDER_LAST_NAME = 'HOLDER_LAST_NAME',
  HOLDER_PHONE = 'HOLDER_PHONE',
  OCCUPANCY = 'OCCUPANCY',
  ROOM_TYPE = 'ROOM_TYPE',
}

/** Whether a change was applied to the existing booking with no financial impact (SOFT_AMENDMENT) or repriced, which on some providers means a cancel-and-rebook (HARD_AMENDMENT). */
export enum TravelReservationModificationKind {
  HARD_AMENDMENT = 'HARD_AMENDMENT',
  SOFT_AMENDMENT = 'SOFT_AMENDMENT',
}

/** How a change attempt ended. SENT means Joy’s request reached the provider, never that the hotel applied it — no provider route reports that. */
export enum TravelReservationModificationOutcome {
  FAILED = 'FAILED',
  REQUESTED = 'REQUESTED',
  SENT = 'SENT',
}

export enum UpdatedBySource {
  JoySystem = 'JoySystem',
  SuperAdmin = 'SuperAdmin',
  User = 'User',
}

export enum StripePaymentDisplayStatus {
  CANCELED = 'CANCELED',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  PENDING_CAPTURE = 'PENDING_CAPTURE',
  PROCESSING = 'PROCESSING',
  REFUNDED = 'REFUNDED',
  REQUIRES_ACTION = 'REQUIRES_ACTION',
  SUCCEEDED = 'SUCCEEDED',
  UNKNOWN = 'UNKNOWN',
}

export enum StripeDisputeReason {
  BANK_CANNOT_PROCESS = 'BANK_CANNOT_PROCESS',
  CHECK_RETURNED = 'CHECK_RETURNED',
  CREDIT_NOT_PROCESSED = 'CREDIT_NOT_PROCESSED',
  CUSTOMER_INITIATED = 'CUSTOMER_INITIATED',
  DEBIT_NOT_AUTHORIZED = 'DEBIT_NOT_AUTHORIZED',
  DUPLICATE = 'DUPLICATE',
  FRAUDULENT = 'FRAUDULENT',
  GENERAL = 'GENERAL',
  INCORRECT_ACCOUNT_DETAILS = 'INCORRECT_ACCOUNT_DETAILS',
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  PRODUCT_NOT_RECEIVED = 'PRODUCT_NOT_RECEIVED',
  PRODUCT_UNACCEPTABLE = 'PRODUCT_UNACCEPTABLE',
  SUBSCRIPTION_CANCELED = 'SUBSCRIPTION_CANCELED',
  UNRECOGNIZED = 'UNRECOGNIZED',
}

export enum StripeDisputeStatus {
  CHARGE_REFUNDED = 'CHARGE_REFUNDED',
  LOST = 'LOST',
  NEEDS_RESPONSE = 'NEEDS_RESPONSE',
  UNDER_REVIEW = 'UNDER_REVIEW',
  WARNING_CLOSED = 'WARNING_CLOSED',
  WARNING_NEEDS_RESPONSE = 'WARNING_NEEDS_RESPONSE',
  WARNING_UNDER_REVIEW = 'WARNING_UNDER_REVIEW',
  WON = 'WON',
}

export type AdminReservationSearchByIdsInput = {
  /** When true, loads Stripe PaymentIntent data (status, refunds, timeline) per result. Defaults to false for bulk lookups so callers opt in to Stripe fan-out; the caller (e.g. FE) should expose this as a toggle to the admin. */
  includeStripeDetails?: InputMaybe<Scalars['Boolean']>;
  /** List of switchOrderIds (booking IDs) to look up. Max 5000 per request. */
  switchOrderIds: Array<Scalars['String']>;
};

export type AdminReservationSearchV2Input = {
  /** Start of date range filter (defaults to 1 year ago) */
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  /** End of date range filter (defaults to now) */
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  /** When true (default), loads Stripe PaymentIntent data per result. Pass false to skip Stripe calls. */
  includeStripeDetails?: InputMaybe<Scalars['Boolean']>;
  /** Number of results to return (1-100, default 20) */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of results to skip (default 0, maximum 1000) */
  offset?: InputMaybe<Scalars['Int']>;
  /** Search term - partial match against email, confirmation codes, booking IDs, UUIDs, guest name, or guest phone. A phone may be typed in any format, with or without the country code (e.g. "+1 (555) 123-4567" or "5551234567"); only its digits are matched, and at least five digits are needed before phones are searched. */
  query: Scalars['String'];
};

export enum CarReservationPaymentStatusDtoEnum {
  captured = 'captured',
  failed = 'failed',
  pending = 'pending',
  refund_failed = 'refund_failed',
  refund_initiated = 'refund_initiated',
  released = 'released',
  succeeded = 'succeeded',
}

export enum CarReservationStatusDtoEnum {
  cancelled = 'cancelled',
  draft = 'draft',
  failed = 'failed',
  pending_confirmation = 'pending_confirmation',
  processing = 'processing',
  submitted = 'submitted',
  success = 'success',
}

export enum ImportedTravelOfferReservationPaymentStatusDtoEnum {
  captured = 'captured',
  not_available = 'not_available',
  pending = 'pending',
  refunded = 'refunded',
  refunded_partially = 'refunded_partially',
  requires_capture = 'requires_capture',
  succeeded = 'succeeded',
}

export enum TravelOfferReservationStatus {
  cancellation_failed = 'cancellation_failed',
  cancelled = 'cancelled',
  draft = 'draft',
  failed = 'failed',
  needs_verification = 'needs_verification',
  pending_confirmation = 'pending_confirmation',
  processing = 'processing',
  submitted = 'submitted',
  success = 'success',
  verification_cancelled = 'verification_cancelled',
}

export enum AdminReservationProductTypeDtoEnum {
  CAR = 'CAR',
  HOTEL = 'HOTEL',
}

export type AdminVendorListPayload = {
  count: Scalars['Int'];
};

export type TravelPricingsComparisonPayload = {
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsComparisonMetadata>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  propertyIdentifier: AccommodationCatalogPropertyIdentifierInput;
};

/** A checkIn/checkOut pair of dates (allows for +/- 2 days), like Kayak using range types */
export type AccommodationCatalogStayDatesInput = {
  checkIn: AccommodationCatalogDateRangeInput;
  checkOut: AccommodationCatalogDateRangeInput;
};

/** A inclusive range of dates [low, high]. When low = high or  it mean this objects represents a single date */
export type AccommodationCatalogDateRangeInput = {
  high: Scalars['DateOnlyString'];
  low: Scalars['DateOnlyString'];
};

export type TravelPricingsComparisonMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export enum DeviceType {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
}

/** Room occupancy information when searching for offers */
export type AccommodationCatalogUnitsOccupancyInput = {
  /** Details for the number of Adults and Children staying in each room. If size of array is more than unitCount, then the first unitCount entries are considered. If the number of entries is less then some defaults will be assumed */
  occupancies?: InputMaybe<Array<AccommodationCatalogUnitOccupancyInput>>;
  /** The number of rooms needed. */
  unitCount?: Scalars['Int'];
};

/** Room occupancy information when searching for offers on a single unit */
export type AccommodationCatalogUnitOccupancyInput = {
  /** Number of adults who will be staying in this unit */
  adults: Scalars['Int'];
  /** Ages of children who will be staying in this unit, if known, otherwise array of nulls */
  childrenAges: Array<InputMaybe<Scalars['Int']>>;
};

export type TravelPricingsBatchComparisonPayload = {
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsComparisonMetadata>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  propertyIdentifiers: Array<AccommodationCatalogPropertyIdentifierInput>;
};

export enum AnswerActorType {
  /** Answer was submitted or modified by an event admin */
  ADMIN = 'ADMIN',
  /** Answer was submitted by the guest themselves */
  GUEST = 'GUEST',
  /** Answer was set by an automated system action (e.g. onSubmitActions) */
  SYSTEM = 'SYSTEM',
  /** Actor is unknown — only legacy rows written before actor attribution was enforced surface this value */
  UNKNOWN = 'UNKNOWN',
}

export enum AttendanceState {
  ATTENDING = 'ATTENDING',
  MAYBE = 'MAYBE',
  NOT_ATTENDING = 'NOT_ATTENDING',
  PENDING = 'PENDING',
}

export type AutopopulateOperationsByEventIdPayload = {
  eventId: Scalars['ID'];
};

export enum IdempotentOperationType {
  amplitudeExposure = 'amplitudeExposure',
  autoAccommodation = 'autoAccommodation',
  autoStayAreas = 'autoStayAreas',
  generateRecommendations = 'generateRecommendations',
  travelAlertNotification = 'travelAlertNotification',
}

export enum AutopopulateJobStatusV5 {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
}

export type AutopopulateStayAreaOperationsByEventIdPayload = {
  eventId: Scalars['ID'];
};

/** How a stay area row was created — AI-populated or manually added. */
export enum StayAreaSource {
  aiAutoPopulated = 'aiAutoPopulated',
  manual = 'manual',
}

/** Status of a stay area */
export enum StayAreaStatus {
  abandoned = 'abandoned',
  added = 'added',
  pending = 'pending',
}

/** Optional guest override. When provided, skips the upstream provider fetch. */
export type AutoSeatGuestInput = {
  /** Guest attendance status. Filtered by includeStatuses (default [ATTENDING]); excluded guests are returned in unseatedGuests. null/unknown is treated as PENDING. */
  attendanceStatus: Scalars['String'];
  /** Contact id (written to seats.guestId). */
  contactId: Scalars['ID'];
  /** Party/group keep-together key. */
  groupId?: InputMaybe<Scalars['ID']>;
  /** Household fallback grouping signal. */
  householdId?: InputMaybe<Scalars['ID']>;
  /** Legacy/firebase guest ID. Enables matching against seats occupied via firebaseGuestId so fill-empty and reseat-all do not duplicate such guests. */
  legacyGuestId?: InputMaybe<Scalars['ID']>;
  /** Tag labels for affinity scoring. */
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** Guest attendance status (from contact_service, which resolves it from form_service or the legacy firebase RSVP depending on event type). Used by includeStatuses to choose who is auto-seated. A guest with no RSVP record is treated as PENDING. */
export enum AttendanceStatus {
  ATTENDING = 'ATTENDING',
  MAYBE = 'MAYBE',
  NOT_ATTENDING = 'NOT_ATTENDING',
  PENDING = 'PENDING',
}

/** Algorithm mode. RESEAT_ALL (default): fresh arrangement of every attending guest. FILL_EMPTY: fill-only, counting just currently-empty seats as available. SHUFFLE: re-arrange the already-seated guests, pulling in nobody new. Each operation accepts a subset — autoSeat takes RESEAT_ALL | SHUFFLE, autoSeatPreview takes RESEAT_ALL | FILL_EMPTY; anything else is a VALIDATION_ERROR. */
export enum AutoSeatMode {
  FILL_EMPTY = 'FILL_EMPTY',
  RESEAT_ALL = 'RESEAT_ALL',
  SHUFFLE = 'SHUFFLE',
}

/** Structured warning emitted by the seating algorithm. */
export enum AutoSeatWarningCode {
  CAPACITY_SHORTFALL = 'CAPACITY_SHORTFALL',
  PARTY_PINNED = 'PARTY_PINNED',
  PARTY_SPLIT = 'PARTY_SPLIT',
}

/** Query for the single best content snapshot per JoyPlace, by provider preference. */
export type InternalBestContentSnapshotsByJoyPlaceIdsInput = {
  /** Fallback content providers, in descending preference order, used when the primary is unavailable. */
  fallbackProviders?: Array<AccommodationContentSnapshotProvider>;
  /** The JoyPlace ids to fetch the best available snapshot for. */
  joyPlaceIds: Array<Scalars['ID']>;
  /** Preferred content provider, ranked ahead of the fallbacks. */
  primaryProvider: AccommodationContentSnapshotProvider;
};

/** Content provider that produced an accommodation content snapshot. */
export enum AccommodationContentSnapshotProvider {
  hopper = 'hopper',
  nuitee = 'nuitee',
  zh = 'zh',
}

/**
 * Input for calculating a cash fund contribution receipt.
 * Expressing the Currency here is not required; it depends upon the connected Payout Account
 */
export type CalculateCashFundContributionReceiptInput = {
  cashFundId: Scalars['ID'];
  contributionAmountInMinorUnits: Scalars['Int'];
};

/** We expect it will slowly evolve and start looking like CreateRegistryPurchaseContextInput type */
export type CalculateRegistryPurchaseInfoInput = {
  address?: InputMaybe<ShippingAddressInput>;
  eCard?: InputMaybe<ECard>;
  eventId: Scalars['ID'];
  lineItems?: InputMaybe<Array<RegistryLineItemInput>>;
  printOrder?: InputMaybe<PrintOrder>;
};

export type ECard = {
  details?: InputMaybe<Array<ECardDetails>>;
  emailDraftId: Scalars['String'];
  imageURL?: InputMaybe<Scalars['String']>;
  offerType?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  type: Scalars['String'];
};

export type ECardDetails = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type RegistryLineItemInput = {
  /**
   * An opaque value provided as result from an earlier API call
   *
   * Initially any non-empty value will trigger an attempt to apply wedding completion discount
   */
  discountCampaign?: InputMaybe<Scalars['String']>;
  /**
   * For the case of standard dropship item - it is a quantity value for line item.
   * For the case of cash fund - it is a way to provide amount which will be given with this purchase in cents. So quantity=100 means $1.
   */
  quantity: Scalars['Int'];
  registryItemId: Scalars['ID'];
};

export type PrintOrder = {
  orderId: Scalars['String'];
};

export enum CarbonWebsiteAiBlockedReason {
  ai_disabled_event = 'ai_disabled_event',
  ai_disabled_global = 'ai_disabled_global',
  ai_spend_ceiling = 'ai_spend_ceiling',
}

export enum CarbonWebsiteAiControlScopeKind {
  event = 'event',
}

export type CarbonWebsiteAiControlScopeInput = {
  id: Scalars['ID'];
  kind: CarbonWebsiteAiControlScopeKind;
};

export type CarbonWebsiteAiSpendFilter = {
  excludeFirstGeneration?: InputMaybe<Scalars['Boolean']>;
  from: Scalars['Timestamp'];
  tasks?: InputMaybe<Array<CarbonWebsiteAiTask>>;
  to: Scalars['Timestamp'];
};

export enum CarbonWebsiteAiTask {
  edit = 'edit',
  image_generation = 'image_generation',
  site_generation = 'site_generation',
}

export enum CarbonWebsiteAiUsageSource {
  editor_turn = 'editor_turn',
  image_request = 'image_request',
  pipeline = 'pipeline',
  site_agent_request = 'site_agent_request',
}

export enum CarbonWebsiteAiUsageStatus {
  abandoned = 'abandoned',
  completed = 'completed',
  failed = 'failed',
  running = 'running',
}

export type CarbonWebsiteV1DesignSourceInput = {
  fromEvent?: InputMaybe<CarbonWebsiteV1EventDesignSourceInput>;
  fromPreset?: InputMaybe<Scalars['String']>;
  fromThemeId?: InputMaybe<Scalars['String']>;
};

export type CarbonWebsiteV1EventDesignSourceInput = {
  purpose?: InputMaybe<CarbonWebsiteV1DesignPurpose>;
};

export enum CarbonWebsiteV1DesignPurpose {
  draft = 'draft',
  live = 'live',
}

export enum CarbonWebsiteV1CompatibilitySeverity {
  blocking = 'blocking',
  degraded = 'degraded',
  info = 'info',
}

export enum CarbonWebsiteArtAssetType {
  accent = 'accent',
  background = 'background',
  masthead = 'masthead',
  spriteTheme = 'spriteTheme',
}

export type CarbonWebsiteArtAssetFilter = {
  groupId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export enum CarbonWebsiteThemeColorRole {
  accent = 'accent',
  background = 'background',
  border = 'border',
  surface = 'surface',
  text = 'text',
}

export enum CarbonWebsiteThemeScope {
  element = 'element',
  global = 'global',
}

export enum CarbonWebsiteThemeTextTransform {
  capitalize = 'capitalize',
  lowercase = 'lowercase',
  none = 'none',
  uppercase = 'uppercase',
}

export enum CarbonWebsiteImageGenStatus {
  completed = 'completed',
  failed = 'failed',
  pending = 'pending',
  running = 'running',
}

export enum CarbonWebsiteSiteVisibility {
  private = 'private',
  public = 'public',
}

export enum CarbonWebsiteSlugStatus {
  published = 'published',
  unpublished = 'unpublished',
}

export type CarbonWebsiteArtAssetRefInput = {
  enabled: Scalars['Boolean'];
  id?: InputMaybe<Scalars['ID']>;
  slot: Scalars['String'];
  type: CarbonWebsiteArtAssetType;
};

export enum CarbonWebsiteV1PresetLayout {
  aloha = 'aloha',
  brannan = 'brannan',
}

export type CarbonWebsiteV1PresetFilter = {
  colorFamilyId?: InputMaybe<Scalars['String']>;
  colors?: InputMaybe<Array<Scalars['String']>>;
  designFamilyId?: InputMaybe<Scalars['String']>;
  hasMasthead?: InputMaybe<Scalars['Boolean']>;
  hasSpriteTheme?: InputMaybe<Scalars['Boolean']>;
  headerLayouts?: InputMaybe<Array<Scalars['String']>>;
  layout?: InputMaybe<CarbonWebsiteV1PresetLayout>;
  search?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  vendors?: InputMaybe<Array<Scalars['String']>>;
};

export type CardAllowancePreviewInput = {
  eventId: Scalars['ID'];
  /**
   * The batch being edited or rescheduled. Its own recipients are left out of
   * the scheduled part of the committed set, so it does not count against
   * itself.
   */
  excludeMessageBatchId?: InputMaybe<Scalars['ID']>;
  /**
   * The selection: person ids on a personId audience, guest keys on a guestKey
   * one. An email and a text to one recipient count once.
   */
  recipientKeys: Array<Scalars['ID']>;
  /** Which key space `recipientKeys` are in. */
  recipientType: MessageDraftRecipientType;
  stationeryOrderId: Scalars['ID'];
};

/** How recipientIds are interpreted for a draft. */
export enum MessageDraftRecipientType {
  /** Recipients are guest keys (Firebase guest references). */
  guestKey = 'guestKey',
  /** Recipients are Joy person IDs. */
  personId = 'personId',
}

export type CardSendSummariesInput = {
  eventId: Scalars['ID'];
  /** At most 50 per request. Ids beyond that are ignored. */
  stationeryOrderIds: Array<Scalars['ID']>;
};

export enum CarCheckoutModeDtoEnum {
  CHARGE_NOW = 'CHARGE_NOW',
  COLLECT_CARD = 'COLLECT_CARD',
  NO_PAYMENT = 'NO_PAYMENT',
}

export enum CarPaymentCollectionDtoEnum {
  PAY_AT_PICKUP = 'PAY_AT_PICKUP',
  PAY_NOW = 'PAY_NOW',
}

/** Payment type a Joy discount coupon works on. ANY means no payment-type restriction. CASH_FUND_AND_CARD is about whether the cash fund is used, so it also matches a fund-only booking — the code can discount the bill below the fund balance on its own. It never matches a card-only booking, and CASH_FUND never matches a split. */
export enum CouponPaidWithDtoEnum {
  ANY = 'ANY',
  CARD = 'CARD',
  CASH_FUND = 'CASH_FUND',
  CASH_FUND_AND_CARD = 'CASH_FUND_AND_CARD',
}

/** Which booker types a Joy discount coupon applies to. */
export enum BookerTypeDtoEnum {
  ALL = 'ALL',
  FIRST_TIME = 'FIRST_TIME',
  REPEAT = 'REPEAT',
}

/** Whether a Joy discount coupon applies a fixed amount or a percentage. */
export enum DiscountTypeDtoEnum {
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  PERCENTAGE = 'PERCENTAGE',
}

/** Whether a Joy discount coupon applies globally or only to a specific event. */
export enum ScopeTypeDtoEnum {
  EVENT = 'EVENT',
  GLOBAL = 'GLOBAL',
}

export type CarReservationsByEventAndEmailPayload = {
  /** Booking email, matched after trim + lowercase normalization. */
  email: Scalars['String'];
  /** Event the car reservations must belong to. */
  eventId: Scalars['ID'];
};

export enum HandleStatus {
  available = 'available',
  unavailable = 'unavailable',
}

export enum InvalidTransitionalRegistryUrlReasonCode {
  invalidRegistryUrl = 'invalidRegistryUrl',
  registryIsPrivate = 'registryIsPrivate',
  registryUnavailable = 'registryUnavailable',
  unsupportedDomain = 'unsupportedDomain',
}

export type ClassifyMessageIntentInput = {
  /** Message body (plain text or rich text / HTML) */
  body: Scalars['String'];
  /** ID of the event the message belongs to. Used for authorization — the caller must be an admin/owner of this event (or a trusted M2M/superadmin request). */
  eventId: Scalars['String'];
  /** Message subject line */
  subject: Scalars['String'];
};

/** Detected intent tags for a host-to-guest message. New tags may be added over time; clients should ignore unknown values. */
export enum MessageIntentTag {
  CASH_FUND = 'CASH_FUND',
  HOTEL_REMINDER = 'HOTEL_REMINDER',
  RSVP_REMINDER = 'RSVP_REMINDER',
}

export type ProductHeuristicSearchInput = {
  lines: Array<ProductHeuristicSearchInput_Line>;
  shippingAddress: ProductHeuristicSearchInput_ShippingAddress;
};

export type ProductHeuristicSearchInput_Line = {
  productInfo: ProductHeuristicSearchInput_Line_ProductInfo;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ProductHeuristicSearchInput_Line_ProductInfo = {
  externalUrl?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<ProductHeuristicSearchInput_Price>;
  title?: InputMaybe<Scalars['String']>;
};

export type ProductHeuristicSearchInput_Price = {
  currencyCode: Scalars['String'];
  valueInMinorUnits: Scalars['Int'];
};

export type ProductHeuristicSearchInput_ShippingAddress = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
};

export type ContactQuarantinedMessageBatchFilter = {
  eventId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  messageBatchId?: InputMaybe<Scalars['ID']>;
  messageBatchType?: InputMaybe<Scalars['String']>;
  quarantineStatus?: InputMaybe<QuarantineStatus>;
};

export enum QuarantineStatus {
  approved = 'approved',
  canceled = 'canceled',
  rejected = 'rejected',
  review = 'review',
}

export type ContactQuarantinedMessageBatchSort = {
  createdAt?: InputMaybe<FilterDirection>;
};

export enum FilterDirection {
  asc = 'asc',
  desc = 'desc',
}

export type GetDesignGuestSiteTargetPayload = {
  layout: DesignLayoutType;
  themeId: Scalars['String'];
};

export enum EmailTemplateType {
  generalMessage = 'generalMessage',
  registrationApproval = 'registrationApproval',
}

/** Which family of emails an unsubscribe applies to */
export enum UnsubscribeScope {
  car_campaign_guest = 'car_campaign_guest',
  hotel_campaign_guest = 'hotel_campaign_guest',
  hotel_campaign_host = 'hotel_campaign_host',
  print_cart_abandonment = 'print_cart_abandonment',
  registry_cart_abandonment = 'registry_cart_abandonment',
}

/** Event trust classification tier */
export enum TrustTier {
  /** Highly trusted, mature event */
  high = 'high',
  /** Low trust, new or sparse event */
  low = 'low',
  /** Moderately trusted event */
  medium = 'medium',
  /** Untrusted, likely spam or test event */
  throwaway = 'throwaway',
}

export type EventTypesByCategoryFilters = {
  category?: InputMaybe<Array<Scalars['String']>>;
  categorySubtype?: InputMaybe<Array<Scalars['String']>>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['String']>>;
};

export type EventVipsPayload = {
  eventId: Scalars['ID'];
};

export type CashFundsPayoutAccountOptions = {
  /**
   * Always re-reads the account from Stripe, ignoring the cached status window. For callers that
   * just showed the couple an account editor and must reflect the edit immediately; ordinary
   * reads should omit it.
   */
  forceRefresh?: InputMaybe<Scalars['Boolean']>;
};

/** Payout methods supported by an external account */
export enum CashFundsExternalAccountPayoutMethod {
  instant = 'instant',
  standard = 'standard',
}

export type CashFundsPayoutAccountOnboardingUrlParams = {
  /** Route where user can start onboarding one more time (as it was not possible to load onboardingUrl this time). */
  restartRoute?: InputMaybe<Scalars['String']>;
  /** Route where users should be returned after they either completed onboarding flow or canceled it. */
  returnRoute?: InputMaybe<Scalars['String']>;
};

export type FindDefaultThingsToDoPagePayload = {
  eventId: Scalars['ID'];
};

export type EmailSearchCriteria = {
  emailType?: InputMaybe<Scalars['String']>;
  endCreateDate?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  fromEmail?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  replyToEmail?: InputMaybe<Scalars['String']>;
  startCreateDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  toEmail?: InputMaybe<Scalars['String']>;
};

export type FindHotelMatchRateInput = {
  adults: Scalars['Float'];
  checkIn: Scalars['String'];
  checkOut: Scalars['String'];
  currencyISO4217: Scalars['String'];
  guestNationalityISO2: Scalars['String'];
};

export type FindMatchingAccommodationCatalogPropertiesByDetailsPayload = {
  eventId?: InputMaybe<Scalars['String']>;
  hotelDetails: AccommodationCatalogPropertyDetailsPayload;
  metadata?: InputMaybe<FindMatchingAccommodationCatalogPropertiesByDetailsMetadata>;
};

export type AccommodationCatalogPropertyDetailsPayload = {
  city: Scalars['String'];
  countryCode: Scalars['String'];
  lat?: InputMaybe<Scalars['Float']>;
  long?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type FindMatchingAccommodationCatalogPropertiesByDetailsMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type FindMatchingAccommodationCatalogPropertyPayload = {
  sourceId: Scalars['String'];
  sourceType: AccommodationPlaceSourceType;
};

/** AccommodationPlaceSourceType */
export enum AccommodationPlaceSourceType {
  google = 'google',
  joyPlace = 'joyPlace',
  nuitee = 'nuitee',
  zh = 'zh',
}

/** Display/input preference. All coordinates and dimensions are stored in cm. */
export enum MeasurementUnit {
  imperial = 'imperial',
  metric = 'metric',
}

/** What the object is. Drives the icon the client shows and the default label and size the server applies; `custom` is anything the catalogue does not name and carries its own label. */
export enum FloorPlanObjectKind {
  bar = 'bar',
  buffet = 'buffet',
  cakeTable = 'cakeTable',
  custom = 'custom',
  danceFloor = 'danceFloor',
  dj = 'dj',
  giftTable = 'giftTable',
  lounge = 'lounge',
  photoBooth = 'photoBooth',
  stage = 'stage',
  welcomeTable = 'welcomeTable',
}

/** Persisted table role. GENERAL (default) tables are auto-seatable; role tables (HEAD, SWEETHEART) are excluded from auto-seat. */
export enum TableType {
  GENERAL = 'GENERAL',
  HEAD = 'HEAD',
  SWEETHEART = 'SWEETHEART',
}

export type FormAnswerFilters = {
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  formId?: InputMaybe<Scalars['ID']>;
  guestKey?: InputMaybe<Scalars['String']>;
};

/**
 * State of a ticket type - controls whether tickets can be purchased.
 * Designed for extensibility (future states can be added).
 */
export enum TicketTypeState {
  /** Available for purchase (subject to capacity/dates) */
  ACTIVE = 'ACTIVE',
  /** Not available for purchase (hidden or paused) */
  INACTIVE = 'INACTIVE',
}

export enum FormType {
  OTHER = 'OTHER',
  REGISTRATION = 'REGISTRATION',
  SURVEY = 'SURVEY',
}

export type FormFilters = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type FormTemplateFilters = {
  eventCategoryTags?: InputMaybe<Array<Scalars['String']>>;
  eventSubTypeTags?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** Input for discovering promotion codes eligible for a booking (AUTO_APPLY codes, plus email-restricted MANUAL codes when a booker email is provided). */
export type GetApplicablePromoCodesInput = {
  /** Payment-type rules the caller can honor. Only codes carrying one of these rules are returned. Omitted or empty returns every rule. */
  couponPaidWith?: InputMaybe<Array<CouponPaidWith>>;
  /** The booker email address. When provided, email-restricted codes whose allowlist includes this address are included alongside globally available codes. */
  email?: InputMaybe<Scalars['String']>;
  /** The event ID to match EVENT-scoped codes. Required to receive event-specific promotions. */
  eventId?: InputMaybe<Scalars['ID']>;
  /** The product type being booked (e.g. TRAVEL). */
  productType: ProductType;
};

export enum CouponPaidWith {
  ANY = 'ANY',
  CARD = 'CARD',
  CASH_FUND = 'CASH_FUND',
  CASH_FUND_AND_CARD = 'CASH_FUND_AND_CARD',
}

export enum ProductType {
  CAR_RENTAL = 'CAR_RENTAL',
  PRINT = 'PRINT',
  REGISTRY = 'REGISTRY',
  TRAVEL = 'TRAVEL',
}

export enum BookerType {
  ALL = 'ALL',
  FIRST_TIME = 'FIRST_TIME',
  REPEAT = 'REPEAT',
}

export enum DiscountType {
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  PERCENTAGE = 'PERCENTAGE',
}

export enum ScopeType {
  EVENT = 'EVENT',
  GLOBAL = 'GLOBAL',
}

export type GetCarDetailsInput = {
  /** ISO 3166-1 alpha-2 point-of-sale country code, used for fee experiment targeting, e.g. "US" */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Caller device type, used for car-rental payment processing fee experiment targeting. */
  deviceType?: InputMaybe<DeviceType>;
  /** Optional Joy event ID used to resolve car-rental payment processing fees. */
  eventId?: InputMaybe<Scalars['String']>;
  /** The base64-JSON offerToken returned by getCarRates for an Expedia offer. */
  offerToken: Scalars['String'];
};

export enum TravelOfferCancellationPolicyRuleValueType {
  Amount = 'Amount',
  Nights = 'Nights',
  Percentage = 'Percentage',
}

export enum CarPaymentCollection {
  PAY_AT_PICKUP = 'PAY_AT_PICKUP',
  PAY_NOW = 'PAY_NOW',
}

export enum CarRateProvider {
  EXPEDIA = 'EXPEDIA',
  HERTZ = 'HERTZ',
}

export enum VehicleCategory {
  ALL_TERRAIN = 'ALL_TERRAIN',
  CAR = 'CAR',
  CONVERTIBLE = 'CONVERTIBLE',
  LIMOUSINE = 'LIMOUSINE',
  MOTORHOME = 'MOTORHOME',
  PICKUP_TRUCK = 'PICKUP_TRUCK',
  STATION_WAGON = 'STATION_WAGON',
  SUV = 'SUV',
  UNKNOWN = 'UNKNOWN',
  VAN = 'VAN',
}

export enum VehicleSize {
  COMPACT = 'COMPACT',
  COMPACT_ELITE = 'COMPACT_ELITE',
  ECONOMY = 'ECONOMY',
  ECONOMY_ELITE = 'ECONOMY_ELITE',
  FULLSIZE = 'FULLSIZE',
  FULLSIZE_ELITE = 'FULLSIZE_ELITE',
  INTERMEDIATE = 'INTERMEDIATE',
  INTERMEDIATE_ELITE = 'INTERMEDIATE_ELITE',
  LUXURY = 'LUXURY',
  LUXURY_ELITE = 'LUXURY_ELITE',
  MIDSIZE = 'MIDSIZE',
  MINI = 'MINI',
  MINI_ELITE = 'MINI_ELITE',
  OVERSIZE = 'OVERSIZE',
  PREMIUM = 'PREMIUM',
  PREMIUM_ELITE = 'PREMIUM_ELITE',
  SPECIAL = 'SPECIAL',
  STANDARD = 'STANDARD',
  STANDARD_ELITE = 'STANDARD_ELITE',
  SUBCOMPACT = 'SUBCOMPACT',
  UNKNOWN = 'UNKNOWN',
}

export type GetCarRatesInput = {
  /** ISO 3166-1 alpha-2 point-of-sale country code, e.g. "US" */
  countryCode?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<TravelCurrencyCode>;
  /** Caller device type, used for car-rental payment processing fee experiment targeting and to derive the Expedia sales channel (DESKTOP/TABLET -> website, MOBILE -> mobile_web). Ignored by non-Expedia providers for the sales-channel derivation. */
  deviceType?: InputMaybe<DeviceType>;
  /** Age of the primary driver, in years, used for age-based fees/restrictions. Defaults to 40. */
  driverAge?: InputMaybe<Scalars['Int']>;
  dropOffLocation?: InputMaybe<CarLocationSearchInput>;
  dropOffTime: Scalars['String'];
  eventId: Scalars['String'];
  filters?: InputMaybe<CarRatesFiltersInput>;
  /** ISO 639-1 language code ("en"), optionally with an ISO 3166-1 alpha-2 region ("en-US"). These are the two forms Expedia Rapid accepts; broader BCP47 tags (e.g. "zh-Hans", "es-419") are not supported. */
  language?: InputMaybe<Scalars['String']>;
  /** Maximum number of car rates to return, 1-200. Defaults to 100 when omitted. Honored by the Expedia live search and by the cached path (`useCache: true`), which applies it as its own limit and falls back to 50 rows when it is omitted. Ignored by Hertz, but validated on this shared input before provider routing. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Product type sold with the car rental for Expedia package or cross-sell rates. Ignored by non-Expedia providers. */
  packagedProduct?: InputMaybe<Array<CarRatesPackagedProduct>>;
  pickUpLocation?: InputMaybe<CarLocationSearchInput>;
  pickUpTime: Scalars['String'];
  provider: CarRateProvider;
  /** Multi-select rate filters mapped 1:1 to Expedia `filter` query params (REFUNDABLE -> refundable). EXPEDIA_COLLECT and VENDOR_COLLECT are both ignored: live Expedia search always allows both pay-now and pay-at-pickup cars, subject to availability and the remaining filters. `paymentCollection` and `paymentRegistrationRequired` on each vehicle identify its payment mode, and `dueAtBooking` the amount due now. Used by Expedia only (ignored for Hertz outbound requests), but validated on this shared input before provider routing. */
  rateFilters?: InputMaybe<Array<CarRatesFilter>>;
  /** Deprecated: use deviceType instead — the sales channel is derived from it. Only honored when deviceType is absent. Defaults to WEBSITE. Ignored by non-Expedia providers. Removed after 2026-08-28. */
  salesChannel?: InputMaybe<CarRatesSalesChannel>;
  /** Deprecated: use packagedProduct instead — the sales environment is derived from it. Only honored when packagedProduct is absent. Defaults to CAR_ONLY. Ignored by non-Expedia providers. */
  salesEnvironment?: InputMaybe<CarRatesSalesEnvironment>;
  /** Search radius in kilometers, 1-100 */
  searchRadiusKm?: InputMaybe<Scalars['Int']>;
  /** Sort order for results. Defaults to RECOMMENDED. Ignored by non-Expedia providers. */
  sort?: InputMaybe<CarRatesSort>;
  /** When true, serve the cached pickup catalogue from Joy storage instead of calling the partner: content only, in milliseconds, with `offerToken` null, every `pricing` money field null, `dropOffLocation` null and `cancellationPolicies` empty (unknown, NOT fully refundable). Requires pickup coordinates — a city/address-only pickup returns no vehicles, as does a cold cache. Defaults to false: the live partner search, with real prices and booking tokens. */
  useCache?: InputMaybe<Scalars['Boolean']>;
};

export type CarLocationSearchInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
};

export type CarRatesFiltersInput = {
  carCode?: InputMaybe<Scalars['String']>;
};

export enum CarRatesPackagedProduct {
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
}

export enum CarRatesFilter {
  /** @deprecated Ignored — search always allows both pay-now and pay-at-pickup cars; read `paymentCollection` on each vehicle instead. */
  EXPEDIA_COLLECT = 'EXPEDIA_COLLECT',
  INSURANCE_BUNDLE = 'INSURANCE_BUNDLE',
  REFUNDABLE = 'REFUNDABLE',
  /** @deprecated Ignored — search always allows both pay-now and pay-at-pickup cars; read `paymentCollection` on each vehicle instead. */
  VENDOR_COLLECT = 'VENDOR_COLLECT',
}

export enum CarRatesSalesChannel {
  AGENT_TOOL = 'AGENT_TOOL',
  CACHE = 'CACHE',
  META = 'META',
  MOBILE_APP = 'MOBILE_APP',
  MOBILE_WEB = 'MOBILE_WEB',
  WEBSITE = 'WEBSITE',
}

export enum CarRatesSalesEnvironment {
  CAR_ONLY = 'CAR_ONLY',
  CAR_PACKAGE = 'CAR_PACKAGE',
}

export enum CarRatesSort {
  CUSTOMER_RATING = 'CUSTOMER_RATING',
  DISTANCE = 'DISTANCE',
  RECOMMENDED = 'RECOMMENDED',
  TOTAL_PRICE = 'TOTAL_PRICE',
}

export type GetCashFundForContributionInput = {
  cashFundId: Scalars['ID'];
  /**
   * Links a specific Invite to the Contribution.
   * The 'inviteToken' has higher priority when linking an Invite. If an 'inviteToken' is provided, this property is ignored.
   * Note: If a guest has multiple Invites for the same Cash Fund (from different Solicitations),
   * the system will automatically select the Invite with the fewest existing Contributions.
   */
  guestKey?: InputMaybe<Scalars['String']>;
  /** Links a specific Invite to the Contribution. */
  inviteToken?: InputMaybe<Scalars['String']>;
};

export enum CollaborationInviteState {
  accepted = 'accepted',
  pending = 'pending',
  revoked = 'revoked',
}

export enum ContactSource {
  created_from_contact = 'created_from_contact',
  created_from_csv = 'created_from_csv',
  created_from_guestlist = 'created_from_guestlist',
  updated_from_contact = 'updated_from_contact',
  updated_from_csv = 'updated_from_csv',
  updated_from_guestlist = 'updated_from_guestlist',
}

/**
 * Whether a given field is collected by the contact collector form, and if so
 * whether the guest must fill it in. `OFF` hides the field entirely and the
 * server rejects submitted values for it.
 */
export enum ContactCollectorFieldRequirement {
  /**
   * Field is hidden from the form and not collected. Server rejects (or strips,
   * per the active enforcement policy) any submitted value for it.
   */
  OFF = 'OFF',
  /**
   * Field is shown on the form but may be left blank. Server accepts any value
   * including absent.
   */
  OPTIONAL = 'OPTIONAL',
  /**
   * Field is shown on the form and must be non-empty on submit. Server rejects
   * submissions where the field is missing or blank.
   */
  REQUIRED = 'REQUIRED',
}

export enum EcardType {
  changethedate = 'changethedate',
  custom = 'custom',
  invitation = 'invitation',
  savethedate = 'savethedate',
  savethedatephoto = 'savethedatephoto',
}

export enum CodeCategory {
  /** A $0 attribution code for an event group. Each event has 1 code, and the service finds it by eventId. */
  EVENT_GROUP = 'EVENT_GROUP',
  PROMOTION = 'PROMOTION',
  REFERRAL = 'REFERRAL',
}

export enum ApplicationType {
  AUTO_APPLY = 'AUTO_APPLY',
  MANUAL = 'MANUAL',
}

export enum CouponRuntimeState {
  ACTIVE = 'ACTIVE',
  CONSUMED = 'CONSUMED',
  EXPIRED = 'EXPIRED',
  INACTIVE = 'INACTIVE',
}

export type EventSearchCriteria = {
  coupleNames?: InputMaybe<Scalars['String']>;
  eventTypes?: InputMaybe<Array<EventType>>;
  includeAllPastEvents?: InputMaybe<Scalars['Boolean']>;
};

/** Filter to apply to getGroupMembersWithAttendanceAndAnswers. All conditions are evaluated with the given logic (AND/OR). */
export type GuestListMemberFilterInput = {
  /** One or more conditions to apply. Must contain at least one condition. */
  conditions: Array<GuestListMemberFilterCondition>;
  /** How to combine conditions: 'and' requires all to match, 'or' requires at least one. */
  logic: FilterLogic;
};

/**
 * A single filter condition. Exactly one of field, registrationQuestionId, or
 * customColumnId must be set to identify the data source being filtered.
 */
export type GuestListMemberFilterCondition = {
  /** Filter by a custom column value. Provide the column's ID. */
  customColumnId?: InputMaybe<Scalars['ID']>;
  /** Inclusive date range — used with the inRange operator for date fields (e.g. orderDate). */
  dateRange?: InputMaybe<GuestListDateRangeInput>;
  /**
   * Built-in contact, address, attendance, or tag field.
   * Exactly one of field, registrationQuestionId, customColumnId must be set.
   */
  field?: InputMaybe<GuestListMemberFilterField>;
  /** Comparison operator to apply. Must be compatible with the field type. */
  operator: GuestListMemberFilterOperator;
  /** Filter by a specific registration form answer. Provide the question's ID. */
  registrationQuestionId?: InputMaybe<Scalars['ID']>;
  /** Single string value — used for text, singleSelect, and single-value operators. */
  value?: InputMaybe<Scalars['String']>;
  /** Array of strings — used for isAnyOf, isNoneOf, hasAnyOf, hasAllOf, hasNoneOf. */
  values?: InputMaybe<Array<Scalars['String']>>;
};

/** Inclusive date range for date-typed filter fields. Provide at least one bound. */
export type GuestListDateRangeInput = {
  /** Inclusive lower bound (ISO 8601 DateTime). Omit for an open-ended start. */
  from?: InputMaybe<Scalars['DateTime']>;
  /** Inclusive upper bound (ISO 8601 DateTime). Omit for an open-ended end. */
  to?: InputMaybe<Scalars['DateTime']>;
};

/** Built-in guest list fields that can be used as filter targets. */
export enum GuestListMemberFilterField {
  /** Address line 1 (DB-level filter). */
  addressLine1 = 'addressLine1',
  /** Address line 2 (DB-level filter). */
  addressLine2 = 'addressLine2',
  /** Guest attendance status — ATTENDING, NOT_ATTENDING, MAYBE, or PENDING (post-hydration filter). */
  attendanceStatus = 'attendanceStatus',
  /** Address city (DB-level filter). */
  city = 'city',
  /** Address country (DB-level filter). */
  country = 'country',
  /** Household display/greeting name (DB-level filter). */
  displayName = 'displayName',
  /** Contact email address (DB-level filter). */
  email = 'email',
  /** Contact first name (DB-level filter). */
  firstName = 'firstName',
  /** Contact last name (DB-level filter). */
  lastName = 'lastName',
  /** Contact mobile phone number (DB-level filter). */
  mobile = 'mobile',
  /** Selected order date — use the inRange operator with dateRange (post-hydration filter). */
  orderDate = 'orderDate',
  /** Selected order number (post-hydration filter). */
  orderNumber = 'orderNumber',
  /** Selected raw order status enum, e.g. COMPLETED/REFUNDED (post-hydration filter). */
  orderStatus = 'orderStatus',
  /** Contact name prefix/honorific, labelled "Title" in the guest list UI (DB-level filter). */
  prefix = 'prefix',
  /** Address state or region (DB-level filter). */
  state = 'state',
  /** Contact name suffix (DB-level filter). */
  suffix = 'suffix',
  /** Guest tags by label (post-hydration filter). */
  tags = 'tags',
  /** Selected ticket type name (post-hydration filter). */
  ticketType = 'ticketType',
  /** Address postal/zip code (DB-level filter). */
  zip = 'zip',
}

/** Comparison operators available for filter conditions. Valid operators depend on the field type. */
export enum GuestListMemberFilterOperator {
  /** Value contains the given substring (text fields only). */
  contains = 'contains',
  /** Value does not contain the given substring (text fields only). */
  doesNotContain = 'doesNotContain',
  /** Multi-select contains all of the given values. Use the values array. */
  hasAllOf = 'hasAllOf',
  /** Multi-select contains at least one of the given values. Use the values array. */
  hasAnyOf = 'hasAnyOf',
  /** Multi-select contains none of the given values. Use the values array. */
  hasNoneOf = 'hasNoneOf',
  /** Date field falls within an inclusive range. Use the dateRange value (date fields only, e.g. orderDate). */
  inRange = 'inRange',
  /** Exact match (case-insensitive for text fields). */
  is = 'is',
  /** Single-select value matches any of the given values. Use the values array. */
  isAnyOf = 'isAnyOf',
  /** Field has no value or is an empty string. */
  isEmpty = 'isEmpty',
  /** Single-select value matches none of the given values. Use the values array. */
  isNoneOf = 'isNoneOf',
  /** Does not match (case-insensitive for text fields). */
  isNot = 'isNot',
  /** Field has a non-empty value. */
  isNotEmpty = 'isNotEmpty',
}

/** Logical operator used to combine multiple filter conditions. */
export enum FilterLogic {
  /** All conditions must match. */
  and = 'and',
  /** At least one condition must match. */
  or = 'or',
}

export type GuestListMemberSort = {
  direction: SortDirection;
  field: GuestListMemberSortField;
};

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum GuestListMemberSortField {
  ADDRESS_LINE_1 = 'ADDRESS_LINE_1',
  ADDRESS_LINE_2 = 'ADDRESS_LINE_2',
  ATTENDANCE_STATUS = 'ATTENDANCE_STATUS',
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  DISPLAY_NAME = 'DISPLAY_NAME',
  EMAIL = 'EMAIL',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  ORDER_DATE = 'ORDER_DATE',
  ORDER_NUMBER = 'ORDER_NUMBER',
  ORDER_STATUS = 'ORDER_STATUS',
  PREFIX = 'PREFIX',
  STATE = 'STATE',
  SUFFIX = 'SUFFIX',
  TICKET_TYPE = 'TICKET_TYPE',
  ZIP = 'ZIP',
}

export enum GuestlistColumnDisplayState {
  DEFAULT = 'DEFAULT',
  DISABLED = 'DISABLED',
  HIDDEN = 'HIDDEN',
}

export enum GuestlistColumnScope {
  CONTACT = 'CONTACT',
  EVENT = 'EVENT',
}

export enum GuestlistCustomColumnType {
  BOOLEAN = 'BOOLEAN',
  CHECKBOX = 'CHECKBOX',
  CURRENCY = 'CURRENCY',
  DATE = 'DATE',
  EMAIL = 'EMAIL',
  LONG_TEXT = 'LONG_TEXT',
  MULTI_SELECT = 'MULTI_SELECT',
  NUMBER = 'NUMBER',
  PHONE = 'PHONE',
  RICH_TEXT = 'RICH_TEXT',
  SINGLE_SELECT = 'SINGLE_SELECT',
  TEXT = 'TEXT',
}

/** Filter the connection to guests who have / have not booked a hotel. */
export enum TravelBookingStatusFilter {
  BOOKED = 'BOOKED',
  NOT_BOOKED = 'NOT_BOOKED',
}

/** How the reservation was matched to the guest. */
export enum TravelReservationMatchType {
  EMAIL = 'EMAIL',
  GUEST_KEY = 'GUEST_KEY',
}

/** Which reservation table the booking came from. */
export enum TravelReservationSource {
  IMPORTED = 'IMPORTED',
  NATIVE = 'NATIVE',
}

/** Arguments for fetching a page of reviews for one hotel. */
export type TravelHotelReviewsInputV1 = {
  /** Joy place id of the hotel to fetch reviews for. */
  joyPlaceId: Scalars['String'];
  /** ISO 639-1 language to return review text in (default "en"). */
  language?: Scalars['String'];
  /** Number of reviews per page (default 10). */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Opaque cursor from a previous page’s nextPageToken. */
  pageToken?: InputMaybe<Scalars['String']>;
  /** Force a specific review vendor; omit to auto-select the best available for the place. */
  provider?: InputMaybe<TravelHotelReviewProvider>;
  /** How to order the returned reviews (default: newest first). */
  sort?: InputMaybe<TravelReviewSortInputV1>;
};

/** Review vendor a set of reviews was sourced from. */
export enum TravelHotelReviewProvider {
  hopper = 'hopper',
  nuitee = 'nuitee',
  zh = 'zh',
}

/** Ordering for the returned reviews. */
export type TravelReviewSortInputV1 = {
  /** Field to order reviews by. */
  field: TravelReviewSortFieldV1;
  /** Sort direction. */
  order: TravelReviewSortOrderV1;
};

/** Field a review list can be ordered by. */
export enum TravelReviewSortFieldV1 {
  DATE = 'DATE',
  RATING = 'RATING',
}

/** Sort direction, ascending or descending. */
export enum TravelReviewSortOrderV1 {
  ASC = 'ASC',
  DESC = 'DESC',
}

/** Party composition of the reviewer (couple, family, friends, solo, or unknown). */
export enum TravelReviewerType {
  COUPLE = 'COUPLE',
  FAMILY = 'FAMILY',
  FRIENDS = 'FRIENDS',
  SOLO = 'SOLO',
  UNKNOWN = 'UNKNOWN',
}

/** Purpose of the reviewer’s trip (leisure, business, or unknown). */
export enum TravelPurpose {
  BUSINESS = 'BUSINESS',
  LEISURE = 'LEISURE',
  UNKNOWN = 'UNKNOWN',
}

export type MessageRelationshipCriteria = {
  externalMessageIds: Array<Scalars['String']>;
  relationshipTag?: InputMaybe<Scalars['String']>;
};

/**
 * Messaging tier for an event. Determines which messaging features are enabled.
 * - basic: Free tier, email-only messaging (equivalent to null for backwards compatibility)
 * - hotel: Experiment tier, granted full Messaging Plus access (e.g. SMS reminders)
 * - messagingPlus: Paid tier, enables SMS messaging in addition to email
 */
export enum MessagingTier {
  basic = 'basic',
  hotel = 'hotel',
  messagingPlus = 'messagingPlus',
}

export type GetPendingAccommodationRecommendationsPayload = {
  eventId: Scalars['ID'];
};

export enum PhoneNumberDeliveryMethod {
  sms = 'sms',
}

export enum PostOfficeMessageType {
  generic = 'generic',
  giftWrap = 'giftWrap',
  greetingCard = 'greetingCard',
  reminder = 'reminder',
  thankyou = 'thankyou',
}

/** Discount type for a promo code. */
export enum PromoCodeDiscountType {
  /** Fixed amount off in minor currency units (e.g. cents) */
  FLAT = 'FLAT',
  /** Percentage off (1–100) */
  PERCENTAGE = 'PERCENTAGE',
}

/** State of a promo code — controls whether it can be applied. */
export enum PromoCodeState {
  /** Active and usable */
  ACTIVE = 'ACTIVE',
  /** Inactive — cannot be applied to new orders */
  INACTIVE = 'INACTIVE',
}

/** Arguments for fetching review rating summaries for a batch of hotels in one call. */
export type TravelRatingSummariesInputV1 = {
  /** Joy place ids to fetch rating summaries for. Batched — send all ids for a page in one call. */
  joyPlaceIds: Array<Scalars['String']>;
  /** Review vendor whose stored rating summaries to return. */
  provider: TravelHotelReviewProvider;
};

/** Answer scope of a registration question. */
export enum RegistrationQuestionScope {
  /** Answered once for the whole party; resolved leader-first at read time. */
  GROUP = 'GROUP',
  /** Answered individually by each guest (default). */
  GUEST = 'GUEST',
}

export enum RegistryStoreConnectAction {
  link = 'link',
  sync = 'sync',
  transfer = 'transfer',
}

export type ImageSizingCriteria = {
  maxHeight?: InputMaybe<Scalars['Int']>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  pixelRatio?: InputMaybe<Scalars['Int']>;
};

export enum RsvpDeadlineStatus {
  closed = 'closed',
  disabled = 'disabled',
  gracePeriod = 'gracePeriod',
  open = 'open',
}

/**
 * RSVP tier for an event. Determines which RSVP features are enabled.
 * - basic: Free tier (equivalent to null for backwards compatibility)
 * - plus: Paid tier, enables RSVP Plus features
 */
export enum RsvpTier {
  basic = 'basic',
  plus = 'plus',
}

/**
 * Who owns a tag, and therefore who may change it.
 *
 * `manual` is every tag a host made: fully editable, and the only kind that
 * existed before Smart Tags. `system` is a tag this service wrote on the host's
 * behalf — the point-in-time audience of a sent message. A host may rename a
 * system tag, but may not delete it or edit who is in it: the record of who
 * received a message has to survive the guest list moving on.
 */
export enum TagDefinitionKind {
  manual = 'manual',
  system = 'system',
}

export type GetThingsToDoContainersPayload = {
  eventId: Scalars['ID'];
};

/** Who triggered the change. ADMIN = logged-in admin user. SYSTEM = M2M / server-internal. GUEST = guest-facing path (reserved; not yet wired). UNKNOWN = fallback when no signal is available. */
export enum ContactChangeActorType {
  /** Edit made by a logged-in event admin via the guest list / contact UIs. */
  ADMIN = 'ADMIN',
  /** Reserved for guest-facing magic-link writes. Not emitted by any Phase-2 call site. */
  GUEST = 'GUEST',
  /** Server-internal change (M2M token or no current user). Bulk paths bypass recording entirely; SYSTEM is reserved for the rare server-driven single-contact mutation. */
  SYSTEM = 'SYSTEM',
  /** Fallback when no actor signal is available. Should be rare; spike indicates the actor-derivation path missed a case. */
  UNKNOWN = 'UNKNOWN',
}

/** Bucket of entity the change row applies to. CONTACT/ADDRESS/PHONE map to the matching DB row; CUSTOM_COLUMN groups by column definition id. */
export enum ContactChangeEntityType {
  /** Change to a scalar sub-field on the Address row (city, postalCode, ...). Attributed to the contact that triggered the mutation. */
  ADDRESS = 'ADDRESS',
  /** Change to a scalar field on the Contact row (firstName, email, ...). */
  CONTACT = 'CONTACT',
  /** Change to a custom column value, keyed by the column definition id. */
  CUSTOM_COLUMN = 'CUSTOM_COLUMN',
  /** Change to a PhoneNumber row owned by the contact (add, remove, or field edit). */
  PHONE = 'PHONE',
}

export type TravelReservationBookingDetailsPayload = {
  eventId: Scalars['String'];
};

export enum JoyFeatureType {
  liveSlideshow = 'liveSlideshow',
  messagingPlus = 'messagingPlus',
  photosGold = 'photosGold',
  photosGoldToPlatinum = 'photosGoldToPlatinum',
  photosPlatinum = 'photosPlatinum',
  photosStorageExtension = 'photosStorageExtension',
  photosUploadExtension = 'photosUploadExtension',
  rsvpPlus = 'rsvpPlus',
  seatingChart = 'seatingChart',
}

export type HotelInventoryByIdsRequest = {
  hotelIds: Array<Scalars['String']>;
  metadata?: InputMaybe<HotelInventoryByIdsRequestMetadata>;
};

export type HotelInventoryByIdsRequestMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export enum HotelTypeEnum {
  Affittacamere = 'Affittacamere',
  AgritourismProperty = 'AgritourismProperty',
  AllInclusiveProperty = 'AllInclusiveProperty',
  Aparthotel = 'Aparthotel',
  Apartment = 'Apartment',
  BedAndBreakfast = 'BedAndBreakfast',
  Boat = 'Boat',
  Bungalow = 'Bungalow',
  Cabin = 'Cabin',
  Campsite = 'Campsite',
  Chalet = 'Chalet',
  Condo = 'Condo',
  Cottage = 'Cottage',
  CountryHouse = 'CountryHouse',
  Cruise = 'Cruise',
  FarmStay = 'FarmStay',
  GuestAccommodation = 'GuestAccommodation',
  GuestHouse = 'GuestHouse',
  HolidayPark = 'HolidayPark',
  Homes = 'Homes',
  Homestay = 'Homestay',
  Hostel = 'Hostel',
  Hotel = 'Hotel',
  House = 'House',
  Houseboat = 'Houseboat',
  Inn = 'Inn',
  Lodge = 'Lodge',
  MobileHome = 'MobileHome',
  Motel = 'Motel',
  Palace = 'Palace',
  Pension = 'Pension',
  Pousada = 'Pousada',
  PrivateVacationHome = 'PrivateVacationHome',
  Ranch = 'Ranch',
  Residence = 'Residence',
  Resort = 'Resort',
  Riad = 'Riad',
  Ryokan = 'Ryokan',
  Tent = 'Tent',
  Tourist = 'Tourist',
  Unknown = 'Unknown',
  Villa = 'Villa',
}

export type HotelInventoryByRadiusRequest = {
  hotelInventorySearchType?: InputMaybe<HotelInventorySearchType>;
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  metadata?: InputMaybe<HotelInventoryByRadiusRequestMetadata>;
  radiusInKM: Scalars['Float'];
};

export enum HotelInventorySearchType {
  ALL = 'ALL',
}

export type HotelInventoryByRadiusRequestMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type HotelRoomsAndRatesRequest = {
  checkIn: Scalars['DateOnly'];
  checkOut: Scalars['DateOnly'];
  currency: TravelCurrencyCode;
  hotelId: Scalars['String'];
  occupancies: Array<HotelRoomsAndRatesRequestOccupancy>;
};

export type HotelRoomsAndRatesRequestOccupancy = {
  childrenAges?: InputMaybe<Array<Scalars['Int']>>;
  numOfAdults: Scalars['Int'];
};

export type HotelRoomsAndRatesByLocationRequest = {
  checkIn: Scalars['DateOnly'];
  checkOut: Scalars['DateOnly'];
  currency: TravelCurrencyCode;
  hotelInventorySearchType?: InputMaybe<HotelInventorySearchType>;
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  metadata?: InputMaybe<HotelInventoryByRadiusRequestMetadata>;
  occupancies: Array<HotelRoomsAndRatesRequestOccupancy>;
  radiusInKM: Scalars['Float'];
};

export type HotelSuggestionRequest = {
  countries?: InputMaybe<Array<Scalars['String']>>;
  hotelInventorySearchType?: InputMaybe<HotelInventorySearchType>;
  metadata?: InputMaybe<HotelInventoryRequestMetadata>;
  size?: InputMaybe<Scalars['Float']>;
  term: Scalars['String'];
};

export type HotelInventoryRequestMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

/** The kind of background operation an idempotent-operation row deduplicates. */
export enum EphemeralIdempotentOperationType {
  amplitudeExposure = 'amplitudeExposure',
  autoAccommodation = 'autoAccommodation',
  autoStayAreas = 'autoStayAreas',
  generateRecommendations = 'generateRecommendations',
  travelAlertNotification = 'travelAlertNotification',
}

/** Lifecycle status of an idempotent operation: started, done, or error. */
export enum IdempotentOperationStatus {
  done = 'done',
  error = 'error',
  started = 'started',
}

/** Query for idempotent operations by event and operation type. */
export type InternalIdempotentOperationsByEventAndTypeInput = {
  /** The event whose operations are being fetched. */
  eventId: Scalars['ID'];
  /** The kind of background operation to filter by. */
  operationType: EphemeralIdempotentOperationType;
};

export type ImproveTextInput = {
  /** The type of improvement to apply */
  action: TextImprovementAction;
  /** The context in which the text will be used */
  context: TextContext;
  /** Custom instructions for NEW_DRAFT and MANUAL actions */
  customInstructions?: InputMaybe<Scalars['String']>;
  /** The event ID for which this text improvement is being requested */
  eventId: Scalars['String'];
  /** Additional metadata for text improvement */
  metadata?: InputMaybe<TextImprovementMetadata>;
  /** The raw text to improve */
  rawText: Scalars['String'];
};

/** The type of text improvement to apply */
export enum TextImprovementAction {
  CONCISE = 'CONCISE',
  EXPAND = 'EXPAND',
  FRIENDLY = 'FRIENDLY',
  MANUAL = 'MANUAL',
  NEW_DRAFT = 'NEW_DRAFT',
  PROFESSIONAL = 'PROFESSIONAL',
  PROOFREAD = 'PROOFREAD',
  REWRITE = 'REWRITE',
  SIMPLIFY = 'SIMPLIFY',
}

/** The context in which the text will be used */
export enum TextContext {
  EMAIL_EVENT_HOST_TO_GUESTS = 'EMAIL_EVENT_HOST_TO_GUESTS',
  EMAIL_TO_GUESTS = 'EMAIL_TO_GUESTS',
  EVENT_REMINDER = 'EVENT_REMINDER',
  GENERAL = 'GENERAL',
  INVITATION_MESSAGE = 'INVITATION_MESSAGE',
  SMS_TO_GUESTS = 'SMS_TO_GUESTS',
  THANK_YOU_NOTE = 'THANK_YOU_NOTE',
  WEBSITE_COMPONENT = 'WEBSITE_COMPONENT',
}

export type TextImprovementMetadata = {
  /** Expected output format (html, markdown, or plaintext) */
  format?: InputMaybe<Scalars['String']>;
  /** Locale for language-specific improvements (e.g., "en-US", "es-ES") */
  locale?: InputMaybe<Scalars['String']>;
};

/** The hotels a host may choose from for an instant room block. */
export type InstantRoomBlockHotelSearchPayload = {
  /** Check-in date, as YYYY-MM-DD. */
  checkInDate: Scalars['String'];
  /** Check-out date, as YYYY-MM-DD. */
  checkOutDate: Scalars['String'];
  /** The event the block is for. The caller must host it. */
  eventId: Scalars['ID'];
  /** Search these hotels, in this order. A repeated id is searched once. More distinct ids than `limit` is refused. Exactly one of `region` or `joyPlaceIds` must be supplied. */
  joyPlaceIds?: InputMaybe<Array<Scalars['String']>>;
  /** Search at most this many hotels: the nearest ones within `region`. Defaults to 50, at most 50, at least 1. */
  limit?: InputMaybe<Scalars['Int']>;
  /** One entry per room wanted. */
  occupancies: Array<InstantRoomBlockOccupancyInput>;
  /** Search the hotels within this circle, nearest first. Exactly one of `region` or `joyPlaceIds` must be supplied. */
  region?: InputMaybe<AccommodationCatalogRegionCircularInput>;
};

/** The guests staying in one room of an instant room block. */
export type InstantRoomBlockOccupancyInput = {
  /** Adults staying in the room. At least 1. */
  adults: Scalars['Int'];
  /** Children staying in the room. Not supported yet: send 0 or leave it out. Any other value is refused. */
  children?: InputMaybe<Scalars['Int']>;
};

/** Circular regions input (latitude and longitude) */
export type AccommodationCatalogRegionCircularInput = {
  /** Latitude in DD (Decimal Degrees) format. +ve is N and -ve is S of Equator */
  latitude: Scalars['Float'];
  /** Longitude in DD (Decimal Degrees) format, +ve is E and -ve is W of Meridian */
  longitude: Scalars['Float'];
  /** radius in KM */
  radius: Scalars['Int'];
};

export type AccommodationPlacesByRoomBlockCutoffWindowInput = {
  /** Opaque cursor taken from a previous page’s `endCursor`. Resumes strictly after that place. Omit for the first page. */
  after?: InputMaybe<Scalars['String']>;
  /** Earliest room block cut-off date, inclusive (YYYY-MM-DD). */
  cutoffFrom: Scalars['DateOnlyString'];
  /** Latest room block cut-off date, inclusive (YYYY-MM-DD). At most 120 days after cutoffFrom. */
  cutoffTo: Scalars['DateOnlyString'];
  /** Page size, 1..500. Defaults to 100. A window may match more places than one page holds — follow `endCursor` until `hasNextPage` is false. */
  first?: InputMaybe<Scalars['Int']>;
  /** Only blocks in this status. Omit for every status. */
  status?: InputMaybe<AccommodationPlaceRoomBlockStatus>;
};

export type InternalEventSearchCriteria = {
  dateCriteria?: InputMaybe<EventSearchDateCriteria>;
  /**
   * Optional finalized-date filter. Omit to keep current behavior (no filtering).
   * When true, only events whose date is finalized are returned; when false, only non-finalized.
   */
  eventDateIsFinalized?: InputMaybe<Scalars['Boolean']>;
  eventTypes?: InputMaybe<Array<EventType>>;
};

export type EventSearchDateCriteria = {
  endDate?: InputMaybe<Scalars['String']>;
  searchField: EventSearchDateType;
  startDate?: InputMaybe<Scalars['String']>;
};

export enum EventSearchDateType {
  createAt = 'createAt',
  eventDate = 'eventDate',
}

export enum MessageType {
  email = 'email',
  sms = 'sms',
}

/**
 * Search criteria for internal message queries.
 * Supports filtering by recipient, event, message batch, card order, and date range.
 */
export type InternalMessageSearchCriteria = {
  email?: InputMaybe<Scalars['String']>;
  endCreateDate?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  fromEmail?: InputMaybe<Scalars['String']>;
  guestKey?: InputMaybe<Scalars['String']>;
  messageBatchId?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  replyTo?: InputMaybe<Scalars['String']>;
  startCreateDate?: InputMaybe<Scalars['String']>;
  /**
   * The premium digital card order a send belongs to. Same filter as
   * `MessageSearchQueryCriteria.stationeryOrderId`: finds every send of one owned card, across
   * however many batches.
   */
  stationeryOrderId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MessageType>;
};

/** Derived matching readiness state for an inventory place. MATCHED, ZH_ONLY_FINAL, and NUITEE_ONLY_FINAL are considered finalized. Deprecated — read providerPlaces to determine which providers are linked. */
export enum InventoryPlaceMatchingStatus {
  /** Matching is finalized with two or more provider records linked. */
  MATCHED = 'MATCHED',
  /** Matching is finalized for the current data with only a Nuitee provider record. */
  NUITEE_ONLY_FINAL = 'NUITEE_ONLY_FINAL',
  /** Deprecated — no longer emitted. Matching has not completed yet for this row. */
  PENDING = 'PENDING',
  /** Deprecated — no longer emitted. Matching found a candidate that still needs manual review (see hasPendingCandidates). */
  REVIEW = 'REVIEW',
  /** Matching is finalized for the current data with only a ZentrumHub provider record. */
  ZH_ONLY_FINAL = 'ZH_ONLY_FINAL',
}

/** Inventory provider that can contribute a place to a cluster. */
export enum Provider {
  /** Hopper. */
  hopper = 'hopper',
  /** Nuitee. */
  nuitee = 'nuitee',
  /** ZentrumHub. */
  zh = 'zh',
}

export type IsPageContainerSlugAvailablePayload = {
  eventId: Scalars['ID'];
  pageSlug: Scalars['String'];
};

/** Input for listing coupons with optional filtering and pagination. */
export type JoyDiscountCouponsInput = {
  /** Optional filter criteria. */
  filter?: InputMaybe<JoyDiscountCouponsFilterInput>;
  /** Number of results to skip for pagination. */
  skip?: InputMaybe<Scalars['Int']>;
  /** Maximum number of results to return (default 20, max 100). */
  take?: InputMaybe<Scalars['Int']>;
};

/** Filter input for querying a paginated list of JoyDiscountCoupons. */
export type JoyDiscountCouponsFilterInput = {
  /** Filter by discount type. */
  discountType?: InputMaybe<DiscountType>;
  /** Filter by enabled/disabled state. */
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Filter to coupons whose eligibleProducts list contains this product type. */
  productType?: InputMaybe<ProductType>;
  /** Search by coupon name (case-insensitive substring match). */
  search?: InputMaybe<Scalars['String']>;
};

export type JoyPlaceBySourceIdRequest = {
  /** The `eventId` argument is deprecated. Use the `externalPDP` field with the appropriate alternative approach instead. */
  eventId?: InputMaybe<Scalars['ID']>;
  sourceId: Scalars['String'];
  sourceType: Scalars['String'];
};

export type JoyPlacesBySourceIdsRequest = {
  sourceIds: Array<Scalars['String']>;
  sourceType: Scalars['String'];
};

/** Query for the JoyPlaces whose snapshot for a provider is missing or stale. */
export type InternalJoyPlaceIdsNeedingContentUpdateInput = {
  /** The JoyPlace ids to check for missing or stale snapshots. */
  joyPlaceIds: Array<Scalars['ID']>;
  /** The content provider to evaluate freshness against. */
  provider: AccommodationContentSnapshotProvider;
};

export type JsonDataContainerByIdPayload = {
  id: Scalars['ID'];
};

export type LinkRedirectBlockFilter = {
  blockType?: InputMaybe<BlockType>;
  id?: InputMaybe<Scalars['ID']>;
  targetValue?: InputMaybe<Scalars['String']>;
};

export enum BlockType {
  domain = 'domain',
  event = 'event',
  user = 'user',
}

export type LinkRedirectFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  eventId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  joyUrl?: InputMaybe<Scalars['Url']>;
  link?: InputMaybe<Scalars['String']>;
  quarantined?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type LocationSuggestionRequest = {
  countries?: InputMaybe<Array<Scalars['String']>>;
  size?: InputMaybe<Scalars['Float']>;
  term: Scalars['String'];
  types?: InputMaybe<Array<LocationSuggestionType>>;
};

export enum LocationSuggestionType {
  Airport = 'Airport',
  BusStation = 'BusStation',
  City = 'City',
  Country = 'Country',
  Hotel = 'Hotel',
  MultiCity = 'MultiCity',
  Neighborhood = 'Neighborhood',
  PointOfInterest = 'PointOfInterest',
  Region = 'Region',
  State = 'State',
  TrainStation = 'TrainStation',
}

/** Input for querying a paginated list of places that have match candidates marked for review. */
export type MatchCandidatesQueryInput = {
  /** When true (default), return only places that still have unresolved candidates, and include only their unresolved candidates. */
  onlyUnresolved?: InputMaybe<Scalars['Boolean']>;
  /** 1-based page number, counting places/groups (default: 1). */
  page?: InputMaybe<Scalars['Int']>;
  /** Number of places per page (default: 50, max: 200). */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Narrow the queue to one or more review reasons. Omit (or pass null) for every reason; an empty list is rejected rather than silently returning nothing. */
  reasons?: InputMaybe<Array<MatchCandidateReviewReason>>;
  /** Filter candidates by a specific resolution outcome (only relevant when onlyUnresolved is false). */
  resolution?: InputMaybe<MatchCandidateResolution>;
  /** Field used to order the place groups (default: confidence — by each place's highest-confidence candidate). */
  sortBy?: InputMaybe<MatchCandidateSortField>;
  /** Sort direction for the place groups (default: desc). */
  sortDirection?: InputMaybe<MatchCandidateSortDirection>;
};

/** Why a row was sent for review. Spans several subsystems: the matcher's decision cascade, stale-id healing, and google-place-id sync. */
export enum MatchCandidateReviewReason {
  /** Best candidate scored between the review and auto-match thresholds. */
  below_auto_match_threshold = 'below_auto_match_threshold',
  /** Legacy, no longer written. Retained because existing rows still carry it. */
  candidate_already_clustered = 'candidate_already_clustered',
  /** Join collision: the target cluster's slot for the source provider is already filled. */
  cluster_provider_taken = 'cluster_provider_taken',
  /** A mutually-exclusive rival sits within the ambiguity margin of the best candidate. */
  competing_candidates = 'competing_candidates',
  /** Cluster members resolved to different Google Place IDs — a likely false-positive cluster. */
  google_place_id_conflict = 'google_place_id_conflict',
  /** The LLM returned a `review` verdict — evidence present, residual ambiguity. */
  llm_decision = 'llm_decision',
  /** Stale-id healing: the replacement candidate scored below the auto-heal threshold. */
  stale_id_heal_below_threshold = 'stale_id_heal_below_threshold',
  /** Stale-id healing: the replacement belongs to an existing fully-paired cluster. */
  stale_id_heal_cluster_conflict = 'stale_id_heal_cluster_conflict',
  /** Synchronous get-or-create: a lock stayed contended through every retry. */
  synchronous_match_lock_timeout = 'synchronous_match_lock_timeout',
}

/** Outcome of a human resolution for a match candidate. */
export enum MatchCandidateResolution {
  discarded = 'discarded',
  matched = 'matched',
}

/** Field to sort the place review groups by. */
export enum MatchCandidateSortField {
  confidence = 'confidence',
  createdAt = 'createdAt',
}

/** Sort direction for match candidate review queries. */
export enum MatchCandidateSortDirection {
  asc = 'asc',
  desc = 'desc',
}

/** Delivery channel for a draft. One row per channel per batch. */
export enum MessageDraftChannel {
  /** Email payload with JoyJson block structure. */
  email = 'email',
  /** SMS payload stored as structured `{ smsContent, from?, link? }`. */
  sms = 'sms',
}

/**
 * Lifecycle states for a MessageDraft. Only `draft` and `failed` are editable —
 * mutations against other states are rejected. On successful dispatch the row
 * is hard-deleted, so `sent` is transient.
 */
export enum MessageDraftStatus {
  /** Editable; ready to send or schedule. */
  draft = 'draft',
  /** Send failed. Editing resets status back to `draft` so the user can retry. */
  failed = 'failed',
  /** In-flight send; rows are locked from user edits. */
  processing = 'processing',
  /** @deprecated No row ever transitions to this status. Drafts are hard-deleted on send whether or not spam guard flags the batch; quarantine review is owned by QuarantinedMessage + the messaging center and never touches the MessageDraft table. Retained in the enum only to avoid a migration. */
  quarantined = 'quarantined',
  /** Scheduled for future delivery; cron will pick it up at scheduledAt. */
  scheduled = 'scheduled',
  /** Successfully delivered. Rows are hard-deleted on reaching this state. */
  sent = 'sent',
}

export type MessageSearchQueryCriteria = {
  email?: InputMaybe<Scalars['String']>;
  endCreateDate?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  guestKey?: InputMaybe<Scalars['String']>;
  messageBatchId?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  startCreateDate?: InputMaybe<Scalars['String']>;
  /**
   * The premium digital card order a send belongs to. Additive and independent of
   * `messageBatchId`: a batch id finds one send, this finds every send of one owned card,
   * across however many batches. Supplying both narrows to that card's rows within that batch.
   */
  stationeryOrderId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MessageType>;
};

export enum MessageStatus {
  clicked = 'clicked',
  delivered = 'delivered',
  failed = 'failed',
  none = 'none',
  pending = 'pending',
  read = 'read',
  sent = 'sent',
}

export type NearbyAttractionsSearchPayload = {
  metadata: NearbyAttractionsSearchMetadata;
  point: TravelInputPoint;
};

export type NearbyAttractionsSearchMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type TravelInputPoint = {
  accommodationPlaceId?: InputMaybe<Scalars['String']>;
  geoLocation?: InputMaybe<TravelGeoLocation>;
  joyPlaceId?: InputMaybe<Scalars['String']>;
  pointType: TravelInputPointType;
};

export type TravelGeoLocation = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export enum TravelInputPointType {
  accommodationPlace = 'accommodationPlace',
  geoLocation = 'geoLocation',
  joyPlace = 'joyPlace',
}

export enum CheckoutType {
  STRIPE_NATIVE = 'STRIPE_NATIVE',
  VAULTERA_VAULT = 'VAULTERA_VAULT',
}

export enum SwitchNames {
  hopper = 'hopper',
  nuitee = 'nuitee',
  zh = 'zh',
}

export enum TravelOfferRefundability {
  FullyRefundable = 'FullyRefundable',
  NonRefundable = 'NonRefundable',
}

/** How an offer is checked out: a Vaultera vault or Stripe native payment. */
export enum EphemeralCheckoutType {
  stripe_native = 'stripe_native',
  vaultera_vault = 'vaultera_vault',
}

/** The inventory provider (switch) that produced an offer: zh, nuitee, or hopper. */
export enum EphemeralSwitchNames {
  hopper = 'hopper',
  nuitee = 'nuitee',
  zh = 'zh',
}

/**
 * Order lifecycle states - determines how tickets are counted in TicketType.
 *
 * **RESERVED states** (tickets held, count towards reservedCount):
 * - PENDING_PAYMENT: Awaiting payment confirmation
 * - PENDING_APPROVAL: Awaiting manual approval (e.g., for comped tickets)
 *
 * **SOLD state** (tickets confirmed, count towards soldCount):
 * - COMPLETED: Payment confirmed, tickets issued
 *
 * **RELEASED states** (tickets returned to availability pool):
 * - CANCELLED: Order cancelled by user or admin
 * - EXPIRED: Payment window expired
 * - REFUNDED: Payment refunded
 */
export enum OrderStatus {
  /** Released: Order cancelled by user or admin */
  CANCELLED = 'CANCELLED',
  /** Sold: Payment confirmed, tickets issued */
  COMPLETED = 'COMPLETED',
  /** Released: Payment window expired */
  EXPIRED = 'EXPIRED',
  /** Reserved: Awaiting manual approval (e.g., comped tickets) */
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  /** Reserved: Awaiting payment confirmation */
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  /** Released: Payment refunded */
  REFUNDED = 'REFUNDED',
}

/** Status of a ticket. */
export enum TicketStatus {
  CANCELLED = 'CANCELLED',
  CHECKED_IN = 'CHECKED_IN',
  VALID = 'VALID',
}

/** Type of order based on payment requirements. */
export enum OrderType {
  COMPED = 'COMPED',
  FREE = 'FREE',
  PAID = 'PAID',
}

export type PageContainerBySlugOptions = {
  /** View from the Admin Perspective */
  admin?: InputMaybe<Scalars['Boolean']>;
  /**
   * Resolve one specific container when a `systemCustom` and a `userGenerated` page share this
   * slug. Omit it for the default resolution, where `systemCustom` owns the canonical route —
   * pass it only when you mean a particular page (e.g. the admin editor previewing the page it
   * has open). Applied after access filtering, so it can only narrow what the session may already
   * see. `systemLegacy` never describes a container and resolves to null.
   */
  pageKind?: InputMaybe<PageKind>;
};

export type PageContainerBySlugPayload = {
  eventName: Scalars['String'];
  pageSlug: Scalars['String'];
};

/** Why a returning guest cannot complete payment for their unpaid order. */
export enum PendingRegistrationPaymentBlockedReason {
  SALES_CLOSED = 'SALES_CLOSED',
  SALES_NOT_OPEN = 'SALES_NOT_OPEN',
  SOLD_OUT = 'SOLD_OUT',
  TICKET_UNAVAILABLE = 'TICKET_UNAVAILABLE',
}

export type PhotosBySimpleTagsPayload = {
  exclude?: InputMaybe<Array<Scalars['String']>>;
  include: Array<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type GuestNotFoundArgs = {
  buttonLink: Scalars['String'];
  guest: EmailPerson;
  recipient: EmailPerson;
  source?: InputMaybe<Scalars['String']>;
};

export type EmailPerson = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type MessageToHostArgs = {
  guest: EmailPerson;
  message: Scalars['String'];
  recipient: EmailPerson;
};

export type RequestCodeArgs = {
  code: Scalars['String'];
  guest: EmailPerson;
  recipient: EmailPerson;
  website: Scalars['String'];
};

/** A provider's own amounts for one rate, with the currency they are quoted in, in minor units. On Hopper, the pay-now leg only. */
export type ProviderRateInput = {
  /** The provider's room rate, their taxes and fees excluded. Required — it cannot be derived from the total. Must be positive and at most 9007199254740991. Read the response back on valueInMinorUnitsBigInt: valueInMinorUnits is a 32-bit Int, and the response amounts exceed this input by Joy's commission adjustment and markup. */
  baseAmountInMinorUnits: Scalars['BigInt'];
  /** The commission the provider states as already inside their base. Send it for a commission-adjustable provider, using 0 rather than null when that provider states none; omit it otherwise. At most 9007199254740991. */
  commissionAmountInMinorUnits?: InputMaybe<Scalars['BigInt']>;
  /** The currency the amounts are quoted in. Must match the offer's own currency where it has one; used directly where it does not. */
  currencyCode: TravelCurrencyCode;
  /** The provider's whole-stay total — the room plus the taxes and fees they charge. Must be positive, at most 9007199254740991, and cannot be below the base, which it contains. Read the response back on valueInMinorUnitsBigInt: valueInMinorUnits is a 32-bit Int, and the response amounts exceed this input by Joy's commission, fees and markup. */
  totalAmountInMinorUnits: Scalars['BigInt'];
};

export enum FeeType {
  payment_processing_fee = 'payment_processing_fee',
}

export type TravelPricingsForAccommodationByRegionPayload = {
  accommodationSearchType?: InputMaybe<AccommodationSearchType>;
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsForAccommodationByRegionPayloadMetaData>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  region: AccommodationCatalogRegionInput;
};

/** AccommodationSearchType */
export enum AccommodationSearchType {
  ALL = 'ALL',
}

export type TravelPricingsForAccommodationByRegionPayloadMetaData = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

/** Different ways to give a search region, only one of the fields should be non-null */
export type AccommodationCatalogRegionInput = {
  circular?: InputMaybe<AccommodationCatalogRegionCircularInput>;
};

export type TravelPricingsForAccommodationByRegionV20250708Payload = {
  accommodationSearchType?: InputMaybe<AccommodationSearchType>;
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  executionSpeed?: InputMaybe<ExecutionSpeed>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsForAccommodationByRegionV20250708PayloadMetaData>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  region: AccommodationCatalogRegionInput;
};

/** Execution speed of the query, SLOW = 15s, NORMAL = 10s, FAST = 6s, FASTEST = 3s */
export enum ExecutionSpeed {
  FAST = 'FAST',
  FASTEST = 'FASTEST',
  NORMAL = 'NORMAL',
  SLOW = 'SLOW',
}

export type TravelPricingsForAccommodationByRegionV20250708PayloadMetaData = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type ProductCatalogBrandsDirectoryQueryInput = {
  /** the category locator */
  category?: InputMaybe<Scalars['String']>;
  /** filter by storefront */
  storefront?: InputMaybe<CatalogStorefront>;
  /**
   * The category URL which ends with the category locator.
   * ie; /shop/brands/:CATEGORY_LOCATOR
   */
  url?: InputMaybe<Scalars['String']>;
};

export enum CatalogStorefront {
  baby = 'baby',
  wedding = 'wedding',
}

/** Reference to a ProductCatalogDisplayInfo, which doesn't have an ID and must be referenced by its displayInfoId and pdpSectionType */
export type ProductCatalogDisplayInfoRef = {
  displayInfoId: Scalars['ID'];
  pdpSectionType: Scalars['String'];
};

export type ProductCatalogItemRecommendationInput = {
  productUrl: Scalars['String'];
};

/** The order that input fields are evaluated is undefined and subject to change in the future */
export type ProductCatalogSearchQueryInput = {
  brandId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Payload for Filter, Search & Sort (FSS) criteria */
  filters?: InputMaybe<ProductCatalogSearchQueryFiltersInput>;
  /**
   * A Category or Item Locator.
   * Other types of Locators (eg. Brand) are not supported by the search logic.
   * NOTE:  A Curation is considered a Category.
   */
  locator?: InputMaybe<Scalars['String']>;
  /**
   * Criteria for sorting.
   * If null, the default is the first value in the 'ProductCatalogSearchQueryOrderBy' enum.
   */
  orderBy?: InputMaybe<ProductCatalogSearchQueryOrderBy>;
  type?: InputMaybe<CatalogTreeRootInput>;
  /**
   * A site URL.
   * The search logic supports URLs for Category, Item, Brand (since they can be differentiated by path structure)
   */
  url?: InputMaybe<Scalars['String']>;
};

/** Criteria for Filter, Search & Sort (FSS) */
export type ProductCatalogSearchQueryFiltersInput = {
  /**
   * Criteria for Filter by Attributes.
   *
   * Each Selection Group in the input is AND-ed into the resulting query.
   * Example: ('brand:kitchenaid' AND 'color:red'):
   *
   * filterSelectionGroups: [
   *   [ { groupCode: "brand", valueCodes: [ "kitchenaid" ] } ]
   *   [ { groupCode: "color", valueCodes: [ "red" ] } ]
   * ]
   */
  filterSelectionGroups?: InputMaybe<Array<ProductCatalogSearchQueryFiltersSelectionGroupInput>>;
  /** Criteria for full-text Search */
  queryText?: InputMaybe<Scalars['String']>;
};

/** Criteria for Filter by Attributes (part of FSS) */
export type ProductCatalogSearchQueryFiltersSelectionGroupInput = {
  /** A unique Attribute Group code */
  groupCode: Scalars['String'];
  /** OR */
  priceRange?: InputMaybe<ProductCatalogSearchQueryFiltersSelectionGroupMonetaryRangeInput>;
  /**
   * One or more unique Attribute Value codes.
   *
   * Each Attribute Value in the input is OR-ed into the resulting query.
   * Example: ('size:small' OR 'size:medium'):
   *
   * {
   *   groupCode: "size",
   *   valueCodes: [ "small", "medium" ]
   * }
   */
  valueCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type ProductCatalogSearchQueryFiltersSelectionGroupMonetaryRangeInput = {
  maxValueInMinorUnits?: InputMaybe<Scalars['Int']>;
  minValueInMinorUnits?: InputMaybe<Scalars['Int']>;
};

/**
 * Possible sorting options.
 * Client should display the enum values in the same order.
 */
export enum ProductCatalogSearchQueryOrderBy {
  featured = 'featured',
  newArrivals = 'newArrivals',
  priceAsc = 'priceAsc',
  priceDesc = 'priceDesc',
}

export type ProductExternalSearchQueryInput = {
  text: Scalars['String'];
};

export type ProductHeroContentInputCriteria = {
  storefront?: InputMaybe<CatalogStorefront>;
};

export enum ProductHeroRedirectUrlType {
  external = 'external',
  inApp = 'inApp',
}

export enum ProductHeroGradientMode {
  custom = 'custom',
  dark = 'dark',
  light = 'light',
  none = 'none',
}

export enum ProductHeroHorizontalAlignment {
  center = 'center',
  left = 'left',
  right = 'right',
}

export enum ProductHeroTextColorMode {
  custom = 'custom',
  dark = 'dark',
  light = 'light',
}

export type ProductInventoryByCatalogItemIdInput = {
  catalogItemId: Scalars['ID'];
  reasonCode?: InputMaybe<InventoryCheckReasonCode>;
};

export enum InventoryCheckReasonCode {
  buyForSelfAvailability = 'buyForSelfAvailability',
  checkoutMechanismsRequest = 'checkoutMechanismsRequest',
  completionDiscount = 'completionDiscount',
  productInventoryRequest = 'productInventoryRequest',
  salesOrderCreation = 'salesOrderCreation',
  salesOrderFulfillment = 'salesOrderFulfillment',
}

/** @Deprecated */
export type ProductUniversalSearchQueryInput = {
  text: Scalars['String'];
};

/** Specifies how many results to return for a given source. */
export type ProductUniversalSearchSourceLimit = {
  /** Maximum number of results for a given source. */
  limit: Scalars['Int'];
  source: ProductUniversalItemSource;
};

export enum ProductUniversalItemSource {
  catalogSearch = 'catalogSearch',
  googleSearch = 'googleSearch',
  googleShoppingRegular = 'googleShoppingRegular',
  googleShoppingSponsored = 'googleShoppingSponsored',
}

/** Input for looking up a specific promotion code by its string value. */
export type PromotionCodeByCodeInput = {
  /** The promotion code string to look up. */
  code: Scalars['String'];
  /** The product type to validate eligibility against. */
  productType: ProductType;
};

/** Sale status for a public ticket type — computed from capacity and sales dates. */
export enum TicketTypeSaleStatus {
  /** Sales have not started yet */
  NOT_YET_ON_SALE = 'NOT_YET_ON_SALE',
  /** Tickets are available for purchase */
  ON_SALE = 'ON_SALE',
  /** Sales have ended */
  SALE_ENDED = 'SALE_ENDED',
  /** All available capacity has been sold or reserved */
  SOLD_OUT = 'SOLD_OUT',
}

/** Query for the best date-aware rate snapshot per JoyPlace. */
export type InternalRateSnapshotsByJoyPlaceIdsInput = {
  /** Target check-in date (YYYY-MM-DD); enables date-aware ranking when provided. */
  checkInDate?: InputMaybe<Scalars['DateOnlyString']>;
  /** Fuzzy match window in days around the check-in date (defaults to 365). */
  dateRangeDays?: InputMaybe<Scalars['Int']>;
  /** The JoyPlace ids to fetch rate snapshots for. */
  joyPlaceIds: Array<Scalars['ID']>;
  /** Preferred length of stay (nights) for exact-match ranking. */
  los?: InputMaybe<Scalars['Int']>;
  /** Preferred occupancy key (e.g. "A2C0") for exact-match ranking. */
  occupancyKey?: InputMaybe<Scalars['String']>;
};

/** Rate provider that produced a travel rate snapshot. */
export enum TravelRateSnapshotProvider {
  hopper = 'hopper',
  nuitee = 'nuitee',
  zh = 'zh',
}

export type RecentTravelReservationsByEventPayload = {
  eventId: Scalars['String'];
};

export type RegistryCatalogInventoryInput = {
  catalogItemId: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
};

/** Identifies the event whose tax destination to resolve, and optionally where to resolve it to. */
export type RegistryEventTaxDestinationInput = {
  /**
   * Overrides the destination Commerce would otherwise resolve for the event — pass the address
   * the goods are actually headed to. Omit it to let Commerce's own fallback chain choose.
   */
  address?: InputMaybe<RegistryEventTaxDestinationAddressInput>;
  /** Event whose tax destination to resolve. The caller must be authorized to read this event. */
  eventId: Scalars['ID'];
};

/**
 * Address override used to resolve an event's tax destination. Every field is a jurisdiction
 * input; street-level detail is deliberately absent, because tax resolves no finer than
 * country / state / postal code / city.
 */
export type RegistryEventTaxDestinationAddressInput = {
  /** City or locality */
  city?: InputMaybe<Scalars['String']>;
  /**
   * ISO 3166-1 alpha-3 country code (e.g. "USA", not "US"). Commerce rejects alpha-2 with a
   * BadRequestError.
   */
  countryCode: Scalars['String'];
  /**
   * Postal or ZIP code. The most precise input available, and the one that decides the answer
   * wherever rates vary below city level.
   */
  postalCode?: InputMaybe<Scalars['String']>;
  /** State, province, or region. Null when the country has no tax-relevant subdivision. */
  state?: InputMaybe<Scalars['String']>;
};

/**
 * A rule that defines an audience. Version 1 carries exactly one predicate.
 * `params` is resolver-specific and is validated against the named resolver, so
 * an unknown resolver or a bad param shape is rejected here rather than at send
 * time.
 */
export type SmartTagRuleInput = {
  /**
   * Resolver-specific arguments, validated against the named resolver's own
   * schema, e.g. `{ "status": "attending" }` for `rsvp-state`. Send `{}` for a
   * resolver that takes none.
   */
  params: Scalars['JSON'];
  /** Name of the resolver that answers this audience, e.g. `rsvp-state`. Must be one the event's guest-list system implements — see `smartTagAudiences`. */
  resolver: Scalars['String'];
  /** Rule format version. Only `1` is accepted today; an unknown version is rejected rather than coerced. */
  version: Scalars['Int'];
};

/** Which guest-list system owns an event's RSVP and tag data. */
export enum SmartTagSystem {
  legacy = 'legacy',
  new = 'new',
}

/** Input for scanning a QR code. Returns ticket details without checking in. */
export type ScanTicketInput = {
  /** Event ID the ticket belongs to */
  eventId: Scalars['ID'];
  /** QR payload from the scanned PKPass barcode */
  qrPayload: Scalars['String'];
};

export type AccommodationContentSearchInput = {
  circularRegionSearch?: InputMaybe<AccommodationCatalogRegionCircularInput>;
  maxResults?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<AccommodationContentSearchInputMetadata>;
  propertyIdentifiers?: InputMaybe<Array<AccommodationCatalogPropertyIdentifierInput>>;
};

export type AccommodationContentSearchInputMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type SearchCarOfferReservationsPayload = {
  /** Joy-prefixed or raw booking ID (e.g. JOY-HZ-L592A8688D3 or L592A8688D3) */
  bookingId?: InputMaybe<Scalars['String']>;
  /** Email address associated with the car reservation */
  email?: InputMaybe<Scalars['String']>;
};

export type ExtendedAccommodationContentSearchPayload = {
  currencyCode?: InputMaybe<TravelCurrencyCode>;
  /** Strategy for fetching accommodation content: cacheOnly (no API calls), preferCache (selective fields if cache miss), preferVendor (full fields from API). Default: preferVendor. */
  fetchStrategy?: InputMaybe<FetchStrategy>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  /** How many properties the geo query may return before scoring and ranking. Defaults to 300; must be between 1 and 1000. See searchExtendedAccommodationPropertiesV2.limit for the full rationale — same semantics here. */
  limit?: InputMaybe<Scalars['Int']>;
  location: ExtendedAccommodationCatalogSearchLocation;
  /** How many sponsored properties this surface has room for, 0-10. Capped by the contracted slot count configured server-side: sending a larger number yields the configured count, not this one. Omit (or send 0) to receive no sponsored properties at all — send 10 to ask for the full configured count. */
  maxSponsoredSlots?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<ExtendedAccommodationContentSearchMetadata>;
  occupancies?: InputMaybe<AccommodationCatalogUnitsOccupancyInput>;
  /** Curated tags to filter the results to (e.g. "honeymoon"), from the `?prioritizeTag=` query params. Only properties carrying one of these tags are returned, ordered by curated rank, and the search widens from the venue radius to the searched destination. Unknown tag values match nothing, so the result is empty. */
  prioritizeTags?: InputMaybe<Array<Scalars['String']>>;
  radiusKM?: InputMaybe<Scalars['Float']>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  stayDates: AccommodationCatalogStayDatesInput;
  /** When true, skips cached pricing and fetches real-time pricing from providers. Default: false (uses cache for faster response). */
  useRealtimePricing?: InputMaybe<Scalars['Boolean']>;
};

/** Strategy for fetching accommodation content from cache vs vendor API */
export enum FetchStrategy {
  CACHE_ONLY = 'CACHE_ONLY',
  PREFER_CACHE = 'PREFER_CACHE',
  PREFER_VENDOR = 'PREFER_VENDOR',
}

export type ExtendedAccommodationCatalogSearchLocation = {
  /** Context of the location */
  context?: InputMaybe<ExtendedAccommodationCatalogSearchLocationContext>;
  /** Latitude in DD (Decimal Degrees) format. +ve is N and -ve is S of Equator */
  latitude: Scalars['Float'];
  /** Longitude in DD (Decimal Degrees) format, +ve is E and -ve is W of Meridian */
  longitude: Scalars['Float'];
};

export type ExtendedAccommodationCatalogSearchLocationContext = {
  /** Google Place ID of the location */
  googlePlaceId?: InputMaybe<Scalars['String']>;
};

export type ExtendedAccommodationContentSearchMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  preferredProviderType?: InputMaybe<PreferredHotelProviderType>;
  priceComparisonPayload?: InputMaybe<PriceComparisonPayload>;
  userCountryCode?: InputMaybe<Scalars['String']>;
};

/** PreferredHotelProviderType */
export enum PreferredHotelProviderType {
  hotels = 'hotels',
  joynativecheckout = 'joynativecheckout',
  stays = 'stays',
}

export type PriceComparisonPayload = {
  comparisonType?: InputMaybe<PriceComparisonType>;
  metadata?: InputMaybe<PriceComparisonPayloadMetaData>;
  preferredProvider?: InputMaybe<PreferredHotelProviderType>;
  preferredProviderPriceMaxExtraPercent?: InputMaybe<Scalars['Float']>;
};

/** PriceComparisonType */
export enum PriceComparisonType {
  basePrice = 'basePrice',
  perNightBasePrice = 'perNightBasePrice',
  perNightTotalPrice = 'perNightTotalPrice',
  totalPrice = 'totalPrice',
}

export type PriceComparisonPayloadMetaData = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export enum ScoringPriorityField {
  distanceFromSearchLocation = 'distanceFromSearchLocation',
  price = 'price',
  standardRoomPriceDiscountPercent = 'standardRoomPriceDiscountPercent',
  starRating = 'starRating',
  usedByEventsCount = 'usedByEventsCount',
  userRating = 'userRating',
}

export enum TravelOfferWalletSpendCoverage {
  /** The fund pays all of it; no card charge is needed. */
  FULL = 'FULL',
  /** The fund pays nothing here — run the existing card-only checkout flow. */
  NONE = 'NONE',
  /** The fund pays part and the card pays the rest; both legs are above zero. */
  PARTIAL = 'PARTIAL',
}

export enum TravelOfferWalletSpendIneligibleReason {
  /** The cash fund's currency differs from this booking's, so it cannot pay for it. */
  CURRENCY_MISMATCH = 'CURRENCY_MISMATCH',
  /** The fund has no spendable money right now. */
  NO_SPENDABLE_BALANCE = 'NO_SPENDABLE_BALANCE',
}

export type SearchExtendedAccommodationPropertiesV2Payload = {
  customSearchParams?: InputMaybe<SearchExtendedAccommodationPropertiesV2CustomSearchParams>;
  /** The couple's event, used only to DEFAULT the search: venue location, dates derived from the wedding date, and currency from the event country. Omit it for a public search that carries no event (e.g. the honeymoon page) — `customSearchParams.location` and `stayDates` then become required, since there is nothing to fall back on. */
  eventHandle?: InputMaybe<Scalars['String']>;
};

export type SearchExtendedAccommodationPropertiesV2CustomSearchParams = {
  currencyCode?: InputMaybe<TravelCurrencyCode>;
  /** Strategy for fetching accommodation content: cacheOnly (no API calls), preferCache (selective fields if cache miss), preferVendor (full fields from API). Default: preferCache. */
  fetchStrategy?: InputMaybe<FetchStrategy>;
  /** Whether fees should be included in totalAmount. If not provided, defaults to false in code */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  /** How many properties the geo query may return before scoring and ranking. Defaults to 300; must be between 1 and 1000. Raise it only for a search that needs candidates the default page cannot reach. Note `prioritizeTags` filters the geo query itself: only tagged properties are selected, by curated rank, before this limit applies, and a distant tagged hotel CAN be a candidate; an untagged one never is. Costs pricing fan-out: every extra property is priced within the same batch timeout budget, so a wider page can leave more properties unpriced. */
  limit?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<ExtendedAccommodationCatalogSearchLocation>;
  /** How many sponsored properties this surface has room for, 0-10. Capped by the contracted slot count configured server-side: sending a larger number yields the configured count, not this one. Omit (or send 0) to receive no sponsored properties at all — send 10 to ask for the full configured count. */
  maxSponsoredSlots?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<ExtendedAccommodationContentSearchMetadata>;
  occupancies?: InputMaybe<AccommodationCatalogUnitsOccupancyInput>;
  /** Curated tags to filter the results to (e.g. "honeymoon"), from the `?prioritizeTag=` query params. Only properties carrying one of these tags are returned, ordered by curated rank, and the search widens from the venue radius to the searched destination. Unknown tag values match nothing, so the result is empty. */
  prioritizeTags?: InputMaybe<Array<Scalars['String']>>;
  radiusKM?: InputMaybe<Scalars['Int']>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  stayDates?: InputMaybe<AccommodationCatalogStayDatesInput>;
  /** When true, skips cached pricing and fetches real-time pricing from providers. Default: false (uses cache for faster response). */
  useRealtimePricing?: InputMaybe<Scalars['Boolean']>;
};

export type ServiceTagSearch = {
  tagName: Scalars['String'];
};

export type SearchPayload = {
  type?: InputMaybe<VendorTypeEnum>;
};

export type SearchTravelOfferReservationsPayload = {
  bookingId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
};

export enum OTAProvider {
  hopper = 'hopper',
  joyNative = 'joyNative',
  nuitee = 'nuitee',
  zh = 'zh',
}

export enum TravelOfferReservationCancellationPolicyRuleValueType {
  Amount = 'Amount',
  Nights = 'Nights',
  Percentage = 'Percentage',
}

export enum TravelOfferReservationRefundability {
  FullyRefundable = 'FullyRefundable',
  NonRefundable = 'NonRefundable',
  PartiallyRefundable = 'PartiallyRefundable',
}

/** Why a field cannot be changed on this booking right now. Always describes the booking, never the supplier behind it. */
export enum ModificationUnavailableReason {
  /** The booking is cancelled, still in flight, or never reached the point of being changeable. Nothing on it can be edited. */
  BOOKING_NOT_ACTIVE = 'BOOKING_NOT_ACTIVE',
  /** The rate's cancellation penalty has already started, so a change would cost the guest money. Nothing produces this yet — whether a change is allowed inside the penalty window is still open with Product. */
  INSIDE_PENALTY_WINDOW = 'INSIDE_PENALTY_WINDOW',
  /** This booking has no route for changing this field at all. A permanent answer for this booking, not a temporary one — do not offer a retry. */
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  /** The field is normally changeable but cannot be changed at this moment. Retrying later is reasonable. Nothing produces this yet. */
  TEMPORARILY_UNAVAILABLE = 'TEMPORARILY_UNAVAILABLE',
  /** Arrival is too near for a change to reach the property in useful time. Applies to every field, including the ones that cost nothing to change. */
  TOO_CLOSE_TO_CHECK_IN = 'TOO_CLOSE_TO_CHECK_IN',
}

export enum RateLockStatus {
  /** The room is held and the card is authorized but not charged. The only state with actions: show the countdown to lockExpiresAt, and offer confirm and release. Silence ends in cancellation. */
  active = 'active',
  /** The room is being released, either because the guest asked or because the hold expired. Show progress, offer no actions. */
  cancelling = 'cancelling',
  /** The hold became a real booking and the card was charged. Hand off to the ordinary booking confirmation screen — there is nothing rate-lock-specific left to say. */
  confirmed = 'confirmed',
  /** The guest confirmed and the capture is in flight. Show progress, offer no actions. Distinct from `cancelling` because the two need different copy and a guest who reloads mid-flight lands in one of them. */
  confirming = 'confirming',
  /** The 48 hours ran out and the room was released. Same guest outcome whether or not Joy paid a cancellation fee. Offer a path to rebook at today’s price. */
  expired = 'expired',
  /** The release did not complete and the room may still be booked. Deliberately NOT reported as released, which would be false. Point the guest at support rather than at a rebook flow. */
  failed = 'failed',
  /** The guest gave the room up before it expired. Covers the case where Joy absorbed a cancellation fee: that cost is Joy’s, not the guest’s, so it is not a different thing to tell them. */
  released = 'released',
}

export enum TravelReservationGuestAgeClassification {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
}

export enum TravelReservationGuestTitle {
  MR = 'MR',
  MRS = 'MRS',
  MS = 'MS',
}

export enum VerificationType {
  /** The guest already has a hotel booking held under fraud review (joyFulfillmentStatus=pending_confirmation): the hotel confirmed the reservation but Stripe capture and the confirmation email were deferred pending LLM evaluation, so the guest never received confirmation and retried. Show a "your booking is being reviewed" modal instead. */
  booking_processing = 'booking_processing',
  /** A recent booking at the same property was detected for this guest. Show a "you may already have a booking" confirmation modal. */
  duplicate_booking = 'duplicate_booking',
}

/** Unified payload for searchTravelReservations — returns both hotel and car reservations matching the provided email and Joy booking ID. Both fields are required. */
export type SearchTravelReservationsPayload = {
  bookingId: Scalars['String'];
  email: Scalars['String'];
};

/** A delivery channel. */
export enum SmsChannel {
  sms = 'sms',
  whatsapp = 'whatsapp',
}

export type StationeryPrintOrdersFiltersInput = {
  category?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['ID']>;
  eventName?: InputMaybe<Scalars['String']>;
  /** Only applies to stationeryPrintOrders. When true, Joy Feature vendor orders (e.g. joy_messaging_plus) are included instead of excluded. */
  includeJoyFeatureVendors?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<StationeryPrintOrdersOrderByFields>;
  ownerId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<StationeryPrintOrderStatusEnum>;
  statusList?: InputMaybe<Array<StationeryPrintOrderStatusEnum>>;
  type?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  /** Only applies to stationeryAllOrders. Ignored by stationeryPrintOrders (which hardcodes its own vendor exclusion). */
  vendorList?: InputMaybe<Array<StationeryPrintOrderVendorEnum>>;
};

export type StationeryPrintOrdersOrderByFields = {
  direction?: InputMaybe<StationeryPrintOrdersOrderByDirection>;
  field?: InputMaybe<StationeryPrintOrdersOrderByField>;
};

export enum StationeryPrintOrdersOrderByDirection {
  asc = 'asc',
  desc = 'desc',
}

export enum StationeryPrintOrdersOrderByField {
  createdAt = 'createdAt',
  currentStatus = 'currentStatus',
}

export enum StationeryPrintOrderStatusEnum {
  canceled = 'canceled',
  complete = 'complete',
  delivered = 'delivered',
  error = 'error',
  init = 'init',
  inProgress = 'inProgress',
  paid = 'paid',
  paused = 'paused',
  queued = 'queued',
  readyToShip = 'readyToShip',
  refunded = 'refunded',
  sent = 'sent',
  shipped = 'shipped',
}

export enum StationeryPrintOrderVendorEnum {
  joy_digital = 'joy_digital',
  joy_live_slideshow = 'joy_live_slideshow',
  joy_messaging_plus = 'joy_messaging_plus',
  joy_photos_gold = 'joy_photos_gold',
  joy_photos_gold_to_platinum = 'joy_photos_gold_to_platinum',
  joy_photos_platinum = 'joy_photos_platinum',
  joy_photos_storage_extension = 'joy_photos_storage_extension',
  joy_photos_upload_extension = 'joy_photos_upload_extension',
  joy_rsvp_plus = 'joy_rsvp_plus',
  joy_seating_chart = 'joy_seating_chart',
  paperlust = 'paperlust',
  taylor = 'taylor',
  taylor_mm = 'taylor_mm',
}

export type StationeryPrintOrdersPaginationInput = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export enum StationeryDraftFormat {
  digital = 'digital',
  print = 'print',
}

export enum StationeryTemplateCategoryEnum {
  enclosure = 'enclosure',
  /**
   * The standalone-envelope PRODUCT, not a design category. Backs one hidden
   * carrier template that a card-less envelope draft points at; the envelope
   * artwork stays under the internal envelope_return / envelope_recipient
   * categories. Public because the cart serialises a draft's template category
   * through this non-null enum (see toGQLTemplateCategory), and those two are
   * deliberately not public.
   */
  envelope = 'envelope',
  holiday = 'holiday',
  invitation = 'invitation',
  menu = 'menu',
  monogram = 'monogram',
  napkin = 'napkin',
  saveTheDate = 'saveTheDate',
  sign = 'sign',
  thankYou = 'thankYou',
}

export enum StationeryPrintOrderDeliveryMethodEnum {
  express = 'express',
  fedex_international_economy = 'fedex_international_economy',
  free = 'free',
  mail_innovations_expedited_parcel = 'mail_innovations_expedited_parcel',
  mail_innovations_standard_flat = 'mail_innovations_standard_flat',
  standard = 'standard',
  /** The same as `ups_express_saver` but more readable. */
  ups_canada_express_saver = 'ups_canada_express_saver',
  ups_express_saver = 'ups_express_saver',
  ups_ground_canada_standard = 'ups_ground_canada_standard',
  ups_international_express_saver = 'ups_international_express_saver',
  usps_international_first_class = 'usps_international_first_class',
}

export enum StationeryPrintOrderIssueTarget {
  cx = 'cx',
  user = 'user',
}

export enum StationeryPrintOrderIssueType {
  quality_control = 'quality_control',
  recipient_address_incomplete = 'recipient_address_incomplete',
}

export enum StationeryPrintOrderStateEnum {
  canceled = 'canceled',
  valid = 'valid',
}

export type GetStationeryDigitalViewInput = {
  cardId?: InputMaybe<Scalars['String']>;
  personIds?: InputMaybe<Array<Scalars['String']>>;
};

export enum StationeryDigitalViewSource {
  copy = 'copy',
  email = 'email',
  link = 'link',
  none = 'none',
  sms = 'sms',
  whatsapp = 'whatsapp',
}

export type StationeryDraftsByEventInput = {
  eventId: Scalars['String'];
};

export type StationeryPrintOrdersByEventInput = {
  eventId: Scalars['String'];
};

export type StationeryTemplateFilter = {
  approved?: InputMaybe<Scalars['Boolean']>;
  /** Performs "OR" operation on the categories. */
  categories?: InputMaybe<Array<StationeryTemplateCategoryEnum>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Performs "OR" operation on the eventIdsFavorites. */
  eventIdsFavorites?: InputMaybe<Array<Scalars['ID']>>;
  heightInches?: InputMaybe<Scalars['Float']>;
  ownerIdFavorites?: InputMaybe<Scalars['ID']>;
  side?: InputMaybe<Scalars['String']>;
  /** Performs "OR" operation on the tags. */
  tags?: InputMaybe<Array<Scalars['String']>>;
  /** Performs "OR" operation on the themeIds. */
  themeIds?: InputMaybe<Array<Scalars['ID']>>;
  widthInches?: InputMaybe<Scalars['Float']>;
};

/**
 * Favorites can not only be created in single user-scope, but also in event-scope.
 * That option allows for fine-grained control on: "how to derive the information about my favorites."
 * e.g. I want to look at all templates, but only show favorites that I have personally added to favorites (vs. the whole event / or in many events).
 */
export type StationeryTemplateIncludeOptions = {
  includeFavoritesByEventIds?: InputMaybe<Array<Scalars['ID']>>;
  includeFavoritesByOwnerId?: InputMaybe<Scalars['ID']>;
  includeProducts?: InputMaybe<Scalars['Boolean']>;
};

export type StationeryTemplateOrderBy = {
  direction: StationeryTemplateOrderDirection;
  field: StationeryTemplateOrderField;
};

export enum StationeryTemplateOrderDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum StationeryTemplateOrderField {
  MY_FAVORITES = 'MY_FAVORITES',
}

export type SuggestedVendorPayload = {
  count: Scalars['Int'];
  idsToExclude?: InputMaybe<Array<Scalars['ID']>>;
};

export type SuggestionGroupByVendorTypePayload = {
  vendorType: VendorTypeEnum;
};

/** Which messaging transport an action or a lookup applies to */
export enum MessagingChannel {
  rcs = 'rcs',
  sms = 'sms',
  whatsapp = 'whatsapp',
}

/** Which family of messages a suppression applies to. `all_messaging` covers every family, including families added after the row was written. */
export enum MessagingScope {
  all_messaging = 'all_messaging',
  event_sms_guest = 'event_sms_guest',
  joy_sms_guest = 'joy_sms_guest',
  joy_sms_host = 'joy_sms_host',
}

export type SyntheticCollectionByIdsPayload = {
  collectionIds: Array<Scalars['String']>;
  name: Scalars['String'];
};

export type SyntheticCollectionByNamesPayload = {
  name: Scalars['String'];
  names: Array<Scalars['String']>;
};

/** Where seats are placed (table-relative). Round/rect/square only; grid uses full/staggered elsewhere. */
export enum Arrangement {
  bottom = 'bottom',
  full = 'full',
  left = 'left',
  right = 'right',
  top = 'top',
}

/** Table shape. Grid is used for seating_tables (ceremony/theater), not templates. */
export enum TableShape {
  rectangle = 'rectangle',
  round = 'round',
  square = 'square',
}

export enum AiModelVersion {
  gpt35turboInstruct = 'gpt35turboInstruct',
  /** Chat model (Chat Completions API). Follows formatting rules that gpt-3.5-turbo-instruct ignores; ~6x cheaper per generation. Used by gift wrap notes. */
  gpt4oMini = 'gpt4oMini',
  /** @deprecated No longer supported */
  textDavinci003 = 'textDavinci003',
}

export type PayloadStrings = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export enum PromptType {
  LoveStoryForWeddingWebsite = 'LoveStoryForWeddingWebsite',
  PoliteDeclineToAnInvitation = 'PoliteDeclineToAnInvitation',
  RegistryGiftSuggestions = 'RegistryGiftSuggestions',
  ThankYouNote = 'ThankYouNote',
  WeddingHashtagIdeas = 'WeddingHashtagIdeas',
  WeddingToastSpeech = 'WeddingToastSpeech',
  WeddingVows = 'WeddingVows',
}

export enum TransitionalRegistryStatus {
  failed = 'failed',
  inProgress = 'inProgress',
  ready = 'ready',
}

export type TravelAlertSubscriptionQueryInputV1 = {
  anonymousId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export enum TravelAlertSubscriptionSourceV1 {
  ACCOMMODATIONS = 'ACCOMMODATIONS',
  GUEST_GUIDE = 'GUEST_GUIDE',
}

export enum TravelAlertSubscriptionStatusV1 {
  ACTIVE = 'ACTIVE',
  OPTED_OUT = 'OPTED_OUT',
  PAUSED = 'PAUSED',
}

export enum TravelAlertTriggerTypeV1 {
  BOOKING_WINDOW = 'BOOKING_WINDOW',
  INVENTORY_LOW = 'INVENTORY_LOW',
  PRICE_DROP = 'PRICE_DROP',
  PRICE_INCREASE = 'PRICE_INCREASE',
}

/** Lookup payload for the checkout event log of a single Joy event. */
export type TravelCheckoutEventLogByEventPayload = {
  /** The Joy event (wedding website) whose checkout event log to retrieve. */
  eventId: Scalars['ID'];
};

/** Discrete user actions during the travel checkout flow. */
export enum TravelCheckoutEventActionDtoEnum {
  BOOK_BUTTON_PRESSED = 'BOOK_BUTTON_PRESSED',
  REVIEW_BUTTON_PRESSED = 'REVIEW_BUTTON_PRESSED',
}

/** Lookup payload for the checkout event log of a single reservation. */
export type TravelCheckoutEventLogByReservationPayload = {
  /** The reservation whose checkout event log to retrieve. */
  reservationId: Scalars['ID'];
};

export type TravelDistancesBetweenPointsPayload = {
  endingPoint: TravelInputPoint;
  startingPoint: TravelInputPoint;
};

export type TravelDistancesFromOriginPayload = {
  destinations: Array<TravelInputPoint>;
  origin: TravelInputPoint;
};

export type TravelOfferFromOfferTokenParams = {
  locale?: InputMaybe<Scalars['String']>;
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export enum TravelOfferDistributionType {
  Corporate = 'Corporate',
  Distribution = 'Distribution',
  Member = 'Member',
  Unknown = 'Unknown',
}

export enum RateLockIneligibleReasonDtoEnum {
  CANCELLATION_WINDOW_TOO_SHORT = 'CANCELLATION_WINDOW_TOO_SHORT',
  MULTI_ROOM_UNSUPPORTED = 'MULTI_ROOM_UNSUPPORTED',
  NOT_REFUNDABLE = 'NOT_REFUNDABLE',
  PRICE_UNAVAILABLE = 'PRICE_UNAVAILABLE',
  SCARCE_INVENTORY = 'SCARCE_INVENTORY',
}

export type TravelOffersForAccommodationByRegionPayload = {
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelOffersForAccommodationByRegionPayloadMetaData>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  /** default pagination: { limit: 20, offset: 0 } */
  pagination?: InputMaybe<Pagination>;
  region: AccommodationCatalogRegionInput;
};

export type TravelOffersForAccommodationByRegionPayloadMetaData = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type Pagination = {
  limit: Scalars['Float'];
  offset: Scalars['Float'];
};

export type TravelOffersForAccommodationForPropertiesPayload = {
  anonymousId?: InputMaybe<Scalars['String']>;
  /**
   * Names the guest page that made this request. Telemetry facets on it.
   *
   * Values joy-web sends, derived from the route:
   * - guest_accommodation — the couple's accommodations list. Also reports for the hotel detail page today, because the route matcher has no branch for it. TRAV-4173 splits these into one value per page.
   * - admin_accommodation — the couple previewing the accommodations list in the editor.
   *
   * Keep values flat: one per page. Never combine two axes into a single value, such as a page and the thing it was showing. The field is a plain String, so a new page needs a new value and no schema change.
   *
   * Omit the field rather than guessing a value. travel_service then applies its own, and sets its own value on requests it makes internally.
   */
  callSource?: InputMaybe<Scalars['String']>;
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  locale?: Scalars['String'];
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  offerProvider?: InputMaybe<TravelOfferProvider>;
  propertyIdentifiers: Array<AccommodationCatalogPropertyIdentifierInput>;
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type TravelPlacePricingAndBookingDetailsPayload = {
  accommodationPlaceIds?: InputMaybe<Array<Scalars['String']>>;
  currencyCode: TravelCurrencyCode;
  /** Controls how stay dates are resolved. USE_EVENT_DATES uses metadata.eventId and falls back to payload dates if eventId is missing. USE_PAYLOAD_DATES always uses payload dates. */
  dateResolutionStrategy?: InputMaybe<DateResolutionStrategy>;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  joyPlaceIds?: InputMaybe<Array<Scalars['String']>>;
  metadata?: InputMaybe<TravelPlacePricingAndBookingDetailsPayloadMetadata>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
};

/** DateResolutionStrategy */
export enum DateResolutionStrategy {
  USE_EVENT_DATES = 'USE_EVENT_DATES',
  USE_PAYLOAD_DATES = 'USE_PAYLOAD_DATES',
}

export type TravelPlacePricingAndBookingDetailsPayloadMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  /**
   * Names the guest page that made this request. Telemetry facets on it.
   *
   * Values joy-web sends, derived from the route:
   * - guest_accommodation — the couple's accommodations list. Also reports for the hotel detail page today, because the route matcher has no branch for it. TRAV-4173 splits these into one value per page.
   * - admin_accommodation — the couple previewing the accommodations list in the editor.
   *
   * Keep values flat: one per page. Never combine two axes into a single value, such as a page and the thing it was showing. The field is a plain String, so a new page needs a new value and no schema change.
   *
   * Omit the field rather than guessing a value. travel_service then applies its own, and sets its own value on requests it makes internally.
   */
  callSource?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  locale?: Scalars['String'];
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export enum AccommodationDatesSource {
  AROUND_EVENT_DATE = 'AROUND_EVENT_DATE',
  AROUND_PUBLIC_SCHEDULE = 'AROUND_PUBLIC_SCHEDULE',
  FROM_TRAVEL_SETTINGS = 'FROM_TRAVEL_SETTINGS',
}

export type TravelPricingsForAccommodationByPropertyIdPayload = {
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsForAccommodationByPropertyIdPayloadMetaData>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  propertyIdentifiers: Array<AccommodationCatalogPropertyIdentifierInput>;
};

export type TravelPricingsForAccommodationByPropertyIdPayloadMetaData = {
  anonymousId?: InputMaybe<Scalars['String']>;
  /**
   * Names the guest page that made this request. Telemetry facets on it.
   *
   * Values joy-web sends, derived from the route:
   * - guest_accommodation — the couple's accommodations list. Also reports for the hotel detail page today, because the route matcher has no branch for it. TRAV-4173 splits these into one value per page.
   * - admin_accommodation — the couple previewing the accommodations list in the editor.
   *
   * Keep values flat: one per page. Never combine two axes into a single value, such as a page and the thing it was showing. The field is a plain String, so a new page needs a new value and no schema change.
   *
   * Omit the field rather than guessing a value. travel_service then applies its own, and sets its own value on requests it makes internally.
   */
  callSource?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type ComparisonsForTravelPlaceIdPayload = {
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsForAccommodationByPropertyIdPayloadMetaData>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  placeIds: Array<PlaceIdInput>;
};

export type PlaceIdInput = {
  accommodationsPlaceId?: InputMaybe<Scalars['String']>;
  joyPlaceId?: InputMaybe<Scalars['String']>;
};

export enum TravelReservationEvaluationDecision {
  PASS = 'PASS',
  QUARANTINE = 'QUARANTINE',
}

export enum TravelReservationEvaluationDispositionCode {
  APPROVED_LEGIT = 'APPROVED_LEGIT',
  CANCELED_EFW_ACTIONABLE = 'CANCELED_EFW_ACTIONABLE',
  CANCELED_FRAUD_SUSPECTED = 'CANCELED_FRAUD_SUSPECTED',
  CANCELED_IDENTITY_COLLISION = 'CANCELED_IDENTITY_COLLISION',
  CANCELED_IDENTITY_FRAUD_ACTIVITY = 'CANCELED_IDENTITY_FRAUD_ACTIVITY',
  CANCELED_NON_REFUNDABLE_RISK = 'CANCELED_NON_REFUNDABLE_RISK',
}

/** Travel product a fraud evaluation belongs to. */
export enum FraudProductTypeDtoEnum {
  car = 'car',
  hotel = 'hotel',
  instant_room_block = 'instant_room_block',
}

export enum TravelReservationEvaluationSpecialHandlingCase {
  INFRA_FAILURE_FALLBACK = 'INFRA_FAILURE_FALLBACK',
  LLM_UNAVAILABLE_FALLBACK_PASS = 'LLM_UNAVAILABLE_FALLBACK_PASS',
  LLM_UNAVAILABLE_FALLBACK_QUARANTINE = 'LLM_UNAVAILABLE_FALLBACK_QUARANTINE',
  POST_TIMEOUT_ASYNC_FAILED = 'POST_TIMEOUT_ASYNC_FAILED',
  POST_TIMEOUT_ASYNC_RESULT = 'POST_TIMEOUT_ASYNC_RESULT',
  TIMEOUT_FALLBACK_QUARANTINE = 'TIMEOUT_FALLBACK_QUARANTINE',
}

export type TravelReservationEvaluationsFilterInput = {
  decision?: InputMaybe<TravelReservationEvaluationDecision>;
  /** YYYY-MM-DD (UTC) — filter by createdAt <= end of that UTC day */
  endDate?: InputMaybe<Scalars['DateOnlyString']>;
  isShadowMode?: InputMaybe<Scalars['Boolean']>;
  /** When true, returns only evaluations with no disposition recorded yet (the CX work queue) */
  pendingDispositionOnly?: InputMaybe<Scalars['Boolean']>;
  /** Restrict the queue to one travel product. Omit to return every product — the CX queue is mixed by default. */
  productType?: InputMaybe<FraudProductTypeDtoEnum>;
  /** YYYY-MM-DD (UTC) — filter by createdAt >= start of that UTC day */
  startDate?: InputMaybe<Scalars['DateOnlyString']>;
};

export type TravelReservationsByCheckInWindowPayload = {
  /** Opaque cursor from the previous page (pageInfo.endCursor). Omit for the first page. */
  after?: InputMaybe<Scalars['String']>;
  /** Inclusive lower bound of the check-in window, as a property-local YYYY-MM-DD date. */
  checkInFrom: Scalars['String'];
  /** Exclusive upper bound of the check-in window, as a property-local YYYY-MM-DD date. The window spans [checkInFrom, checkInTo) and must not exceed 31 days. */
  checkInTo: Scalars['String'];
  /** Page size (1-100, default 50). */
  first?: InputMaybe<Scalars['Int']>;
};

export type TravelReservationsByCheckOutWindowPayload = {
  /** Opaque cursor from the previous page (pageInfo.endCursor). Omit for the first page. */
  after?: InputMaybe<Scalars['String']>;
  /** Inclusive lower bound of the check-out window, as a property-local YYYY-MM-DD date. */
  checkOutFrom: Scalars['String'];
  /** Exclusive upper bound of the check-out window, as a property-local YYYY-MM-DD date. The window spans [checkOutFrom, checkOutTo) and must not exceed 31 days. */
  checkOutTo: Scalars['String'];
  /** Page size (1-100, default 50). */
  first?: InputMaybe<Scalars['Int']>;
};

export type TravelReservationsByEventIdPayload = {
  eventId: Scalars['String'];
};

export type TravelReservationsByIdsPayload = {
  /** Reservation IDs (UUIDs) to look up, native or imported. Max 500 per request. */
  reservationIds: Array<Scalars['String']>;
};

export type TravelReservationSummariesByPropertyIdentifiersPayload = {
  afterDate: Scalars['DateOnlyString'];
  identifiers: Array<AccommodationCatalogPropertyIdentifierInputV2>;
};

export type AccommodationCatalogPropertyIdentifierInputV2 = {
  id: Scalars['String'];
  type: AccommodationCatalogPropertyIdentifierV2Type;
};

export enum AccommodationCatalogPropertyIdentifierV2Type {
  joyPlace = 'joyPlace',
}

export type TravelReservationSummaryByEventIdsPayload = {
  /** List of event IDs to fetch booking stats for. Max 500 per request. */
  eventIds: Array<Scalars['String']>;
};

export enum UploadStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
}

export enum MediaStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
}

export type UrlMetadataInput = {
  cacheBust?: InputMaybe<Scalars['Boolean']>;
  url: Scalars['String'];
};

/**
 * Input for validating a promo code against an order context.
 * Guest-callable — no authentication required.
 */
export type ValidatePromoCodeInput = {
  code: Scalars['String'];
  currency: Scalars['String'];
  eventId: Scalars['ID'];
  quantity: Scalars['Int'];
  ticketTypeId?: InputMaybe<Scalars['ID']>;
};

export type VendorListPayload = {
  items: Scalars['Int'];
  offset: Scalars['Int'];
  type: VendorTypeEnum;
};

export enum UrlVerificationStatus {
  invalid = 'invalid',
  valid = 'valid',
}

export type WarehouseInventorySearchInput = {
  joySKU: Scalars['String'];
  reasonCode: InventoryCheckReasonCode;
  requestedQty: Scalars['Int'];
};

export type WebsiteHeaderPresentationLayoutBySchemaInput = {
  eventId: Scalars['String'];
  schemaURL: Scalars['String'];
  websiteLayout?: InputMaybe<Scalars['String']>;
};

export type WebsiteStylistDerivePhotoCropsInput = {
  /** 1..10 photos. ids must be unique. urls must be http/https. */
  photos: Array<WebsiteStylistDerivePhotoCropsPhotoInput>;
};

export type WebsiteStylistDerivePhotoCropsPhotoInput = {
  id: Scalars['ID'];
  url: Scalars['String'];
};

export enum WebsiteStylistDesignRecommendationJobStatus {
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
}

export type WebsiteStylistExtractDominantColorsInput = {
  /** Number of colors to return, 1..10. */
  count?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<WebsiteStylistDominantColorsOptionsInput>;
  /** Photo URL. Must be http/https on withjoy.com / *.withjoy.com. */
  url: Scalars['String'];
};

export type WebsiteStylistDominantColorsOptionsInput = {
  /**
   * Echo Rekognition's raw (CSS-named-color-snapped) lists and the true-color
   * refined lists in the debug field. Tuning aid; off by default.
   */
  debug?: InputMaybe<Scalars['Boolean']>;
  /**
   * Demote greys/off-whites and muddy tans/browns. Backfills with neutrals when
   * the photo has too few chromatic colors, so the result never shrinks below
   * min(count, colorsFound) because of this flag.
   */
  excludeNeutrals?: InputMaybe<Scalars['Boolean']>;
  strategy?: InputMaybe<WebsiteStylistDominantColorStrategy>;
};

/**
 * Ranking strategy for websiteStylistExtractDominantColors.
 * subjectFirst — weight foreground (people/outfits) colors above the environment
 * and boost vivid hues. overall — whole-image pixel share only (color-thief-like
 * baseline, kept for side-by-side comparison while tuning).
 */
export enum WebsiteStylistDominantColorStrategy {
  overall = 'overall',
  subjectFirst = 'subjectFirst',
}

/** Which Rekognition IMAGE_PROPERTIES list the emitted representative color came from. */
export enum WebsiteStylistDominantColorSource {
  background = 'background',
  foreground = 'foreground',
  image = 'image',
}

/**
 * Soft-fail vocabulary. Every non-ok status is returned with colors: [] rather
 * than as a GraphQL error so joy-web can treat the palette as progressive
 * enhancement.
 */
export enum WebsiteStylistDominantColorsStatus {
  color_detection_failed = 'color_detection_failed',
  fetch_failed = 'fetch_failed',
  http_error = 'http_error',
  invalid_image = 'invalid_image',
  ok = 'ok',
  source_too_large = 'source_too_large',
  unsafe_url = 'unsafe_url',
}

export type ZentrumHubHotelIsValidRequest = {
  checkIn?: InputMaybe<Scalars['DateTime']>;
  checkOut?: InputMaybe<Scalars['DateTime']>;
  metadata?: InputMaybe<ZentrumHubHotelIsValidRequestWithMetadata>;
  zhId: Scalars['Float'];
};

export type ZentrumHubHotelIsValidRequestWithMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type AddAccommodationPlaceV2Request = {
  accommodationRoomBlock?: InputMaybe<AccommodationPlaceV2RoomBlockRequest>;
  autoSuggestionAlgo?: InputMaybe<AutoSuggestionAlgoType>;
  category?: InputMaybe<AccommodationPlaceCategory>;
  customAddress?: InputMaybe<Scalars['String']>;
  customName?: InputMaybe<Scalars['String']>;
  customPhone?: InputMaybe<Scalars['String']>;
  customPhotoId?: InputMaybe<Scalars['String']>;
  customStarRating?: InputMaybe<Scalars['Float']>;
  customUrl?: InputMaybe<Scalars['String']>;
  displayLocation?: InputMaybe<AccommodationPlaceDisplayLocation>;
  eventId: Scalars['ID'];
  isCustomLinkEnabled?: InputMaybe<Scalars['Boolean']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  isGuestFavorite?: InputMaybe<Scalars['Boolean']>;
  isHostStayingHere?: InputMaybe<Scalars['Boolean']>;
  isPhotoHidden?: InputMaybe<Scalars['Boolean']>;
  layoutType?: InputMaybe<Scalars['String']>;
  sourceOfData: AccommodationPlaceSourceOfData;
  type?: InputMaybe<AccommodationPlaceType>;
  userNote?: InputMaybe<Scalars['String']>;
};

export type AccommodationPlaceV2RoomBlockRequest = {
  bookingUrl: Scalars['String'];
  checkInDate: Scalars['DateOnlyString'];
  checkOutDate: Scalars['DateOnlyString'];
  currencyCode?: InputMaybe<Scalars['String']>;
  cutoffDate: Scalars['DateOnlyString'];
  isJoyManagedRoomBlock: Scalars['Boolean'];
  numberOfRoomsReserved: Scalars['Float'];
  pricePerNight?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<AccommodationPlaceRoomBlockStatus>;
  strikeoutPricePerNight?: InputMaybe<Scalars['Float']>;
};

/** AutoSuggestionAlgoType */
export enum AutoSuggestionAlgoType {
  PastEventBased = 'PastEventBased',
  PriceBased = 'PriceBased',
  Proximity = 'Proximity',
}

export type AccommodationPlaceSourceOfData = {
  sourceId: Scalars['String'];
  sourceType: AccommodationPlaceSourceType;
};

export type AddAccommodationRecommendationToEventPayload = {
  recommendationId: Scalars['ID'];
};

export type AddAccommodationRecommendationToEventPayloadV2 = {
  eventId: Scalars['ID'];
  recommendationId: Scalars['ID'];
};

export type AddContactToGroupInput = {
  contactId: Scalars['ID'];
  groupId: Scalars['ID'];
  makeLeader?: InputMaybe<Scalars['Boolean']>;
};

/** A batch of accommodation content snapshots to upsert. */
export type InternalAddContentSnapshotsInput = {
  /** When true, overwrite existing snapshots regardless of the 30-day freshness window and let write failures propagate. */
  force?: InputMaybe<Scalars['Boolean']>;
  /** The content snapshots to upsert. */
  snapshots: Array<InternalUpsertContentSnapshotInput>;
};

/** A single content snapshot to upsert for a JoyPlace and provider. */
export type InternalUpsertContentSnapshotInput = {
  /** The JoyPlace this snapshot describes. */
  joyPlaceId: Scalars['ID'];
  /** The provider content payload to store for this accommodation. */
  propertyJson: Scalars['JSON'];
  /** Content provider that produced this snapshot. */
  provider: AccommodationContentSnapshotProvider;
};

export type AddDigitalStationeryCartItemInput = {
  /**
   * Currency to charge in. Defaults to USD. The price is always stored in USD and
   * converted at checkout using server-side exchange rates — the client cannot
   * supply conversion data, since an exchange rate is a price input.
   * Supported: AUD, CAD, EUR, GBP, JPY, NZD, SGD.
   */
  currencyISO4217?: InputMaybe<Scalars['String']>;
  details: AddDigitalStationeryCartItemDetailsInput;
  /** Optional promo code. The server resolves the rate; an unknown code is rejected. */
  discountCode?: InputMaybe<Scalars['String']>;
  /**
   * The digital draft to buy. Its eventId, priceConfigId, quantity, delivery
   * package and billing address are all read from the draft.
   */
  stationeryDraftId: Scalars['ID'];
};

/**
 * Presentation details only. assetUrl, cardType, cardTypeSku and taxCode are set by
 * the server and cannot be overridden.
 */
export type AddDigitalStationeryCartItemDetailsInput = {
  digitalEnvelopeImageUrl?: InputMaybe<Scalars['String']>;
  features: Array<Scalars['String']>;
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
};

export type AddEventCountdownComponentPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddEventDetailsComponentPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddEventDisplayNameComponentPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddGreetingMessageComponentPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddInviteePayload = {
  email?: InputMaybe<Scalars['String']>;
  /** Display name for mailings/correspondence (e.g., 'Mr. Evan Jones & Guest', 'The Smith Family') */
  envelopeName?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  /** Country code of the user's phone, numbers without a country code will be assumed to be in this country. Ignored if phoneDisplay has a country code, otherwise, this will be used to help parse it to E.164. */
  fallbackCountryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  /** Phone number as entered by the user, not necessarily valid */
  phoneDisplay?: InputMaybe<Scalars['String']>;
};

export type AddJoyFeatureCartItemInput = {
  /**
   * Billing address for the purchase. Nothing ships — a Joy Feature is an
   * entitlement — but the cart's checkout guards require an address on every item,
   * and its country selects the Stripe account that charges the cart. It must
   * therefore agree on country with the other items in the cart, or checkout will
   * reject the whole cart.
   *
   * Required fields must be non-empty. `region` may be empty: GB and SG addresses
   * legitimately have none.
   */
  billingAddress: StationeryPrintOrderShippingAddressInput;
  currencyISO4217?: InputMaybe<Scalars['String']>;
  /** The event to entitle. The caller must be an admin of it. */
  eventId: Scalars['ID'];
  /** The feature to buy. Rejected unless the feature is enabled for cart purchase. */
  featureType: JoyFeatureType;
};

export type StationeryPrintOrderShippingAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  name: Scalars['String'];
  postalCode: Scalars['String'];
  region: Scalars['String'];
};

export type AddJsonDataBlobComponentPayload = {
  containerId: Scalars['ID'];
  jsonDataContainerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddMediaGalleryComponentPayload = {
  containerId: Scalars['ID'];
  /** Photo gallery layout style. Free-form string interpreted by the frontend; omit/null for the default layout. */
  layout?: InputMaybe<Scalars['String']>;
  mediaCollectionId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type addMediaToCollectionInput = {
  collectionId: Scalars['ID'];
  magicToken?: InputMaybe<Scalars['String']>;
  mediaId: Scalars['ID'];
};

export type addMediaToCollectionInputV2 = {
  collectionId: Scalars['ID'];
  magicToken?: InputMaybe<Scalars['String']>;
  mediaIds: Array<Scalars['ID']>;
};

export type PhotoComponentAddPayload = {
  containerId: Scalars['ID'];
  photoId: Scalars['String'];
  sortOrder: Scalars['Float'];
};

export type PlacesMapComponentAddPayload = {
  containerId: Scalars['ID'];
  illustrationSettings?: InputMaybe<Scalars['JSONObject']>;
  placeIds?: InputMaybe<Array<Scalars['ID']>>;
  placeTypes?: InputMaybe<Array<EventPlaceType>>;
  /** Defaults to standard. */
  presentation?: InputMaybe<PlacesMapPresentation>;
  sortOrder: Scalars['Float'];
};

export type PointsOnMapAddPayload = {
  address: Scalars['String'];
  componentId: Scalars['ID'];
  googlePlaceID?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  postalCode: Scalars['String'];
  type: PointOnMapType;
};

/** Input for adding a new promotion code to an existing coupon. */
export type AddPromotionCodeToCouponInput = {
  /** Whether this code is applied manually or automatically. */
  applicationType: ApplicationType;
  /** Booker-type restriction for this code. */
  bookerType: BookerType;
  /** Explicit code string. If omitted, a code is auto-generated. */
  code?: InputMaybe<Scalars['String']>;
  /** The coupon to attach this promotion code to. */
  couponId: Scalars['ID'];
  /** Payment type this code works on. Omit for ANY (no restriction). */
  couponPaidWith?: InputMaybe<CouponPaidWith>;
  /** Event ID. Required when scopeType is EVENT. */
  eventId?: InputMaybe<Scalars['ID']>;
  /** Whether this promotion code is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Maximum number of times this code can be used. */
  maxUses: Scalars['Int'];
  /** Minimum booking spend required, in minor units (cents). */
  minSpend?: InputMaybe<Scalars['Int']>;
  /** Prefix used when auto-generating the code. */
  prefix?: InputMaybe<Scalars['String']>;
  /** Email addresses that may use this code. */
  restrictedToEmails?: InputMaybe<Array<Scalars['String']>>;
  /** Scope of the promotion code (GLOBAL or EVENT). */
  scopeType: ScopeType;
  /** Optional per-code expiry date. Must be on or before the parent coupon's validUntil. When null, the coupon's validUntil applies. */
  validUntil?: InputMaybe<Scalars['DateTime']>;
};

/** A batch of travel rate snapshots to upsert. */
export type InternalAddRateSnapshotsBatchInput = {
  /** The rate snapshots to upsert. */
  snapshots: Array<UpsertTravelRateSnapshotInput>;
};

/** A single travel rate snapshot to upsert for a JoyPlace, provider, and stay configuration. */
export type UpsertTravelRateSnapshotInput = {
  /** Base (pre-tax/fees) nightly rate, as a decimal string. */
  baseRatePerNight: Scalars['Decimal'];
  /** When the underlying rate was captured from the provider. */
  capturedAt: Scalars['DateTime'];
  /** Check-in date (YYYY-MM-DD) the rate applies to. Required alongside los for a date-aware upsert. */
  checkInDate?: InputMaybe<Scalars['DateOnlyString']>;
  /** ISO 4217 currency code the rates are expressed in. */
  currencyCode: Scalars['String'];
  /** When this snapshot should be treated as expired. */
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  /** Whether this is the latest snapshot; defaults to true. */
  isLatest?: InputMaybe<Scalars['Boolean']>;
  /** The JoyPlace this rate snapshot describes. */
  joyPlaceId: Scalars['ID'];
  /** Length of stay (nights) the rate applies to. */
  los?: InputMaybe<Scalars['Int']>;
  /** Occupancy key (e.g. "A2C0"); defaults to "A2C0" when omitted. */
  occupancyKey?: InputMaybe<Scalars['String']>;
  /** Rate provider that produced this snapshot. */
  provider: TravelRateSnapshotProvider;
  /** Total (all-in) nightly rate, as a decimal string. */
  totalRatePerNight: Scalars['Decimal'];
};

export type AddRsvpAndUnlockGuestDetailsButtonComponentPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type CreateStationeryPrintOrderInput = {
  category?: InputMaybe<Scalars['String']>;
  currencyConversionData?: InputMaybe<Scalars['JSON']>;
  currencyISO4217?: InputMaybe<Scalars['String']>;
  deliveryMethod: StationeryPrintOrderDeliveryMethodEnum;
  deliveryPriceCurrencyISO4217?: InputMaybe<Scalars['String']>;
  deliveryPriceInMinorUnits?: InputMaybe<Scalars['Int']>;
  details: StationeryPrintOrderDetailsInput;
  discount?: InputMaybe<StationeryPrintOrderDiscountInput>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  issues?: InputMaybe<Array<CreateStationeryPrintOrderIssueInput>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  priceConfigId?: InputMaybe<Scalars['ID']>;
  priceInMinorUnits: Scalars['Int'];
  purchaseContextId?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  salesOrderId?: InputMaybe<Scalars['ID']>;
  selectedProductDetails?: InputMaybe<StationeryPrintOrderProductInput>;
  shippingAddress: StationeryPrintOrderShippingAddressInput;
  stationeryDraftId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Scalars['String']>;
  vendor: StationeryPrintOrderVendorEnum;
};

export type StationeryPrintOrderDetailsInput = {
  assetUrl: Scalars['String'];
  cardType: Scalars['String'];
  cardTypeSku: Scalars['String'];
  dieCut?: InputMaybe<Scalars['String']>;
  envelope?: InputMaybe<StationeryPrintOrderDetailsEnvelopeInput>;
  foil?: InputMaybe<StationeryPrintOrderDetailsFoilInput>;
  paymentInfo?: InputMaybe<StationeryPrintOrderPaymentInfoInput>;
  postcard?: InputMaybe<StationeryPrintOrderDetailsPostcardInput>;
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
  taxCode?: InputMaybe<Scalars['String']>;
};

export type StationeryPrintOrderDetailsEnvelopeInput = {
  backImageUrl?: InputMaybe<Scalars['String']>;
  frontImageUrl?: InputMaybe<Scalars['String']>;
  hasRecipientAddress: Scalars['Boolean'];
  sku: Scalars['String'];
  url: Scalars['String'];
};

export type StationeryPrintOrderDetailsFoilInput = {
  colorId: Scalars['String'];
  foilAssetId: Scalars['String'];
  priceInMinorUnits?: InputMaybe<Scalars['Int']>;
};

export type StationeryPrintOrderPaymentInfoInput = {
  creditCardBrand: Scalars['String'];
  creditCardLast4: Scalars['String'];
};

export type StationeryPrintOrderDetailsPostcardInput = {
  backImageUrl?: InputMaybe<Scalars['String']>;
  hasRecipientAddress: Scalars['Boolean'];
  interleavedPdfUrl?: InputMaybe<Scalars['String']>;
  sku: Scalars['String'];
  url: Scalars['String'];
};

export type StationeryPrintOrderDiscountInput = {
  amountInMinorUnits: Scalars['Int'];
  code: Scalars['String'];
  percentage?: InputMaybe<Scalars['Float']>;
};

export type CreateStationeryPrintOrderIssueInput = {
  additionalUserFacingDescription?: InputMaybe<Scalars['String']>;
  createdByEventId?: InputMaybe<Scalars['String']>;
  createdByUserId: Scalars['String'];
  issueTarget: StationeryPrintOrderIssueTarget;
  issueType: StationeryPrintOrderIssueType;
};

export type StationeryPrintOrderProductInput = {
  attributes: Array<SelectedStationeryPrintOrderProductAttributeInput>;
  selectedShippingMethodId?: InputMaybe<Scalars['String']>;
  variantGroupId?: InputMaybe<Scalars['String']>;
};

export type SelectedStationeryPrintOrderProductAttributeInput = {
  attributeId: Scalars['String'];
  optionId: Scalars['String'];
};

export type AddStayAreaRequest = {
  bestForTags?: InputMaybe<Array<Scalars['String']>>;
  customPhotoIds?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['ID'];
  locale: Scalars['String'];
  name: Scalars['String'];
  placeId: Scalars['String'];
  whyThisAreaIsAGreatPick?: InputMaybe<Scalars['String']>;
};

/** How the action reached Joy. This is what makes a CX release and a guest START distinguishable. */
export enum SuppressionSource {
  admin = 'admin',
  import = 'import',
  inbound_keyword = 'inbound_keyword',
  link_click = 'link_click',
}

/** How `occurredAt` was obtained. There is no default: a writer that cannot name its provenance must not claim the carrier supplied the timestamp. */
export enum TimestampSource {
  actor = 'actor',
  import_run = 'import_run',
  observed = 'observed',
  provider = 'provider',
  receipt = 'receipt',
}

/** `duplicate` means the provider delivered this message before and nothing was written. It is a success — ack it rather than retrying. */
export enum RecordActionOutcome {
  duplicate = 'duplicate',
  recorded = 'recorded',
}

/** Where one key stands now. Nothing is deleted; a suppression is released. */
export enum MessagingSuppressionStatus {
  released = 'released',
  suppressed = 'suppressed',
}

export type ServiceTagPayload = {
  serviceTagId: Scalars['ID'];
  vendorId: Scalars['ID'];
};

export type AddTestimonyPayload = {
  content: Scalars['String'];
  matchId?: InputMaybe<Scalars['String']>;
  reviewer?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['String'];
};

export type TextComponentAddPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
  text: Scalars['String'];
};

export type TravelMapComponentAddPayload = {
  blockOrdering?: InputMaybe<Array<Scalars['String']>>;
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddVendorProfilePhoto = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  vendorId: Scalars['ID'];
};

export type AddMatchToListPayload = {
  eventId: Scalars['String'];
  vendorId: Scalars['String'];
};

export type VideoComponentAddPayload = {
  caption?: InputMaybe<Scalars['String']>;
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
  videoUrl: Scalars['String'];
};

/**
 * Admin-only input for overriding an answer value.
 * Only answerValue is accepted — formId, questionId, and guestKey are locked to the existing row.
 */
export type AdminOverrideAnswerInput = {
  /** New answer value */
  answerValue: Scalars['String'];
  /** ID of the existing answer to override */
  id: Scalars['ID'];
};

export type AnnotateRegistryOrderPayload = {
  lineItemAnnotations?: InputMaybe<Array<AnnotateRegistryOrderLineItemInput>>;
  orderAnnotations?: InputMaybe<AnnotateRegistryOrderInput>;
};

export type AnnotateRegistryOrderLineItemInput = {
  lineItemNote?: InputMaybe<Scalars['String']>;
  locator: Scalars['String'];
};

export type AnnotateRegistryOrderInput = {
  giftNote?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type ApplyAlbumPhotosToEventPagesInput = {
  eventId: Scalars['ID'];
  /** Photo IDs from the upload receipt (MediaUpload.photo.id). Distributed round-robin across event pages. */
  mediaPhotoIds: Array<Scalars['ID']>;
};

/** Input for applying a Joy discount coupon to a travel reservation. */
export type ApplyJoyDiscountCouponInput = {
  /** The promotion code string to apply. */
  couponCode: Scalars['String'];
  /** How the guest is paying for this booking. Sent so a code restricted to one payment type can be refused here rather than at booking. Omitted or null falls back to the reservation's own rail: a cash-fund checkout is CASH_FUND, anything else is CARD. A client that cannot tell a split payment apart should send nothing rather than guess. */
  couponPaidWith?: InputMaybe<CouponPaidWithDtoEnum>;
  /** How much of this booking the guest chose to pay from the cash fund, in booking-currency minor units. Required when `couponPaidWith` is `CASH_FUND_AND_CARD` and the code is restricted to `CASH_FUND`: that code is worth a percentage of the fund share alone, and the fund hold does not exist yet at apply time, so only the client knows this figure. Ignored for every other code and payment type. */
  fundAppliedMinorUnits?: InputMaybe<Scalars['Int']>;
  /** The redeemer's email address. Required when the coupon has email restrictions or a FIRST_TIME/REPEAT booker-type rule; may be omitted for unrestricted ALL-booker coupons. */
  redeemerEmail?: InputMaybe<Scalars['String']>;
  /** Opt in to last-one-wins behaviour: when a *different* code is already applied, swap it for this one in a single operation instead of failing with COUPON_ALREADY_APPLIED. The swap updates the PaymentIntent once, and restores the original coupon if any step fails, so the guest is never left with no discount having started with one. Absent or false preserves the existing behaviour exactly. Reapplying the already-applied code stays an idempotent no-op either way. */
  replaceExisting?: InputMaybe<Scalars['Boolean']>;
  /** The travel offer reservation ID the coupon is applied to. */
  reservationId: Scalars['String'];
};

export type ApplyEventConfigPayload = {
  eventConfigData: Scalars['JSONObject'];
  eventConfigSchemaUrl: Scalars['String'];
  eventId: Scalars['ID'];
};

/** Input for atomically reserving a coupon slot. */
export type ApplyPromotionCodeInput = {
  /** When EVENT_GROUP, the event-keyed event group code is resolved by eventId and couponCode is treated as a display label (so attribution survives a couple renaming). Defaults to resolving by couponCode string. */
  codeCategory?: InputMaybe<CodeCategory>;
  /** The promotion code string to apply. */
  couponCode: Scalars['String'];
  /** Discount amount converted to the coupon currency for budget tracking, in minor units (cents). Set by Travel. */
  couponCurrencyDiscountAmount?: InputMaybe<Scalars['Int']>;
  /** How this booking is being paid for. Required only when the code restricts the payment type; a code set to ANY ignores it. */
  couponPaidWith?: InputMaybe<CouponPaidWith>;
  /** The discount amount to apply, in minor units (cents) of discountCurrency. */
  discountAmount: Scalars['Int'];
  /** ISO 4217 currency code for discountAmount. */
  discountCurrency: Scalars['String'];
  /** The event ID. Required when applying an EVENT-scoped code. */
  eventId?: InputMaybe<Scalars['ID']>;
  /** Exchange rate used when coupon currency differs from booking currency. Set by Travel. */
  exchangeRateUsed?: InputMaybe<Scalars['Float']>;
  /** The booking total before the discount, in minor units (cents) of discountCurrency. */
  originalAmount: Scalars['Int'];
  /** Number of prior confirmed bookings for this guest. Required for FIRST_TIME / REPEAT booker-type enforcement. */
  priorBookingCount: Scalars['Int'];
  /** Opaque JSON string with product-specific metadata. Stored but never interpreted by this service. */
  productContext?: InputMaybe<Scalars['String']>;
  /** The product-owned entity ID (e.g. reservationId for TRAVEL). */
  productReferenceId: Scalars['ID'];
  /** The product type being discounted (e.g. TRAVEL). */
  productType: ProductType;
  /** The redeemer's email address, used to enforce email restrictions. */
  redeemerEmail: Scalars['String'];
};

export enum ConsumptionStatus {
  APPLIED = 'APPLIED',
  CONSUMED = 'CONSUMED',
  REMOVED = 'REMOVED',
  RESTORED = 'RESTORED',
}

export type ApplyWebsiteColorsPayload = {
  artBackgroundColor: Scalars['String'];
  artFontColor: Scalars['String'];
  eventDesignId: Scalars['ID'];
  linkAndButtonColor: Scalars['String'];
  pageBackgroundColor: Scalars['String'];
  pageFontColor: Scalars['String'];
};

export type ApplyWebSiteTemplateSettingsPayload = {
  /** to Apply Brannan Specific Settings (required when websiteLayout is brannan) */
  brannanSettings?: InputMaybe<BrannanSettings>;
  /** to Apply Color Settings */
  colorSettings: EventDesignColorsSettings;
  eventDesignId: Scalars['ID'];
  /** to Apply FontPack Settings */
  fontPackName: Scalars['String'];
  /** to Apply Header Layout Settings */
  headerLayout: HeaderLayoutSettings;
  /** to Apply Theme and Layout Settings */
  themeAndLayoutSettings: ThemeAndLayoutSettings;
};

export type BrannanSettings = {
  bgTransparency?: InputMaybe<BackgroundTransparency>;
  innerFrameBorder?: InputMaybe<InnerFrameBorder>;
};

export type BackgroundTransparency = {
  featureId: Scalars['ID'];
  rangeValue: Scalars['Float'];
};

export type InnerFrameBorder = {
  booleanValue: Scalars['Boolean'];
  featureId: Scalars['ID'];
};

export type EventDesignColorsSettings = {
  artBackgroundColor: Scalars['String'];
  artFontColor: Scalars['String'];
  linkAndButtonColor: Scalars['String'];
  pageBackgroundColor: Scalars['String'];
  pageFontColor: Scalars['String'];
};

export type HeaderLayoutSettings = {
  dataJSON: Scalars['JSON'];
  eventId: Scalars['ID'];
  schemaURL: Scalars['String'];
  websiteLayout: Scalars['String'];
};

export type ThemeAndLayoutSettings = {
  brannanNavigation?: InputMaybe<BrannanNavigation>;
  fontId: Scalars['ID'];
  layoutId: Scalars['ID'];
  /** For blank-based templates: the specific template variant (e.g. pampas, palm_tree) */
  templateVariantId?: InputMaybe<Scalars['String']>;
  themeId: Scalars['ID'];
  useCustomTheme?: InputMaybe<Scalars['Boolean']>;
  useSuggestedThemeColor: Scalars['Boolean'];
};

export type ArchiveCollectionPayload = {
  id: Scalars['ID'];
};

export type AssignAddressPayload = {
  location: InviteeLocation;
  personId: Scalars['ID'];
};

export type InviteeLocation = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

/** One seat's target state. Omit both guest ids to vacate the seat. guestId and legacyGuestId are the same guest's two identity forms, not two guests. */
export type SeatAssignmentInput = {
  /** Contact id of the guest to seat. */
  guestId?: InputMaybe<Scalars['ID']>;
  /** The same guest's legacy/firebase key. Supply it alongside guestId whenever known: it lets the server clear a prior seat the guest holds under the legacy key, which a guestId-only call cannot see. Alone, it seats the guest under the legacy key. */
  legacyGuestId?: InputMaybe<Scalars['String']>;
  /** Seat to write. Must be live and on the given floor plan. */
  seatId: Scalars['ID'];
};

export type AuthenticateRegistryReservationInput = {
  /** A specially-formatted url the user currently recieves via email */
  url: Scalars['String'];
};

export type AutoPopulateAccommodationPlacesPayload = {
  eventId: Scalars['ID'];
  force?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<AutoPopulateAccommodationPlacesLocation>;
};

export type AutoPopulateAccommodationPlacesLocation = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type AutoPopulateAccommodationPlacesPayloadV3 = {
  eventId: Scalars['ID'];
  filters?: InputMaybe<AutoPopulateAccommodationPlacesFilters>;
  force?: InputMaybe<Scalars['Boolean']>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<AutoPopulateAccommodationPlacesLocationV3>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  searchRadiusKm?: InputMaybe<Scalars['Int']>;
  venueGooglePlaceId?: InputMaybe<Scalars['String']>;
};

export type AutoPopulateAccommodationPlacesFilters = {
  priceRange?: InputMaybe<AutoPopulateAccommodationPlacesFiltersPriceRange>;
  starRatings?: InputMaybe<Array<Scalars['Int']>>;
  userRatingRange?: InputMaybe<UserRatingRange>;
};

export type AutoPopulateAccommodationPlacesFiltersPriceRange = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type UserRatingRange = {
  excludeUnrated?: InputMaybe<Scalars['Boolean']>;
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type AutoPopulateAccommodationPlacesLocationV3 = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type AutoPopulateAccommodationPlacesPayloadV4 = {
  eventId: Scalars['ID'];
  filters?: InputMaybe<AutoPopulateAccommodationPlacesFilters>;
  force?: InputMaybe<Scalars['Boolean']>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<AutoPopulateAccommodationPlacesLocationV3>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  searchRadiusKm?: InputMaybe<Scalars['Int']>;
  venueGooglePlaceId?: InputMaybe<Scalars['String']>;
};

export type AutoPopulateAccommodationPlacesPayloadV5 = {
  eventId: Scalars['ID'];
  filters?: InputMaybe<AutoPopulateAccommodationPlacesFilters>;
  force?: InputMaybe<Scalars['Boolean']>;
  idempotentId?: InputMaybe<Scalars['String']>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<AutoPopulateAccommodationPlacesLocationV3>;
  scenario?: InputMaybe<AutopopulateAccommodationPlacesScenario>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  searchRadiusKm?: InputMaybe<Scalars['Int']>;
  /** When true, the BE asks the LLM for additional recommendations beyond the 4 added to the event. The extras are persisted as pending recommendations and retrievable via getPendingAccommodationRecommendations. Total count is server-controlled via the travel-extra-recommendations-count feature flag. When false or omitted, behavior matches the legacy 4-and-done flow. */
  shouldGenerateExtraRecommendations?: InputMaybe<Scalars['Boolean']>;
  /** Optional user feedback driving regeneration behavior. */
  userFeedback?: InputMaybe<UserFeedbackDtoEnum>;
  venueGooglePlaceId?: InputMaybe<Scalars['String']>;
};

/** AutopopulateAccommodationPlacesScenario */
export enum AutopopulateAccommodationPlacesScenario {
  eventCreate = 'eventCreate',
  venueChange = 'venueChange',
}

/** User feedback for hotel suggestion regeneration */
export enum UserFeedbackDtoEnum {
  CLOSER = 'CLOSER',
  LUXURY = 'LUXURY',
  MORE_AFFORDABLE = 'MORE_AFFORDABLE',
  SIMILAR = 'SIMILAR',
}

export type AutoPopulateStayAreasPayload = {
  address?: InputMaybe<Scalars['String']>;
  autoPopulate?: InputMaybe<Scalars['Boolean']>;
  eventId: Scalars['ID'];
  idempotentId?: InputMaybe<Scalars['String']>;
  locale: Scalars['String'];
  location?: InputMaybe<StayAreaCoordinatesInput>;
  scenario?: InputMaybe<Scalars['String']>;
  searchRadius?: InputMaybe<Scalars['Int']>;
};

export type StayAreaCoordinatesInput = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export enum DeferredOperationJobStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
}

/** Why a guest was not seated. */
export enum UnseatedReasonCode {
  /** @deprecated Never emitted — declined guests report NOT_ATTENDING. Retained for backward-compat; migrate to NOT_ATTENDING. */
  DECLINED = 'DECLINED',
  MAYBE = 'MAYBE',
  NO_CAPACITY = 'NO_CAPACITY',
  NOT_ATTENDING = 'NOT_ATTENDING',
  PARTY_TOO_LARGE = 'PARTY_TOO_LARGE',
  PENDING = 'PENDING',
}

export type BackfillBlurHashPayload = {
  /** Maximum concurrent blurHash computations. Default 2, max 5. */
  concurrency?: InputMaybe<Scalars['Int']>;
  /** Maximum number of photos to process when photoIds is omitted. Default 100, max 1000. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Optional list of photo IDs to backfill. If omitted, processes all photos with null blurHash. */
  photoIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type BackfillPaymentAttemptsInput = {
  /** YYYY-MM-DD end date for the backfill range */
  endDate: Scalars['DateOnlyString'];
  /** YYYY-MM-DD start date for the backfill range */
  startDate: Scalars['DateOnlyString'];
};

/** A batch of rawOffer backfills for already-stored offer tokens. */
export type InternalBackfillRawOffersInput = {
  /** The rawOffer backfills to apply. */
  items: Array<InternalBackfillRawOfferItemInput>;
};

/** A single rawOffer backfill for an already-stored offer token. */
export type InternalBackfillRawOfferItemInput = {
  /** The Joy-minted offer id to backfill. */
  joyOfferId: Scalars['ID'];
  /** The raw offer snapshot to write onto the token. */
  rawOffer: Scalars['JSON'];
};

export type BackfillStripeDisputesInput = {
  /** YYYY-MM-DD end date for the dispute backfill range */
  endDate: Scalars['DateOnlyString'];
  /** When true (default), enqueue LLM evaluation for each non-bank-processing dispute that has a linked reservation. */
  isEnqueueEvaluation?: InputMaybe<Scalars['Boolean']>;
  /** YYYY-MM-DD start date for the dispute backfill range */
  startDate: Scalars['DateOnlyString'];
};

export type BacktestEvaluationsInput = {
  /** YYYY-MM-DD (UTC) — end of the backtest window */
  endDate?: InputMaybe<Scalars['DateOnlyString']>;
  /** Poll an existing backtest by key. When provided, all other fields are ignored. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  /** YYYY-MM-DD (UTC) — start of the backtest window */
  startDate?: InputMaybe<Scalars['DateOnlyString']>;
  systemPromptOverride?: InputMaybe<Scalars['String']>;
};

export enum BacktestOperationStatus {
  DONE = 'DONE',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
}

export type BatchUpdateEventPagesPayload = {
  id: Scalars['ID'];
  payload: PartialUpdatePagePayload;
};

export type PartialUpdatePagePayload = {
  visibility: EventPageVisibility;
};

/** Bulk-set the final price on multiple offer tokens. */
export type InternalBulkUpdateOfferPricingInput = {
  /** The final-price updates to apply. */
  items: Array<InternalBulkUpdateOfferPricingItemInput>;
};

/** A single final-price update in a bulk operation. */
export type InternalBulkUpdateOfferPricingItemInput = {
  /** Currency of priceInMinorUnits. */
  currency: Scalars['String'];
  /** The Joy-minted offer id. */
  joyOfferId: Scalars['ID'];
  /** Final price (post-fee, post-margin) in minor units. */
  priceInMinorUnits: Scalars['Int'];
};

/** Bulk-set the best-price-wins margin context on multiple offer tokens. */
export type InternalBulkUpdateOfferTokenMarginContextInput = {
  /** The margin-context updates to apply. */
  items: Array<InternalBulkUpdateOfferTokenMarginContextItemInput>;
};

/** A single margin-context update in a bulk operation. */
export type InternalBulkUpdateOfferTokenMarginContextItemInput = {
  /** The best-price-wins margin decision context to persist. */
  bestPriceWinsMarginContext: Scalars['JSON'];
  /** The Joy-minted offer id. */
  joyOfferId: Scalars['ID'];
};

export type RegistryOrderCancelInput = {
  cancelationMethod: SalesOrderCancelMethod;
  cancelationReason: Scalars['String'];
  registryOrderId: Scalars['ID'];
};

export enum SalesOrderCancelMethod {
  local = 'local',
}

export type CaptureCheckoutEmailAbandonmentInput = {
  /** Email the guest typed into the native (Stripe) checkout form. */
  email: Scalars['String'];
  /** Joy offer token (prefixed format: offer-zh-UUID or offer-nu-UUID) minted for this checkout. */
  offerToken: Scalars['String'];
};

export type CarbonNewCarbonGenerateFromPlanInput = {
  eventId: Scalars['String'];
  planId: Scalars['String'];
  /**
   * JSON-encoded plan export: { board: PlanDecisionItem[], chat: PlanChatMessage[] }.
   * Board items are the folded plan-seam snapshots (id, area, title, status,
   * value, note, rationale, dependsOn, updatedAt).
   */
  sourceJson: Scalars['String'];
};

export type CarbonVisionGenerateFromPlanInput = {
  eventId: Scalars['String'];
  planId: Scalars['String'];
};

export type CarbonVisionRenameSiteInput = {
  name: Scalars['String'];
  siteId: Scalars['String'];
};

export type CarbonWebsiteAddSectionInput = {
  navTitle: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  role: Scalars['String'];
  title: Scalars['String'];
};

export type CarbonWebsiteAppendToCopyListInput = {
  kind?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  path: Scalars['String'];
  siteId: Scalars['String'];
};

export type CarbonWebsiteApplyV1DesignInput = {
  acknowledgeBlocking?: InputMaybe<Scalars['Boolean']>;
  fromEvent?: InputMaybe<CarbonWebsiteV1EventDesignSourceInput>;
  fromPreset?: InputMaybe<Scalars['String']>;
  fromThemeId?: InputMaybe<Scalars['String']>;
  siteId: Scalars['String'];
};

export type CarbonWebsiteCreateSlugInput = {
  eventId?: InputMaybe<Scalars['String']>;
  siteId: Scalars['String'];
  slug: Scalars['String'];
};

export type CarbonWebsiteEditSiteInput = {
  instruction: Scalars['String'];
  siteId: Scalars['String'];
};

export type CarbonWebsiteExportDesignToV1Input = {
  publish?: InputMaybe<Scalars['Boolean']>;
  siteId: Scalars['String'];
};

export type CarbonWebsiteGenerateArtifactSiteFromPlanInput = {
  eventId: Scalars['String'];
  planId: Scalars['String'];
};

export type CarbonWebsiteGenerateImageInput = {
  aspect?: InputMaybe<Scalars['String']>;
  ownerEventId?: InputMaybe<Scalars['String']>;
  ownerSiteId?: InputMaybe<Scalars['String']>;
  prompt: Scalars['String'];
  quality?: InputMaybe<CarbonWebsiteImageQualityTier>;
  slugHint?: InputMaybe<Scalars['String']>;
  webhookUrl?: InputMaybe<Scalars['String']>;
};

export enum CarbonWebsiteImageQualityTier {
  default = 'default',
  pro = 'pro',
}

export type CarbonWebsiteGenerateSiteFromEventInput = {
  brief?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  experiment?: InputMaybe<CarbonWebsiteV2ExperimentInput>;
  name?: InputMaybe<Scalars['String']>;
  planId?: InputMaybe<Scalars['String']>;
};

export type CarbonWebsiteV2ExperimentInput = {
  designSystemModel?: InputMaybe<Scalars['String']>;
  fixModel?: InputMaybe<Scalars['String']>;
  primaryModel?: InputMaybe<Scalars['String']>;
  unitMockup?: InputMaybe<Scalars['Boolean']>;
  unitModel?: InputMaybe<Scalars['String']>;
};

export type CarbonWebsiteGenerateSiteFromPlanInput = {
  eventId: Scalars['String'];
  personalize?: Scalars['Boolean'];
  planId: Scalars['String'];
  templateId?: InputMaybe<Scalars['String']>;
};

export type CarbonWebsiteRemoveFromCopyListInput = {
  index: Scalars['Int'];
  locale?: InputMaybe<Scalars['String']>;
  path: Scalars['String'];
  siteId: Scalars['String'];
};

export type CarbonWebsiteRenameSiteInput = {
  name: Scalars['String'];
  siteId: Scalars['String'];
};

export type CarbonWebsiteRenameTemplateInput = {
  name: Scalars['String'];
  templateId: Scalars['String'];
};

export type CarbonWebsiteReorderCopyListInput = {
  fromIndex: Scalars['Int'];
  locale?: InputMaybe<Scalars['String']>;
  path: Scalars['String'];
  siteId: Scalars['String'];
  toIndex: Scalars['Int'];
};

export type CarbonWebsiteSaveTemplateInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  siteId: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export type CarbonWebsiteScaffoldImagesInput = {
  context: Scalars['String'];
  defaultAspect?: InputMaybe<Scalars['String']>;
  guidance?: InputMaybe<Scalars['String']>;
  ownerEventId?: InputMaybe<Scalars['String']>;
  ownerSiteId?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<CarbonWebsiteImageQualityTier>;
  requests?: InputMaybe<Array<CarbonWebsiteImageRequestInput>>;
};

export type CarbonWebsiteImageRequestInput = {
  aspect?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  key: Scalars['String'];
};

export type CarbonWebsiteSetAiControlPolicyInput = {
  aiDisabled?: InputMaybe<Scalars['Boolean']>;
  ceilingMicros?: InputMaybe<Scalars['String']>;
  scope: CarbonWebsiteAiControlScopeInput;
};

export type CarbonWebsiteSetImageCropInput = {
  crop?: InputMaybe<CarbonWebsiteImageCropInput>;
  path: Scalars['String'];
  siteId: Scalars['String'];
};

export type CarbonWebsiteImageCropInput = {
  fit?: InputMaybe<CarbonWebsiteImageCropFit>;
  focalX: Scalars['Float'];
  focalY: Scalars['Float'];
  zoom: Scalars['Float'];
};

export enum CarbonWebsiteImageCropFit {
  contain = 'contain',
  cover = 'cover',
}

export type CarbonWebsiteUpdateSectionInput = {
  access?: InputMaybe<Scalars['String']>;
  audienceIds?: InputMaybe<Array<Scalars['String']>>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  inNav?: InputMaybe<Scalars['Boolean']>;
  navTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

export type CarbonWebsiteUpdateSiteCopyInput = {
  locale?: InputMaybe<Scalars['String']>;
  path: Scalars['String'];
  siteId: Scalars['String'];
  value: Scalars['String'];
};

export type CarbonWebsiteUpdateSiteSettingsInput = {
  settings: CarbonWebsiteSiteSettingsInput;
  siteId: Scalars['String'];
};

export type CarbonWebsiteSiteSettingsInput = {
  visibility?: InputMaybe<CarbonWebsiteSiteVisibility>;
};

export type CarbonWebsiteUpdateSiteThemeInput = {
  siteId: Scalars['String'];
  theme: CarbonWebsiteSiteThemeInput;
};

export type CarbonWebsiteSiteThemeInput = {
  assets?: InputMaybe<Array<CarbonWebsiteThemeAssetValueInput>>;
  colors: Array<CarbonWebsiteThemeColorInput>;
  controls?: InputMaybe<Array<CarbonWebsiteThemeControlValueInput>>;
  fontPackName?: InputMaybe<Scalars['String']>;
  typography: Array<CarbonWebsiteThemeTypographyVariantInput>;
  version: Scalars['Int'];
};

export type CarbonWebsiteThemeAssetValueInput = {
  enabled: Scalars['Boolean'];
  slot: Scalars['String'];
  value?: InputMaybe<Scalars['ID']>;
};

export type CarbonWebsiteThemeColorInput = {
  label: Scalars['String'];
  role: CarbonWebsiteThemeColorRole;
  value: Scalars['String'];
  variable: Scalars['String'];
};

export type CarbonWebsiteThemeControlValueInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']>;
  key: Scalars['String'];
  numberValue?: InputMaybe<Scalars['Float']>;
  stringValue?: InputMaybe<Scalars['String']>;
};

export type CarbonWebsiteThemeTypographyVariantInput = {
  fallback: Scalars['String'];
  family: Scalars['String'];
  key: Scalars['String'];
  label: Scalars['String'];
  letterSpacing?: InputMaybe<Scalars['Float']>;
  lineHeight?: InputMaybe<Scalars['Float']>;
  scope: CarbonWebsiteThemeScope;
  size: Scalars['Int'];
  textTransform?: InputMaybe<CarbonWebsiteThemeTextTransform>;
  weight: Scalars['Int'];
};

export type CarbonWebsiteUpdateSlugInput = {
  eventId?: InputMaybe<Scalars['ID']>;
  siteId: Scalars['String'];
  slugId: Scalars['String'];
};

export type CarbonWeddingWebsiteEditSiteInput = {
  instruction: Scalars['String'];
  siteId: Scalars['String'];
};

export type CarbonWeddingWebsiteGenerateFromEventInput = {
  brief?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  experiment?: InputMaybe<CarbonWeddingWebsiteExperimentInput>;
  name?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
  v1Design?: InputMaybe<CarbonWebsiteV1DesignSourceInput>;
};

export type CarbonWeddingWebsiteExperimentInput = {
  designSystemModel?: InputMaybe<Scalars['String']>;
  fixModel?: InputMaybe<Scalars['String']>;
  primaryModel?: InputMaybe<Scalars['String']>;
  unitMockup?: InputMaybe<Scalars['Boolean']>;
  unitModel?: InputMaybe<Scalars['String']>;
};

export type CarbonWeddingWebsiteImportFromV1Input = {
  eventId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<CarbonWebsiteV1DesignPurpose>;
};

export type CarReservationCancelPayload = {
  reservationId: Scalars['String'];
};

export type CarReservationConfirmPayload = {
  reservationId: Scalars['String'];
  vaulteraCardToken?: InputMaybe<Scalars['String']>;
};

export type CarReservationCreatePayload = {
  carProvider: CarProviderDtoEnum;
  countryCode?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceTypeDtoEnum>;
  dropOffLocation: CarLocationSearchInput;
  dropOffTime: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  guest?: InputMaybe<CarReservationGuestInput>;
  offerToken: Scalars['String'];
  pickUpLocation: CarLocationSearchInput;
  pickUpTime: Scalars['String'];
  selectedOptionalExtraIds?: InputMaybe<Array<Scalars['String']>>;
};

export enum CarProviderDtoEnum {
  EXPEDIA = 'EXPEDIA',
  HERTZ = 'HERTZ',
}

export enum DeviceTypeDtoEnum {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
}

export type CarReservationGuestInput = {
  age?: InputMaybe<Scalars['Int']>;
  country?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type CarReservationUpdatePayload = {
  billingContact?: InputMaybe<CarBillingContactInput>;
  email?: InputMaybe<Scalars['String']>;
  guest?: InputMaybe<CarReservationGuestInput>;
  id: Scalars['String'];
};

export type CarBillingContactInput = {
  address: CarBillingAddressInput;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
};

export type CarBillingAddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};

export type CarReservationVaulteraSessionCreatePayload = {
  reservationId: Scalars['String'];
};

export type ChangeLinkRedirectUrlInput = {
  linkRedirectId: Scalars['ID'];
  redirectUrl: Scalars['Url'];
};

/** Input for checking in a guest by guest key. */
export type CheckInTicketByGuestKeyInput = {
  /** Event ID the ticket belongs to */
  eventId: Scalars['ID'];
  /** Guest key identifying the guest to check in */
  guestKey: Scalars['String'];
  /** Optional — if provided, check in this specific ticket; otherwise check in the first VALID ticket for the guest */
  ticketId?: InputMaybe<Scalars['ID']>;
};

export enum PhoneNumberVerificationStatus {
  approved = 'approved',
  canceled = 'canceled',
  deleted = 'deleted',
  expired = 'expired',
  failed = 'failed',
  maxAttemptsReached = 'maxAttemptsReached',
  pending = 'pending',
}

export type ClaimVendorUserWithToken = {
  token: Scalars['String'];
};

export type BundleStationeryPrintOrderInput = {
  childOrderNumbers: Array<Scalars['String']>;
  mainOrderNumber: Scalars['String'];
};

export type CompleteFreeDigitalStationeryOrderInput = {
  details: CompleteFreeDigitalStationeryOrderDetailsInput;
  /**
   * The free digital draft to complete. Its event, owner and design are all read
   * from it — the input accepts no eventId, and the caller must be an admin of the
   * draft's event.
   */
  stationeryDraftId: Scalars['ID'];
};

/**
 * Presentation details only. assetUrl, cardType, cardTypeSku, taxCode and the
 * delivery `features` (email + link, never sms — that is the free tier boundary)
 * are set by the server and cannot be overridden.
 */
export type CompleteFreeDigitalStationeryOrderDetailsInput = {
  digitalEnvelopeImageUrl?: InputMaybe<Scalars['String']>;
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
};

/** Input for confirming a coupon slot as consumed. */
export type ConsumePromotionCodeInput = {
  /** Which category's application to confirm. Defaults to PROMOTION; pass EVENT_GROUP to confirm the event group code slot. */
  codeCategory?: InputMaybe<CodeCategory>;
  /** The product-owned entity ID whose coupon slot should be confirmed. */
  productReferenceId: Scalars['ID'];
  /** The product type of the confirmed booking. */
  productType: ProductType;
};

export type TransferRegistryOptions = {
  timeoutMs?: InputMaybe<Scalars['Int']>;
};

export type CreateConciergePrintOrderInput = {
  checkoutFailureUrlTemplate: Scalars['String'];
  checkoutSuccessUrlTemplate: Scalars['String'];
  currencyISO4217?: InputMaybe<Scalars['String']>;
  details: StationeryConciergePrintOrderDetailsInput;
  discount?: InputMaybe<StationeryPrintOrderDiscountInput>;
  email: Scalars['String'];
  eventId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  phoneNumber: Scalars['String'];
  priceInMinorUnits: Scalars['Int'];
  quantity: Scalars['Int'];
  shippingAddress: StationeryPrintOrderShippingAddressInput;
  vendor: StationeryPrintOrderVendorEnum;
};

export type StationeryConciergePrintOrderDetailsInput = {
  assetUrl: Scalars['String'];
  cardType: Scalars['String'];
  cardTypeSku: Scalars['String'];
  designSetLabel?: InputMaybe<Scalars['String']>;
  designSetName: Scalars['String'];
  eventDate?: InputMaybe<Scalars['String']>;
  formLink: Scalars['String'];
  magnetCard?: InputMaybe<Scalars['Boolean']>;
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
  taxCode?: InputMaybe<Scalars['String']>;
};

export type CreateDigitalPrintOrderInput = {
  checkoutFailureUrlTemplate: Scalars['String'];
  checkoutSuccessUrlTemplate: Scalars['String'];
  currencyISO4217?: InputMaybe<Scalars['String']>;
  details: StationeryDigitalPrintOrderDetailsInput;
  discount?: InputMaybe<StationeryPrintOrderDiscountInput>;
  email: Scalars['String'];
  eventId: Scalars['String'];
  priceInMinorUnits: Scalars['Int'];
  quantity: Scalars['Int'];
  selectedProductDetails?: InputMaybe<StationeryPrintOrderProductInput>;
  shippingAddress: StationeryPrintOrderShippingAddressInput;
  stationeryDraftId: Scalars['ID'];
  vendor: StationeryPrintOrderVendorEnum;
};

export type StationeryDigitalPrintOrderDetailsInput = {
  digitalEnvelopeImageUrl?: InputMaybe<Scalars['String']>;
  features: Array<Scalars['String']>;
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
  taxCode?: InputMaybe<Scalars['String']>;
};

export type CreateStationerySamplePrintOrderInput = {
  checkoutFailureUrlTemplate: Scalars['String'];
  checkoutSuccessUrlTemplate: Scalars['String'];
  currencyISO4217?: InputMaybe<Scalars['String']>;
  deliveryMethod: StationeryPrintOrderDeliveryMethodEnum;
  details: StationerySamplePrintOrderDetailsInput;
  discount?: InputMaybe<StationeryPrintOrderDiscountInput>;
  email: Scalars['String'];
  eventId: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  priceConfigId: Scalars['ID'];
  quantity: Scalars['Int'];
  shippingAddress: StationeryPrintOrderShippingAddressInput;
  vendor: StationeryPrintOrderVendorEnum;
};

export type StationerySamplePrintOrderDetailsInput = {
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
};

export type CreateBookingTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  bookingType?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type CreateBudgetInput = {
  currency?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  /** Optional locale (e.g., "en-GB") used to derive the default currency. Falls back to USD if omitted. */
  eventLocale?: InputMaybe<Scalars['String']>;
  guestCount?: InputMaybe<Scalars['Int']>;
  totalBudget: Scalars['BigInt'];
  weddingLocation?: InputMaybe<Scalars['String']>;
};

export type CreateBudgetItemInput = {
  actualCost?: InputMaybe<Scalars['BigInt']>;
  budgetId: Scalars['ID'];
  categoryId: Scalars['ID'];
  estimatedCost: Scalars['BigInt'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Float']>;
};

/** Input for creating a new Cash Fund associated with a host. This initiates the collection mechanism for contributions towards a specific goal or fixed amounts. */
export type CreateCashFundInput = {
  /** Optional fixed amount per contribution in minor units, if contributions are standardized. */
  fixedContributionAmountInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** Whether to hide the progress towards the total goal from contributors. */
  hideGoal: Scalars['Boolean'];
  /** The ID of the host this cash fund belongs to, linking to the CashFundsHost type. */
  hostId: Scalars['ID'];
  /** The name or title of the cash fund, displayed to contributors. */
  name: Scalars['String'];
  /** Optional descriptive note about the cash fund's purpose. */
  note?: InputMaybe<Scalars['String']>;
  /**
   * ID of an existing Photo (owned by photo_service) to associate with the cash fund.
   * The Photo's container must match the cash fund's event id.
   * Contributes to the Solicitation Photo reference
   */
  photoId?: InputMaybe<Scalars['ID']>;
  /**
   * DEPRECATED — use photoId instead. Scheduled for removal once all clients migrate.
   * URL of a photo to associate with the cash fund, used in solicitations and displays.
   * Contributes to the Solicitation Photo reference
   */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** The total target amount in minor currency units (e.g., cents for USD) for the fund's goal. */
  totalGoalInMinorUnits?: InputMaybe<Scalars['Int']>;
};

/**
 * Used for creating a Checkout Session for standard checkout flow.
 * This input follows the same field pattern as CreateCashFundPaymentIntentInput.
 */
export type CreateCashFundCheckoutSessionInput = {
  /** Contribution amount. */
  amountInMinorUnits: Scalars['Int'];
  /**
   * URL template where customers will be redirected if they decide to cancel the checkout.
   * The template supports the following placeholders (same as successUrlTemplate)
   * - '{cashFundId}' - ID of the cash fund
   * - '{paymentAttemptId}' or '{paymentId}' - ID of the payment attempt
   * - '{contributionId}' - Deprecated: use {paymentAttemptId} instead (kept for backward compatibility)
   * - '{eventId}' - ID of the event
   */
  cancelUrlTemplate: Scalars['String'];
  /** The ID of the cash fund. */
  cashFundId: Scalars['ID'];
  /** Contributor's email. */
  contributorEmail: Scalars['String'];
  /** Contributor's full name. */
  contributorFullName: Scalars['String'];
  /** Optional message. */
  contributorMessage?: InputMaybe<Scalars['String']>;
  /**
   * Links a specific Invite to the contribution.
   * The 'inviteToken' has higher priority when linking an Invite. If an 'inviteToken' is provided, this property is ignored.
   * Note: If a guest has multiple Invites for the same Cash Fund (from different Solicitations),
   * the system will automatically select the Invite with the fewest existing Contributions.
   */
  guestKey?: InputMaybe<Scalars['String']>;
  /**
   * Links a specific Invite to the contribution.
   * Omitted if Contribution is not from an Invite.
   */
  inviteToken?: InputMaybe<Scalars['String']>;
  /**
   * URL template where customers will be redirected after successful checkout.
   * The template supports the following placeholders:
   * - '{cashFundId}' - ID of the cash fund
   * - '{paymentAttemptId}' or '{paymentId}' - ID of the payment attempt
   * - '{contributionId}' - Deprecated: use {paymentAttemptId} instead (kept for backward compatibility)
   * - '{eventId}' - ID of the event
   */
  successUrlTemplate: Scalars['String'];
};

/** Input for creating a Payment Intent for express checkout to a cash fund. Used in scenarios where contributor details are captured post-payment. */
export type CreateCashFundPaymentIntentInput = {
  /** The contribution amount in minor currency units. */
  amountInMinorUnits: Scalars['Int'];
  /** The ID of the cash fund receiving the contribution. */
  cashFundId: Scalars['ID'];
  /** Email of the contributor for receipts and tracking. */
  contributorEmail: Scalars['String'];
  /** A single unified name, first + last, same format as the Cardholder name provided by Stripe. */
  contributorFullName: Scalars['String'];
  /** Optional message from contributor to the host. */
  contributorMessage?: InputMaybe<Scalars['String']>;
  /**
   * Links a specific Invite to the Contribution.
   * The 'inviteToken' has higher priority when linking an Invite. If an 'inviteToken' is provided, this property is ignored.
   * Note: If a guest has multiple Invites for the same Cash Fund (from different Solicitations),
   * the system will automatically select the Invite with the fewest existing Contributions.
   */
  guestKey?: InputMaybe<Scalars['String']>;
  /**
   * Links a specific Invite to the Contribution.
   * Omitted if Contribution is not from an Invite.
   */
  inviteToken?: InputMaybe<Scalars['String']>;
};

/** Input for creating a Cash Fund Solicitation, which is an email campaign to invite recipients to contribute to the cash fund. */
export type CreateCashFundSolicitationInput = {
  /** The ID of the cash fund this solicitation promotes. */
  cashFundId: Scalars['ID'];
  /** Configuration for the solicitation's appearance and behavior. */
  config: CreateCashFundSolicitationConfigInput;
  /** The body message for the invitation emails. */
  inviteMessage: Scalars['String'];
  /** The subject line for the invitation emails. */
  inviteSubject: Scalars['String'];
  /** Optional name for the solicitation campaign. */
  name?: InputMaybe<Scalars['String']>;
};

/**
 * Configuration options when creating a new Cash Fund Solicitation. Lacks
 * `clearPhoto` (nothing to clear at creation time) — that field appears only
 * on the Update variant.
 */
export type CreateCashFundSolicitationConfigInput = {
  /** Text for the call-to-action button in the email. */
  buttonText: Scalars['String'];
  /** Whether to include recipient names in the salutation or content. */
  includeRecipientNames: Scalars['Boolean'];
  /**
   * ID of an existing Photo (owned by photo_service) to display in the solicitation email.
   * Mutually exclusive with photoUrl.
   * Contributes to the Solicitation Photo reference
   */
  photoId?: InputMaybe<Scalars['ID']>;
  /**
   * DEPRECATED — use photoId instead. Scheduled for removal once all clients migrate.
   * URL for the photo displayed in the solicitation email (legacy
   * upload-by-URL path).
   * Contributes to the Solicitation Photo reference
   */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** Greeting style for personalized emails (e.g., "Dear friends"). */
  salutation: Scalars['String'];
};

export type CreateBudgetCategoryInput = {
  budgetId: Scalars['ID'];
  icon?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  priority?: InputMaybe<Scalars['Float']>;
};

export type ChecklistItemCreateInput = {
  action?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  reminderAt?: InputMaybe<Scalars['DateTime']>;
  subItems?: InputMaybe<Array<ChecklistSubItemCreateInput>>;
  subtitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ChecklistSubItemCreateInput = {
  action?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateCollectionOnEventMatchPayload = {
  description: Scalars['String'];
  eventMatchId: Scalars['ID'];
  name: Scalars['String'];
};

export type CreateCollectionOnVendorPayload = {
  description: Scalars['String'];
  name: Scalars['String'];
  vendorId: Scalars['ID'];
};

export type CreateCollectionWithPhotos = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  photoIds: Array<Scalars['String']>;
};

export type ContactInput = {
  address?: InputMaybe<ContactAddressInput>;
  contact: ContactInputData;
  phoneNumbers?: InputMaybe<Array<InputMaybe<ContactPhoneNumberInput>>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type ContactAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  householdId?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  region: Scalars['String'];
  validated: Scalars['Boolean'];
};

export type ContactInputData = {
  contactCollectionId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  firebaseEventId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  guestId?: InputMaybe<Scalars['String']>;
  householdDisplayName?: InputMaybe<Scalars['String']>;
  householdId?: InputMaybe<Scalars['String']>;
  isNewPartyMember?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  legacyAddressString?: InputMaybe<Scalars['String']>;
  party?: InputMaybe<Scalars['String']>;
  /** Optional free-text honorific/title. Any value accepted; empty string is treated as unset. */
  prefix?: InputMaybe<Scalars['String']>;
  /** Optional free-text suffix. Any value accepted; empty string is treated as unset. */
  suffix?: InputMaybe<Scalars['String']>;
};

export type ContactPhoneNumberInput = {
  allowSMS: Scalars['Boolean'];
  label?: InputMaybe<Scalars['String']>;
  mobile: Scalars['Boolean'];
  number: Scalars['String'];
};

export type ContactCollectionInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  collectHousehold?: InputMaybe<Scalars['Boolean']>;
  eventDateDisplayEnabled: Scalars['Boolean'];
  eventId?: InputMaybe<Scalars['String']>;
  /**
   * Optional partial update for which fields the collector form asks for. When
   * omitted, current stored settings are preserved. See
   * `ContactCollectorFieldSettingsInput` for merge semantics.
   */
  fieldSettings?: InputMaybe<ContactCollectorFieldSettingsInput>;
  mediaSource: Scalars['String'];
  mediaType: Scalars['String'];
  message: Scalars['String'];
  websiteLinkEnabled: Scalars['Boolean'];
};

/**
 * Partial update payload for `ContactCollection.fieldSettings`. Omitted fields
 * preserve their current stored value; the merged result must still satisfy the
 * at-least-one-REQUIRED invariant or the mutation is rejected.
 */
export type ContactCollectorFieldSettingsInput = {
  address?: InputMaybe<ContactCollectorFieldRequirement>;
  email?: InputMaybe<ContactCollectorFieldRequirement>;
  phone?: InputMaybe<ContactCollectorFieldRequirement>;
};

export type ContactInputWithoutTags = {
  address?: InputMaybe<ContactAddressInput>;
  contact: ContactInputData;
  phoneNumbers?: InputMaybe<Array<InputMaybe<ContactPhoneNumberInput>>>;
};

export enum ContactTagSource {
  contact = 'contact',
  guestlist = 'guestlist',
}

export type RegistryItemMetadata = {
  /** Tells us where the registry item is added from, refer to doc for source type */
  source?: InputMaybe<Scalars['String']>;
  sourceMetadata?: InputMaybe<RegistryItemSourceMetadata>;
};

export type RegistryItemSourceMetadata = {
  /**
   * The Registry Item's known price, as a String, in USD, with no currency symbol when first scanned,
   * It does not necessarily have to match the price that was saved (in fact, when it doesn't that's when we care the most).
   */
  scannedPrice?: InputMaybe<Scalars['String']>;
};

export enum InsertPositionType {
  first = 'first',
  last = 'last',
}

export type CreateDonationFundDonationInput = {
  amountMonetaryMinorValue: Scalars['Int'];
  email: Scalars['String'];
  fundId: Scalars['ID'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  platformType?: InputMaybe<DonationFundPaymentMethodEnum>;
};

export type CreateEmailTemplateInput = {
  eventId: Scalars['String'];
  name: Scalars['String'];
  templateData: Scalars['JSON'];
  templateType: EmailTemplateType;
};

export type EventChecklistCreateInput = {
  eventId: Scalars['ID'];
  items?: InputMaybe<Array<ChecklistItemCreateInput>>;
  title: Scalars['String'];
};

export type CreateEventDesignPayload = {
  colors?: InputMaybe<CreateEventDesignColorsPayload>;
  eventId: Scalars['ID'];
  fontPackName?: InputMaybe<Scalars['String']>;
  layoutName?: InputMaybe<Scalars['String']>;
  pageShadow?: InputMaybe<Scalars['Boolean']>;
  pageTransparency?: InputMaybe<Scalars['Boolean']>;
  /** ie succulent_sunset */
  themeId?: InputMaybe<Scalars['String']>;
};

export type CreateEventDesignColorsPayload = {
  artBackgroundColor?: InputMaybe<Scalars['String']>;
  artFontColor?: InputMaybe<Scalars['String']>;
  linkAndButtonColor?: InputMaybe<Scalars['String']>;
  pageBackgroundColor?: InputMaybe<Scalars['String']>;
  pageFontColor?: InputMaybe<Scalars['String']>;
};

export type CreateEventPagePayload = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  pageSlug?: InputMaybe<Scalars['String']>;
  pageSubTitle?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  private?: InputMaybe<Scalars['Boolean']>;
  type: EventPageType;
};

export type EventPlaceCreatePayload = {
  customName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  googlePlaceId: Scalars['String'];
  type: EventPlaceType;
};

export type EventScheduleCreateItemPayload = {
  description?: InputMaybe<Scalars['String']>;
  dressCode?: InputMaybe<Scalars['String']>;
  endTimeISO8601TZ?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  isPublic?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
  /** Per-item override for the 'Show Add to Calendar' button. null = inherit website settings. */
  showAddToCalendar?: InputMaybe<Scalars['Boolean']>;
  /** Per-item override for the 'Show Directions' link. null = inherit website settings. */
  showDirections?: InputMaybe<Scalars['Boolean']>;
  showMap?: InputMaybe<Scalars['Boolean']>;
  /** Per-item override for the 'Show Where to Stay' link. null = inherit website settings. */
  showWhereToStay?: InputMaybe<Scalars['Boolean']>;
  startTimeISO8601TZ?: InputMaybe<Scalars['String']>;
  unplugged?: InputMaybe<Scalars['Boolean']>;
  virtualEventLink?: InputMaybe<Scalars['String']>;
};

export type CreateEventTypeInput = {
  category: Scalars['String'];
  categorySubtype: Scalars['String'];
  configJson: Scalars['JSONObject'];
  description: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  schemaUrl: Scalars['String'];
  title: Scalars['String'];
};

export type CreateEventPayload0301 = {
  accentColor?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  accentLightText?: InputMaybe<Scalars['Boolean']>;
  accentText?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  acquisitionContext?: InputMaybe<AcquisitionContext>;
  baseColor?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  baseLightText?: InputMaybe<Scalars['Boolean']>;
  baseText?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Navigation layout for the Brannan design */
  brannanNavigation?: InputMaybe<BrannanNavigation>;
  /** Source of the event being created. ie: Create Wedding, Vendor RFP */
  creationSource?: InputMaybe<Scalars['String']>;
  enableTranslucentEffect?: InputMaybe<Scalars['Boolean']>;
  eventDisplayName?: InputMaybe<Scalars['String']>;
  /** List of feature flags to enable for this event */
  eventFeatures?: InputMaybe<Array<Scalars['String']>>;
  eventType?: InputMaybe<EventType>;
  exhibitId?: InputMaybe<Scalars['String']>;
  fianceeFirstName?: InputMaybe<Scalars['String']>;
  fianceeLastName?: InputMaybe<Scalars['String']>;
  font?: InputMaybe<Scalars['String']>;
  graphicAccent?: InputMaybe<Scalars['String']>;
  headerLayout?: InputMaybe<CreateEventHeaderLayoutSettings>;
  /** Tracking information for an Impact Radius Campaign */
  impactRadiusTracking?: InputMaybe<CreateEventImpactRadiusTrackingPayload>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  /** Optional locale override (BCP 47 format, e.g., 'en-US', 'fr', 'ja'). Overrides middleware-detected locale if provided. */
  locale?: InputMaybe<Scalars['String']>;
  /** An ISO-8601 timestamp or datestamp (no 'T') */
  mainDate?: InputMaybe<Scalars['String']>;
  mainTzid?: InputMaybe<Scalars['String']>;
  ownerFirstName?: InputMaybe<Scalars['String']>;
  ownerLastName?: InputMaybe<Scalars['String']>;
  paletteId?: InputMaybe<Scalars['String']>;
  paletteName?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  placeName?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
  theme?: InputMaybe<Scalars['String']>;
  /**
   * Requests that this wedding be created on the Firebase-free stack. The server re-evaluates its
   * own rollout gate and falls back to the legacy stack when that gate is off, so this is a request
   * rather than an instruction. Immutable once the event exists.
   */
  usesNewStack?: InputMaybe<Scalars['Boolean']>;
  useSuggestedBackgroundColor?: InputMaybe<Scalars['Boolean']>;
  useWeddingColor?: InputMaybe<Scalars['Boolean']>;
  /** Venue information for the event. Prefer this over the deprecated flat fields below. */
  venue?: InputMaybe<EventLocationInput>;
  websiteDesignSettings?: InputMaybe<WebsiteDesignSettingsInput>;
};

export type AcquisitionContext = {
  currentTimestamp: Scalars['Float'];
  details: Array<AcquisitionContextDetails>;
};

export type AcquisitionContextDetails = {
  data: Array<AcquisitionContextData>;
  referrer?: InputMaybe<Scalars['String']>;
  relativeUrl: Scalars['String'];
  timestamp: Scalars['Float'];
};

export type AcquisitionContextData = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type CreateEventHeaderLayoutSettings = {
  dataJSON: Scalars['JSON'];
  schemaURL: Scalars['String'];
  websiteLayout?: InputMaybe<Scalars['String']>;
};

export type CreateEventImpactRadiusTrackingPayload = {
  actionTrackerId: Scalars['Int'];
  campaignId: Scalars['Int'];
  clickId: Scalars['String'];
  /** New or Returning */
  customerStatus: Scalars['String'];
  /** An ISO-8601 timestamp */
  eventDate: Scalars['String'];
  orderId: Scalars['String'];
};

/** Venue information for an event */
export type EventLocationInput = {
  countryCode?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  placeId?: InputMaybe<Scalars['String']>;
  placeName?: InputMaybe<Scalars['String']>;
};

export type WebsiteDesignSettingsInput = {
  colors?: InputMaybe<WebsiteDesignColorSettingsInput>;
  fontPackName?: InputMaybe<Scalars['String']>;
  pageShadow?: InputMaybe<Scalars['Boolean']>;
  pageTransparency?: InputMaybe<Scalars['Boolean']>;
  welcomePhotoPresentationLayout?: InputMaybe<Scalars['String']>;
};

export type WebsiteDesignColorSettingsInput = {
  artBackgroundColor?: InputMaybe<Scalars['String']>;
  artFontColor?: InputMaybe<Scalars['String']>;
  linkAndButtonColor?: InputMaybe<Scalars['String']>;
  pageBackgroundColor?: InputMaybe<Scalars['String']>;
  pageFontColor?: InputMaybe<Scalars['String']>;
};

export type CreateFerryTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateFlightTravelItemPayload = {
  code?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateFloorPlanInput = {
  eventId?: InputMaybe<Scalars['ID']>;
  firebaseEventId?: InputMaybe<Scalars['String']>;
  firebaseScheduleItemId?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  measurementUnit?: InputMaybe<MeasurementUnit>;
  name: Scalars['String'];
  scheduleItemId?: InputMaybe<Scalars['ID']>;
  seatOffset?: InputMaybe<Scalars['Float']>;
  venueSpaceId?: InputMaybe<Scalars['ID']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type CreateFloorPlanObjectInput = {
  /** cm; defaults to the kind's catalogue size. */
  height?: InputMaybe<Scalars['Float']>;
  kind: FloorPlanObjectKind;
  /** Defaults to the kind's catalogue label. */
  label?: InputMaybe<Scalars['String']>;
  rotation?: InputMaybe<Scalars['Int']>;
  /** cm; defaults to the kind's catalogue size. */
  width?: InputMaybe<Scalars['Float']>;
  /** Top-left x in cm. Omit x and y together to have the server place the object clear of everything. */
  x?: InputMaybe<Scalars['Float']>;
  /** Top-left y in cm. Omit x and y together to have the server place the object clear of everything. */
  y?: InputMaybe<Scalars['Float']>;
};

export type CreateFloorPlanWithContentsInput = {
  floorPlan: CreateFloorPlanInput;
  /** Non-seating objects to place in the room. At most 100. */
  objects?: InputMaybe<Array<CreateFloorPlanObjectInput>>;
  /** The plan's tables, in the order they should be numbered 1..N. At most 250. `templateId` is not supported here — send the resolved fields. */
  tables: Array<CreateTableInput>;
};

export type CreateTableInput = {
  arrangement?: InputMaybe<SeatingTableArrangement>;
  capacity?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  radius?: InputMaybe<Scalars['Float']>;
  rotation?: InputMaybe<Scalars['Int']>;
  seatLayout?: InputMaybe<Scalars['JSON']>;
  seatOffset?: InputMaybe<Scalars['Float']>;
  shape?: InputMaybe<SeatingTableShape>;
  templateId?: InputMaybe<Scalars['ID']>;
  width?: InputMaybe<Scalars['Float']>;
  /** Top-left x in cm. Omit x and y together to have the server place the table clear of the others. */
  x?: InputMaybe<Scalars['Float']>;
  /** Top-left y in cm. Omit x and y together to have the server place the table clear of the others. */
  y?: InputMaybe<Scalars['Float']>;
};

/** Where seats are placed. staggered only for grid. */
export enum SeatingTableArrangement {
  bottom = 'bottom',
  full = 'full',
  left = 'left',
  right = 'right',
  staggered = 'staggered',
  top = 'top',
}

/** Table shape. Grid for ceremony/theater layout. */
export enum SeatingTableShape {
  grid = 'grid',
  rectangle = 'rectangle',
  round = 'round',
  square = 'square',
}

export type CreateFormInput = {
  config: Scalars['JSONObject'];
  description: Scalars['String'];
  eventId?: InputMaybe<Scalars['String']>;
  schemaUrl: Scalars['String'];
  settings?: InputMaybe<Scalars['JSONObject']>;
  /** Ticket types for this form. Required when ticketingEnabled is true in settings. */
  ticketTypes?: InputMaybe<Array<FormTicketTypeInput>>;
  title: Scalars['String'];
  type?: InputMaybe<FormType>;
};

/**
 * Ticket type definition for form creation (embedded in CreateFormInput).
 * Note: This is different from CreateTicketTypeInput which is used for standalone ticket type creation.
 * eventId and formId are set from the parent form context.
 */
export type FormTicketTypeInput = {
  /** Maximum capacity. Null means unlimited. */
  capacity?: InputMaybe<Scalars['Int']>;
  /** ISO 4217 currency code (e.g., 'USD', 'EUR'). Required. */
  currency: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** Price in minor currency units (cents for USD). Defaults to 0 (free ticket). */
  priceInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** When ticket sales end. Null means no end date. */
  salesEndAt?: InputMaybe<Scalars['DateTime']>;
  /** When ticket sales begin. Null means immediately available. */
  salesStartAt?: InputMaybe<Scalars['DateTime']>;
  /** State of this ticket type. Defaults to ACTIVE. */
  state?: InputMaybe<TicketTypeState>;
};

export type CreateFormTemplateInput = {
  config: Scalars['JSONObject'];
  description: Scalars['String'];
  eventCategoryTags: Array<Scalars['String']>;
  eventSubTypeTags: Array<Scalars['String']>;
  schemaUrl: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type CreateGeneralEventPayload = {
  eventCategory?: InputMaybe<Scalars['String']>;
  eventCategorySubtype?: InputMaybe<Scalars['String']>;
  eventDateIsFinalized?: InputMaybe<Scalars['Boolean']>;
  eventDateISOString?: InputMaybe<Scalars['String']>;
  eventDisplayName: Scalars['String'];
  eventEndTimeISOString?: InputMaybe<Scalars['String']>;
  /** List of feature flags to enable for this event */
  eventFeatures?: InputMaybe<Array<Scalars['String']>>;
  eventLocation?: InputMaybe<GeneralEventPlace>;
  /** Optional locale override (BCP 47 format, e.g., 'en-US', 'fr', 'ja'). Overrides middleware-detected locale if provided. */
  locale?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type GeneralEventPlace = {
  googlePlaceId?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  placeName?: InputMaybe<Scalars['String']>;
};

export type GuestlistCreateCustomColumnInput = {
  defaultValue?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  displayPriority?: InputMaybe<Scalars['Float']>;
  eventId: Scalars['String'];
  name: Scalars['String'];
  placeholderValue?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<GuestlistColumnScope>;
  settings?: InputMaybe<Scalars['JSON']>;
  type: GuestlistCustomColumnType;
};

/** Input for creating a new saved guest list view. */
export type CreateGuestListViewInput = {
  /** Per-view column order and visibility to save. Omit to save no override (fall back to event-level defaults). */
  columns?: InputMaybe<Array<GuestListViewColumnInput>>;
  /** The event this view belongs to. */
  eventId: Scalars['String'];
  /** Filter state to save. Omit to save no filter. */
  filter?: InputMaybe<GuestListMemberFilterInput>;
  /** Display name for the saved view. */
  name: Scalars['String'];
  /** Page size to save. Omit to defer to the user's GuestListSettings default. */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Sort state to save. Omit to save no sort preference. */
  sort?: InputMaybe<GuestListMemberSort>;
};

/** A single column in a view's saved layout. Set exactly one of field / registrationQuestionId / customColumnId. */
export type GuestListViewColumnInput = {
  /** Set when the column is a custom column. */
  customColumnId?: InputMaybe<Scalars['ID']>;
  /** Set when the column is a built-in field (opaque key, e.g. firstName, rsvp). */
  field?: InputMaybe<Scalars['String']>;
  /** Whether this column is hidden in this view. */
  hidden?: Scalars['Boolean'];
  /** Set when the column is a registration answer. */
  registrationQuestionId?: InputMaybe<Scalars['ID']>;
};

export type CreateHotelGuestHaveYouBookedMessageInput = {
  eventId: Scalars['String'];
  guestKeys: Array<Scalars['String']>;
  /**
   * Omit to publish immediately. When set, the send is scheduled for this time, which must be in the
   * future and at least one day before the event date.
   */
  reminderDate?: InputMaybe<Scalars['DateTime']>;
};

export type CreateHotelTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Input to create a new idempotent-operation row. */
export type InternalCreateIdempotentOperationInput = {
  /** The event this operation belongs to. */
  eventId: Scalars['ID'];
  /** The idempotency key that uniquely identifies this operation. */
  idempotencyKey: Scalars['ID'];
  /** The kind of background operation this row tracks. */
  operationType: EphemeralIdempotentOperationType;
  /** The initial lifecycle status of the operation. */
  status: IdempotentOperationStatus;
};

export type CreateInviteePayload = {
  code?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  /** Display name for mailings/correspondence (e.g., 'Mr. Evan Jones & Guest', 'The Smith Family') */
  envelopeName?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<InviteeLocation>;
};

export type CreateJoyDiscountCouponInput = {
  budgetAmount?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<Scalars['String']>;
  discountType: DiscountType;
  discountValue: Scalars['Float'];
  eligibleProducts: Array<ProductType>;
  isBudgetLimited: Scalars['Boolean'];
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  maxDiscountAmount?: InputMaybe<Scalars['Float']>;
  maxUses: Scalars['Int'];
  metadata?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  promotionCodes: Array<CreatePromotionCodeInput>;
  validFrom: Scalars['DateTime'];
  validUntil: Scalars['DateTime'];
};

export type CreatePromotionCodeInput = {
  applicationType: ApplicationType;
  bookerType: BookerType;
  code?: InputMaybe<Scalars['String']>;
  /** Payment type this code works on. Omit for ANY (no restriction). */
  couponPaidWith?: InputMaybe<CouponPaidWith>;
  eventId?: InputMaybe<Scalars['ID']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  maxUses: Scalars['Int'];
  /** Minimum booking spend required to use this code, in minor units (cents). */
  minSpend?: InputMaybe<Scalars['Int']>;
  prefix?: InputMaybe<Scalars['String']>;
  restrictedToEmails?: InputMaybe<Array<Scalars['String']>>;
  scopeType: ScopeType;
  /** Optional per-code expiry date. Must be on or before the parent coupon's validUntil. When null, the coupon's validUntil applies. */
  validUntil?: InputMaybe<Scalars['DateTime']>;
};

export type CreateJoyFeatureCheckoutInput = {
  checkoutFailureUrlTemplate: Scalars['String'];
  checkoutSuccessUrlTemplate: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  currencyConversionData?: InputMaybe<Scalars['JSON']>;
  currencyISO4217?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<StationeryPrintOrderDiscountInput>;
  email: Scalars['String'];
  eventId: Scalars['String'];
  featureType: JoyFeatureType;
  priceConfigId: Scalars['ID'];
  quantity: Scalars['Int'];
  returnUrl?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<StationeryPrintOrderShippingAddressInput>;
};

export type CreateJsonDataContainerPayload = {
  content: Scalars['JSONObject'];
  eventId: Scalars['ID'];
  schemaUrl: Scalars['String'];
  type: Scalars['String'];
};

export type CreateLinkRedirectInput = {
  /** Will be set to true if not provided. */
  active?: InputMaybe<Scalars['Boolean']>;
  /**
   * Optional association to the SMS/email batch that generated this link.
   * Create-only: never changed by an update mutation.
   */
  batchId?: InputMaybe<Scalars['ID']>;
  eventId?: InputMaybe<Scalars['ID']>;
  /**
   * Optional idempotency key. When provided, if a LinkRedirect already exists with
   * the same (sourceService, idempotencyKey), the existing record is returned
   * instead of creating a new one. Max 255 chars: alphanumeric, hyphens, underscores.
   */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /**
   * https://withjoy.com/go/<link> part.
   * Supports custom links, will generate a short link if not provided.
   */
  link?: InputMaybe<Scalars['String']>;
  /**
   * Optional association to the SMS/email message that generated this link.
   * Create-only: never changed by an update mutation.
   */
  messageId?: InputMaybe<Scalars['ID']>;
  /** Metadata: How much service charged for creating this link */
  priceInMinorUnits?: InputMaybe<Scalars['Int']>;
  redirectUrl: Scalars['Url'];
  sourceService: Scalars['String'];
  userId: Scalars['ID'];
};

export type CreateLinkRedirectBlockInput = {
  blockType: BlockType;
  reason?: InputMaybe<Scalars['String']>;
  targetValue: Scalars['String'];
};

export type CreateListTravelItemPayload = {
  eventId: Scalars['ID'];
  name: Scalars['String'];
  newItems: Array<InputMaybe<ListTravelSubItems>>;
};

export type ListTravelSubItems = {
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateMatchPayload = {
  eventId: Scalars['String'];
  matchNote?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MatchStatus>;
  vendorId: Scalars['String'];
  vendorTypeId?: InputMaybe<Scalars['String']>;
};

export type CreateMediaCollectionInput = {
  eventId: Scalars['ID'];
  mediaCollectionAttributes?: InputMaybe<MediaCollectionAlbumAttributeInput>;
  name: Scalars['String'];
  sortBy?: InputMaybe<MediaCollectionSortField>;
  sortDirection?: InputMaybe<MediaCollectionSortDirection>;
  /** Optional stable identifier for the collection kind (e.g. eventPhotos). Free-form; used for later identification. An event may have at most one collection per non-null type. */
  type?: InputMaybe<Scalars['String']>;
};

/** Partial album settings. Optional fields may be omitted; explicit null is treated as omit (merge keeps existing). */
export type MediaCollectionAlbumAttributeInput = {
  /** Whether photo comments are enabled for this album. Null means unset (merge keeps existing). */
  commentsEnabled?: InputMaybe<Scalars['Boolean']>;
  displayMode?: InputMaybe<MediaCollectionDisplayMode>;
  /** Whether photo reactions are enabled for this album. Null means unset (merge keeps existing). */
  reactionsEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type createMediaPhotoInput = {
  eventId: Scalars['ID'];
  magicToken?: InputMaybe<Scalars['String']>;
  photoId: Scalars['ID'];
};

export type createMediaPhotosInput = {
  eventId: Scalars['ID'];
  magicToken?: InputMaybe<Scalars['String']>;
  photoIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Input for creating a new draft. The server zod-validates messagePayload against the channel. */
export type CreateMessageDraftInput = {
  channel: MessageDraftChannel;
  displayLabel: Scalars['String'];
  eventId: Scalars['ID'];
  /** FE-generated UUID. Siblings across channels must share this value. */
  messageBatchId: Scalars['ID'];
  /** Channel-specific payload; see MessageDraft.messagePayload for shape. */
  messagePayload: Scalars['JSON'];
  recipientIds: Array<Scalars['String']>;
  recipientType: MessageDraftRecipientType;
  /**
   * Smart audience, as an alternative to `recipientIds`. Send `recipientIds: []`
   * alongside it — passing both a non-empty `recipientIds` and a rule is
   * rejected, because the server cannot know which the host meant.
   */
  smartRule?: InputMaybe<SmartTagRuleInput>;
  /**
   * The card order this draft is composed from, for a premium digital card send.
   * Omit for every other draft. Siblings across channels must agree on it, for
   * the same reason they must agree on `messageBatchId` — dispatch reads it from
   * whichever sibling is `primary`. A disagreement is rejected here at create,
   * rather than warned about at dispatch, where nothing could be done about it.
   *
   * Must be a card order belonging to `eventId`, on the same terms as the direct
   * send inputs.
   *
   * Set at create and immutable thereafter: `UpdateMessageDraftInput` does not
   * accept it. To re-target a draft at a different card, delete and recreate.
   */
  stationeryOrderId?: InputMaybe<Scalars['ID']>;
};

export type CreateNewEventAdminInvitePayload = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type CreateNoteTravelItemPayload = {
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type PageContainerCreatePayload = {
  contentType?: InputMaybe<PageContentType>;
  eventId: Scalars['ID'];
  labelIds?: InputMaybe<Array<Scalars['ID']>>;
  mainPhotoAlignment?: InputMaybe<PhotoAlignment>;
  mainPhotoCropInfo?: InputMaybe<MainPhotoCropInfoInput>;
  mainPhotoId?: InputMaybe<Scalars['ID']>;
  mainPhotoPresentationLayout?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  personIds?: InputMaybe<Array<Scalars['ID']>>;
  slug: Scalars['String'];
  sortOrder: Scalars['Float'];
  title: Scalars['String'];
  visibility: EventPageVisibility;
};

export type PhotoAlignment = {
  x: PhotoXPosition;
  y: PhotoYPosition;
};

export type MainPhotoCropInfoInput = {
  height: Scalars['Float'];
  unit: Scalars['String'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type CreateColorPayload = {
  color: Scalars['String'];
  eventDesignId: Scalars['ID'];
};

export type CreatePartyForGuestInput = {
  eventId: Scalars['ID'];
  /**
   * The acting guest, resolved from the guest session by form_service. Never
   * client-supplied.
   */
  guestKey: Scalars['String'];
  /** Co-members only. Must be non-empty — an empty party is the single-guest flow. */
  members: Array<PartyMemberNameInput>;
};

/**
 * A co-member the guest declared.
 *
 * An address is optional and is not matched against anything: a contact is created
 * for the declared member either way, exactly as a guest registering off the list
 * gets one. Two contacts may therefore share an address, which is already true
 * elsewhere and is why `Contact.email` carries no unique index.
 */
export type PartyMemberNameInput = {
  /**
   * Where to reach this member. Optional, and blank counts as absent.
   *
   * Stored on their contact, which is what lets an approval or rejection reach
   * them — those notifications are skipped for a member with no address. It does
   * not let them open the registration form: they hold no guest session, so a link
   * to it would start a second registration rather than edit this one.
   *
   * Rejected when present and not a valid address, rather than being dropped
   * silently: the guest typed it for someone who is expecting to hear from us.
   */
  email?: InputMaybe<Scalars['String']>;
  /**
   * The co-member's given name. Required and non-blank. When lastName is omitted
   * this may carry a full name as free text ("Sam Rivera") and is split on the
   * first space; when lastName is given, this is stored as the given name
   * verbatim, so "Mary Jane" + "Watson" is preserved rather than re-split.
   */
  firstName: Scalars['String'];
  /** Omitted falls back to the acting guest's surname. */
  lastName?: InputMaybe<Scalars['String']>;
};

/**
 * Input for creating a payout account for an event.
 * All fields are optional — the payment service defaults to individual/USD/US.
 */
export type CreatePayoutAccountInput = {
  /** Stripe business type (defaults to individual) */
  businessType?: InputMaybe<Scalars['String']>;
  /** ISO 3166-1 alpha-2 country code (defaults to US) */
  countryCode?: InputMaybe<Scalars['String']>;
  /** ISO 4217 currency code (defaults to USD) */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Contact email for the Stripe account (defaults to event owner email) */
  email?: InputMaybe<Scalars['String']>;
};

export type CreatePlusOneGuestInput = {
  eventId: Scalars['ID'];
  guestListMemberId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  /**
   * Optional ID of a previously created plus-one placeholder to consume.
   * If provided, the placeholder will be marked as consumed and linked to the new contact.
   */
  plusOneId?: InputMaybe<Scalars['ID']>;
};

export type CreatePostRsvpHotelBookReminderMessageInput = {
  contactIds: Array<Scalars['String']>;
  eventId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
};

/** Input for creating a new promo code. */
export type CreatePromoCodeInput = {
  /** Whether the code applies to all ticket types. Defaults to true. */
  applicableToAll?: InputMaybe<Scalars['Boolean']>;
  /** Whether orders using this code are auto-approved. Defaults to false. */
  autoApprove?: InputMaybe<Scalars['Boolean']>;
  /** Promo code string. Stored uppercase. Must not contain spaces. */
  code: Scalars['String'];
  /** ISO 4217 currency code. Required for FLAT discount type. */
  currency?: InputMaybe<Scalars['String']>;
  /** Organizer-only description. Never shown to guests. */
  description?: InputMaybe<Scalars['String']>;
  discountType: PromoCodeDiscountType;
  /** Amount in minor units for FLAT; integer 1–100 for PERCENTAGE. */
  discountValue: Scalars['Int'];
  eventId: Scalars['ID'];
  /** Ticket type IDs this code applies to. Required (non-empty) when applicableToAll is false. */
  ticketTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Maximum number of uses. Null means unlimited. */
  usageLimit?: InputMaybe<Scalars['Int']>;
  /** When the code becomes valid (ISO datetime). Null = immediately. */
  validFrom?: InputMaybe<Scalars['DateTime']>;
  /** When the code expires (ISO datetime). Null = no expiry. */
  validUntil?: InputMaybe<Scalars['DateTime']>;
};

export type CreateQandaPayload = {
  answer: Scalars['String'];
  category?: InputMaybe<Scalars['String']>;
  question: Scalars['String'];
  sampleQuestionId?: InputMaybe<Scalars['String']>;
  type: QandaType;
};

export type CreateQRCodeInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  fillColor?: InputMaybe<Scalars['String']>;
  initials?: InputMaybe<Scalars['String']>;
  link: Scalars['String'];
  logoUrl?: InputMaybe<Scalars['String']>;
};

export type CreateRegistrationPartyInput = {
  eventId: Scalars['ID'];
  formId: Scalars['ID'];
  /**
   * Co-members only. The acting guest is implied by the session and must not be
   * listed. Must be non-empty — an empty party is the single-guest flow.
   */
  members: Array<RegistrationPartyMemberInput>;
};

/**
 * A co-member the guest declared.
 *
 * An address is optional and is matched against nothing: a contact is created for
 * the declared member either way, exactly as a guest registering off the list gets
 * one. Two contacts may therefore share an address, as they already can.
 */
export type RegistrationPartyMemberInput = {
  /**
   * Where to reach this member. Optional, and blank counts as absent.
   *
   * Stored on their contact, which is what lets a later approval or rejection
   * reach them — those notifications are skipped for a member with no address. It
   * does not let them open this form: they hold no guest session, so a link to it
   * would begin a second registration rather than edit theirs.
   *
   * Rejected when present and not a valid address, rather than dropped silently:
   * the guest typed it for somebody who is expecting to hear from us.
   */
  email?: InputMaybe<Scalars['String']>;
  /**
   * The co-member's given name. Required and non-blank. When lastName is omitted
   * this may carry a full name as free text ("Sam Rivera") and is split on the
   * first space; when lastName is given, this is stored verbatim as the given name.
   */
  firstName: Scalars['String'];
  /** Omitted falls back to the acting guest's surname. */
  lastName?: InputMaybe<Scalars['String']>;
};

export type CreateRegistryPayload = {
  name: Scalars['String'];
  /** The URL to the Registry website */
  url: Scalars['String'];
};

export type CreateRegistryChecklistPayload = {
  checklistTemplate: ChecklistTemplateEnum;
  eventId: Scalars['ID'];
};

export enum ChecklistTemplateEnum {
  defaultBabyChecklist = 'defaultBabyChecklist',
  /** Used by default for deprecated createRegistryChecklist mutation. */
  defaultWeddingChecklist = 'defaultWeddingChecklist',
}

export type CreateRegistryItemPayload = {
  /** product level data that we own */
  custom: CreateCustomItemDataInput;
  /** Floating point index value, see docs for RegistryItem type */
  fpIndex?: InputMaybe<Scalars['Float']>;
  /** flag to allow the couple to enable get cash equivalent feature */
  isGetCashEquivalent?: InputMaybe<Scalars['Boolean']>;
  /** registry item metadata */
  metadata?: InputMaybe<RegistryItemMetadata>;
  /** flag to allow the couple to mark an item as a 'must have' / favorite */
  mustHave?: InputMaybe<Scalars['Boolean']>;
  /** note added to registry item by couple */
  note?: InputMaybe<Scalars['String']>;
  /**
   * Insertion position in list of all items in event.
   * If specified, this value takes precedence over any fpIndex value
   */
  position?: InputMaybe<InsertPositionType>;
  /** the quantity (number of) items */
  totalRequested?: InputMaybe<Scalars['Int']>;
};

export type CreateCustomItemDataInput = {
  /** External url of image to be imported for product photo */
  imageUrlForImport?: InputMaybe<Scalars['String']>;
  priceAsFloatingPointDecimalString?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: CustomItemDataType;
  url: Scalars['String'];
};

export type CreateRegistryItemFromCatalogItemPayload = {
  /**
   * The id of the catalog category that the item was added from.
   *
   * An item may appear under multiple categories and the specific category
   * needs to be captured for context.
   *
   * Ideally this field would be mandatory (non-null), but we need a migration
   * path as code is already in the wild.
   */
  catalogCategoryId?: InputMaybe<Scalars['ID']>;
  /** The id of the catalog curation type category */
  catalogItemId: Scalars['ID'];
  /** Indicates whether this item should be hidden for guests */
  isHidden?: InputMaybe<Scalars['Boolean']>;
  /** registry item metadata */
  metadata?: InputMaybe<RegistryItemMetadata>;
  /** optional note added to registry item by couple */
  note?: InputMaybe<Scalars['String']>;
  /** Insertion position in list of all items in event. Uses default if omitted */
  position?: InputMaybe<InsertPositionType>;
  /** the quantity (number of) items */
  totalRequested: Scalars['Int'];
};

export type CreateRegistryItemsFromCatalogCategoryPayload = {
  /** The id of the catalog curation type category */
  catalogCategoryId: Scalars['ID'];
  /** Optional note added to registry item by couple */
  note?: InputMaybe<Scalars['String']>;
  /** Optional insertion position in list of all items in event. Uses default if omitted */
  position?: InputMaybe<InsertPositionType>;
  /** Optional quantity (number of) times to add each item. Defaults to 1 */
  totalRequested?: InputMaybe<Scalars['Int']>;
};

export type CreateRegistryPaymentIntentInput = {
  address?: InputMaybe<ShippingAddressInput>;
  /**
   * Used for automatic server-side payment confirmation.
   * Read more about [confirmation tokens](https://docs.stripe.com/payments/finalize-payments-on-the-server?platform=web&type=payment#create-ct)
   */
  confirmationTokenId?: InputMaybe<Scalars['String']>;
  eCard?: InputMaybe<ECard>;
  email: Scalars['String'];
  eventId: Scalars['ID'];
  lineItems?: InputMaybe<Array<RegistryLineItemInput>>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  printOrder?: InputMaybe<PrintOrder>;
  /** example: 'https://withjoy.com/success/${purchaseContextId}' */
  returnUrlTemplate: Scalars['String'];
};

export type CreateRegistryPayoutAccountInput = {
  /** Country code in ISO 3166-1 alpha-3 */
  countryCode: Scalars['String'];
  /** Currency code in ISO 4217 alpha-3 */
  currencyCode: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type CreateRegistryPurchaseContextInput = {
  address?: InputMaybe<ShippingAddressInput>;
  eCard?: InputMaybe<ECard>;
  email: Scalars['String'];
  eventId: Scalars['ID'];
  /** will be mandatory (non-nullable) in future */
  failureUrlTemplate?: InputMaybe<Scalars['String']>;
  lineItems?: InputMaybe<Array<RegistryLineItemInput>>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  printOrder?: InputMaybe<PrintOrder>;
  /** deprecated, use successUrlTemplate and failureUrlTemplate instead, this field will be removed in future */
  rootUrl?: InputMaybe<Scalars['String']>;
  /** example: 'https://withjoy.com/success/${purchaseContextId}' will be mandatory (non-nullable) in future */
  successUrlTemplate?: InputMaybe<Scalars['String']>;
};

export type CreateRegistryOptions = {
  /** If missing, the registry will automatically check if it is syncable */
  type?: InputMaybe<CreateRegistryType>;
};

/** Subset of the 'RegistryType' enum */
export enum CreateRegistryType {
  linked = 'linked',
  synced = 'synced',
}

export type CreateRemindMeLaterEmailInput = {
  email?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
};

export type CreateRentalCarTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateRentalHomeTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateServiceTagPayload = {
  tagName: Scalars['String'];
  vendorId: Scalars['ID'];
};

export type CreateShuttleTravelItemPayload = {
  eventId: Scalars['ID'];
  name: Scalars['String'];
  newItems: Array<InputMaybe<ShuttleTravelSubItems>>;
  notes?: InputMaybe<Scalars['String']>;
};

export type ShuttleTravelSubItems = {
  endTime?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateSingleRegistryItemOrderInput = {
  email: Scalars['String'];
  isPurchased?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  registryItemId: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type CreateSlimEventAndCollection = {
  collectionName: Scalars['String'];
  description: Scalars['String'];
};

export type CreateStationeryDraftPreviewInput = {
  cardConfig: Scalars['JSON'];
  eventID?: InputMaybe<Scalars['String']>;
  hasPostcardRecipientAddress?: InputMaybe<Scalars['Boolean']>;
  hasRecipientAddress?: InputMaybe<Scalars['Boolean']>;
  noLegacyAddressFallback?: InputMaybe<Scalars['Boolean']>;
  stationeryDraftId?: InputMaybe<Scalars['String']>;
};

export type CreateStationeryDraftInput = {
  cardJSON: Scalars['JSON'];
  eventId?: InputMaybe<Scalars['ID']>;
  format?: InputMaybe<StationeryDraftFormat>;
  priceConfigId?: InputMaybe<Scalars['ID']>;
  stationeryTemplateId: Scalars['ID'];
};

export type CreateStationeryDraftFromPrintOrderInput = {
  format?: InputMaybe<StationeryDraftFormat>;
  orderId: Scalars['String'];
};

export type CreateStationeryPriceConfigInput = {
  /** Defaults to false */
  active?: InputMaybe<Scalars['Boolean']>;
  currencyISO4217: Scalars['String'];
  priceConfig: Scalars['JSON'];
  productId: Scalars['ID'];
};

/** Defines a new survey contract. Super-admin/M2M only — the survey definition is never exposed to clients; joy-web hardcodes the resulting id and options in source. */
export type CreateSurveyInput = {
  /** Human-readable description of what this survey is for. */
  description?: InputMaybe<Scalars['String']>;
  /** Unique machine name for the survey, e.g. "hotel_cancellation_guest". */
  name: Scalars['String'];
  /** Fixed set of allowed values for selectedOption on responses to this survey — a closed enum, never validated as free text. */
  options: Array<Scalars['String']>;
  /** Reserved for an optional extended question structure. Not currently validated against. */
  schema?: InputMaybe<Scalars['JSON']>;
  /** Whether responses to this survey are submitted via submitAdminSurveyResponse or submitGuestSurveyResponse. */
  surveyType: SurveyTypeDtoEnum;
};

/** Whether a survey is submitted by an authenticated Joy user (ADMIN) or an unauthenticated guest (GUEST). */
export enum SurveyTypeDtoEnum {
  ADMIN = 'ADMIN',
  GUEST = 'GUEST',
}

export type CreateTableTemplateInput = {
  arrangement?: InputMaybe<Arrangement>;
  capacity: Scalars['Int'];
  height?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  radius?: InputMaybe<Scalars['Float']>;
  seatLayout?: InputMaybe<Scalars['JSON']>;
  shape: TableShape;
  width?: InputMaybe<Scalars['Float']>;
};

export type CreateTaxiTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateTentTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Input for creating a new ticket type. */
export type CreateTicketTypeInput = {
  /** Maximum capacity. Null means unlimited. */
  capacity?: InputMaybe<Scalars['Int']>;
  /** ISO 4217 currency code (e.g., 'USD', 'EUR'). Required. */
  currency: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  formId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  /** Price in minor currency units (cents for USD). Defaults to 0 (free ticket). */
  priceInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** Require approval for on-list guests registering with this ticket under GUEST_LIST_APPROVAL. Defaults to false. */
  requireApproval?: InputMaybe<Scalars['Boolean']>;
  /** When ticket sales end. Null means no end date. */
  salesEndAt?: InputMaybe<Scalars['DateTime']>;
  /** When ticket sales begin. Null means immediately available. */
  salesStartAt?: InputMaybe<Scalars['DateTime']>;
  /** State of this ticket type. Defaults to ACTIVE. */
  state?: InputMaybe<TicketTypeState>;
};

export type CreateTrainTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateTransitionalRegistryPayload = {
  eventId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type CreateTravelAlertSubscriptionInputV1 = {
  anonymousId?: InputMaybe<Scalars['String']>;
  baselinePricingInfo?: InputMaybe<AccommodationCatalogPropertyPricingInfoInputV1>;
  consentAccepted: Scalars['Boolean'];
  email?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  phoneNumber: Scalars['String'];
  source: TravelAlertSubscriptionSourceV1;
  subscribedAlertTypes?: InputMaybe<Array<TravelAlertTriggerTypeV1>>;
};

export type AccommodationCatalogPropertyPricingInfoInputV1 = {
  /** base rate is a price without taxes and fees */
  baseRate: TravelMonetaryValueInputV1;
  /** Platform fees applied to this pricing (e.g. payment processing fee) */
  fees?: InputMaybe<Array<TravelOfferFeeInputV1>>;
  /** nightly base rate is a price without taxes and fees for a one night stay */
  nightlyBaseRate: TravelMonetaryValueInputV1;
  /** nightly total rate is a price with taxes and fees for a one night stay */
  nightlyTotalRate: TravelMonetaryValueInputV1;
  /** nightly base rate per occupancy for a one night stay */
  perNightPerOccupancyBaseAmount?: InputMaybe<TravelMonetaryValueInputV1>;
  /** nightly base rate per occupancy for a one night stay from a compared provider */
  perNightPerOccupancyStrikeoutBaseAmount?: InputMaybe<TravelMonetaryValueInputV1>;
  /** nightly total rate per occupancy for a one night stay */
  perNightPerOccupancyTotalAmount?: InputMaybe<TravelMonetaryValueInputV1>;
  /** a price without taxes and fees from a compared provider */
  strikeoutBaseRate?: InputMaybe<TravelMonetaryValueInputV1>;
  /** a price without taxes and fees for a one night stay from a compared provider */
  strikeoutNightlyBaseRate?: InputMaybe<TravelMonetaryValueInputV1>;
  /** a price with taxes and fees for a one night stay from a compared provider */
  strikeoutNightlyTotalRate?: InputMaybe<TravelMonetaryValueInputV1>;
  /** a provider which was used to get strikeout rates (a compared provider) */
  strikeoutRateProvider?: InputMaybe<StrikeoutRateProviderV1>;
  /** a price with taxes and fees from a compared provider */
  strikeoutTotalRate?: InputMaybe<TravelMonetaryValueInputV1>;
  /** total rate is a price with taxes and fees, but without some fees which can be paid in the hotel */
  totalRate: TravelMonetaryValueInputV1;
};

export type TravelMonetaryValueInputV1 = {
  currency: CurrencyCode;
  digits: Scalars['Int'];
  floatingPointDecimalString: Scalars['String'];
  valueInMinorUnits: Scalars['Int'];
  valueInMinorUnitsBigInt: Scalars['String'];
};

export enum CurrencyCode {
  AED = 'AED',
  AFN = 'AFN',
  ALL = 'ALL',
  AMD = 'AMD',
  ARS = 'ARS',
  AUD = 'AUD',
  AZN = 'AZN',
  BAM = 'BAM',
  BDT = 'BDT',
  BGN = 'BGN',
  BHD = 'BHD',
  BIF = 'BIF',
  BND = 'BND',
  BOB = 'BOB',
  BRL = 'BRL',
  BWP = 'BWP',
  BYN = 'BYN',
  BZD = 'BZD',
  CAD = 'CAD',
  CDF = 'CDF',
  CHF = 'CHF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  CRC = 'CRC',
  CVE = 'CVE',
  CZK = 'CZK',
  DJF = 'DJF',
  DKK = 'DKK',
  DOP = 'DOP',
  DZD = 'DZD',
  EEK = 'EEK',
  EGP = 'EGP',
  ERN = 'ERN',
  ETB = 'ETB',
  EUR = 'EUR',
  GBP = 'GBP',
  GEL = 'GEL',
  GHS = 'GHS',
  GNF = 'GNF',
  GTQ = 'GTQ',
  HKD = 'HKD',
  HNL = 'HNL',
  HRK = 'HRK',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  INR = 'INR',
  IQD = 'IQD',
  IRR = 'IRR',
  ISK = 'ISK',
  JMD = 'JMD',
  JOD = 'JOD',
  JPY = 'JPY',
  KES = 'KES',
  KHR = 'KHR',
  KMF = 'KMF',
  KRW = 'KRW',
  KWD = 'KWD',
  KZT = 'KZT',
  LBP = 'LBP',
  LKR = 'LKR',
  LTL = 'LTL',
  LVL = 'LVL',
  LYD = 'LYD',
  MAD = 'MAD',
  MDL = 'MDL',
  MGA = 'MGA',
  MKD = 'MKD',
  MMK = 'MMK',
  MOP = 'MOP',
  MUR = 'MUR',
  MXN = 'MXN',
  MYR = 'MYR',
  MZN = 'MZN',
  NAD = 'NAD',
  NGN = 'NGN',
  NIO = 'NIO',
  NOK = 'NOK',
  NPR = 'NPR',
  NZD = 'NZD',
  OMR = 'OMR',
  PAB = 'PAB',
  PEN = 'PEN',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  PYG = 'PYG',
  QAR = 'QAR',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  RWF = 'RWF',
  SAR = 'SAR',
  SDG = 'SDG',
  SEK = 'SEK',
  SGD = 'SGD',
  SOS = 'SOS',
  SYP = 'SYP',
  THB = 'THB',
  TND = 'TND',
  TOP = 'TOP',
  TRY = 'TRY',
  TTD = 'TTD',
  TWD = 'TWD',
  TZS = 'TZS',
  UAH = 'UAH',
  UGX = 'UGX',
  USD = 'USD',
  UYU = 'UYU',
  UZS = 'UZS',
  VEF = 'VEF',
  VND = 'VND',
  XAF = 'XAF',
  XOF = 'XOF',
  YER = 'YER',
  ZAR = 'ZAR',
  ZMK = 'ZMK',
  ZWL = 'ZWL',
}

export type TravelOfferFeeInputV1 = {
  amount: TravelMonetaryValueInputV1;
  isIncludedInTotal: Scalars['Boolean'];
  rate: Scalars['Float'];
  type: FeeTypeV1;
  visibility: Scalars['String'];
};

export enum FeeTypeV1 {
  payment_processing_fee = 'payment_processing_fee',
}

export enum StrikeoutRateProviderV1 {
  booking = 'booking',
  expedia = 'expedia',
  unknown = 'unknown',
}

export type CreateVendor = {
  description?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  handle: Scalars['String'];
  location?: InputMaybe<LocationInput>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  startingPrice?: InputMaybe<Scalars['Int']>;
  typeId: Scalars['String'];
  typicalSpend?: InputMaybe<Scalars['Int']>;
  website?: InputMaybe<Scalars['String']>;
};

export type LocationInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type CreateVendorAsCoupleForContactList = {
  email: Scalars['String'];
  eventId: Scalars['String'];
  location?: InputMaybe<LocationInput>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  typeId: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
};

export type CreateVendorUserOnVendor = {
  vendorId: Scalars['String'];
};

export type CreateVenueFromPlaceIdPayload = {
  eventId: Scalars['ID'];
  placeId: Scalars['String'];
};

export type CreateVenueSpaceInput = {
  description?: InputMaybe<Scalars['String']>;
  dimensions?: InputMaybe<Scalars['JSON']>;
  eventId?: InputMaybe<Scalars['ID']>;
  firebaseEventId?: InputMaybe<Scalars['String']>;
  maxCapacity?: InputMaybe<Scalars['Int']>;
  placeId?: InputMaybe<Scalars['String']>;
  seatingSpaceName: Scalars['String'];
};

export type CreateVipPayload = {
  alias?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  photoUrl?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type DeclineAccommodationRecommendationPayload = {
  recommendationId: Scalars['ID'];
};

export type DeleteAccommodationPlaceV2Payload = {
  eventId: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteCustomThemeAssetPayload = {
  eventId: Scalars['ID'];
  id: Scalars['ID'];
};

export type EventScheduleDeleteItemPayload = {
  scheduleId: Scalars['ID'];
};

export type DeleteEventTypeInput = {
  id: Scalars['ID'];
};

/** Input for deleting a saved guest list view. */
export type DeleteGuestListViewInput = {
  /** The event this view belongs to (used for ownership verification). */
  eventId: Scalars['String'];
  /** ID of the view to delete. */
  id: Scalars['ID'];
};

export type DeleteJsonDataContainerPayload = {
  id: Scalars['ID'];
};

export type PageComponentDeletePayload = {
  id: Scalars['ID'];
};

export type PageContainerDeletePayload = {
  id: Scalars['ID'];
};

export type PointsOnMapDeletePayload = {
  id: Scalars['ID'];
};

export type DeleteVipPayload = {
  id: Scalars['ID'];
};

export type DeliverEventInfoChangedPayload = {
  /**
   * Raw legacy changed-info token (client-controlled free text). Never
   * rendered: the consumer maps a bounded allowlist of tokens to specific
   * copy and degrades everything else to the generic message.
   */
  changedInfo?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  kind: EventInfoChangedKind;
  recipient: EmailPerson;
  /**
   * Point-in-time website handle read by the producer at trigger time; when
   * present (non-empty) it wins over the event row, which can lag the
   * legacy->event_service sync.
   */
  website?: InputMaybe<Scalars['String']>;
};

export enum EventInfoChangedKind {
  general = 'general',
  website = 'website',
}

export type DeliverGuestNotFoundMessagePayload = {
  eventId: Scalars['ID'];
  guest: EmailPerson;
};

export type DeliverPhotoAlbumRestoreRequestPayload = {
  eventId: Scalars['ID'];
};

export type DeliverRequestForPasswordPayload = {
  eventId: Scalars['ID'];
  guest: EmailPerson;
};

/** Identifies the dispute whose proposed evidence package CX has decided not to submit. */
export type DisputeEvidenceDismissInput = {
  /** Free-text reviewer note recorded alongside the action; not sent to Stripe. */
  notes?: InputMaybe<Scalars['String']>;
  /** Stripe's dispute id (`dp_...`) for the dispute whose proposal is being dismissed. */
  stripeDisputeId: Scalars['String'];
};

/** Identifies the dispute whose CX-reviewed evidence package should be submitted to Stripe. */
export type DisputeEvidenceSubmitInput = {
  /** Free-text reviewer note recorded alongside the action; not sent to Stripe. */
  notes?: InputMaybe<Scalars['String']>;
  /** Stripe's dispute id (`dp_...`) for the dispute to contest. */
  stripeDisputeId: Scalars['String'];
};

export type DuplicateCashFundInput = {
  cashFundId: Scalars['ID'];
  newName?: InputMaybe<Scalars['String']>;
};

export type PageContainerDuplicatePayload = {
  slug: Scalars['String'];
  sourceId: Scalars['ID'];
  title: Scalars['String'];
};

export enum CacheModes {
  CACHE = 'CACHE',
  NOCACHE = 'NOCACHE',
}

export type EditCollectionInfoPayload = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type EditCollectionItemDataPayload = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type SetConfigurationInput = {
  category: Category;
  fontId?: InputMaybe<Scalars['ID']>;
  fontSize?: InputMaybe<Scalars['Float']>;
  fontSizePercent?: InputMaybe<Scalars['Float']>;
};

export type EditStationeryPrintOrderInput = {
  card: EditStationeryPrintOrderDraftBlobCardInput;
  customizations?: InputMaybe<EditStationeryPrintOrderDraftBlobCustomizationsInput>;
  details: EditStationeryPrintOrderDetailsInput;
  digitalCustomizations?: InputMaybe<EditStationeryPrintOrderDraftBlobDigitalCustomizationsInput>;
  orderId: Scalars['String'];
};

export type EditStationeryPrintOrderDraftBlobCardInput = {
  back?: InputMaybe<Scalars['JSON']>;
  envelope?: InputMaybe<Scalars['JSON']>;
  /**
   * Optional since standalone envelopes: a card-less draft has no front, and its
   * ABSENCE is what marks the blob as envelope-only. Required here, a client would
   * have to send `{}` to satisfy the schema, and the merge in
   * EditStationeryPrintOrderUseCase spreads that back over the stored blob —
   * reintroducing a front key and silently turning the order back into a card.
   *
   * Omit it to leave the stored front alone. An explicit null does the same:
   * the merge drops nullish pages rather than blanking them, because nothing
   * should be able to delete a stored page as a side effect of an edit.
   */
  front?: InputMaybe<Scalars['JSON']>;
};

export type EditStationeryPrintOrderDraftBlobCustomizationsInput = {
  shape?: InputMaybe<Scalars['String']>;
};

export type EditStationeryPrintOrderDetailsInput = {
  assetUrl: Scalars['String'];
  digitalEnvelopeImageUrl?: InputMaybe<Scalars['String']>;
  envelope?: InputMaybe<EditStationeryPrintOrderDetailsEnvelopeInput>;
  postcard?: InputMaybe<EditStationeryPrintOrderDetailsPostcardInput>;
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
};

export type EditStationeryPrintOrderDetailsEnvelopeInput = {
  backImageUrl?: InputMaybe<Scalars['String']>;
  frontImageUrl?: InputMaybe<Scalars['String']>;
  hasRecipientAddress?: InputMaybe<Scalars['Boolean']>;
  url: Scalars['String'];
};

export type EditStationeryPrintOrderDetailsPostcardInput = {
  backImageUrl?: InputMaybe<Scalars['String']>;
  hasRecipientAddress?: InputMaybe<Scalars['Boolean']>;
  interleavedPdfUrl?: InputMaybe<Scalars['String']>;
  sku: Scalars['String'];
  url: Scalars['String'];
};

export type EditStationeryPrintOrderDraftBlobDigitalCustomizationsInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  envelopeAnimation?: InputMaybe<Scalars['String']>;
  envelopeColor?: InputMaybe<Scalars['String']>;
};

export type EventAccommodationsMintShareUrlsPayload = {
  /** The event whose accommodations page will be shared. */
  eventId: Scalars['String'];
};

export type EventSetWebsiteStatePayload = {
  eventId: Scalars['ID'];
  websiteState: EventWebsiteState;
};

export type ExtractMetadataPayload = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  handle: Scalars['String'];
  url: Scalars['String'];
};

export type GenerateAccommodationRecommendationsPayload = {
  /**
   * Override configuration for AI recommendation agent. Only available to superAdmin users.
   * Allows experimentation with different prompts and recommendation limits.
   * Note: Only applies when OpenAI recommendation strategy is active.
   */
  agentConfigOverride?: InputMaybe<AiRecommendationAgentConfigInput>;
  /** Override autorecommendation algorithm. */
  algorithmOverride?: InputMaybe<AutoRecommendationAlgoDtoEnum>;
  customLocation?: InputMaybe<GenerateAccommodationRecommendationsCustomLocation>;
  eventId: Scalars['ID'];
  filters?: InputMaybe<AutoPopulateAccommodationPlacesFilters>;
  /** Optional idempotency key for deferred operation. If provided, enables polling for async results using this ID. */
  idempotentId?: InputMaybe<Scalars['String']>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  searchRadiusKm?: InputMaybe<Scalars['Int']>;
  /** Optional user feedback driving regeneration behavior. */
  userFeedback?: InputMaybe<UserFeedbackDtoEnum>;
};

export type AiRecommendationAgentConfigInput = {
  maxRecommendations?: InputMaybe<Scalars['Int']>;
  modelReasoningEffort?: InputMaybe<Scalars['String']>;
  modelVersion?: InputMaybe<Scalars['String']>;
  prompt?: InputMaybe<Scalars['String']>;
  systemPrompt?: InputMaybe<Scalars['String']>;
};

/** AutoRecommendation algorithm */
export enum AutoRecommendationAlgoDtoEnum {
  LuxSolidDecent = 'LuxSolidDecent',
  OpenAIInternetFirst = 'OpenAIInternetFirst',
  OpenAIInternetFirstV3 = 'OpenAIInternetFirstV3',
  PartnerPicks = 'PartnerPicks',
  UserPreferences = 'UserPreferences',
}

export type GenerateAccommodationRecommendationsCustomLocation = {
  googlePlaceId?: InputMaybe<Scalars['String']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

/** Input for getOrCreateInventoryPlace: a provider and the id that identifies the place within that provider. */
export type GetOrCreateInventoryPlaceInput = {
  /** Which provider the id belongs to. */
  provider: GetOrCreateInventoryPlaceProvider;
  /** Provider-specific id: a zh/nuitee/hopper property id, or a Google Place ID when provider = google. */
  providerId: Scalars['String'];
};

/** Provider key accepted by getOrCreateInventoryPlace. Unlike Provider (the cluster-membership enum), this includes google so a Google Place ID can be resolved to its matched provider cluster. */
export enum GetOrCreateInventoryPlaceProvider {
  /** A Google Place ID; resolves to the inventory place already linked to it. */
  google = 'google',
  /** Hopper property id. */
  hopper = 'hopper',
  /** Nuitee property id. */
  nuitee = 'nuitee',
  /** ZentrumHub property id. */
  zh = 'zh',
}

export type GroupContactsInput = {
  contactIds: Array<Scalars['ID']>;
  eventId: Scalars['ID'];
};

/** Input for creating a Cash Funds Host, which associates payout details with an event. */
export type CreateCashFundsHostInput = {
  /** Address details for the payout account. */
  address: CashFundsHostAddressInput;
  /** An ISO 4217 three-letter currency code */
  currencyCode: Scalars['String'];
  /** The ID of the event to host the cash funds for. */
  eventId: Scalars['ID'];
  /** First name of the host (payee). */
  firstName: Scalars['String'];
  /** Last name of the host (payee). */
  lastName: Scalars['String'];
};

/** Input for the address associated with a Cash Funds Host for payout purposes. */
export type CashFundsHostAddressInput = {
  /** City. */
  city?: InputMaybe<Scalars['String']>;
  /** Country code in ISO 3166-1 alpha-3 */
  countryCode: Scalars['String'];
  /** Primary address line. */
  line1?: InputMaybe<Scalars['String']>;
  /** Secondary address line. */
  line2?: InputMaybe<Scalars['String']>;
  /** Full name on the payout account. */
  name?: InputMaybe<Scalars['String']>;
  /** Phone number for verification. */
  phone?: InputMaybe<Scalars['String']>;
  /** Postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** State or province. */
  state?: InputMaybe<Scalars['String']>;
};

export type InitializeGuestListAttendanceInput = {
  /** Event whose guest list the guests were added to */
  eventId: Scalars['ID'];
  /**
   * Guest keys of the newly added guests. Accepts at most 500 keys per call;
   * larger requests are rejected. Callers adding more should page in batches.
   */
  guestKeys: Array<Scalars['String']>;
};

export type InstagramAuthorizationPayload = {
  code: Scalars['String'];
  vendorId: Scalars['String'];
};

/** The host accepting a room block that holds fewer rooms than they asked for. */
export type InstantRoomBlockAcceptPartialPayload = {
  /** The room count the host is accepting. Must equal the number actually booked. */
  acceptedRoomCount: Scalars['Int'];
  instantRoomBlockId: Scalars['ID'];
};

/** Whether the guest's name has reached the hotel on a claimed room. Sending the request and the hotel applying it are separate steps, and only the hotel's answer finishes the job. */
export enum InstantRoomBlockRenameStateDtoEnum {
  /** The hotel confirmed the guest's name is on the reservation. */
  confirmed = 'confirmed',
  /** The name could not be sent. Joy retries and the block view stays accurate meanwhile. */
  failed = 'failed',
  /** The guest's name has not been sent yet. */
  outstanding = 'outstanding',
  /** The name was sent. It is not finished: the hotel has not yet confirmed it applied the change, and a room can sit here for some days without anything being wrong. */
  sent = 'sent',
}

/** The stage one room inside a block has reached. */
export enum InstantRoomBlockRoomStateDtoEnum {
  /** Cancelled because the block it belongs to did not complete. */
  cancelled = 'cancelled',
  /** A guest has taken this room and paid for it. */
  claimed = 'claimed',
  /** A guest's claim is in progress. No other guest can take this room. */
  claiming = 'claiming',
  /** Booked and available. A guest can claim it. */
  held = 'held',
  /** Cancelled, and Joy is still settling it. Treat it exactly as `released`. */
  release_failed = 'release_failed',
  /** Cancelled because no guest claimed it before the release date. */
  released = 'released',
  /** Joy is still booking this room. */
  reserving = 'reserving',
}

/** The stage a room block has reached. */
export enum InstantRoomBlockStatusDtoEnum {
  /** Rooms are held and guests can claim them. */
  active = 'active',
  /** Fewer rooms were reserved than the host asked for. Those rooms are held until `partialAcceptanceDeadline`. The host accepts them with `instantRoomBlockAcceptPartial`. No answer by the deadline releases them. */
  awaiting_partial_acceptance = 'awaiting_partial_acceptance',
  /** You closed this block. No new guests can claim a room, and any rooms still being cancelled are on their way out. Rooms already claimed by guests are unaffected. */
  closing = 'closing',
  /** The block did not complete, and no room is held. */
  failed = 'failed',
  /** Every room has been claimed or released. Nothing is held any more. */
  finalised = 'finalised',
  /** Joy is still reserving the rooms. No room can be claimed yet. */
  reserving = 'reserving',
}

/** A request to hold a block of hotel rooms for an event. */
export type InstantRoomBlockCreatePayload = {
  /** Echo back the book-by and release dates shown to the host, as their agreement to them. */
  agreedBookByDate: Scalars['String'];
  agreedReleaseDate: Scalars['String'];
  eventId: Scalars['ID'];
  hostEmail: Scalars['String'];
  hostFirstName: Scalars['String'];
  hostLastName: Scalars['String'];
  hostPhone?: InputMaybe<Scalars['String']>;
  /** The offer the host chose from the hotel list. Every room is booked at it. */
  offerToken: Scalars['String'];
  roomCount: Scalars['Int'];
};

/** Photo tier as sold by card_service (free = monetization on, nothing purchased). */
export enum InternalPhotoTier {
  free = 'free',
  gold = 'gold',
  platinum = 'platinum',
}

/** Which expiry clock an extension purchase targets. */
export enum InternalPhotoExpiryType {
  storage = 'storage',
  upload = 'upload',
}

export type JoinEventAsActiveUserWithPasswordPayload = {
  /** Event Password, optional for public Events */
  eventPassword?: InputMaybe<Scalars['String']>;
};

export type JoinEventAsPersonWithPasswordPayload = {
  /** Event Password, optional for public Events */
  eventPassword?: InputMaybe<Scalars['String']>;
  /** Person ID Tag, optional for anonymous unlock */
  personIdTag?: InputMaybe<Scalars['String']>;
};

export type JoinEventWithGuidPayload = {
  guidId: Scalars['String'];
};

export type LoadImageMetadataPayload = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  url: Scalars['String'];
};

/** Input for managing (replacing) the full list of recipients for a Cash Fund Solicitation. This performs a full replacement: deletes all existing and inserts new. */
export type ManageCashFundSolicitationRecipientsInput = {
  /** The complete new list of recipients; must provide all. */
  recipients: Array<CashFundSolicitationRecipientInput>;
  /** The ID of the solicitation whose recipients are being managed. */
  solicitationId: Scalars['ID'];
};

/** Input for specifying a recipient of a Cash Fund Solicitation invite, linking to contacts or providing direct details. */
export type CashFundSolicitationRecipientInput = {
  /** The email address to send the invite to. */
  email: Scalars['String'];
  /** Optional full name of the recipient. */
  fullName?: InputMaybe<Scalars['String']>;
  /** ID of an existing contact from contact_service. */
  guestKey?: InputMaybe<Scalars['String']>;
};

export type ManageJoyCreditInput = {
  /**
   * Values from Commerce_ManageJoyCreditAction:
   *   'create', 'view', 'increment', 'delete'
   */
  action: Scalars['String'];
  /** Required unless 'action' is 'view' or 'delete'. */
  amount?: InputMaybe<CommerceMonetaryValueInput>;
  /** The Event handle; exclusive to 'eventId' */
  eventHandle?: InputMaybe<Scalars['String']>;
  /** The Event ID; exclusive to 'eventHandle' */
  eventId?: InputMaybe<Scalars['ID']>;
  /**
   * Values from Commerce_ManageJoyCreditReason:
   *   'return', 'vendorCancelled', 'delayOOS', 'other', 'shipWhatWeCan'
   */
  reason?: InputMaybe<Scalars['String']>;
};

export type CommerceMonetaryValueInput = {
  currencyCode: Scalars['String'];
  valueInMinorUnits: Scalars['Int'];
};

export type ManagePayoutAccountInput = {
  /**
   * Values from Commerce_ManagePayoutAccountAction:
   *   'view', 'drain', 'fill', 'delete', 'pause', 'reject', 'resume'
   */
  action: Scalars['String'];
  /** The specified management operation is applied to all Events. */
  eventIds: Array<Scalars['ID']>;
  /**
   * Values from RegistryFraudDetectionStatusEnum:
   *   'notFraud', 'suspicious', 'fraud'
   */
  fraudStatus?: InputMaybe<Scalars['String']>;
};

export type MergeContactsInput = {
  contactId: Scalars['ID'];
  contactIdToMerge: Scalars['ID'];
};

/** Bulk-merge PDP bid-history fields into rawOffer.bidHistory on multiple offer tokens. */
export type InternalMergeOfferTokenBidHistoryInput = {
  /** The bid-history merges to apply. */
  items: Array<InternalMergeOfferTokenBidHistoryItemInput>;
};

/** A single PDP bid-history merge in a bulk operation. */
export type InternalMergeOfferTokenBidHistoryItemInput = {
  /** The Joy-minted offer id. */
  joyOfferId: Scalars['ID'];
  /** The PDP bid-history fields to merge into rawOffer.bidHistory. */
  pdpBidHistoryFields: Scalars['JSON'];
};

/** Merge a checkout-time provider offer into an offer token rawOffer.providerVendorResp. */
export type InternalMergeProviderVendorRespInput = {
  /** The Joy-minted offer id. */
  joyOfferId: Scalars['ID'];
  /** The provider offer id the token must still match to be written. */
  providerOfferId: Scalars['String'];
  /** The checkout-time provider offer to store under rawOffer.providerVendorResp. */
  providerVendorResp: Scalars['JSON'];
};

export enum PageMigrationStatus {
  alreadyMigrated = 'alreadyMigrated',
  migrated = 'migrated',
  noNativePage = 'noNativePage',
  skippedFirebasePhoto = 'skippedFirebasePhoto',
  skippedUserGenerated = 'skippedUserGenerated',
}

/** You must provide 3 of 5 properties; (1) `targetId`, (2) **either** `beforeId` or `toLast`, and (3) **either** `afterId` or `toFirst` */
export type ModelReorderPayload = {
  /** The ID of the Model to the left of the Model's new position; *do not specify* `toFirst` */
  afterId?: InputMaybe<Scalars['ID']>;
  /** The ID of the Model to the right of the Model's new position; *do not specify* `toLast` */
  beforeId?: InputMaybe<Scalars['ID']>;
  /** The ID of the Model being moved to a new position in the list */
  targetId: Scalars['ID'];
  /** The Model's new position will be at the start of the list; *do not specify* `afterId` */
  toFirst?: InputMaybe<Scalars['Boolean']>;
  /** The Model's new position will be at the end of the list; *do not specify* `beforeId` */
  toLast?: InputMaybe<Scalars['Boolean']>;
};

export type MoveMediaInCollectionInput = {
  /** Photo that ends up immediately BELOW the moved photo. Null or omitted = moved to the end — beforePhotoId must then be the collection's current LAST photo. */
  afterPhotoId?: InputMaybe<Scalars['ID']>;
  /** Photo that ends up immediately ABOVE the moved photo. Null or omitted = moved to the top — afterPhotoId must then be the collection's current FIRST photo. */
  beforePhotoId?: InputMaybe<Scalars['ID']>;
  /** The collection whose photos are being reordered. */
  collectionId: Scalars['ID'];
  /** The photo being moved. */
  photoId: Scalars['ID'];
};

/** Rating-only patch applied to an existing snapshot without touching its freshness clock. */
export type InternalPatchSnapshotRatingInput = {
  /** The number of ratings the score is based on. */
  count: Scalars['Int'];
  /** The JoyPlace whose snapshot rating is being patched. */
  joyPlaceId: Scalars['ID'];
  /** Content provider whose snapshot rating is being patched. */
  provider: AccommodationContentSnapshotProvider;
  /** The user rating score to store on the snapshot. */
  score: Scalars['Float'];
};

export type ProcessRecommendationPayload = {
  action: ProcessRecommendationAction;
  catalogItemId?: InputMaybe<Scalars['ID']>;
  registryItemId: Scalars['ID'];
};

export enum ProcessRecommendationAction {
  skip = 'skip',
  swap = 'swap',
}

export type QuarantineContactMessageBatchDetailsInput = {
  eventId: Scalars['String'];
  messageBatchId: Scalars['String'];
  messageBatchPayload: Scalars['JSON'];
  messageBatchType: Scalars['String'];
  spamIndicatorsPayload?: InputMaybe<Scalars['JSON']>;
};

export type RecentTravelReservationsByEventMarkAsReadPayload = {
  eventId: Scalars['ID'];
  reservationIds: Array<Scalars['ID']>;
};

/** Options for recordPayoutIncentiveEngagement */
export type RecordPayoutIncentiveEngagementInput = {
  /** The Event whose Couple engaged with the offer. */
  eventId: Scalars['ID'];
  /** The offer that was engaged with. */
  incentiveId: Scalars['ID'];
  /** Whether the offer was seen or clicked. */
  kind: PayoutIncentiveEngagementKind;
  /**
   * Optional free-form label for where in the product the engagement happened, for attribution
   * reporting.
   */
  placement?: InputMaybe<Scalars['String']>;
};

/** The kind of engagement being recorded against an incentive offer. */
export enum PayoutIncentiveEngagementKind {
  /** The Couple clicked through to the partner. */
  click = 'click',
  /** The offer was displayed to the Couple. */
  view = 'view',
}

/** Arguments for warming (background-fetching) reviews for a batch of hotels. */
export type TravelRefreshHotelReviewsInputV1 = {
  /** Force a specific review vendor to warm (e.g. hopper for the content-rating cache); omit to auto-select per place. */
  forceProvider?: InputMaybe<TravelHotelReviewProvider>;
  /** Joy place ids to warm. Each is enqueued as a deduped background fetch job. */
  joyPlaceIds: Array<Scalars['String']>;
};

export type RefreshOfferTokenAfterReservationPayload = {
  currency?: InputMaybe<Scalars['String']>;
  joyOfferId: Scalars['String'];
  originalPriceInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** Room details for all rooms in the reservation. Used for matching offers when old offer is expired. */
  roomDetails?: InputMaybe<Array<RefreshOfferTokenRoomDetails>>;
};

export type RefreshOfferTokenRoomDetails = {
  /** Number of adults in this room */
  adults: Scalars['Int'];
  /** Board basis type */
  boardBasis: Scalars['String'];
  /** Ages of children in this room */
  childrenAges: Array<Scalars['Int']>;
  /** refundable or nonRefundable */
  refundability: Scalars['String'];
  roomName: Scalars['String'];
};

export type RefreshVendorUserTokenPayload = {
  vendorUserId: Scalars['String'];
};

/** Input for re-fetching specific ZH properties. */
export type RefreshZhPlacesInput = {
  /** ZH property ids to re-fetch (1 to 50, duplicates collapsed). */
  zhPropertyIds: Array<Scalars['String']>;
};

/** Result of re-fetching one ZH property. */
export enum ZhPlaceRefreshOutcome {
  /** The upsert failed; see logs. */
  failed = 'failed',
  /** ZH returned no content for this id. The row is left as is. */
  notFound = 'notFound',
  /** Content unchanged; nothing was written. */
  skipped = 'skipped',
  /** Content changed and the row was rewritten. */
  written = 'written',
}

export type TravelOfferReservationRegeneratePaymentPayload = {
  id: Scalars['String'];
};

/**
 * Register a Photo whose bytes already live in the canonical media store at
 * `{containerId}/{assetId}` (written by file-upload-service). Unlike `uploadPhotoFromUrl`,
 * this does no media_service ingest — the caller supplies the metadata the file upload service
 * already extracted. Idempotent: re-registering the same container+assetId returns
 * the existing Photo.
 */
export type RegisterPhotoPayload = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  exifMetadata?: InputMaybe<ExifMetadataInput>;
  height: Scalars['Int'];
  mimeType: Scalars['String'];
  size: Scalars['Int'];
  width: Scalars['Int'];
};

export type ExifMetadataInput = {
  colorSpace?: InputMaybe<Scalars['String']>;
  dateTimeOriginal?: InputMaybe<Scalars['String']>;
  imageHeight?: InputMaybe<Scalars['Int']>;
  imageWidth?: InputMaybe<Scalars['Int']>;
  orientation?: InputMaybe<Scalars['Int']>;
  software?: InputMaybe<Scalars['String']>;
  uploadDateTime?: InputMaybe<Scalars['String']>;
};

export type RemapSeatAssignmentGuestIdsInput = {
  /** The event whose floor plans should be repaired. */
  eventId: Scalars['ID'];
  /** Retired-to-surviving contact id pairs. At most 500 per call. */
  pairs: Array<SeatAssignmentRemapPairInput>;
};

/** One retired contact id and the contact id that survives it. For a merge, `to` is the guest who is still coming — for an inverted bad merge that is the alias, not the original keeper. */
export type SeatAssignmentRemapPairInput = {
  /** The retired contact id currently on the assignment. */
  from: Scalars['ID'];
  /** The surviving contact id that should hold the seat. */
  to: Scalars['ID'];
};

/** Input for removing a Joy discount coupon from a travel reservation. */
export type RemoveJoyDiscountCouponInput = {
  /** The travel offer reservation ID whose coupon should be removed. */
  reservationId: Scalars['String'];
};

export type RemoveContactFromGroupInput = {
  contactId: Scalars['ID'];
  groupId: Scalars['ID'];
};

export type removeMediaFromCollectionInput = {
  collectionId: Scalars['ID'];
  mediaId: Scalars['ID'];
};

export type RemoveMultipleInviteesPayload = {
  eventId: Scalars['ID'];
  personIdsList: Array<Scalars['ID']>;
};

/** Input for releasing a reserved coupon slot. */
export type RemovePromotionCodeInput = {
  /** Which category's application to release. Defaults to PROMOTION (the real coupon slot); pass EVENT_GROUP to release the event group code without touching the real coupon. */
  codeCategory?: InputMaybe<CodeCategory>;
  /** The product-owned entity ID whose slot should be released. */
  productReferenceId: Scalars['ID'];
  /** The product type of the reservation holding the slot. */
  productType: ProductType;
};

export type RemoveStayAreaPayload = {
  id: Scalars['ID'];
};

export type RemoveStayAreaPayloadV2 = {
  eventId: Scalars['ID'];
  id: Scalars['ID'];
};

export type RemoveMatchFromListPayload = {
  eventId: Scalars['String'];
  vendorId: Scalars['String'];
};

export type GuestlistReorderCustomColumnsInput = {
  columnIds: Array<Scalars['ID']>;
  eventId: Scalars['String'];
};

export type ReorderPageComponent = {
  id: Scalars['ID'];
};

/** Input for reporting a provider property id that appears dead. */
export type ReportStaleProviderIdInput = {
  provider: InventoryProvider;
  /** The provider property id that is returning not-found errors. */
  providerId: Scalars['String'];
};

/** Hotel inventory provider that owns a property id. */
export enum InventoryProvider {
  nuitee = 'nuitee',
  zh = 'zh',
}

/** Lifecycle of a stale-provider-id refresh request. Terminal statuses keep the row for dedupe; a new report past the cooldown resets it to pending. */
export enum StaleProviderIdRefreshRequestStatus {
  /** Verified dead but no replacement was found, even after an area refresh. */
  dead_no_replacement = 'dead_no_replacement',
  /** The provider still returns this id, but it now describes a different property. The row is flagged and an area refresh is queued to re-ingest it; nothing was retired, and the re-clustering has not necessarily happened yet. */
  drifted = 'drifted',
  /** Verification kept failing transiently and ran out of attempts. */
  failed = 'failed',
  /** Verified dead and replaced; the healed place was re-published with previousZhId/previousNuiteeId set. */
  healed = 'healed',
  /** Queued for verification by the healing scheduler. */
  pending = 'pending',
  /** The reported id is unknown to the inventory service. */
  rejected = 'rejected',
  /** The provider still returns this id, and it still describes the same property — nothing to heal. */
  rejected_alive = 'rejected_alive',
  /** A replacement candidate exists but is not confident enough to auto-heal; queued for human review. */
  review = 'review',
}

/** Ask for a server-built zip of one album. Nothing is returned inline: the download link is emailed. */
export type RequestBulkPhotoDownloadInput = {
  /** The album (media collection) to zip */
  collectionId: Scalars['ID'];
  /** Guest album callers only: the album's magic token */
  magicToken?: InputMaybe<Scalars['String']>;
  /** Guest album callers only: where to send the link. Hosts receive it at their account email. */
  recipientEmail?: InputMaybe<Scalars['String']>;
  /** Rendition to include; raw needs the event's photos tier to allow full-resolution download */
  resolution: BulkPhotoDownloadResolution;
};

/** `raw` = the stored original bytes; every other value is a media_service rendition passed through as ?rendition= */
export enum BulkPhotoDownloadResolution {
  avatar = 'avatar',
  full = 'full',
  large = 'large',
  medium = 'medium',
  raw = 'raw',
  small = 'small',
  thumb = 'thumb',
  tiny = 'tiny',
  xlarge = 'xlarge',
}

/** Input for requesting an inventory places refresh for a geographic area. */
export type RequestInventoryPlacesRefreshInput = {
  /** Latitude of the center point (-90 to 90). */
  lat: Scalars['Float'];
  /** Longitude of the center point (-180 to 180). */
  lng: Scalars['Float'];
  /** Processing priority (default: normal). */
  priority?: InputMaybe<RefreshPriority>;
  /** Search radius in kilometers (default 5.0, capped at 50). */
  radiusKm?: InputMaybe<Scalars['Float']>;
};

/** Priority level for refresh requests. Higher priority requests are processed first. */
export enum RefreshPriority {
  critical = 'critical',
  high = 'high',
  low = 'low',
  normal = 'normal',
}

/** Processing status of a refresh request. */
export enum RefreshStatus {
  completed = 'completed',
  failed = 'failed',
  pending = 'pending',
  processing = 'processing',
}

export type RequestVendorEdit = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  location?: InputMaybe<LocationInput>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

/** Input for resending the booking confirmation email to one or more email addresses (up to 5). */
export type ResendBookingConfirmationEmailPayload = {
  /** Email addresses to send the confirmation to. At least 1, at most 5. */
  emailAddresses: Array<Scalars['String']>;
  /** ID of the confirmed reservation. */
  reservationId: Scalars['String'];
};

/** Input for resolving a duplicate booking verification — either resume the booking flow or decline and release the hold. */
export type DuplicateBookingVerificationInput = {
  /** Whether the guest wants to resume or decline the booking */
  action: DuplicateBookingVerificationAction;
  /** ID of the reservation */
  reservationId: Scalars['String'];
};

export enum DuplicateBookingVerificationAction {
  /** Cancel the booking attempt and immediately release the Stripe payment hold. */
  decline = 'decline',
  /** Continue with the booking flow. */
  resume = 'resume',
}

/** Input for resolving a single match candidate. */
export type ResolveMatchCandidateInput = {
  id: Scalars['ID'];
  /** Optional note explaining the resolution. */
  note?: InputMaybe<Scalars['String']>;
  resolution: MatchCandidateResolution;
};

/** Why a snapshot entry could not be applied. Restore is best-effort against the plan as it stands now and never resurrects deleted tables, seats or objects. */
export enum RestoreSkipReason {
  OBJECT_DELETED = 'OBJECT_DELETED',
  SEAT_DELETED = 'SEAT_DELETED',
  TABLE_DELETED = 'TABLE_DELETED',
}

/** Input for bulk reviewing (approving or rejecting) photos in a collection */
export type ReviewMediaPhotosInput = {
  /** The collection containing the photos to review */
  collectionId: Scalars['ID'];
  /** The event the collection belongs to */
  eventId: Scalars['ID'];
  /** IDs of the media photos to review (max 500) */
  mediaPhotoIds: Array<Scalars['ID']>;
  /** The approval status to apply */
  status: ApprovalStatus;
};

/** Approval status for admin review actions. Only APPROVED and REJECTED are valid for review — PENDING is set automatically on guest uploads. */
export enum ApprovalStatus {
  /** Photo has been approved by an admin and will appear in the slideshow */
  APPROVED = 'APPROVED',
  /** Photo has been rejected by an admin and will not appear in the slideshow */
  REJECTED = 'REJECTED',
}

/** Machine-readable result code for the reviewMediaPhotos mutation */
export enum ReviewMediaPhotosCode {
  /** All requested photos were reviewed successfully */
  REVIEW_COMPLETE = 'REVIEW_COMPLETE',
  /** Some requested photos were not found in the collection and were skipped */
  REVIEW_PARTIAL = 'REVIEW_PARTIAL',
}

export type ElectronicCardInput = {
  additionalMessage?: InputMaybe<Scalars['String']>;
  coupleNameFormat?: InputMaybe<Scalars['String']>;
  displayDateFormat?: InputMaybe<Scalars['String']>;
  displayDateString?: InputMaybe<Scalars['String']>;
  displayEventLink?: InputMaybe<Scalars['Boolean']>;
  displayTypeString?: InputMaybe<Scalars['String']>;
  ecardId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['String'];
  linkOptionPrimary?: InputMaybe<Scalars['String']>;
  linkOptionSecondary?: InputMaybe<Scalars['String']>;
  locationString?: InputMaybe<Scalars['String']>;
  locationStringFormat?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  photoEcardTheme?: InputMaybe<Scalars['String']>;
  photoEcardThemePositionX?: InputMaybe<Scalars['Float']>;
  photoEcardThemePositionY?: InputMaybe<Scalars['Float']>;
  photoEcardThemeScale?: InputMaybe<Scalars['Float']>;
  photoId?: InputMaybe<Scalars['String']>;
  recipientIds: Array<Scalars['ID']>;
  subTitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
};

export type EcardDesignInput = {
  ecardDesignId?: InputMaybe<Scalars['ID']>;
  ecardId: Scalars['ID'];
  shouldUseEventDesign: Scalars['Boolean'];
  themeId: Scalars['ID'];
};

export type ElectronicCardEmailDraftInput = {
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  ecardEmailDraftId?: InputMaybe<Scalars['ID']>;
  ecardId: Scalars['ID'];
  ecardType: EcardType;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAddToCalendar: Scalars['Boolean'];
  includeDate: Scalars['Boolean'];
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  recipientIds?: InputMaybe<Array<Scalars['ID']>>;
  replyToEmail: Scalars['String'];
  salutation: Scalars['String'];
  subject: Scalars['String'];
  subTitle?: InputMaybe<Scalars['String']>;
  testEmail?: InputMaybe<Scalars['String']>;
  testName?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ElectronicCardPhotoPayloadInput = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  ecardId: Scalars['ID'];
};

export type EmailPhotoPayloadInput = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  emailId: Scalars['ID'];
};

export type UpdateEventProductVerticalsPayload = {
  optOutOfGuestList?: InputMaybe<Scalars['Boolean']>;
  optOutOfInvites?: InputMaybe<Scalars['Boolean']>;
  optOutOfRegistry?: InputMaybe<Scalars['Boolean']>;
  optOutOfWebsite?: InputMaybe<Scalars['Boolean']>;
};

export type EventRegistrationInput = {
  answers?: InputMaybe<Array<CreateAnswerInput>>;
  /** Same contract as SubmitFormAnswersInput.clearedQuestionIds (RSVP-34). */
  clearedQuestionIds?: InputMaybe<Array<Scalars['ID']>>;
  contactInfo?: InputMaybe<FormContactInput>;
  formId: Scalars['ID'];
  guestKey?: InputMaybe<Scalars['String']>;
  /** Optional promo code to apply at checkout. Ignored when form.enablePromoCodes is false. */
  promoCode?: InputMaybe<Scalars['String']>;
  /**
   * The ONLY way to take an applied promo off an existing order (GL-47). Absent or
   * null means false.
   *
   * An absent promoCode on its own no longer removes anything: a re-submit that
   * simply does not re-send the code — a reload of the form with ?guestKey= does
   * not rehydrate it — keeps the order's discounted total, its status and its promo
   * usage exactly as they are. Send removePromoCode: true (with no promoCode) to
   * drop the discount and reprice the order to full price.
   *
   * Sending a promoCode alongside this flag ignores the flag; the code wins.
   */
  removePromoCode?: InputMaybe<Scalars['Boolean']>;
  /** Selected ticket type ID. Required when form has ticketingEnabled in settings. */
  ticketTypeId?: InputMaybe<Scalars['ID']>;
};

export type CreateAnswerInput = {
  answerValue: Scalars['String'];
  questionId: Scalars['ID'];
};

export type FormContactInput = {
  address?: InputMaybe<FormContactAddressInput>;
  contact: FormContactInputData;
  phoneNumbers?: InputMaybe<Array<InputMaybe<FormContactPhoneNumberInput>>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type FormContactAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  householdId?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  region: Scalars['String'];
  validated: Scalars['Boolean'];
};

export type FormContactInputData = {
  email?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  householdDisplayName?: InputMaybe<Scalars['String']>;
  householdId?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  party?: InputMaybe<Scalars['String']>;
};

export type FormContactPhoneNumberInput = {
  allowSMS: Scalars['Boolean'];
  label?: InputMaybe<Scalars['String']>;
  mobile: Scalars['Boolean'];
  number: Scalars['String'];
};

export type GreetingCardInput = {
  cardDetails: Scalars['JSONObject'];
  eventId: Scalars['String'];
  purchaseID?: InputMaybe<Scalars['String']>;
  theme: Scalars['String'];
  type: Scalars['String'];
};

export type GreetingCardInputWithUrl = {
  baseUrl: Scalars['String'];
  cardDetails: Scalars['JSONObject'];
  eventId: Scalars['String'];
  purchaseID?: InputMaybe<Scalars['String']>;
  theme: Scalars['String'];
  type: Scalars['String'];
};

/** Persist a prebook id on an offer token, guarded by its current provider offer id. */
export type InternalSaveOfferTokenPrebookIdInput = {
  /** The Joy-minted offer id. */
  joyOfferId: Scalars['ID'];
  /** The amounts re-derived from the prebook quote. An omitted member is left unchanged. */
  moneyContext?: InputMaybe<InternalOfferTokenMoneyContextInput>;
  /** The prebook id to persist. */
  prebookId: Scalars['String'];
  /** The provider offer id the prebook must still match to be written. */
  providerOfferId: Scalars['String'];
};

/** The offer_token money group (TRAV-4009). Each member is optional: an omitted member leaves its columns untouched on an update and NULL on an insert — never half a member. */
export type InternalOfferTokenMoneyContextInput = {
  /** Joy's commission pair, when the offer carries one. */
  commission?: InputMaybe<InternalOfferTokenCommissionInput>;
  /** The guest-facing FX rate (markup included) Hopper's mapper resolved to convert its vendor-USD amounts into this offer currency. A bare scalar, not a pair like the two members above — no partner column, so it is written or cleared entirely on its own. */
  exchangeRate?: InputMaybe<Scalars['Float']>;
  /** The provider amounts, when the offer carries a provider total. */
  providerAmounts?: InputMaybe<InternalOfferTokenProviderAmountsInput>;
};

/** Joy's own commission on a supplier rate, supplied as a pair (both fields together). */
export type InternalOfferTokenCommissionInput = {
  /** Joy's commission in minor units. */
  amountInMinorUnits: Scalars['Int'];
  /** Joy's commission as a percent of the base rate (0 <= x < 100). */
  percentOfBase: Scalars['Float'];
};

/** What the provider sent: their own total and the commission stated inside it. */
export type InternalOfferTokenProviderAmountsInput = {
  /** Currency of commissionInMinorUnits, independent of totalCurrency. */
  commissionCurrency?: InputMaybe<Scalars['String']>;
  /** The commission the provider stated as inside their total, in minor units. Null when the provider reports none (Nuitee/ZH); must be below the total when present. */
  commissionInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** Currency of totalInMinorUnits. NOT always the same as the offer currency: Hopper reports vendor-USD, every other provider's total is already the guest-currency figure. */
  totalCurrency?: InputMaybe<Scalars['String']>;
  /** The provider total in minor units (> 0). */
  totalInMinorUnits: Scalars['Int'];
};

export type PostOfficeGenericEmailMessageInput = {
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  footerText?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAppInstructions: Scalars['Boolean'];
  includeEventPassword: Scalars['Boolean'];
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  includeWebsiteDetails: Scalars['Boolean'];
  message: Scalars['String'];
  personIds: Array<Scalars['ID']>;
  replyToEmail: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  testEmail?: InputMaybe<Scalars['String']>;
  testName?: InputMaybe<Scalars['String']>;
};

export type PostOfficeGiftWrapEmailMessageInput = {
  assetId?: InputMaybe<Scalars['String']>;
  containerId?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  giftExtraCount?: InputMaybe<Scalars['Int']>;
  giftImage?: InputMaybe<Scalars['String']>;
  giftLink?: InputMaybe<Scalars['String']>;
  giftProvider?: InputMaybe<Scalars['String']>;
  giftTitle?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  replyToEmail?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  theme: Scalars['String'];
};

export type PostOfficeGreetingCardEmailMessageInput = {
  assetId?: InputMaybe<Scalars['String']>;
  containerId?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  greetingCardUrl: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  replyToEmail?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type PostOfficeReminderEmailMessageInput = {
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  footerText?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAppInstructions: Scalars['Boolean'];
  includeEventPassword: Scalars['Boolean'];
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  includeWebsiteDetails: Scalars['Boolean'];
  message: Scalars['String'];
  personIds: Array<Scalars['ID']>;
  replyToEmail: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  testEmail?: InputMaybe<Scalars['String']>;
  testName?: InputMaybe<Scalars['String']>;
};

export type PostOfficeThankYouEmailMessageInput = {
  assetId?: InputMaybe<Scalars['String']>;
  containerId?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  footerText?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  personEmails?: InputMaybe<Array<Scalars['String']>>;
  personIds?: InputMaybe<Array<Scalars['ID']>>;
  replyToEmail: Scalars['String'];
  subject: Scalars['String'];
  testEmail?: InputMaybe<Scalars['String']>;
  testName?: InputMaybe<Scalars['String']>;
};

export type SaveStationeryTemplateInput = {
  approved?: InputMaybe<Scalars['Boolean']>;
  category: StationeryTemplateInternalCategoryEnum;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  side: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  themeId: Scalars['ID'];
  themeJSON: Scalars['JSON'];
  thumbnailUrl?: InputMaybe<Scalars['String']>;
};

/**
 * Superset of StationeryTemplateCategoryEnum — includes all public categories plus
 * internal-only envelope categories (envelope_return, envelope_recipient) that are
 * intentionally excluded from the output enum to avoid breaking joy-web consumers.
 *
 * Do not confuse those two with `envelope`, which IS public: they are envelope
 * artwork, `envelope` is the standalone-envelope product's carrier template.
 *
 * IMPORTANT: every value in StationeryTemplateCategoryEnum must also exist here.
 * GraphQL cannot enforce this relationship, so keep these two enums in sync manually
 * when adding new categories to either. saveStationeryTemplate takes this enum, so a
 * value missing here cannot be written at all.
 */
export enum StationeryTemplateInternalCategoryEnum {
  enclosure = 'enclosure',
  envelope = 'envelope',
  envelope_recipient = 'envelope_recipient',
  envelope_return = 'envelope_return',
  holiday = 'holiday',
  invitation = 'invitation',
  menu = 'menu',
  monogram = 'monogram',
  napkin = 'napkin',
  saveTheDate = 'saveTheDate',
  sign = 'sign',
  thankYou = 'thankYou',
}

export type SaveTagInput = {
  /** Omit for a new tag; provide an existing active tag's id to rename/reorder it. */
  id?: InputMaybe<Scalars['ID']>;
  label: Scalars['String'];
};

export type SaveUserConsentForEventInput = {
  consentAnswer: Scalars['Boolean'];
  consentKey: Scalars['String'];
  consentTermsOfServiceLink?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
};

export type ShortListPayload = {
  eventId: Scalars['String'];
  vendorId: Scalars['String'];
};

export type ShortListEventCreatePayload = {
  vendorId: Scalars['String'];
};

export type ScheduleEventReminderInput = {
  endDate: Scalars['DateTime'];
  isTest?: InputMaybe<Scalars['Boolean']>;
  referenceDate?: InputMaybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
};

/** What became of the target seat’s previous occupant. `UNCHANGED` — the guest already held the seat, so nobody moved. `SEATED` — the seat was empty. `SWAPPED` — both guests were seated, so they exchanged seats. `DISPLACED` — the occupant moved to the nearest free seat at the same table. `UNSEATED` — that table was full, so the occupant left the chart; the only outcome that reduces the number of seated guests. */
export enum SeatGuestOutcome {
  DISPLACED = 'DISPLACED',
  SEATED = 'SEATED',
  SWAPPED = 'SWAPPED',
  UNCHANGED = 'UNCHANGED',
  UNSEATED = 'UNSEATED',
}

/** One drop in a `seatGuests` batch: a guest, and the seat to seat them on. Unlike `SeatAssignmentInput` there is no vacate mode — seating nobody is not a drop — so at least one identity form is required. guestId and legacyGuestId are the same guest’s two forms, not two guests. */
export type SeatGuestAssignmentInput = {
  /** Contact id of the guest being seated. */
  guestId?: InputMaybe<Scalars['ID']>;
  /** The same guest’s legacy/firebase key. Pass alongside guestId whenever known: matching on either form is what lets the server see a guest who is already seated under the legacy key. */
  legacyGuestId?: InputMaybe<Scalars['String']>;
  /** The drop target. May be empty or occupied. */
  seatId: Scalars['ID'];
};

/** Input for sending a test email for a Cash Fund Solicitation to verify formatting and content. */
export type SendCashFundSolicitationTestEmailInput = {
  /** Email address to send the test to. */
  email: Scalars['String'];
  /** Name to use for the test recipient personalization. */
  name: Scalars['String'];
  /** The ID of the solicitation to test. */
  solicitationId: Scalars['ID'];
};

export type SendContactCollectorMessagesInput = {
  body: Scalars['String'];
  emailPersonIds?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  linkLabel?: InputMaybe<Scalars['String']>;
  smsContent?: InputMaybe<Scalars['String']>;
  smsPersonIds?: InputMaybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
  testEmailAddress?: InputMaybe<Scalars['String']>;
  testSMSNumber?: InputMaybe<Scalars['String']>;
};

export type EcardEmailArgs = {
  buttonLink: Scalars['String'];
  buttonText: Scalars['String'];
  date: Scalars['String'];
  emailType: Scalars['String'];
  eventId: Scalars['ID'];
  eventName: Scalars['String'];
  eventWebsite: Scalars['String'];
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  greeting: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAddToCalendar: Scalars['Boolean'];
  includeDate: Scalars['Boolean'];
  location?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  sentToPersonId: Scalars['String'];
  subject: Scalars['String'];
  subTitle: Scalars['String'];
  title: Scalars['String'];
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type ElectronicCardEmailMessageInput = {
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  ecardEmailId?: InputMaybe<Scalars['ID']>;
  ecardId?: InputMaybe<Scalars['ID']>;
  ecardType?: InputMaybe<EcardType>;
  footerText?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAddToCalendar: Scalars['Boolean'];
  includeDate: Scalars['Boolean'];
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  recipientIds?: InputMaybe<Array<Scalars['ID']>>;
  replyToEmail?: InputMaybe<Scalars['String']>;
  salutation: Scalars['String'];
  subject: Scalars['String'];
  subTitle?: InputMaybe<Scalars['String']>;
  testEmail?: InputMaybe<Scalars['String']>;
  testName?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SendEventDateReminderInput = {
  emailHeadline: Scalars['String'];
  emailTypeOverride: Scalars['String'];
  eventId: Scalars['String'];
  guestFirstName: Scalars['String'];
  guestId?: InputMaybe<Scalars['String']>;
  notAttending?: InputMaybe<Scalars['Boolean']>;
  recipientEmailList: Array<Scalars['String']>;
  recipientPhoneNumberList: Array<Scalars['String']>;
  smsHeadline: Scalars['String'];
  subject: Scalars['String'];
  utmCampaign: Scalars['String'];
};

export type GenericEmailArgs = {
  emailType: Scalars['String'];
  eventId: Scalars['String'];
  eventLink?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventPassword?: InputMaybe<Scalars['String']>;
  eventWebsite?: InputMaybe<Scalars['String']>;
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  greeting?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAppInstructions?: InputMaybe<Scalars['Boolean']>;
  includeEventPassword?: InputMaybe<Scalars['Boolean']>;
  includeWebsiteDetails?: InputMaybe<Scalars['Boolean']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  replyToEmail: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  sentByUserId?: InputMaybe<Scalars['String']>;
  sentForEventId?: InputMaybe<Scalars['String']>;
  sentForVendorId?: InputMaybe<Scalars['String']>;
  sentToPersonId?: InputMaybe<Scalars['String']>;
  sentToUserId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type GiftCardEmailArgs = {
  emailType: Scalars['String'];
  eventId: Scalars['String'];
  fromEmail: Scalars['String'];
  giftExtraCount?: InputMaybe<Scalars['Int']>;
  giftImage?: InputMaybe<Scalars['String']>;
  giftLink?: InputMaybe<Scalars['String']>;
  giftProvider?: InputMaybe<Scalars['String']>;
  giftTitle?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  replyToEmail: Scalars['String'];
  sentByUserId?: InputMaybe<Scalars['String']>;
  sentForEventId?: InputMaybe<Scalars['String']>;
  sentForVendorId?: InputMaybe<Scalars['String']>;
  sentToPersonId?: InputMaybe<Scalars['String']>;
  sentToUserId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  theme: Scalars['String'];
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type MessageRelationArgs = {
  externalMessageId: Scalars['String'];
  redirectUri?: InputMaybe<Scalars['String']>;
  relationId?: InputMaybe<Scalars['ID']>;
  relationshipTag?: InputMaybe<Scalars['String']>;
};

export type SendHostGuestStayReportInputV1 = {
  eventId: Scalars['ID'];
};

/** What the guest-stay-report send actually did. Only `sent` means an email left this run. */
export enum HostGuestStayReportOutcomeV1 {
  /** Every host was mailed on an earlier call; nothing was sent. */
  alreadySent = 'alreadySent',
  /** At least one host was mailed on this call. */
  sent = 'sent',
  /** The per-event launch flag is off for this event. */
  skippedDisabled = 'skippedDisabled',
  /** No owner or admin on the event has an email address. */
  skippedNoHostEmail = 'skippedNoHostEmail',
  /** The event has no website slug, so both links would be dead. Also returned when the event is not found. */
  skippedNoWebsite = 'skippedNoWebsite',
  /** The host turned off travel emails, or this email type. */
  skippedOptedOut = 'skippedOptedOut',
}

export type SendHotelBlockReminderRequest = {
  body: Scalars['String'];
  emailPersonIds?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['String'];
  link: Scalars['String'];
  smsPersonIds?: InputMaybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
  testEmailAddress?: InputMaybe<Scalars['String']>;
  testSMSNumber?: InputMaybe<Scalars['String']>;
};

export type SendHotelReminderEmailRequest = {
  body: Scalars['String'];
  emailPersonIds?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['String'];
  link: Scalars['String'];
  subject: Scalars['String'];
  testEmailAddress?: InputMaybe<Scalars['String']>;
};

export type SendHotelReminderEmailV2Input = {
  body: Scalars['String'];
  emailPersonIds?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  link: Scalars['String'];
  smsContent?: InputMaybe<Scalars['String']>;
  smsPersonIds?: InputMaybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
  testEmailAddress?: InputMaybe<Scalars['String']>;
  testSMSNumber?: InputMaybe<Scalars['String']>;
};

/**
 * Input for sending a JSON-structured message email to guests.
 * The payload must include schemaURI (URL to JSON schema), subject, and messageType fields.
 */
export type SendJoyJsonMessageEmailInput = {
  eventId: Scalars['String'];
  /** List of guest keys to send the message to */
  guestKeys: Array<Scalars['String']>;
  /** JSON payload that will be validated against the schema specified in payload.schemaURI */
  payload: Scalars['JSON'];
  /** Subject line for the email message */
  subject: Scalars['String'];
};

/**
 * Input for sending a JSON-structured message email to people.
 * The payload must include schemaURI (URL to JSON schema), subject, and messageType fields.
 * NOTE: This is only for Events during the transitionary state before full wedding parity.
 */
export type SendJoyJsonMessageEmailByPeopleIdsInput = {
  eventId: Scalars['String'];
  /** JSON payload that will be validated against the schema specified in payload.schemaURI */
  payload: Scalars['JSON'];
  /** List of people to send the message to */
  people: Array<PersonRecipientInput>;
  /** Subject line for the email message */
  subject: Scalars['String'];
};

/**
 * Person recipient information for sending emails.
 * Client provides all necessary data to avoid redundant M2M calls.
 * NOTE: This is only for Events during the transitionary state before full wedding parity.
 */
export type PersonRecipientInput = {
  /** Person's email address (required for delivery) */
  email: Scalars['String'];
  /** Person's first name for email personalization */
  firstName?: InputMaybe<Scalars['String']>;
  /** Person's last name for email personalization */
  lastName?: InputMaybe<Scalars['String']>;
  personId: Scalars['String'];
};

export type SendJoyJsonMessagesInput = {
  /** Guest keys for email recipients */
  emailGuestKeys: Array<Scalars['String']>;
  eventId: Scalars['String'];
  /**
   * Optional custom display name for the email sender. When omitted, the Event
   * Display Name is used. Has no effect on SMS — SMS sender identity is controlled
   * by the originating number.
   */
  fromName?: InputMaybe<Scalars['String']>;
  /** JSON payload validated against payload.schemaURI. Must include schemaURI and messageType. */
  payload: Scalars['JSON'];
  /**
   * Plain-text content for SMS messages. Required when sending SMS.
   * The email JSON payload structure is dynamic and there is no reliable way to extract
   * appropriate SMS content from it, so explicit SMS text must be provided when sending SMS.
   */
  smsContent?: InputMaybe<Scalars['String']>;
  /** Guest keys for SMS recipients. Requires Messaging Plus tier. */
  smsGuestKeys: Array<Scalars['String']>;
  /**
   * Optional CTA link for the SMS. Carried as a structured linkUrls field (not inlined
   * into smsContent). Each recipient's guest identifier (guestKey) is appended
   * downstream for first-party withjoy.com URLs only; pre-existing query params (UTM)
   * are preserved. Omit for no SMS link.
   */
  smsLink?: InputMaybe<Scalars['String']>;
  /**
   * Optional MMS media for the SMS. Emitted as smsInfo.mediaUrls and forwarded to
   * Twilio as a combined MMS (image + text in one message). Limited to a single
   * image URL for now; modeled as an array for forward-compat. Omit for a
   * text-only SMS.
   */
  smsMediaUrls?: InputMaybe<Array<Scalars['String']>>;
  /**
   * The card order this send is composed from, for a premium digital card send.
   * Omit for every other send.
   *
   * Rides the queue envelope alongside `messageBatchId`, so every message this
   * batch produces — email and SMS alike — is attributable to the order. The
   * batch id identifies this one send; this identifies the card, which the
   * couple may send again later. Per-order surfaces aggregate on it.
   *
   * Must be a card order belonging to `eventId`. Being an admin of the event is
   * not enough on its own — the order is checked too, because the association is
   * stamped onto the envelope and cannot be corrected afterwards.
   */
  stationeryOrderId?: InputMaybe<Scalars['ID']>;
  /** Subject line for the email message */
  subject: Scalars['String'];
};

export type SendJoyJsonMessagesByPersonIdsInput = {
  /** Person IDs for email recipients */
  emailPersonIds: Array<Scalars['ID']>;
  eventId: Scalars['String'];
  /**
   * Optional custom display name for the email sender. When omitted, the Event
   * Display Name is used. Has no effect on SMS — SMS sender identity is controlled
   * by the originating number.
   */
  fromName?: InputMaybe<Scalars['String']>;
  /** JSON payload validated against payload.schemaURI. Must include schemaURI and messageType. */
  payload: Scalars['JSON'];
  /**
   * Plain-text content for SMS messages. Required when sending SMS.
   * The email JSON payload structure is dynamic and there is no reliable way to extract
   * appropriate SMS content from it, so explicit SMS text must be provided when sending SMS.
   */
  smsContent?: InputMaybe<Scalars['String']>;
  /**
   * Optional CTA link for the SMS. Carried as a structured linkUrls field (not inlined
   * into smsContent). Each recipient's guest identifier (inviteeId/pid) is appended
   * downstream for first-party withjoy.com URLs only; pre-existing query params (UTM)
   * are preserved. Omit for no SMS link.
   */
  smsLink?: InputMaybe<Scalars['String']>;
  /**
   * Optional MMS media for the SMS. Emitted as smsInfo.mediaUrls and forwarded to
   * Twilio as a combined MMS (image + text in one message). Limited to a single
   * image URL for now; modeled as an array for forward-compat. Omit for a
   * text-only SMS.
   */
  smsMediaUrls?: InputMaybe<Array<Scalars['String']>>;
  /** Person IDs for SMS recipients. Requires Messaging Plus tier. */
  smsPersonIds: Array<Scalars['ID']>;
  /**
   * The card order this send is composed from, for a premium digital card send.
   * Omit for every other send.
   *
   * Rides the queue envelope alongside `messageBatchId`, so every message this
   * batch produces — email and SMS alike — is attributable to the order. The
   * batch id identifies this one send; this identifies the card, which the
   * couple may send again later. Per-order surfaces aggregate on it.
   *
   * Must be a card order belonging to `eventId`. Being an admin of the event is
   * not enough on its own — the order is checked too, because the association is
   * stamped onto the envelope and cannot be corrected afterwards.
   */
  stationeryOrderId?: InputMaybe<Scalars['ID']>;
  /** Subject line for the email message */
  subject: Scalars['String'];
};

export type SendJoyProGeneralMessageEmailInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  guestKeys: Array<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type MessageToMultipleVendorsPayload = {
  budget?: InputMaybe<Scalars['Int']>;
  coupleName?: InputMaybe<Scalars['String']>;
  eventDate?: InputMaybe<Scalars['String']>;
  fianceeFirstName: Scalars['String'];
  fromEmail: Scalars['String'];
  ids: Array<Scalars['String']>;
  ownerFirstName: Scalars['String'];
  photosForCollection?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeIdForVenue?: InputMaybe<Scalars['String']>;
  requestSentAt: Scalars['String'];
  text: Scalars['String'];
};

export type MessageToVendorPayload = {
  budget?: InputMaybe<Scalars['Int']>;
  coupleName?: InputMaybe<Scalars['String']>;
  eventDate?: InputMaybe<Scalars['String']>;
  fianceeFirstName: Scalars['String'];
  fromEmail: Scalars['String'];
  id: Scalars['ID'];
  ownerFirstName: Scalars['String'];
  photosForCollection?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeIdForVenue?: InputMaybe<Scalars['String']>;
  requestSentAt: Scalars['String'];
  text: Scalars['String'];
};

export type PostOfficeGreetingCardEmailInput = {
  draftId: Scalars['ID'];
  eventId: Scalars['ID'];
  giverName: Scalars['String'];
  replyToEmail: Scalars['String'];
};

export type EmailRelationInput = {
  externalMessageId: Scalars['String'];
  redirectUri: Scalars['String'];
  relationshipTag?: InputMaybe<Scalars['String']>;
};

export type SendPostOfficeThankYouEmailV2Input = {
  eventId: Scalars['String'];
  eventName: Scalars['String'];
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  personId: Scalars['String'];
  relationData?: InputMaybe<SendPostOfficeThankYouEmailRelationDataV2Input>;
  replyToEmail: Scalars['String'];
  subject: Scalars['String'];
  toEmail: Scalars['String'];
};

export type SendPostOfficeThankYouEmailRelationDataV2Input = {
  externalMessageId: Scalars['String'];
  redirectUri: Scalars['String'];
  relationshipTag?: InputMaybe<Scalars['String']>;
};

export type SendPostRsvpEventDetailsEmailInput = {
  email: Scalars['String'];
  eventId: Scalars['String'];
  guestFirstName: Scalars['String'];
  guestId?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  notAttending?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type SendPostRsvpMessagesInput = {
  eventId: Scalars['String'];
  recipientResponses: Array<RsvpResponse>;
  /** When true, suppresses the couple/host RSVP summary email. Used for replaying failed guest notifications without sending stale summaries. */
  skipCoupleSummaryEmail?: InputMaybe<Scalars['Boolean']>;
};

export type RsvpResponse = {
  guestFirebaseId: Scalars['String'];
  isRsvpSubmitter?: InputMaybe<Scalars['Boolean']>;
  notAttending?: InputMaybe<Scalars['Boolean']>;
  questions: Array<RsvpQuestion>;
  sendHouseholdSms?: InputMaybe<Scalars['Boolean']>;
  skipRsvpEmails?: InputMaybe<Scalars['Boolean']>;
};

export type RsvpQuestion = {
  answer: Scalars['String'];
  question: Scalars['String'];
};

/** One sendPostRsvpMessagesByGuestKeys batch: an event and its opted-in recipients. */
export type SendPostRsvpMessagesByGuestKeysInput = {
  /** The event whose event-details email is being sent. */
  eventId: Scalars['String'];
  /**
   * The party's rendered RSVP record — one entry per member who has answers, leader
   * first. Display names and display text only, never email addresses. On a
   * NEW-STACK WEDDING (eventType wedding with usesNewStack) a non-empty list also
   * sends every opted-in recipient the guest RSVP-summary email carrying this record;
   * for every other event it is ignored (with telemetry). Omitted or empty: the
   * event-details email only, exactly as before. At most 20 entries.
   */
  partyResponses?: InputMaybe<Array<PostRsvpPartyResponseInput>>;
  /** Deduplicated by guestKey server-side; at most 20 per call. */
  recipients: Array<PostRsvpRecipientInput>;
  /**
   * Site-relative destination for the guest RSVP-summary email's "Edit Your
   * Responses" button — e.g. `/registration/<formId>`. The server wraps it in the
   * event's `/eventredirect/` hop, so it must be a path and not a URL: one leading
   * slash, no `//` prefix, no scheme or host, no whitespace or backslash, at most
   * 512 characters. Anything else is a 400, because the value ends up as a
   * redirect destination.
   *
   * Only meaningful together with `partyResponses` on a NEW-STACK WEDDING; every
   * other event ignores it exactly as it ignores the record. Omitted: the summary
   * email keeps its built-in legacy `/rsvp` link.
   */
  rsvpPath?: InputMaybe<Scalars['String']>;
};

/**
 * One party member's entry in the party's RSVP record. `guestName` is a display
 * name (first name or display name), never an email address.
 */
export type PostRsvpPartyResponseInput = {
  guestName: Scalars['String'];
  questions: Array<PostRsvpQuestionInput>;
};

/**
 * One rendered registration question and its answer, as form_service renders them
 * (question text and answer as display text only — no ids, no addresses).
 */
export type PostRsvpQuestionInput = {
  answer: Scalars['String'];
  question: Scalars['String'];
};

/**
 * One post-RSVP recipient, identified by the guest key form_service registration
 * issues — not by the legacy `guestFirebaseId` the older mutations expect.
 */
export type PostRsvpRecipientInput = {
  /** The recipient's guest key, as issued by form_service registration. */
  guestKey: Scalars['String'];
  /** Suppresses accommodations/travel links for declining guests. */
  notAttending?: InputMaybe<Scalars['Boolean']>;
};

export type SendPostRsvpMessagesInputV2 = {
  eventId: Scalars['String'];
  recipientResponses: Array<RsvpResponseV2>;
};

export type RsvpResponseV2 = {
  guestFirebaseId: Scalars['String'];
  isRsvpSubmitter?: InputMaybe<Scalars['Boolean']>;
  notAttending?: InputMaybe<Scalars['Boolean']>;
  questions: Array<RsvpQuestionV2>;
  sendHouseholdSms?: InputMaybe<Scalars['Boolean']>;
  skipRsvpEmails?: InputMaybe<Scalars['Boolean']>;
};

export type RsvpQuestionV2 = {
  answer: Scalars['String'];
  question: Scalars['String'];
};

export type SendPostRsvpSmsInput = {
  code: Scalars['String'];
  eventId: Scalars['String'];
  guestId?: InputMaybe<Scalars['String']>;
  notAttending?: InputMaybe<Scalars['Boolean']>;
  phone: Scalars['String'];
};

export type SendPremiumDigitalOrderInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  recipientIdList: Array<Scalars['ID']>;
  senderName: Scalars['String'];
  smsRecipientIdList?: InputMaybe<Array<Scalars['ID']>>;
  subject: Scalars['String'];
};

/** An registryItemId and email used to lookup a RegistryOrder item for resending an email */
export type SendRegistryOrderConfirmationInput = {
  email: Scalars['String'];
  emailIntent?: InputMaybe<RegistryOrderEmailIntent>;
  registryItemId: Scalars['String'];
};

/** Email type so send different subject lines and headers */
export enum RegistryOrderEmailIntent {
  find = 'find',
  reminder = 'reminder',
  reservation = 'reservation',
}

export type ReminderEmailArgs = {
  emailType: Scalars['String'];
  eventId: Scalars['String'];
  eventLink?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventPassword?: InputMaybe<Scalars['String']>;
  eventWebsite?: InputMaybe<Scalars['String']>;
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  greeting?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAppInstructions?: InputMaybe<Scalars['Boolean']>;
  includeEventPassword?: InputMaybe<Scalars['Boolean']>;
  includeWebsiteDetails?: InputMaybe<Scalars['Boolean']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  replyToEmail: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  sentByUserId?: InputMaybe<Scalars['String']>;
  sentForEventId?: InputMaybe<Scalars['String']>;
  sentForVendorId?: InputMaybe<Scalars['String']>;
  sentToPersonId?: InputMaybe<Scalars['String']>;
  sentToUserId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type SendRsvpReminderV2Input = {
  body: Scalars['String'];
  emailPersonIds?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  link: Scalars['String'];
  smsContent?: InputMaybe<Scalars['String']>;
  smsPersonIds?: InputMaybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
};

/**
 * Input for sending a plain-text SMS to guests via guest keys (SMS-only path).
 * No email sibling — the email-payload validation is skipped.
 */
export type SendSmsMessageInput = {
  /** Human-readable batch identifier used for tracking-center display and spam-guard metadata. */
  displayLabel: Scalars['String'];
  eventId: Scalars['String'];
  /** Guest keys for SMS recipients. Requires Messaging Plus tier. */
  guestKeys: Array<Scalars['String']>;
  /** Optional override. When provided, reuses this batch id instead of generating one. Scoped to the SMS draft/scheduling path. */
  messageBatchId?: InputMaybe<Scalars['ID']>;
  /** Plain-text SMS body. Required. */
  smsContent: Scalars['String'];
  /**
   * Optional MMS media. Emitted as smsInfo.mediaUrls and forwarded to Twilio as a
   * combined MMS. Limited to a single image URL for now; modeled as an array for
   * forward-compat. Omit for a text-only SMS.
   */
  smsMediaUrls?: InputMaybe<Array<Scalars['String']>>;
  /**
   * The card order this send is composed from, for a premium digital card send.
   * Omit for every other send. See SendJoyJsonMessagesInput.stationeryOrderId.
   */
  stationeryOrderId?: InputMaybe<Scalars['ID']>;
};

/**
 * Input for sending a plain-text SMS to people via person IDs (SMS-only path).
 * No email sibling — the email-payload validation is skipped.
 */
export type SendSmsMessageByPersonIdsInput = {
  /** Human-readable batch identifier used for tracking-center display and spam-guard metadata. */
  displayLabel: Scalars['String'];
  eventId: Scalars['String'];
  /** Optional override. When provided, reuses this batch id instead of generating one. Scoped to the SMS draft/scheduling path. */
  messageBatchId?: InputMaybe<Scalars['ID']>;
  /** Person IDs for SMS recipients. Requires Messaging Plus tier. */
  personIds: Array<Scalars['ID']>;
  /** Plain-text SMS body. Required. */
  smsContent: Scalars['String'];
  /**
   * Optional MMS media. Emitted as smsInfo.mediaUrls and forwarded to Twilio as a
   * combined MMS. Limited to a single image URL for now; modeled as an array for
   * forward-compat. Omit for a text-only SMS.
   */
  smsMediaUrls?: InputMaybe<Array<Scalars['String']>>;
  /**
   * The card order this send is composed from, for a premium digital card send.
   * Omit for every other send. See SendJoyJsonMessagesInput.stationeryOrderId.
   */
  stationeryOrderId?: InputMaybe<Scalars['ID']>;
};

export type AutomaticEventReminderInput = {
  eventDate: Scalars['DateTime'];
  eventDisplayName: Scalars['String'];
  eventId: Scalars['ID'];
  firebaseEventId: Scalars['String'];
};

export type TestEmailWithTemplateArgs = {
  subject: Scalars['String'];
  templateName: Scalars['String'];
  toEmail: Scalars['String'];
};

export type SendTestJoyJsonMessageEmailInput = {
  eventId: Scalars['String'];
  /**
   * Optional custom display name for the email sender. When omitted, the Event
   * Display Name is used.
   */
  fromName?: InputMaybe<Scalars['String']>;
  payload: Scalars['JSON'];
  subject: Scalars['String'];
  testEmailAddress: Scalars['String'];
  testName: Scalars['String'];
};

export type SendTestJoyProGeneralMessageEmailInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  testEmailAddress: Scalars['String'];
  testName: Scalars['String'];
};

export type SendTestMmsInput = {
  /** Pause in milliseconds before the second message in two-message formats (default 5000). */
  delayMs?: InputMaybe<Scalars['Int']>;
  format: SmsTestFormat;
  /** Which sender identity to send from; defaults to coupleToGuests. */
  fromSender?: InputMaybe<SmsTestSender>;
  imageUrl: Scalars['String'];
  /**
   * Forces a provider. A test send carries no event, so the rollout flag cannot bucket it
   * and always resolves to twilio; name a provider here to reach the other arm. An
   * unconfigured provider falls back to twilio and the row records what actually ran.
   */
  provider?: InputMaybe<SmsProvider>;
  text: Scalars['String'];
  toPhone: Scalars['String'];
};

/** Delivery formats under test for comparing device rendering and cost (MSG-20). */
export enum SmsTestFormat {
  /** A single MMS carrying both text and image. */
  COMBINED_MMS = 'COMBINED_MMS',
  /** MMS (image-only) first, then a separate SMS (text) second. */
  IMAGE_THEN_TEXT = 'IMAGE_THEN_TEXT',
  /** SMS (text) first, then a separate MMS (image-only) second. */
  TEXT_THEN_IMAGE = 'TEXT_THEN_IMAGE',
}

/** Sender identity for a test send. */
export enum SmsTestSender {
  coupleToGuests = 'coupleToGuests',
  joyToCouple = 'joyToCouple',
}

/** An SMS delivery provider. */
export enum SmsProvider {
  telnyx = 'telnyx',
  twilio = 'twilio',
}

export type SendTestPremiumDigitalCardInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  senderName: Scalars['String'];
  subject: Scalars['String'];
};

export type SendTestRsvpReminderV2Input = {
  body: Scalars['String'];
  eventId: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  link: Scalars['String'];
  subject: Scalars['String'];
  testEmailAddress: Scalars['String'];
};

export type SendTestWhatsAppInput = {
  /** The URL shortened into the link slot. */
  link: Scalars['String'];
  /** Producer-side slots: headline, body, image. */
  templateVariables: Array<TemplateVariableInput>;
  /** E.164, any country. No national-format fallback. */
  toPhone: Scalars['String'];
};

/** A named template slot. */
export type TemplateVariableInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type ThankYouEmailArgs = {
  emailType: Scalars['String'];
  eventId: Scalars['String'];
  eventName?: InputMaybe<Scalars['String']>;
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  html?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  replyToEmail: Scalars['String'];
  sentByUserId?: InputMaybe<Scalars['String']>;
  sentForEventId?: InputMaybe<Scalars['String']>;
  sentForVendorId?: InputMaybe<Scalars['String']>;
  sentToPersonId?: InputMaybe<Scalars['String']>;
  sentToUserId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type SendTravelAlertOtpInputV1 = {
  channel: TravelAlertChannelV1;
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export enum TravelAlertChannelV1 {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

/** A raw, un-resolved wedding-party invite recipient (MSG-358). */
export type VipInviteRecipientInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SetAccentPayload = {
  accent: Scalars['String'];
  eventDesignId: Scalars['ID'];
};

export type SetFeaturePreferenceColor = {
  colorLocation?: InputMaybe<ColorPointerLocation>;
  eventDesignId: Scalars['ID'];
  index: Scalars['Int'];
};

export type AttendanceInput = {
  attendanceState: AttendanceState;
  eventId: Scalars['ID'];
  formId?: InputMaybe<Scalars['ID']>;
  guestKey: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
};

export type DesignPreferenceRangeInput = {
  eventDesignId: Scalars['ID'];
  featureId: Scalars['ID'];
  rangeValue: Scalars['Float'];
};

export type DesignPreferenceBooleanInput = {
  booleanValue: Scalars['Boolean'];
  eventDesignId: Scalars['ID'];
  featureId: Scalars['ID'];
};

export type SetCustomCssPayload = {
  customCss: Scalars['String'];
  eventDesignId: Scalars['ID'];
};

/** Asset information for an Image */
export type SetAssetPayload = {
  assetId: Scalars['String'];
  fileSize: Scalars['Int'];
  height: Scalars['Int'];
  ignoreChannel?: InputMaybe<Scalars['Boolean']>;
  md5?: InputMaybe<Scalars['String']>;
  mimeType: Scalars['String'];
  width: Scalars['Int'];
};

export type SetDesignPhotoPayload = {
  designPhotoId?: InputMaybe<Scalars['ID']>;
  eventDesignId: Scalars['ID'];
};

/** Set the desktop photo URL for an event */
export type SetEventPhotoV2Payload = {
  eventId: Scalars['ID'];
  photoV2Url: Scalars['String'];
};

/** Set the mobile version of photo URL for an event */
export type SetEventPhotoV2MobilePayload = {
  eventId: Scalars['ID'];
  photoV2UrlMobile: Scalars['String'];
};

export type SetEventStylePayload = {
  accent?: InputMaybe<Scalars['String']>;
  backgroundType?: InputMaybe<Scalars['String']>;
  customCss?: InputMaybe<Scalars['String']>;
  font?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<Layout>;
  primaryColor?: InputMaybe<Scalars['String']>;
  primaryTextColor?: InputMaybe<Scalars['String']>;
  suggestedColor?: InputMaybe<Scalars['Boolean']>;
  theme?: InputMaybe<Scalars['String']>;
  translucent?: InputMaybe<Scalars['Boolean']>;
  useSuggestedThemeColorAloha?: InputMaybe<Scalars['Boolean']>;
};

export type SetFontPayload = {
  eventDesignId: Scalars['ID'];
  fontId: Scalars['ID'];
};

export type GuestlistSetCustomColumnValueInput = {
  columnId: Scalars['ID'];
  contactId: Scalars['ID'];
  eventId: Scalars['String'];
  value?: InputMaybe<Scalars['JSON']>;
};

export type GuestlistBulkSetColumnValueEntry = {
  columnId: Scalars['ID'];
  contactId: Scalars['ID'];
  value?: InputMaybe<Scalars['JSON']>;
};

export type SetHasVisitedDesignPagePayload = {
  eventDesignId: Scalars['ID'];
  hasVisitedDesignPage: Scalars['Boolean'];
};

export type SetMapStylePayload = {
  eventDesignId: Scalars['ID'];
  /**
   * Required. STANDARD is how a couple asks for Google's unstyled basemap;
   * it is not the same as never having chosen, which stays null.
   */
  mapStyle: EventDesignMapStyle;
};

export type SetMastheadPayload = {
  eventId: Scalars['ID'];
  /** Setting a masthead always enables it; use setMastheadEnabled to toggle it off */
  mastheadId: Scalars['String'];
};

export type SetMastheadEnabledPayload = {
  enabled: Scalars['Boolean'];
  eventId: Scalars['ID'];
};

export type setMediaTokenPermissionsInput = {
  collectionId: Scalars['ID'];
  permissions: Array<InputMaybe<MagicTokenPermissions>>;
};

export type SetColorPayload = {
  color: Scalars['String'];
  eventDesignId: Scalars['ID'];
  paletteId: Scalars['ID'];
};

export type SetPhotoAlignmentPayload = {
  alignment: PhotoAlignment;
  isMobile?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<EventPageType>;
};

export type StationeryPrintOrderStatusInput = {
  message?: InputMaybe<Scalars['String']>;
  printOrderId: Scalars['ID'];
  status: StationeryPrintOrderStatusEnum;
};

export type SetPropertiesPayload = {
  accent?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  customCss?: InputMaybe<Scalars['String']>;
  eventDesignId: Scalars['ID'];
  fontId?: InputMaybe<Scalars['ID']>;
  layoutId?: InputMaybe<Scalars['ID']>;
  paletteId?: InputMaybe<Scalars['ID']>;
  themeId?: InputMaybe<Scalars['ID']>;
  useSuggestedThemeColor?: InputMaybe<Scalars['Boolean']>;
};

/** The currency code */
export type EventCurrencyInput = {
  code: Scalars['String'];
};

export type RegistryEventDataInput = {
  delayOrderFulfillment?: InputMaybe<Scalars['Boolean']>;
  disableIntlRegistry?: InputMaybe<Scalars['Boolean']>;
  disableWhiteGloveforPartnerItems?: InputMaybe<Scalars['Boolean']>;
  disableWhiteGloveforSyncedItems?: InputMaybe<Scalars['Boolean']>;
  disableWhiteGloveforTransferredItems?: InputMaybe<Scalars['Boolean']>;
  hideRegistryInMessaging?: InputMaybe<Scalars['Boolean']>;
};

export type ReservedRoomBlocksRequest = {
  address?: InputMaybe<Scalars['String']>;
  bookingUrl?: InputMaybe<Scalars['String']>;
  checkInDate?: InputMaybe<Scalars['DateTime']>;
  checkOutDate?: InputMaybe<Scalars['DateTime']>;
  cutoffDate?: InputMaybe<Scalars['DateTime']>;
  displayName?: InputMaybe<Scalars['String']>;
  hotelMoreInfoUrl?: InputMaybe<Scalars['String']>;
  hotelRoomBlocksId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  note?: InputMaybe<Scalars['String']>;
  numberOfNightsBooked?: InputMaybe<Scalars['Int']>;
  numberOfNightsGuestBooked?: InputMaybe<Scalars['Int']>;
  numberOfRoomsBooked?: InputMaybe<Scalars['Int']>;
  numberOfRoomsGuestBooked?: InputMaybe<Scalars['Int']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  pricePerNight?: InputMaybe<Scalars['Float']>;
  starRating?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<ReservedRoomBlockStatus>;
  strikeoutPricePerNight?: InputMaybe<Scalars['Float']>;
};

export type SetSearchMetadataInput = {
  description?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  templateID: Scalars['String'];
};

export type SetStationeryDigitalPrintOrderDeliveryPackageInput = {
  deliveryPackageKey: StationeryDigitalDeliveryPackageKeyEnum;
  orderId: Scalars['String'];
};

export enum StationeryDigitalDeliveryPackageKeyEnum {
  basic = 'basic',
  diamond = 'diamond',
  premium = 'premium',
}

export type SetStationeryDigitalPrintOrderFeatureSmsInput = {
  enabled: Scalars['Boolean'];
  orderId: Scalars['String'];
};

export type SetStationeryDigitalPrintOrderQuantityInput = {
  orderId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type SetStationeryDraftRecipientIdListInput = {
  id: Scalars['ID'];
  recipientIdList?: InputMaybe<Array<Scalars['ID']>>;
};

export type SetThemePayload = {
  eventDesignId: Scalars['ID'];
  themeId: Scalars['ID'];
  useSuggestedThemeColor?: InputMaybe<Scalars['Boolean']>;
};

export type SetThemeAndLayoutPayload = {
  brannanNavigation?: InputMaybe<BrannanNavigation>;
  eventDesignId: Scalars['ID'];
  layoutId: Scalars['ID'];
  /**
   * For blank-based templates: the specific template variant (e.g. pampas, palm_tree).
   * For legacy templates: the themeId.
   * When omitted, null or empty, the existing value is preserved; only a non-empty value updates it.
   */
  templateVariantId?: InputMaybe<Scalars['String']>;
  themeId: Scalars['ID'];
  useCustomTheme?: InputMaybe<Scalars['Boolean']>;
  useSuggestedThemeColor?: InputMaybe<Scalars['Boolean']>;
};

export type SetLayoutPayload = {
  eventDesignId: Scalars['ID'];
  layoutId: Scalars['ID'];
};

export type AddSimpleTagToPhotosInCollectionPayload = {
  collectionId: Scalars['ID'];
  tags: Array<Scalars['String']>;
};

export type AddSimpleTagPayload = {
  photoIds: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
};

export type SortItemsPayload = {
  eventId: Scalars['String'];
  items: Array<ItemToSort>;
};

export type ItemToSort = {
  id: Scalars['ID'];
  sortKey: Scalars['String'];
};

export enum SalesOrderRefundMethod {
  REFUND = 'REFUND',
  STRIPE_REFUND = 'STRIPE_REFUND',
  SWAP_FOR_CASH = 'SWAP_FOR_CASH',
}

export type StartStationeryCartCheckoutInput = {
  eventId: Scalars['ID'];
  failureUrlTemplate: Scalars['String'];
  successUrlTemplate: Scalars['String'];
};

export type StartStationeryCheckoutInput = {
  address: StationeryShippingAddressInput;
  email: Scalars['String'];
  eventId: Scalars['ID'];
  failureUrlTemplate: Scalars['String'];
  name: Scalars['String'];
  printOrder: StationeryCheckoutPrintOrderInput;
  successUrlTemplate: Scalars['String'];
  themeDisplayName?: InputMaybe<Scalars['String']>;
};

export type StationeryShippingAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  validated?: InputMaybe<Scalars['Boolean']>;
};

export type StationeryCheckoutPrintOrderInput = {
  orderId: Scalars['String'];
};

export type StartStationeryInternationalCheckoutInput = {
  failureUrlTemplate: Scalars['String'];
  printOrderId: Scalars['String'];
  successUrlTemplate: Scalars['String'];
};

export type AIBackgroundPromptPayload = {
  prompt: Scalars['String'];
  style: Scalars['String'];
};

export type CreateStationeryDigitalViewInput = {
  cardOrderId: Scalars['String'];
  personId: Scalars['String'];
  src: Scalars['String'];
};

/** A batch of offer tokens to store. */
export type InternalStoreOfferTokensInput = {
  /** The offer tokens to store. */
  items: Array<InternalStoreOfferTokenItemInput>;
};

/** A single offer token to store. */
export type InternalStoreOfferTokenItemInput = {
  /** Distribution channel this offer was minted for, if any. */
  channelId?: InputMaybe<Scalars['String']>;
  /** Stay check-in date (YYYY-MM-DD). */
  checkInDate: Scalars['DateOnlyString'];
  /** Stay check-out date (YYYY-MM-DD). */
  checkOutDate: Scalars['DateOnlyString'];
  /** How this offer is checked out (Vaultera vault or Stripe native). */
  checkoutType: EphemeralCheckoutType;
  /** The event this offer was minted for, when event-scoped. */
  eventId?: InputMaybe<Scalars['ID']>;
  /** The external provider's identifier, when routed through one. */
  externalOfferProvider?: InputMaybe<Scalars['String']>;
  /** Fee configuration applied to this offer. */
  feeConfig?: InputMaybe<Scalars['JSON']>;
  /** Whether the offer price already includes fees. */
  isFeesIncluded: Scalars['Boolean'];
  /** The Joy offer id for this row. Two modes: supply it for dual-write MIRROR mode — the id travel_service already minted into the core DB is stored verbatim so both stores share the same primary key during the migration window; omit it for AUTHORITY mode — the service generates `offer-{provider}-{uuid}` as it does today. */
  joyOfferId?: InputMaybe<Scalars['ID']>;
  /** The JoyPlace this offer is for. */
  joyPlaceId: Scalars['ID'];
  /** ZH's own room-group arbitration losers for this offer's recommendation, mirrored from travel_service at mint time. Omitted/empty for uncontested options and for every non-ZH provider. */
  loserRecommendationIds?: InputMaybe<Array<Scalars['String']>>;
  /** The money group to persist at mint (commission and/or provider amounts). */
  moneyContext?: InputMaybe<InternalOfferTokenMoneyContextInput>;
  /** The inventory provider (switch) that produced this offer. */
  provider: EphemeralSwitchNames;
  /** The provider's own identifier for this offer. */
  providerOfferId: Scalars['String'];
  /** The provider rate ids backing this offer. */
  rateIds?: InputMaybe<Array<Scalars['String']>>;
  /** Cached raw offer snapshot captured at mint time. */
  rawOffer?: InputMaybe<Scalars['JSON']>;
  /** Per-room booking details as JSON: array of { roomId, roomName?, occupancy: { adults, childrenAges }, refundability? }. */
  roomDetails?: InputMaybe<Scalars['JSON']>;
  /** Opaque provider offer token, when the provider issues one. */
  token?: InputMaybe<Scalars['String']>;
};

/** Input for submitAdminSurveyResponse. Requires an authenticated Joy user — identity (user id, email) is derived server-side from the request context, never from client input. */
export type AdminSurveyResponseInput = {
  /** Id of the entity this response relates to, e.g. a reservation id. */
  entityId?: InputMaybe<Scalars['String']>;
  /** Type of entity this response relates to, e.g. "travel_reservation". */
  entityType?: InputMaybe<Scalars['String']>;
  /** Joy event id this response relates to, e.g. the couple's event. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Client-supplied key used to dedupe double-submits — resubmitting the same key for the same survey returns the original response instead of creating a duplicate. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Locale the survey was rendered in. */
  locale?: InputMaybe<Scalars['String']>;
  /** Freeform open-ended text answer, if the survey collects one. */
  openEndedText?: InputMaybe<Scalars['String']>;
  /** Catch-all for any additional answers beyond selectedOption/openEndedText. */
  responseDetail?: InputMaybe<Scalars['JSON']>;
  /** Lifecycle state of the response. Defaults to COMPLETED. */
  responseStatus?: InputMaybe<ResponseStatusDtoEnum>;
  /** The respondent's primary answer. Validated against the survey's stored options — a mismatch is still accepted and stored, never rejected, but is logged and alerted on. */
  selectedOption: Scalars['String'];
  /** Where the survey was triggered from, e.g. "booking_page". */
  source?: InputMaybe<Scalars['String']>;
  /** When the respondent started the survey. Used with the completion time to compute duration. */
  startedAt?: InputMaybe<Scalars['DateTime']>;
  /** Id of the Survey this response is for. Must reference an existing survey. */
  surveyId: Scalars['String'];
};

/** Lifecycle state of a survey response — whether it was only started, fully completed, or abandoned. */
export enum ResponseStatusDtoEnum {
  ABANDONED = 'ABANDONED',
  COMPLETED = 'COMPLETED',
  STARTED = 'STARTED',
}

export type SubmitFormAnswersInput = {
  answers: Array<CreateAnswerInput>;
  /**
   * Question ids whose prior answers this submission clears (RSVP-34).
   *
   * A clear supersedes every live answer the guest holds for that question — the
   * rows are soft-deleted in the same transaction as this submission's new rows,
   * so reads (latest-wins per question) resolve to "no answer" afterwards. Absent
   * or empty, the write is byte-identical to before this field existed.
   *
   * Constraints, each rejected with ANSWER_INVALID_CLEAR: requires guestKey (a
   * clear must be scoped to an existing guest's rows); may not name the attendance
   * question ('attendanceState' — attendance is corrected by re-answering, never
   * cleared); may not name a question this submission also answers. GROUP-scoped
   * ids pass the same party write gate as GROUP answers, with one stricter rule:
   * a GROUP clear under another member's key is rejected unconditionally
   * (ANSWER_GROUP_FOREIGN_TARGET), and the clear covers every active key the
   * writing member holds, since reads resolve a member's answers across all of
   * them. A clear-only submission (no answers) writes the clears and skips the
   * answer-driven registration tail — attendance, ticketing, notices — so it can
   * never flip a declined guest to attending.
   */
  clearedQuestionIds?: InputMaybe<Array<Scalars['ID']>>;
  formId: Scalars['ID'];
  guestKey?: InputMaybe<Scalars['String']>;
};

/** Input for submitGuestSurveyResponse. Unauthenticated — the client supplies whatever guest identity it has; the server never requires a JWT for this mutation. */
export type GuestSurveyResponseInput = {
  /** Client-provided email for the guest, if known. Not verified. */
  email?: InputMaybe<Scalars['String']>;
  /** Id of the entity this response relates to, e.g. a reservation id. */
  entityId?: InputMaybe<Scalars['String']>;
  /** Type of entity this response relates to, e.g. "travel_reservation". */
  entityType?: InputMaybe<Scalars['String']>;
  /** Joy event id this response relates to, e.g. the couple's event. */
  eventId?: InputMaybe<Scalars['String']>;
  /** Client-supplied key used to dedupe double-submits — resubmitting the same key for the same survey returns the original response instead of creating a duplicate. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Locale the survey was rendered in. */
  locale?: InputMaybe<Scalars['String']>;
  /** Freeform open-ended text answer, if the survey collects one. */
  openEndedText?: InputMaybe<Scalars['String']>;
  /** Catch-all for any additional answers beyond selectedOption/openEndedText. */
  responseDetail?: InputMaybe<Scalars['JSON']>;
  /** Lifecycle state of the response. Defaults to COMPLETED. */
  responseStatus?: InputMaybe<ResponseStatusDtoEnum>;
  /** The respondent's primary answer. Validated against the survey's stored options — a mismatch is still accepted and stored, never rejected, but is logged and alerted on. */
  selectedOption: Scalars['String'];
  /** Where the survey was triggered from, e.g. "booking_page". */
  source?: InputMaybe<Scalars['String']>;
  /** When the respondent started the survey. Used with the completion time to compute duration. */
  startedAt?: InputMaybe<Scalars['DateTime']>;
  /** Id of the Survey this response is for. Must reference an existing survey. */
  surveyId: Scalars['String'];
};

export type HotelRoomBlockLeadInfoSubmittedRequest = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  anyOtherInformation?: InputMaybe<Scalars['String']>;
  calendlyUri?: InputMaybe<Scalars['String']>;
  checkInDate?: InputMaybe<Scalars['DateOnly']>;
  checkOutDate?: InputMaybe<Scalars['DateOnly']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  destinationWedding?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  eventDisplayName?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  externalHotelInfo?: InputMaybe<Array<ExternalHotelInfo>>;
  fullName?: InputMaybe<Scalars['String']>;
  guestCount?: InputMaybe<Scalars['Float']>;
  /** deprecated, use externalHotelInfo */
  hotelUrls?: InputMaybe<Array<Scalars['String']>>;
  /** Is the given address same as the address of the venue */
  isAddressTheVenue?: InputMaybe<Scalars['Boolean']>;
  lat?: InputMaybe<Scalars['Float']>;
  long?: InputMaybe<Scalars['Float']>;
  outOfTown?: InputMaybe<Scalars['Float']>;
  partner1?: InputMaybe<PartnerInfo>;
  partner2?: InputMaybe<PartnerInfo>;
  phone?: InputMaybe<Scalars['String']>;
  placeName?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  preferredContactMethod?: InputMaybe<ContactMethods>;
  roomsToBlock?: InputMaybe<Scalars['String']>;
  secondaryEmail?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<LeadSourceTypes>;
  stateRegionProvince?: InputMaybe<Scalars['String']>;
};

export type ExternalHotelInfo = {
  address?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  hotelUrl: Scalars['String'];
  lat?: InputMaybe<Scalars['Float']>;
  long?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<HotelLocationProvider>;
};

/** The provider of the hotels data */
export enum HotelLocationProvider {
  Google = 'Google',
  Zentrumhub = 'Zentrumhub',
}

export type PartnerInfo = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

/** The source of the lead */
export enum LeadSourceTypes {
  preferred = 'preferred',
}

/**
 * The post-RSVP notification step's submission.
 *
 * `recipients` may be empty — that is the opt-out, not a malformed request. It is
 * capped at the same order of magnitude as a party, because these keys are all
 * supposed to come from one.
 */
export type SubmitPostRsvpNotificationsInput = {
  eventId: Scalars['ID'];
  formId: Scalars['ID'];
  recipients: Array<PostRsvpNotificationRecipientInput>;
};

/**
 * One person being opted in, keyed the way postRsvpNotificationRecipientsByFormId
 * reports them.
 *
 * Listing somebody here is the consent — there is nothing else to set. The acting
 * guest may only list themselves and members of their own party.
 */
export type PostRsvpNotificationRecipientInput = {
  /** New email to store on the recipient's contact before sending. Omitted = use the email already on file. */
  email?: InputMaybe<Scalars['String']>;
  guestKey: Scalars['String'];
};

export type SyncReserveRoomBlocksToAccommodationPlacesRequest = {
  batchSize?: InputMaybe<Scalars['Float']>;
};

export type TagUserInPhotoPayload = {
  photoId: Scalars['ID'];
  userId: Scalars['String'];
};

export type TagVendorInPhotoPayload = {
  photoId: Scalars['ID'];
  vendorId: Scalars['String'];
};

export type TagVendorInPhotosOnCollectionPayload = {
  collectionId: Scalars['ID'];
  vendorIds: Array<Scalars['String']>;
};

export type ToggleDesignFavoriteInput = {
  eventId: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
  /** Primary resource to favorite (Font: FontId, Art: ThemeId, Template: ThemeId) */
  resourceId: Scalars['ID'];
  /** Secondary resource to favorite (Template: LayoutId) */
  secondaryResourceId?: InputMaybe<Scalars['ID']>;
  type: FavoriteType;
};

export type ImpactRadiusTrackingPayload = {
  actionTrackerId: Scalars['Int'];
  campaignId: Scalars['Int'];
  clickId: Scalars['String'];
  customerEmail: Scalars['String'];
  customerId: Scalars['String'];
  /** New or Returning */
  customerStatus: Scalars['String'];
  /** An ISO-8601 timestamp */
  eventDate: Scalars['String'];
  itemCategory1?: InputMaybe<Scalars['String']>;
  itemQuantity1?: InputMaybe<Scalars['Int']>;
  itemSKU1?: InputMaybe<Scalars['String']>;
  itemSubtotal1?: InputMaybe<Scalars['Float']>;
  orderId: Scalars['String'];
  text1?: InputMaybe<Scalars['String']>;
};

export type TransferTransitionalRegistryItemsPayload = {
  transitionalRegistryId: Scalars['ID'];
  transitionalRegistryItemIds: Array<Scalars['ID']>;
};

/** Payload for recording a single travel checkout event from the guest checkout flow. Captures both the displayed values (for dispute evidence) and request metadata (for fraud signals). */
export type TravelCheckoutEventCreatePayload = {
  /** The checkout action being recorded. */
  action: TravelCheckoutEventActionDtoEnum;
  /** Structured cancellation policy snapshot the guest saw. */
  cancellationPolicy?: InputMaybe<Scalars['JSONObject']>;
  /** Human-readable cancellation policy text the guest saw. */
  cancellationPolicyText?: InputMaybe<Scalars['String']>;
  /** Client-reported timestamp of the action (may drift from server time). */
  clientTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** Correlation ID linking this event to upstream client traces. */
  correlationId?: InputMaybe<Scalars['String']>;
  /** Display snapshot — labels and copy the guest saw at checkout. */
  displaySnapshot?: InputMaybe<Scalars['JSONObject']>;
  /** The Joy event (wedding website) this checkout is for. */
  eventId: Scalars['ID'];
  /** Opaque offer token presented to the guest at the moment of the event. */
  offerToken?: InputMaybe<Scalars['String']>;
  /** The reservation this event is associated with, when available. Omit when the event occurs before a reservation exists. */
  reservationId?: InputMaybe<Scalars['ID']>;
  /** Total amount snapshot the guest saw (minor units, currency, digits). */
  totalAmount?: InputMaybe<Scalars['JSONObject']>;
  /** Client user agent. */
  userAgent?: InputMaybe<Scalars['String']>;
};

export type TravelOfferReservationApplyWalletSpendPayload = {
  /** The fund amount the couple chose, in minor units. Recomputed against the live balance server-side, so less may be applied than asked for. */
  amountMinorUnits: Scalars['Int'];
  /** Stable per Continue press. The same key with the same amount is a safe replay; a new amount releases the previous hold and takes a new one. */
  idempotencyKey: Scalars['String'];
  /** The draft reservation to apply the fund share to. */
  reservationId: Scalars['ID'];
};

/** Machine-readable reason applying a cash-fund share failed. Set only when outcome = FAILED. INELIGIBLE covers a closed switch, an amount that covers the whole bill (use cash-fund checkout), and a reservation that can no longer take one. PAYMENT_UPDATE_FAILED means the card charge could not be reduced, so the fund hold was released and full-price card checkout still works. RELEASE_FAILED is specific to a release (amountMinorUnits: 0): the card IS back at the full amount, but the fund share could not be handed back, so it is still held — retry the release rather than sending the couple to cash-fund checkout. Switch on this rather than failureReason. */
export enum TravelOfferReservationApplyWalletSpendFailureCode {
  CURRENCY_MISMATCH = 'CURRENCY_MISMATCH',
  INELIGIBLE = 'INELIGIBLE',
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  PAYMENT_UPDATE_FAILED = 'PAYMENT_UPDATE_FAILED',
  RELEASE_FAILED = 'RELEASE_FAILED',
  TOPUP_FAILED = 'TOPUP_FAILED',
}

/** Outcome of applying a cash-fund share to a card checkout. APPLIED and FAILED are terminal. PROCESSING is no longer returned: a cash-fund transfer whose result is unknown returns FAILED with TOPUP_FAILED before any share is held, so the card is still at full price and may pay the whole amount; reconciliation settles the money into the wallet or back to the cash fund. Kept in the enum for existing clients. APPLIED does NOT mean "a share is now applied": a release (amountMinorUnits: 0) succeeds with APPLIED too, and there the share was removed. Read `walletSpend.coverage` to tell them apart — NONE means nothing is applied any more — and never key UI state off APPLIED alone. */
export enum TravelOfferReservationApplyWalletSpendOutcome {
  APPLIED = 'APPLIED',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
}

export type TravelOfferReservationCancelPayload = {
  reservationId: Scalars['String'];
};

export type TravelOfferReservationConfirmPayload = {
  billingContact: TravelOfferReservationBillingContact;
  campaignId?: InputMaybe<Scalars['String']>;
  paymentCredential: Scalars['String'];
  paymentCredentialType: TravelPaymentCredentialType;
  travelOfferReservationId: Scalars['String'];
};

export type TravelOfferReservationBillingContact = {
  age?: InputMaybe<Scalars['Float']>;
  contact?: InputMaybe<TravelOfferReservationBillingContactContact>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: TravelReservationGuestAgeClassification;
};

export type TravelOfferReservationBillingContactContact = {
  address: TravelOfferReservationBillingContactAddress;
  email: Scalars['String'];
  phone: Scalars['String'];
};

export type TravelOfferReservationBillingContactAddress = {
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  state: Scalars['String'];
};

export enum TravelPaymentCredentialType {
  VAULTERA_CREDIT_CARD_TOKENIZED = 'VAULTERA_CREDIT_CARD_TOKENIZED',
}

export type TravelOfferReservationConfirmRateLockPayload = {
  /** The signed token from the confirm link in the hold, reminder or last-call message. Send exactly one of this and `paymentIntentClientSecret`; neither or both is refused with RATE_LOCK_TOKEN_INVALID. */
  confirmToken?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  /** The `payment_intent_client_secret` Stripe appended to the checkout's return URL. Send exactly one of this and `confirmToken`; neither or both is refused with RATE_LOCK_TOKEN_INVALID. */
  paymentIntentClientSecret?: InputMaybe<Scalars['String']>;
  reservationId: Scalars['String'];
};

export type TravelOfferReservationCreatePayload = {
  billingContact?: InputMaybe<TravelOfferReservationBillingContact>;
  campaignId?: InputMaybe<Scalars['String']>;
  checkoutType?: InputMaybe<TravelOfferReservationCheckoutType>;
  couponCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  /** The event's event group code, threaded from the booking URL. Applied at create as a $0 attribution promotion (not a discount); surfaced back as `joyEventGroupCode`. */
  eventGroupCode?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  /** Deprecated (target removal: 2026-Q3) — resolved server-side as the canonical session ID (event_session.id) from the active gateway session; any client-supplied value is ignored. */
  eventSessionId?: InputMaybe<Scalars['String']>;
  /** Deprecated (target removal: 2026-Q3) — resolved server-side from the active gateway session; any client-supplied value is ignored. */
  guestKey?: InputMaybe<Scalars['String']>;
  /** Client-generated idempotency key for one checkout attempt (e.g. per Book-button press), stable across retries of that attempt. Used by the travel_wallet path to make create idempotent (a retried request replays the same outcome, no double-book/charge). Absent => a server-derived key is used as a fallback. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** A Joy discount coupon the guest typed at checkout, carried on the create call because the travel_wallet rail books in one step and has no draft for the separate apply mutation to act on. Read only on that rail; the card rail applies its codes through `applyJoyDiscountCoupon` instead. Unlike `couponCode` (a percentage from a flag allowlist) and `referralCode` (best-effort at create), this one is not best-effort: a code the coupon service refuses fails the booking with `COUPON_REJECTED` before any money moves, because charging full price after showing a lower one is a surprise charge. */
  joyCouponCode?: InputMaybe<Scalars['String']>;
  offerToken: Scalars['String'];
  /** Payment rail chosen by the client. Optional and backward-compatible: absent => existing card flow. Only `travel_wallet` routes the wallet path. */
  paymentMethod?: InputMaybe<TravelOfferReservationPaymentMethod>;
  /** Deprecated (target removal: 2026-Q3) — resolved server-side as the canonical person ID (event_person.id) from the active gateway session; any client-supplied value is ignored. */
  personId?: InputMaybe<Scalars['String']>;
  /** Present only when the guest is starting a 48-hour Rate Lock hold from a checkout-abandonment email. Presence is what selects the hold path: the room is booked for real and the card authorized but not captured, and the guest is not told they are confirmed. Absent for every ordinary checkout. */
  rateLock?: InputMaybe<TravelOfferReservationRateLockInput>;
  /** A Share Your Stay referral code, threaded from the shared link's `joyReferralCode` query parameter. Applied at create as a real fixed-amount promotion code and surfaced back as `joyDiscountCoupon`. Deliberately separate from `couponCode`, which selects a percentage discount from a flag allowlist and must keep meaning only that. A code that cannot be applied (exhausted, expired, unknown) is logged and ignored — the reservation is created at full price rather than failing. */
  referralCode?: InputMaybe<Scalars['String']>;
  roomGuests?: InputMaybe<Array<TravelOfferReservationRoomGuestsInput>>;
  /** The `utm_campaign` the booking URL was reached with. Inbound wins on every internal hop, so `honeymoon_fund_travel` marks a booking the couple made from their honeymoon page. */
  utmCampaign?: InputMaybe<Scalars['String']>;
  /** The `utm_medium` the booking URL was reached with. See utmSource. */
  utmMedium?: InputMaybe<Scalars['String']>;
  /** Marketing attribution read off the booking URL at create: the `utm_source` the page was reached with. Internal hops rewrite it (joy-web's INTERNAL_UTM_SOURCES is the vocabulary), so it names the last Joy surface, not the entry; use utmCampaign to tell a couple's honeymoon booking apart. Persisted on the reservation and stamped on the BookingConfirmed analytics event so bookings can be counted by flow without a session join. */
  utmSource?: InputMaybe<Scalars['String']>;
};

/** Type of checkout for TravelOfferReservation */
export enum TravelOfferReservationCheckoutType {
  stripe_native = 'stripe_native',
  travel_wallet = 'travel_wallet',
  vaultera_vault = 'vaultera_vault',
}

/** How the couple pays. Absent or `card` => the existing card (or Vaultera) flow. `travel_wallet` => pay from the travel wallet (owner-only, joyMOR only). */
export enum TravelOfferReservationPaymentMethod {
  card = 'card',
  travel_wallet = 'travel_wallet',
}

export type TravelOfferReservationRateLockInput = {
  /** Currency of expectedTotalAmountMinorUnits. Compared alongside the amount — a currency change is a price change. */
  currency: Scalars['String'];
  /** The checkout's Pay Today total in minor units — the amount charged online when the hold is confirmed, excluding anything payable at the property. Send the same figure the checkout screen is showing under Pay Today. Hold creation re-checks the live refundable price against this, and re-checks it again against the PaymentIntent that authorizes it, refusing the hold if either has moved rather than locking a number the guest never saw. Not the total from the abandonment email: that CTA carries no price, so the only figure the guest has agreed to is the one on the screen they pressed the button on. */
  expectedTotalAmountMinorUnits: Scalars['Int'];
  /** Whether the guest ticked the SMS opt-in shown next to the phone field. Omit when they were not asked; that is not the same as declining. The consent timestamp is recorded server-side. Note an opt-in only produces an SMS for US and IN numbers — every other country gets the same touch by email. */
  smsConsentGranted?: InputMaybe<Scalars['Boolean']>;
};

export type TravelOfferReservationRoomGuestsInput = {
  guests: Array<TravelOfferReservationGuestInformationInput>;
  unitId: Scalars['String'];
};

export type TravelOfferReservationGuestInformationInput = {
  age?: InputMaybe<Scalars['Float']>;
  ageClassification: TravelReservationGuestAgeClassification;
  countryCode?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<TravelReservationGuestTitle>;
};

/** Machine-readable reason a travel_wallet create failed. Set only when outcome = FAILED; null on BOOKED. Clients should switch on this, not on failureReason (which is human-readable and may change). */
export enum TravelOfferReservationCreateTravelWalletFailureCode {
  BOOKING_FAILED = 'BOOKING_FAILED',
  COUPON_REJECTED = 'COUPON_REJECTED',
  CURRENCY_MISMATCH = 'CURRENCY_MISMATCH',
  INELIGIBLE = 'INELIGIBLE',
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  MISSING_GUEST_INFO = 'MISSING_GUEST_INFO',
  TOPUP_FAILED = 'TOPUP_FAILED',
  UNKNOWN = 'UNKNOWN',
}

/** Outcome of a travel_wallet create. BOOKED or FAILED are terminal. PROCESSING means the hotel provider did not answer after the fund was held, so the booking may exist; it will be settled by reconciliation — the client must show "processing", not offer another payment method. A cash-fund top-up whose outcome is unknown returns FAILED with TOPUP_FAILED: no booking was attempted, and reconciliation settles the money into the wallet or back to the cash fund. NEEDS_VERIFICATION means the duplicate-booking gate paused the attempt before any money moved — the client should open the reservation page, where the guest confirms or cancels the booking. */
export enum TravelOfferReservationCreateTravelWalletOutcome {
  BOOKED = 'BOOKED',
  FAILED = 'FAILED',
  NEEDS_VERIFICATION = 'NEEDS_VERIFICATION',
  PROCESSING = 'PROCESSING',
}

export type TravelOfferReservationMintShareUrlsPayload = {
  reservationId: Scalars['String'];
};

export type TravelOfferReservationReleaseRateLockPayload = {
  email: Scalars['String'];
  reservationId: Scalars['String'];
};

export type TravelOfferReservationUpdatePayload = {
  billingContact?: InputMaybe<TravelOfferReservationBillingContact>;
  /** How the guest intends to pay for this booking. Sent so a code restricted to one payment type is refused here, before the card is charged, rather than at booking. Send your intent whenever you know it — a full cash-fund reservation is read off its own rail and overrides this value, so an out-of-date CARD can never refuse a fund-only code. Omitted or null skips the check entirely and leaves this mutation behaving exactly as it does today. */
  couponPaidWith?: InputMaybe<CouponPaidWithDtoEnum>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  /** The price the guest is locking. Required with `rateLockAction: HOLD_RATE`, and ignored otherwise. */
  rateLock?: InputMaybe<TravelOfferReservationRateLockInput>;
  /** Which checkout button the guest pressed, sent on every submit immediately before confirming the card. HOLD_RATE turns this unpaid draft into a 48-hour Rate Lock hold and requires `rateLock` alongside it; BOOK_NOW clears any hold the draft had started, which is what stops a guest whose card failed on the hold path from silently getting a hold when they then press Book Now. Omitting this leaves the hold state untouched, which is what a plain update does. The existing PaymentIntent is switched to manual capture (or back) and keeps its client secret, so a Payment Element already mounted against it keeps working; nothing is booked and no money moves until the card is confirmed. Both directions are refused once the card has been submitted, and repeating either is a no-op. A refusal leaves the draft exactly as it was, and carries a RATE_LOCK_* code in extensions.code — branch on that and render your own copy, since the accompanying message is an untranslated English fallback. RATE_LOCK_PRICE_CHANGED when the live price no longer matches expectedTotalAmountMinorUnits, RATE_LOCK_UNAVAILABLE when this checkout cannot hold a rate at all (switched off, ineligible, a fund share or a discount applied, the card already submitted, or not a card checkout). */
  rateLockAction?: InputMaybe<TravelOfferReservationRateLockAction>;
  roomGuests?: InputMaybe<Array<TravelOfferReservationRoomGuestsInput>>;
};

/** Which checkout button the guest pressed. Send it on every submit; omitting it leaves the draft's hold state untouched, which is what a plain update does. */
export enum TravelOfferReservationRateLockAction {
  BOOK_NOW = 'BOOK_NOW',
  HOLD_RATE = 'HOLD_RATE',
}

export type TravelReservationSoftAmendmentPayload = {
  /** Which of the booking holder’s details to change. */
  holder: TravelReservationHolderAmendmentInput;
  /** The reservation to change. */
  reservationId: Scalars['ID'];
};

export type TravelReservationHolderAmendmentInput = {
  /** New contact email for the booking holder. Also changes where the hotel's own correspondence about this booking is sent. */
  email?: InputMaybe<Scalars['String']>;
  /** New first name for the booking holder. */
  firstName?: InputMaybe<Scalars['String']>;
  /** New last name for the booking holder. */
  lastName?: InputMaybe<Scalars['String']>;
  /** New contact phone number for the booking holder. */
  phone?: InputMaybe<Scalars['String']>;
};

export type TravelReservationEvaluationApproveInput = {
  dispositionCode: TravelReservationEvaluationApproveDispositionCode;
  evaluationId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
};

export enum TravelReservationEvaluationApproveDispositionCode {
  APPROVED_LEGIT = 'APPROVED_LEGIT',
}

export type TravelReservationEvaluationCancelInput = {
  dispositionCode: TravelReservationEvaluationCancelDispositionCode;
  evaluationId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
};

export enum TravelReservationEvaluationCancelDispositionCode {
  CANCELED_EFW_ACTIONABLE = 'CANCELED_EFW_ACTIONABLE',
  CANCELED_FRAUD_SUSPECTED = 'CANCELED_FRAUD_SUSPECTED',
  CANCELED_IDENTITY_COLLISION = 'CANCELED_IDENTITY_COLLISION',
  CANCELED_IDENTITY_FRAUD_ACTIVITY = 'CANCELED_IDENTITY_FRAUD_ACTIVITY',
  CANCELED_NON_REFUNDABLE_RISK = 'CANCELED_NON_REFUNDABLE_RISK',
}

export type TravelVendorStatementImportInput = {
  /** The filename the upload picker returned. The container is the service's own; this names a blob inside it, not a location. */
  blobName: Scalars['String'];
  /** The uploader declaring that this statement has already been paid. Every payable booking is then recorded as paid, at the expected amount, and protected from being billed again by a later statement. The file itself can never claim this — a reconciliation cannot observe a bank transfer, so only a person can assert one. */
  markAsPaid?: InputMaybe<Scalars['Boolean']>;
  /** The switch provider the statement is from. */
  provider: TravelVendorStatementProviderDtoEnum;
  /** Identifies the statement this file reconciles, typed by the uploader, e.g. "nuitee-2026-08-17". */
  statementRef: Scalars['String'];
};

/** The switch provider a statement came from. */
export enum TravelVendorStatementProviderDtoEnum {
  bookingcom = 'bookingcom',
  dotw = 'dotw',
  ean = 'ean',
  hotelbeds = 'hotelbeds',
  nuitee = 'nuitee',
  restel = 'restel',
}

/** What a reconciled booking means for the payment run. */
export enum TravelVendorStatementPayStatusDtoEnum {
  already_paid = 'already_paid',
  amount_mismatch = 'amount_mismatch',
  details_mismatch = 'details_mismatch',
  do_not_pay = 'do_not_pay',
  human_review = 'human_review',
  not_found = 'not_found',
  ok_to_pay = 'ok_to_pay',
  paid = 'paid',
  partially_paid = 'partially_paid',
  pay_expect_credit = 'pay_expect_credit',
  provider_mismatch = 'provider_mismatch',
}

export type TravelEventCacheWarmUpRequestPayload = {
  currencyCode?: InputMaybe<TravelCurrencyCode>;
  /** Event handle/website identifier (e.g., "my-event-handle") */
  eventHandle: Scalars['String'];
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  /** UX scenario triggering the warm-up request */
  scenario: TravelEventCacheWarmUpRequestUxType;
};

/** UX which is triggering the warm-up request */
export enum TravelEventCacheWarmUpRequestUxType {
  GUEST = 'GUEST',
  HOST = 'HOST',
  HOST_CHANGED_VENUE = 'HOST_CHANGED_VENUE',
}

export type UnlockRequestForProposalPayload = {
  id: Scalars['ID'];
};

export type UpdateAccommodationPlaceV2Request = {
  accommodationRoomBlock?: InputMaybe<AccommodationPlaceV2RoomBlockRequest>;
  autoSuggestionAlgo?: InputMaybe<AutoSuggestionAlgoType>;
  category?: InputMaybe<AccommodationPlaceCategory>;
  customAddress?: InputMaybe<Scalars['String']>;
  customName?: InputMaybe<Scalars['String']>;
  customPhone?: InputMaybe<Scalars['String']>;
  customPhotoId?: InputMaybe<Scalars['String']>;
  customStarRating?: InputMaybe<Scalars['Float']>;
  customUrl?: InputMaybe<Scalars['String']>;
  displayLocation?: InputMaybe<AccommodationPlaceDisplayLocation>;
  id: Scalars['ID'];
  isCustomLinkEnabled?: InputMaybe<Scalars['Boolean']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  isGuestFavorite?: InputMaybe<Scalars['Boolean']>;
  isHostStayingHere?: InputMaybe<Scalars['Boolean']>;
  isPhotoHidden?: InputMaybe<Scalars['Boolean']>;
  layoutType?: InputMaybe<Scalars['String']>;
  sourceOfData?: InputMaybe<AccommodationPlaceSourceOfData>;
  userNote?: InputMaybe<Scalars['String']>;
};

export type UpdateAccommodationPlaceV2RequestV2 = {
  accommodationRoomBlock?: InputMaybe<AccommodationPlaceV2RoomBlockRequest>;
  autoSuggestionAlgo?: InputMaybe<AutoSuggestionAlgoType>;
  category?: InputMaybe<AccommodationPlaceCategory>;
  customAddress?: InputMaybe<Scalars['String']>;
  customName?: InputMaybe<Scalars['String']>;
  customPhone?: InputMaybe<Scalars['String']>;
  customPhotoId?: InputMaybe<Scalars['String']>;
  customStarRating?: InputMaybe<Scalars['Float']>;
  customUrl?: InputMaybe<Scalars['String']>;
  displayLocation?: InputMaybe<AccommodationPlaceDisplayLocation>;
  eventId: Scalars['ID'];
  id: Scalars['ID'];
  isCustomLinkEnabled?: InputMaybe<Scalars['Boolean']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  isGuestFavorite?: InputMaybe<Scalars['Boolean']>;
  isHostStayingHere?: InputMaybe<Scalars['Boolean']>;
  isPhotoHidden?: InputMaybe<Scalars['Boolean']>;
  layoutType?: InputMaybe<Scalars['String']>;
  sourceOfData?: InputMaybe<AccommodationPlaceSourceOfData>;
  userNote?: InputMaybe<Scalars['String']>;
};

export type UpdateEventSessionPayload = {
  givenPassword?: InputMaybe<Scalars['String']>;
  givenSecret?: InputMaybe<Scalars['String']>;
  guestKey?: InputMaybe<Scalars['String']>;
  isLoggedOut?: InputMaybe<Scalars['Boolean']>;
  permitUserId?: InputMaybe<Scalars['String']>;
  personIdTag?: InputMaybe<Scalars['String']>;
};

export type UpdateBookingTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  bookingType?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UpdateBudgetInput = {
  currency?: InputMaybe<Scalars['String']>;
  guestCount?: InputMaybe<Scalars['Int']>;
  totalBudget?: InputMaybe<Scalars['BigInt']>;
  weddingLocation?: InputMaybe<Scalars['String']>;
};

export type UpdateBudgetItemInput = {
  actualCost?: InputMaybe<Scalars['BigInt']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  estimatedCost?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Float']>;
};

/**
 * Used for updating an existing Cash Fund with complete replacement of fields.
 * Dense input: the caller must provide **all Fields** in the input. Any field that is omitted will be either nulled or blanked.
 * Currency cannot be updated.
 */
export type UpdateCashFundInput = {
  /** The ID of the cash fund to update. */
  cashFundId: Scalars['ID'];
  /** If true, the existing photo is cleared. Mutually exclusive with photoId. */
  clearPhoto?: InputMaybe<Scalars['Boolean']>;
  /** Updated fixed contribution amount, if omitted will be cleared. */
  fixedContributionAmountInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** Updated hide goal flag. */
  hideGoal: Scalars['Boolean'];
  /** Updated name of the cash fund. */
  name: Scalars['String'];
  /** Updated note, if omitted will be cleared. */
  note?: InputMaybe<Scalars['String']>;
  /**
   * ID of an existing Photo (owned by photo_service) to associate with the cash fund.
   * Sparse semantics (photo only): if omitted and clearPhoto is not true, the existing
   * photo is preserved. Mutually exclusive with clearPhoto: true and photoUrl.
   */
  photoId?: InputMaybe<Scalars['ID']>;
  /**
   * DEPRECATED — use photoId / clearPhoto instead. Scheduled for removal once all clients migrate.
   * Updated photo URL (legacy upload-by-URL path).
   *
   * Contract change vs. the prior schema: omitting `photoUrl` no longer clears
   * the photo. The photo field is now sparse — use `clearPhoto: true` to clear.
   * When set, `photoUrl` still uploads via the legacy pipeline and replaces the
   * photo.
   *
   * Contributes to the Solicitation Photo reference
   */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** Updated goal amount, if omitted will be cleared. */
  totalGoalInMinorUnits?: InputMaybe<Scalars['Int']>;
};

/**
 * Used for updating an existing Cash Fund Solicitation.
 * Dense input: the caller must provide **all Fields** in the input. Any field that is omitted will be either nulled or blanked.
 */
export type UpdateCashFundSolicitationInput = {
  /** Updated configuration. */
  config: UpdateCashFundSolicitationConfigInput;
  /** Updated message body. */
  inviteMessage: Scalars['String'];
  /** Updated subject line. */
  inviteSubject: Scalars['String'];
  /** Updated name, if omitted cleared. */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the solicitation to update. */
  solicitationId: Scalars['ID'];
};

/**
 * Configuration options when updating an existing Cash Fund Solicitation.
 * Includes the `clearPhoto` companion (sparse-photo semantics — see field
 * docstrings).
 */
export type UpdateCashFundSolicitationConfigInput = {
  /** Text for the call-to-action button in the email. */
  buttonText: Scalars['String'];
  /** If true, the existing photo is cleared. Mutually exclusive with photoId. */
  clearPhoto?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include recipient names in the salutation or content. */
  includeRecipientNames: Scalars['Boolean'];
  /**
   * ID of an existing Photo (owned by photo_service) to display in the solicitation email.
   * If omitted and clearPhoto is not true, the existing photo is preserved.
   * Mutually exclusive with clearPhoto: true and photoUrl.
   * Contributes to the Solicitation Photo reference
   */
  photoId?: InputMaybe<Scalars['ID']>;
  /**
   * DEPRECATED — use photoId / clearPhoto instead. Scheduled for removal once all clients migrate.
   * URL for the photo displayed in the solicitation email (legacy
   * upload-by-URL path).
   *
   * Contract change vs. the prior schema: omitting `photoUrl` no longer
   * clears the photo. The photo field is now sparse — use
   * `clearPhoto: true` to clear.
   *
   * Contributes to the Solicitation Photo reference
   */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** Greeting style for personalized emails (e.g., "Dear friends"). */
  salutation: Scalars['String'];
};

export type UpdateBudgetCategoryInput = {
  icon?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Float']>;
};

export type ChecklistItemUpdateInput = {
  action?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  reminderAt?: InputMaybe<Scalars['DateTime']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ChecklistSubItemUpdateInput = {
  action?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ConciergeImageUpload = {
  photoUrl: Scalars['String'];
  salesforceOwnerId: Scalars['String'];
};

/** Added in erorr. Do not use */
export type UpdateDonationFundDonationInput = {
  amountMonetaryMinorValue: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  platformType: DonationFundPaymentMethodEnum;
};

export type UpdateEmailTemplateInput = {
  eventId: Scalars['String'];
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  templateData?: InputMaybe<Scalars['JSON']>;
};

export type EventChecklistUpdateInput = {
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateEventCountdownComponentPayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateEventDetailsComponentPayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateEventDetailsMessagingPayload = {
  eventDetailsAutomaticRemindersEnabled?: InputMaybe<Scalars['Boolean']>;
  eventDetailsMessageBody?: InputMaybe<Scalars['String']>;
  eventDetailsMessagingEnabled?: InputMaybe<Scalars['Boolean']>;
  eventId: Scalars['String'];
  /**
   * Whether the post-RSVP email carries a calendar invitation. Writable only by a
   * super-admin while the feature ramps; from anyone else it is ignored, leaving
   * the rest of the save untouched rather than failing it. Null clears the event's
   * choice, returning it to the platform default.
   */
  rsvpCalendarInviteEnabled?: InputMaybe<Scalars['Boolean']>;
  rsvpNoCustomRedirectEnabled?: InputMaybe<Scalars['Boolean']>;
  rsvpNoCustomRedirectUrl?: InputMaybe<Scalars['String']>;
  rsvpPendingCustomRedirectEnabled?: InputMaybe<Scalars['Boolean']>;
  rsvpPendingCustomRedirectUrl?: InputMaybe<Scalars['String']>;
  /**
   * Who receives the post-RSVP couple summary. Host-editable: the mutation's
   * existing admin-for-event check is the only gate, deliberately unlike
   * rsvpCalendarInviteEnabled. Null clears the event's choice, returning it to the
   * platform default.
   */
  rsvpSummaryToAdminsEnabled?: InputMaybe<Scalars['Boolean']>;
  rsvpYesCustomRedirectEnabled?: InputMaybe<Scalars['Boolean']>;
  rsvpYesCustomRedirectUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateEventDisplayNameComponentPayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateEventDomainPayload = {
  /** The domain name; set this property to null to delete the Event Domain */
  domainName?: InputMaybe<Scalars['String']>;
};

export type UpdateEventInfoPayload = {
  announcementBanner?: InputMaybe<EventAnnouncementBannerPayload>;
  /** Clock for displaying times. Omit to leave unchanged; pass null to clear (back to locale-auto). */
  clockFormat?: InputMaybe<ClockFormat>;
  /** An ISO-8601 timestamp or datestamp (no 'T') */
  date?: InputMaybe<Scalars['String']>;
  /** Date metadata; merged with the existing value. Pass null to clear (back to single-date). */
  dateMetadata?: InputMaybe<EventDateMetadataPayload>;
  /** An ISO-8601 timestamp or datestamp (no 'T'); the range END. Required when dateMetadata.dateDisplayType is 'dateRange'. Pass null to clear (back to single-date). */
  endDate?: InputMaybe<Scalars['String']>;
  eventDateIsFinalized?: InputMaybe<Scalars['Boolean']>;
  eventDisplayName?: InputMaybe<Scalars['String']>;
  /** NOT FOR CLIENT USE.  @deprecated(reason: 'for M2M communication only') */
  eventPassword?: InputMaybe<Scalars['String']>;
  /** NOT FOR CLIENT USE.  @deprecated(reason: 'for M2M communication only') */
  eventSecret?: InputMaybe<Scalars['String']>;
  fianceeFirstName?: InputMaybe<Scalars['String']>;
  fianceeLastName?: InputMaybe<Scalars['String']>;
  /** Guest display languages; entries must be supported locale codes. Omit or pass null to leave unchanged; pass [] to clear (back to event-locale-only). */
  guestDisplayLocales?: InputMaybe<Array<Scalars['String']>>;
  locale?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationInput>;
  ownerFirstName?: InputMaybe<Scalars['String']>;
  ownerLastName?: InputMaybe<Scalars['String']>;
  /** An ISO-8601 timestamp or datestamp (no 'T'); the range START override. Pass null to clear (range start falls back to the event date). */
  startDate?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type EventAnnouncementBannerPayload = {
  active: Scalars['Boolean'];
  message?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EventDateMetadataPayload = {
  customText?: InputMaybe<Scalars['String']>;
  dateDisplayType: DateDisplayType;
  dateFormat?: InputMaybe<Scalars['String']>;
  dateRangeFormat?: InputMaybe<Scalars['String']>;
};

export type EventDataPayload = {
  budget?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['String']>;
  guestCount?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
};

export type UpdateEventPagePayload = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  /** Controls the visual layout of this Page */
  layoutType?: InputMaybe<Scalars['String']>;
  pageSubTitle?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  private?: InputMaybe<Scalars['Boolean']>;
  visibility?: InputMaybe<EventPageVisibility>;
};

export type EventPlaceUpdatePayload = {
  customName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  googlePlaceId: Scalars['String'];
  id: Scalars['ID'];
};

export type EventScheduleUpdateItemPayload = {
  description?: InputMaybe<Scalars['String']>;
  dressCode?: InputMaybe<Scalars['String']>;
  endTimeISO8601TZ?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
  scheduleId: Scalars['ID'];
  /** Per-item override for the 'Show Add to Calendar' button. null = inherit website settings. */
  showAddToCalendar?: InputMaybe<Scalars['Boolean']>;
  /** Per-item override for the 'Show Directions' link. null = inherit website settings. */
  showDirections?: InputMaybe<Scalars['Boolean']>;
  showMap?: InputMaybe<Scalars['Boolean']>;
  /** Per-item override for the 'Show Where to Stay' link. null = inherit website settings. */
  showWhereToStay?: InputMaybe<Scalars['Boolean']>;
  startTimeISO8601TZ?: InputMaybe<Scalars['String']>;
  unplugged?: InputMaybe<Scalars['Boolean']>;
  virtualEventLink?: InputMaybe<Scalars['String']>;
};

export type UpdateEventSettingsPayload = {
  allowFacebookAndInstagramSharingOnApp?: InputMaybe<Scalars['Boolean']>;
  allowGuestsNotInGuestListToRSVP?: InputMaybe<Scalars['Boolean']>;
  allowGuestsToInviteOtherGuestsOnApp?: InputMaybe<Scalars['Boolean']>;
  allowGuestsToRSVPPlusOne?: InputMaybe<Scalars['Boolean']>;
  allowGuestsToViewOtherGuestsOnApp?: InputMaybe<Scalars['Boolean']>;
  hideDownloadAppPage?: InputMaybe<Scalars['Boolean']>;
  hideEventCountdown?: InputMaybe<Scalars['Boolean']>;
  hideFromJoySearch?: InputMaybe<Scalars['Boolean']>;
  hideFromSearchEngines?: InputMaybe<Scalars['Boolean']>;
  optOutOfCharm?: InputMaybe<Scalars['Boolean']>;
  requirePasswordForEventDate?: InputMaybe<Scalars['Boolean']>;
  requirePasswordForEventLocation?: InputMaybe<Scalars['Boolean']>;
  requirePasswordToUploadPhotos?: InputMaybe<Scalars['Boolean']>;
  requirePasswordToViewEngagementPhotos?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEventSuggestionPayload = {
  stateJSON?: InputMaybe<Scalars['JSONObject']>;
};

export type UpdateEventTypeInput = {
  category?: InputMaybe<Scalars['String']>;
  categorySubtype?: InputMaybe<Scalars['String']>;
  configJson?: InputMaybe<Scalars['JSONObject']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  schemaUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateFerryTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateFlightTravelItemPayload = {
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateFloorPlanInput = {
  height?: InputMaybe<Scalars['Float']>;
  measurementUnit?: InputMaybe<MeasurementUnit>;
  name?: InputMaybe<Scalars['String']>;
  scheduleItemId?: InputMaybe<Scalars['ID']>;
  seatOffset?: InputMaybe<Scalars['Float']>;
  venueSpaceId?: InputMaybe<Scalars['ID']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type UpdateFloorPlanObjectInput = {
  height?: InputMaybe<Scalars['Float']>;
  label?: InputMaybe<Scalars['String']>;
  rotation?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Float']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type UpdateFormInput = {
  config: Scalars['JSONObject'];
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  schemaUrl: Scalars['String'];
  settings?: InputMaybe<Scalars['JSONObject']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateFormTemplateInput = {
  config: Scalars['JSONObject'];
  description?: InputMaybe<Scalars['String']>;
  eventCategoryTags: Array<Scalars['String']>;
  eventSubTypeTags: Array<Scalars['String']>;
  id: Scalars['ID'];
  schemaUrl: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateGreetingMessageComponentPayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type GuestlistUpdateCustomColumnInput = {
  columnId: Scalars['ID'];
  defaultValue?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  displayPriority?: InputMaybe<Scalars['Float']>;
  displayState?: InputMaybe<GuestlistColumnDisplayState>;
  eventId: Scalars['String'];
  isRequired?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  placeholderValue?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['JSON']>;
  type?: InputMaybe<GuestlistCustomColumnType>;
  width?: InputMaybe<Scalars['Int']>;
};

/** Partial input for updating guest list view preferences. Only provided fields are changed; omitted fields retain their current values. */
export type UpdateGuestListSettingsInput = {
  /** Direction of the initial sort order. */
  defaultSortDirection?: InputMaybe<SortDirection>;
  /** Column used for the initial sort order. */
  defaultSortField?: InputMaybe<GuestListMemberSortField>;
  /** The event whose settings are being updated. */
  eventId: Scalars['String'];
  /** Number of groups shown per page (1–200). */
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** Input for updating an existing saved guest list view. Only provided fields are changed. */
export type UpdateGuestListViewInput = {
  /** Pass null explicitly to clear the per-view column override (revert to event-level defaults). */
  columns?: InputMaybe<Array<GuestListViewColumnInput>>;
  /** The event this view belongs to (used for ownership verification). */
  eventId: Scalars['String'];
  /** Pass null explicitly to clear the saved filter. */
  filter?: InputMaybe<GuestListMemberFilterInput>;
  /** ID of the view to update. */
  id: Scalars['ID'];
  /** If omitted, name is unchanged. */
  name?: InputMaybe<Scalars['String']>;
  /** Pass null explicitly to clear the saved page size. */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Pass null explicitly to clear the saved sort. */
  sort?: InputMaybe<GuestListMemberSort>;
};

export type UpdateHotelTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Input to update an existing idempotent-operation row. */
export type InternalUpdateIdempotentOperationInput = {
  /** When the operation completed. Its handling is entangled with `status`: when `status` is omitted the value is applied as given (`null` clears); with a terminal `status` (done/error) an explicit value is applied but `null` is coalesced to now; with `status: started` the value is ignored entirely. Omit to leave unchanged. */
  completedAt?: InputMaybe<Scalars['DateTime']>;
  /** The error payload. Omit to leave unchanged; pass null to clear. */
  error?: InputMaybe<Scalars['JSON']>;
  /** The successful result payload. Omit to leave unchanged; pass null to clear. */
  result?: InputMaybe<Scalars['JSON']>;
  /** The new lifecycle status. Omit to leave unchanged. */
  status?: InputMaybe<IdempotentOperationStatus>;
};

export type UpdateInviteePayload = {
  address?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  /** Display name for mailings/correspondence (e.g., 'Mr. Evan Jones & Guest', 'The Smith Family') */
  envelopeName?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  /** Country code of the user's phone, numbers without a country code will be assumed to be in this country. Ignored if phoneDisplay has a country code, otherwise, this will be used to help parse it to E.164. */
  fallbackCountryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  personId: Scalars['ID'];
  /** Phone number as entered by the user, not necessarily valid */
  phoneDisplay?: InputMaybe<Scalars['String']>;
};

/** Input for updating a JoyDiscountCoupon. All fields except id are optional. */
export type UpdateJoyCouponInput = {
  /** Updated budget amount in minor units (cents). Required when isBudgetLimited is true. */
  budgetAmount?: InputMaybe<Scalars['Int']>;
  /** ISO 4217 currency code. Required for FIXED_AMOUNT coupons. */
  currency?: InputMaybe<Scalars['String']>;
  /** Updated discount value (percentage 0–100 or fixed amount in cents). */
  discountValue?: InputMaybe<Scalars['Float']>;
  /** Updated list of eligible product types. */
  eligibleProducts?: InputMaybe<Array<ProductType>>;
  /** The ID of the coupon to update. */
  id: Scalars['ID'];
  /** Whether this coupon has a spending budget cap. */
  isBudgetLimited?: InputMaybe<Scalars['Boolean']>;
  /** Whether the coupon is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Updated per-transaction cap for PERCENTAGE coupons, in the coupon currency. */
  maxDiscountAmount?: InputMaybe<Scalars['Float']>;
  /** Updated maximum number of redemptions. */
  maxUses?: InputMaybe<Scalars['Int']>;
  /** Opaque JSON string of internal metadata. */
  metadata?: InputMaybe<Scalars['String']>;
  /** Updated display name for the coupon. */
  name?: InputMaybe<Scalars['String']>;
  /** Updated start of the validity window. */
  validFrom?: InputMaybe<Scalars['DateTime']>;
  /** Updated end of the validity window. */
  validUntil?: InputMaybe<Scalars['DateTime']>;
};

/** Input for updating a JoyPromotionCode. All fields except id are optional. */
export type UpdateJoyPromotionCodeInput = {
  /** Updated booker-type restriction. */
  bookerType?: InputMaybe<BookerType>;
  /** Updated payment type this code works on. Omit to leave it unchanged. */
  couponPaidWith?: InputMaybe<CouponPaidWith>;
  /** Updated event ID. Required when scopeType is EVENT. */
  eventId?: InputMaybe<Scalars['ID']>;
  /** The ID of the promotion code to update. */
  id: Scalars['ID'];
  /** Whether the promotion code is enabled. */
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Updated maximum number of uses. */
  maxUses?: InputMaybe<Scalars['Int']>;
  /** Updated minimum booking spend in minor units (cents). */
  minSpend?: InputMaybe<Scalars['Int']>;
  /** Updated scope type (GLOBAL or EVENT). */
  scopeType?: InputMaybe<ScopeType>;
  /** Updated per-code expiry date. When set, overrides the parent coupon's validUntil. Set to null to revert to the coupon's validUntil. */
  validUntil?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateJsonDataBlobComponentPayload = {
  id: Scalars['ID'];
  jsonDataContainerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateJsonDataContainerPayload = {
  content?: InputMaybe<Scalars['JSONObject']>;
  id: Scalars['ID'];
  schemaUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateListTravelItemPayload = {
  id: Scalars['ID'];
  name: Scalars['String'];
  newItems?: InputMaybe<Array<InputMaybe<ListTravelSubItems>>>;
  updatedItems?: InputMaybe<Array<InputMaybe<ListTravelSubItemsWithId>>>;
};

export type ListTravelSubItemsWithId = {
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type MarketingEmailPreferencesInput = {
  email: Scalars['String'];
  preferences: Array<MessagePreferenceInput>;
};

export type MessagePreferenceInput = {
  id: Scalars['Int'];
  isSubscribed: Scalars['Boolean'];
};

export type UpdateMediaCollectionInput = {
  mediaCollectionAttributes?: InputMaybe<MediaCollectionAlbumAttributeInput>;
  mediaCollectionId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<MediaCollectionSortField>;
  sortDirection?: InputMaybe<MediaCollectionSortDirection>;
};

export type UpdateMediaGalleryComponentPayload = {
  id: Scalars['ID'];
  /** Photo gallery layout style. Free-form string interpreted by the frontend; omit/null for the default layout. */
  layout?: InputMaybe<Scalars['String']>;
  mediaCollectionId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

/**
 * Input for partial updates. Only `draft` and `failed` drafts are editable;
 * editing a `failed` draft resets its status to `draft` and clears failure
 * metadata. To change channel / messageBatchId / stationeryOrderId, delete and
 * recreate instead.
 *
 * `eventId` is required so authorization runs before any DB lookup
 * (authorize-before-fetch). The server scopes the update by `(id, eventId)`
 * — a caller with admin rights on event A can never mutate a draft that
 * belongs to event B, and cross-event ids return the same NotFound as
 * genuinely missing rows (no existence oracle).
 */
export type UpdateMessageDraftInput = {
  displayLabel?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  id: Scalars['ID'];
  messagePayload?: InputMaybe<Scalars['JSON']>;
  recipientIds?: InputMaybe<Array<Scalars['String']>>;
  /**
   * The identifier space `recipientIds` are expressed in. Omit to leave the
   * draft's existing value unchanged. Only applied together with `recipientIds`
   * or `smartRule`; ignored on an update that leaves the audience alone.
   *
   * Send it whenever you send `recipientIds`. A draft first saved while the
   * event's identity still resolved to `personId` otherwise keeps that label
   * while later updates rewrite `recipientIds` with guestKeys, and dispatch
   * routes on this field — so the send resolves nothing and reaches nobody
   * (MGT-85).
   */
  recipientType?: InputMaybe<MessageDraftRecipientType>;
  /**
   * Smart audience. Omit to leave the draft's audience unchanged; send an
   * explicit `null` to clear the rule.
   *
   * The two audience kinds are mutually exclusive, and the side you send wins:
   * a non-empty `recipientIds` clears any existing rule, and a rule empties
   * `recipientIds`. Sending a non-empty `recipientIds` AND a rule in the same
   * update is rejected as ambiguous.
   */
  smartRule?: InputMaybe<SmartTagRuleInput>;
};

export type UpdateNoteTravelItemPayload = {
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Fields to update on an offer token. Omitted fields are left unchanged. */
export type InternalUpdateOfferTokenInput = {
  /** New best-price-wins margin decision context. */
  bestPriceWinsMarginContext?: InputMaybe<Scalars['JSON']>;
  /** New currency for priceInMinorUnits. */
  currency?: InputMaybe<Scalars['String']>;
  /** The Joy-minted offer id to update. */
  joyOfferId: Scalars['ID'];
  /** New loser-recommendation fallback candidates. Every identity-replacing update should pass an empty array — the previous list was computed against the identity now being replaced, so it is stale (or, for a promoted loser, self-referential) the moment the swap lands. Omitted leaves it unchanged. */
  loserRecommendationIds?: InputMaybe<Array<Scalars['String']>>;
  /** The money group carried by the replacement offer. An omitted member is left unchanged. */
  moneyContext?: InputMaybe<InternalOfferTokenMoneyContextInput>;
  /** New final price (post-fee, post-margin) in minor units. Omitted leaves it unchanged. */
  priceInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** New provider offer id. Setting it (even to the same value) clears any stored prebookId. Optional (omit to leave unchanged); an explicit null is treated the same as omitted (the column is NOT NULL). */
  providerOfferId?: InputMaybe<Scalars['String']>;
  /** New provider rate ids. When provided, the legacy singular rateId is mirrored from the first id. */
  rateIds?: InputMaybe<Array<Scalars['String']>>;
  /** New cached raw offer snapshot. */
  rawOffer?: InputMaybe<Scalars['JSON']>;
  /** New per-room booking details JSON. */
  roomDetails?: InputMaybe<Scalars['JSON']>;
  /** New opaque provider offer token (null clears it). */
  token?: InputMaybe<Scalars['String']>;
};

export type PageContainerUpdatePayload = {
  contentType?: InputMaybe<PageContentType>;
  defaultPhotoJson?: InputMaybe<DefaultPagePhotoInput>;
  id: Scalars['ID'];
  labelIds?: InputMaybe<Array<Scalars['ID']>>;
  layoutType?: InputMaybe<Scalars['String']>;
  mainPhotoAlignment?: InputMaybe<PhotoAlignment>;
  mainPhotoCropInfo?: InputMaybe<MainPhotoCropInfoInput>;
  mainPhotoId?: InputMaybe<Scalars['ID']>;
  mainPhotoPresentationLayout?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  personIds?: InputMaybe<Array<Scalars['ID']>>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<EventPageVisibility>;
};

export type DefaultPagePhotoInput = {
  assetId: Scalars['String'];
  height: Scalars['Float'];
  mimeType: Scalars['String'];
  url: Scalars['String'];
  width: Scalars['Float'];
};

export type UpdatePaidMessagingSettingsInput = {
  eventId: Scalars['String'];
  messagingTier?: InputMaybe<MessagingTier>;
};

/** Super-admin / M2M-only input for changing the RSVP tier on an event. */
export type UpdatePaidRsvpSettingsInput = {
  /** The event whose RSVP tier to update. */
  eventId: Scalars['String'];
  /** The new RSVP tier. Omit to leave unchanged. */
  rsvpTier?: InputMaybe<RsvpTier>;
};

export type UpdatePaidSeatingSettingsInput = {
  eventId: Scalars['ID'];
  seatingTier: SeatingTier;
};

/** Seating Chart entitlement tier. basic is the free client-side sandbox; plus unlocks every seat_service write. */
export enum SeatingTier {
  basic = 'basic',
  plus = 'plus',
}

export type UpdatePaymentIntentAmountPayload = {
  id: Scalars['String'];
};

export type PhotoComponentUpdatePayload = {
  id: Scalars['ID'];
  photoId: Scalars['String'];
  sortOrder: Scalars['Float'];
};

export type PlacesMapComponentUpdatePayload = {
  id: Scalars['ID'];
  illustrationSettings?: InputMaybe<Scalars['JSONObject']>;
  placeIds?: InputMaybe<Array<Scalars['ID']>>;
  placeTypes?: InputMaybe<Array<EventPlaceType>>;
  presentation?: InputMaybe<PlacesMapPresentation>;
  sortOrder: Scalars['Float'];
};

export type PointsOnMapUpdatePayload = {
  address: Scalars['String'];
  googlePlaceID?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  postalCode: Scalars['String'];
  type: PointOnMapType;
};

/** Update the room state and final (post-fee, post-margin) price a prebook quote produced on an offer token, guarded by its current provider offer id. Never touches the money/commission columns — those are persisted separately by saveOfferTokenPrebookId. */
export type InternalUpdatePostPrebookRoomDetailsAndPricingInput = {
  /** Currency of priceInMinorUnits. */
  currency: Scalars['String'];
  /** The Joy-minted offer id. */
  joyOfferId: Scalars['ID'];
  /** Final (post-fee, post-margin) price the prebook quote settled on, in minor units. */
  priceInMinorUnits: Scalars['Int'];
  /** The provider offer id the token must still match to be written. */
  providerOfferId: Scalars['String'];
  /** New per-room booking details as JSON: array of { roomId, roomName?, occupancy: { adults, childrenAges }, refundability?, boardBasis? }. */
  roomDetails: Scalars['JSON'];
};

/**
 * Input for updating an existing promo code.
 * code, discountType, discountValue, and currency are immutable after creation.
 */
export type UpdatePromoCodeInput = {
  applicableToAll?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  id: Scalars['ID'];
  /** Set to true/false to activate or deactivate the promo code. */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** New set of ticket type IDs. Applied when applicableToAll is false. */
  ticketTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  /** New usage limit. Cannot be set below current usageCount. */
  usageLimit?: InputMaybe<Scalars['Int']>;
  validFrom?: InputMaybe<Scalars['DateTime']>;
  validUntil?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateQandaPayload = {
  answer?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
};

/** Identical to RecommendRegistryOnboardingSurveyResults. */
export type RecommendRegistryOnboardingSurveyPayload = {
  coupleInterests?: InputMaybe<Array<Scalars['String']>>;
  guestCount?: InputMaybe<Scalars['Int']>;
  interestedInBrowserButton?: InputMaybe<Scalars['Boolean']>;
  isSurveyCompleted?: InputMaybe<Scalars['Boolean']>;
  registeringAtOtherStores?: InputMaybe<Scalars['Boolean']>;
  registryTypes?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateRegistryPayload = {
  name?: InputMaybe<Scalars['String']>;
  /** update status as user goes through recommendations */
  recommendationStatus?: InputMaybe<RegistryRecommendationStatus>;
  /** The URL to the Registry website */
  url?: InputMaybe<Scalars['String']>;
  wantSync?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateRegistryChecklistItemPayload = {
  checked?: InputMaybe<Scalars['Boolean']>;
  isChecked?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Generic update mutation. Note stillNeeded and totalRequested are being withdrawn
 * from this payload. Use specific mutations such as updateRegistryItemQuantity() to
 * update quantity values
 */
export type UpdateRegistryItemPayload = {
  /** product level data that we own */
  custom?: InputMaybe<UpdateCustomItemDataInput>;
  /** donation fund info for group gifting */
  donationFundPayload?: InputMaybe<CreateDonationFundInput>;
  /** always updatable, sort related updates may be moved to dedicated endpoints */
  fpIndex?: InputMaybe<Scalars['Float']>;
  /** flag to allow the couple to enable the get cash equivalent feature */
  isGetCashEquivalent?: InputMaybe<Scalars['Boolean']>;
  /** flag to allow the couple to enable the group gifting feature */
  isGroupGiftingEnabled?: InputMaybe<Scalars['Boolean']>;
  /** flag to allow the couple to hide an item */
  isHidden?: InputMaybe<Scalars['Boolean']>;
  /** flag to allow the couple to musthave an item */
  mustHave?: InputMaybe<Scalars['Boolean']>;
  /** note added to item by couple */
  note?: InputMaybe<Scalars['String']>;
  /**
   * Insertion position in list of all items in event.
   * If specified, this value takes precedence over any fpIndex value
   */
  position?: InputMaybe<InsertPositionType>;
  /** only updatable for custom items, being deprecated, use specific mutations */
  stillNeeded?: InputMaybe<Scalars['Int']>;
  /** only updatable for custom items, being deprecated, use specific mutations */
  totalRequested?: InputMaybe<Scalars['Int']>;
};

export type UpdateCustomItemDataInput = {
  priceAsFloatingPointDecimalString?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: CustomItemDataType;
  url: Scalars['String'];
};

/**
 * Used to attach donation fund to a physical gift as part of updateRegistryItem mutation
 * when group gifting feature is enabled.
 */
export type CreateDonationFundInput = {
  description?: InputMaybe<Scalars['String']>;
  donationsAreCapped?: InputMaybe<Scalars['Boolean']>;
  enableCashOrCheck?: InputMaybe<Scalars['Boolean']>;
  enforceSuggestedDonationAmount?: InputMaybe<Scalars['Boolean']>;
  eventId: Scalars['String'];
  feePaidBy?: InputMaybe<FeePaidByEnum>;
  fpIndex?: InputMaybe<Scalars['Int']>;
  fundType?: InputMaybe<CustomItemDataType>;
  goalMonetaryMinorValue?: InputMaybe<Scalars['Int']>;
  hideFundingGoal?: InputMaybe<Scalars['Boolean']>;
  imageUrlForImport?: InputMaybe<Scalars['String']>;
  platformId?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<InsertPositionType>;
  suggestedDonationMonetaryMinorValue?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type UpdateRentalCarTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateRentalHomeTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type ReservedRoomBlocksUpdateRequest = {
  hiddenForGuests?: InputMaybe<Scalars['Boolean']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  reservedRoomBlockId: Scalars['ID'];
  status?: InputMaybe<ReservedRoomBlockStatus>;
};

export type UpdateRsvpAndUnlockGuestDetailsButtonComponentPayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateRsvpSettingsPayload = {
  deadlineDate?: InputMaybe<Scalars['DateTime']>;
  deadlineEnabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Custom message shown to guests once the RSVP deadline has passed. Max 1000
   * characters. Send null, an empty string, or whitespace-only input to clear it
   * and revert to the default post-deadline message.
   */
  deadlineNote?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  gracePeriodEnabled?: InputMaybe<Scalars['Boolean']>;
  gracePeriodHours?: InputMaybe<Scalars['Int']>;
  showDeadline?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateShuttleTravelItemPayload = {
  id: Scalars['ID'];
  name: Scalars['String'];
  newItems?: InputMaybe<Array<InputMaybe<ShuttleTravelSubItems>>>;
  notes?: InputMaybe<Scalars['String']>;
  updatedItems?: InputMaybe<Array<InputMaybe<ShuttleTravelSubItemsWithId>>>;
};

export type ShuttleTravelSubItemsWithId = {
  endTime?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateStationeryDraftInput = {
  cardJSON: Scalars['JSON'];
  eventId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};

/** Switches an existing stationery draft to a different product (e.g. print to digital). */
export type UpdateStationeryDraftProductInput = {
  /** ID of the stationery draft to update. */
  id: Scalars['ID'];
  /** ID of the target product to switch to. Determines the new format and price config. */
  productId: Scalars['ID'];
};

export type UpdateStationeryDraftWithAuditInput = {
  /** Full replacement; unknown fields are preserved. Must match the draft's existing format if supplied. */
  cardJSON: Scalars['JSON'];
  /** Pass updatedAt from the draft read before making changes. If the draft has changed, reread and reconcile your changes before retrying. */
  expectedUpdatedAt: Scalars['DateTime'];
  id: Scalars['ID'];
};

export type UpdateStationeryPrintOrderShippingAddressInput = {
  orderId: Scalars['ID'];
  shippingAddress: StationeryPrintOrderShippingAddressInput;
};

export type UpdateStayAreaRequest = {
  address?: InputMaybe<Scalars['String']>;
  bestForTags?: InputMaybe<Array<Scalars['String']>>;
  customPhotoIds?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  photoIdsToRemove?: InputMaybe<Array<Scalars['String']>>;
  proposedNoteFromHostToGuest?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StayAreaStatus>;
  watchOuts?: InputMaybe<Scalars['String']>;
  whyThisAreaIsAGreatPick?: InputMaybe<Scalars['String']>;
};

export type UpdateStayAreaRequestV2 = {
  address?: InputMaybe<Scalars['String']>;
  bestForTags?: InputMaybe<Array<Scalars['String']>>;
  customPhotoIds?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  photoIdsToRemove?: InputMaybe<Array<Scalars['String']>>;
  proposedNoteFromHostToGuest?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StayAreaStatus>;
  watchOuts?: InputMaybe<Scalars['String']>;
  whyThisAreaIsAGreatPick?: InputMaybe<Scalars['String']>;
};

export type UpdateTableInput = {
  arrangement?: InputMaybe<SeatingTableArrangement>;
  capacity?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  radius?: InputMaybe<Scalars['Float']>;
  rotation?: InputMaybe<Scalars['Int']>;
  seatLayout?: InputMaybe<Scalars['JSON']>;
  seatOffset?: InputMaybe<Scalars['Float']>;
  shape?: InputMaybe<SeatingTableShape>;
  width?: InputMaybe<Scalars['Float']>;
  x?: InputMaybe<Scalars['Float']>;
  y?: InputMaybe<Scalars['Float']>;
};

export type UpdateTableTemplateInput = {
  arrangement?: InputMaybe<Arrangement>;
  capacity?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  radius?: InputMaybe<Scalars['Float']>;
  seatLayout?: InputMaybe<Scalars['JSON']>;
  shape?: InputMaybe<TableShape>;
  width?: InputMaybe<Scalars['Float']>;
};

export type UpdateTaxiTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateTentTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateTestimonyPayload = {
  content: Scalars['String'];
  reviewer?: InputMaybe<Scalars['String']>;
  testimonyId: Scalars['String'];
};

export type TextComponentUpdatePayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
  text: Scalars['String'];
};

export type UpdateThingsToDoContainersPayload = {
  /** An array of Things To Do content to update */
  contents: Array<Scalars['JSONObject']>;
  eventId: Scalars['ID'];
  /** @deprecated(reason: "It only update contents for containers with the same 'poi.id', so the strategy is no longer needed") */
  strategy?: InputMaybe<UpdateThingsToDoContainersStrategy>;
};

export enum UpdateThingsToDoContainersStrategy {
  /** Adds new containers */
  add = 'add',
  /** Removes all containers for the cities specified in the container contents and then creates new containers for that cities */
  replace = 'replace',
}

/**
 * Input for updating an existing ticket type.
 * Nullable fields can be cleared by setting their corresponding clear flag to true.
 */
export type UpdateTicketTypeInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  /** Set to true to clear capacity (make unlimited) */
  clearCapacity?: InputMaybe<Scalars['Boolean']>;
  /** Set to true to clear the description (set to null) */
  clearDescription?: InputMaybe<Scalars['Boolean']>;
  /** Set to true to clear salesEndAt */
  clearSalesEndAt?: InputMaybe<Scalars['Boolean']>;
  /** Set to true to clear salesStartAt */
  clearSalesStartAt?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** Require approval for on-list guests registering with this ticket under GUEST_LIST_APPROVAL. */
  requireApproval?: InputMaybe<Scalars['Boolean']>;
  salesEndAt?: InputMaybe<Scalars['DateTime']>;
  salesStartAt?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<TicketTypeState>;
};

export type UpdateTrainTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateTravelAlertSubscriptionInputV1 = {
  action: TravelAlertSubscriptionActionV1;
  eventId: Scalars['ID'];
  subscriptionId: Scalars['ID'];
};

export enum TravelAlertSubscriptionActionV1 {
  OPT_OUT = 'OPT_OUT',
  RE_ENGAGE = 'RE_ENGAGE',
}

export type TravelMapComponentUpdatePayload = {
  blockOrdering?: InputMaybe<Array<Scalars['String']>>;
  hideExploreCTA?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateTravelSettingsRequest = {
  /** Host-editable intro copy for the guest Neighborhoods section. Falls back to default copy when null. */
  accommodationsNeighborhoodsNote?: InputMaybe<Scalars['String']>;
  accommodationsNotePrompt?: InputMaybe<Scalars['String']>;
  /** Layout variant for the accommodations page. */
  accommodationsPageLayout?: InputMaybe<AccommodationsPageLayout>;
  checkInDate?: InputMaybe<Scalars['DateOnlyString']>;
  checkOutDate?: InputMaybe<Scalars['DateOnlyString']>;
  currencyCode?: InputMaybe<TravelCurrencyCode>;
  datesMatchingReminder?: InputMaybe<Scalars['Boolean']>;
  eventId: Scalars['ID'];
  /** Per-email-type opt-out for the hotel abandonment reminder emails (checkout and product page). Set false to disable them for this event; defaults to true. Does not affect hotelBookingReminderEnabled. */
  hotelAbandonmentReminderEnabled?: InputMaybe<Scalars['Boolean']>;
  /** When false, hotel booking reminder emails are disabled for this event. Defaults to true. */
  hotelBookingReminderEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Per-email-type opt-out for the pre- and post-first-booking emails — every email that encourages or follows up on a hotel booking outside the abandonment series, both before the event has one (host A1/A2, guest HA1/HA2) and after (host B1/C1 + B2/C2, guest G1/G2). Set false to disable them for this event; defaults to true. Does not affect hotelBookingReminderEnabled. */
  preAndPostFirstBookingEmailsEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Host opt-out for the guest event group code banner shown on the where-to-stay page. */
  showEventGroupCodeBanner?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateUserPayload = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateVendor = {
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  location?: InputMaybe<LocationInput>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  startingPrice?: InputMaybe<Scalars['Int']>;
  typicalSpend?: InputMaybe<Scalars['Int']>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateVendorAsCouplePayload = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  location?: InputMaybe<LocationInput>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateVendorUserPayload = {
  displayFirstName?: InputMaybe<Scalars['String']>;
  displayLastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateVenueSpaceInput = {
  description?: InputMaybe<Scalars['String']>;
  dimensions?: InputMaybe<Scalars['JSON']>;
  maxCapacity?: InputMaybe<Scalars['Int']>;
  placeId?: InputMaybe<Scalars['String']>;
  seatingSpaceName?: InputMaybe<Scalars['String']>;
};

export type VideoComponentUpdatePayload = {
  caption?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
  videoUrl: Scalars['String'];
};

export type UpdateVipPayload = {
  alias?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  photoUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateGreetingInput = {
  greeting: Scalars['String'];
};

export type UploadCustomThemeAssetPayload = {
  assetId: Scalars['String'];
  eventId: Scalars['ID'];
  height?: InputMaybe<Scalars['Int']>;
  mimeType?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type createMediaFromUrlsInput = {
  collectionId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  magicToken?: InputMaybe<Scalars['String']>;
  photos: Array<PhotoInput>;
};

export type PhotoInput = {
  assetId: Scalars['String'];
  handle?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type UploadPhotoFromUrlPayload = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  url: Scalars['String'];
};

export enum PhotoEnvelopeActionCode {
  /** Processing is not possible, and never will be; do not retry */
  abandon = 'abandon',
  /** Processing failed; please retry */
  retry = 'retry',
  /** Processing was successful */
  success = 'success',
}

/** A batch of car inventory snapshots to upsert. */
export type InternalUpsertCarInventorySnapshotsInput = {
  /** The car inventory snapshots to upsert. */
  snapshots: Array<InternalUpsertCarInventorySnapshotInput>;
};

/** A single car inventory snapshot to upsert. */
export type InternalUpsertCarInventorySnapshotInput = {
  /** Display-only vehicle and pickup-station content to store. */
  details: Scalars['JSON'];
  /** Geohash (precision 5) of the search pickup coordinates. */
  pickupAreaKey: Scalars['String'];
  /** Partner-scoped key identifying the pickup station. */
  pickupStationKey: Scalars['String'];
  /** Partner that supplied this snapshot. */
  provider: CarInventorySnapshotProvider;
  /** Partner-scoped key identifying the vehicle. */
  providerVehicleKey: Scalars['String'];
  /** Radius in km of the live search this car was seen under. */
  radiusKmBucket: Scalars['Int'];
  /** What produced this snapshot, e.g. LIVE_SEARCH. */
  source: Scalars['String'];
};

export type UpsertCustomThemePayload = {
  description?: InputMaybe<Scalars['String']>;
  desktopThemeAssetId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  mobileThemeAssetId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type UpsertStationeryTagInput = {
  category?: InputMaybe<Scalars['String']>;
  displayLabel: Scalars['String'];
  name: Scalars['String'];
  thumbnailUrl?: InputMaybe<Scalars['String']>;
};

export type VerifyEmailPayload = {
  returnUrl?: InputMaybe<Scalars['String']>;
};

export type VerifyTravelAlertOtpInputV1 = {
  channel: TravelAlertChannelV1;
  email?: InputMaybe<Scalars['String']>;
  /** One-time code from SMS or email. Exactly 4 digits; must match the code we generated when sendTravelAlertOtpV1 ran. */
  otp: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type WebsiteActivateHeaderForDesignInput = {
  designId: Scalars['String'];
  eventId: Scalars['String'];
  schemaURL: Scalars['String'];
  websiteLayout: Scalars['String'];
};

export type WebsiteActivateHeaderForEventInput = {
  eventId: Scalars['String'];
  schemaURL: Scalars['String'];
  websiteLayout: Scalars['String'];
};

export type WebsiteApplyHeaderPresentationSettingsInput = {
  dataJSON: Scalars['JSON'];
  eventId: Scalars['ID'];
  schemaURL: Scalars['String'];
  websiteLayout: Scalars['String'];
};

export type websiteCreateOrUpdatePagePhotoPresentationPayload = {
  cropInfo?: InputMaybe<WebsitePagePhotoPresentationCropInfoInput>;
  id?: InputMaybe<Scalars['ID']>;
  pageId?: InputMaybe<Scalars['ID']>;
  /** fullWidth, center */
  presentationLayout: Scalars['String'];
};

export type WebsitePagePhotoPresentationCropInfoInput = {
  height: Scalars['Float'];
  /** percent */
  unit: Scalars['String'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type WebsiteRemoveActiveHeaderForEventInput = {
  eventId: Scalars['String'];
  websiteLayout: Scalars['String'];
};

export type WebsiteRemoveDeletedPhotoFromHeadersInput = {
  eventId: Scalars['ID'];
  mediaUrl: Scalars['String'];
};

/**
 * Input for selecting (applying) one of the AI-generated design
 * recommendations produced by a successful WebsiteStylistDesignRecommendationJob.
 */
export type WebsiteStylistApplyDesignRecommendationInput = {
  /**
   * The id of the design recommendation to apply, matching one of the
   * `id` values in the job result's `recommendations` array.
   */
  designId: Scalars['ID'];
  /** The job whose recommendation the user is selecting. */
  jobId: Scalars['ID'];
};

export type WebsiteStylistStartDesignRecommendationsInput = {
  eventId: Scalars['ID'];
  photos: Array<WebsiteStylistDesignRecommendationPhotoInput>;
};

export type WebsiteStylistDesignRecommendationPhotoInput = {
  id: Scalars['ID'];
  url: Scalars['String'];
};

/** Options for withdrawCashFundsPayoutAccount */
export type WithdrawCashFundsPayoutAccountOptions = {
  /** Amount to withdraw in minor currency units. Defaults to full available balance. */
  amountInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** Payout method. Defaults to standard. */
  payoutMethod?: InputMaybe<CashFundsExternalAccountPayoutMethod>;
};

/** Options for the withdrawFromPayoutAccount mutation */
export type WithdrawRegistryPayoutAccountOptions = {
  /** Amount to withdraw in minor currency units. Defaults to full available balance. */
  amountInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** Payout method. Defaults to standard. */
  payoutMethod?: InputMaybe<RegistryPayoutAccountExternalAccountPayoutMethod>;
};

export type CalendarDate = {
  dayOfMonth: Scalars['Int'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};

/** Represents the role of the user accessing the cash fund. */
export enum CashFundRole {
  admin = 'admin',
}

/** Different types of checkout mechanisms we support */
export enum CheckoutMechanismType {
  /** external link */
  externalNavigation = 'externalNavigation',
  /** we ship it */
  joyWeb = 'joyWeb',
}

export type ContactAuthorizedUseInput = {
  allow: Scalars['Boolean'];
  contactListId: Scalars['String'];
  householdId: Scalars['String'];
  personId: Scalars['String'];
};

export type ContactHouseholdInput = {
  displayName?: InputMaybe<Scalars['String']>;
  ownerId: Scalars['String'];
};

export type CreateEventPayload = {
  accentColor?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  accentLightText?: InputMaybe<Scalars['Boolean']>;
  accentText?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  acquisitionContext?: InputMaybe<AcquisitionContext>;
  baseColor?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  baseLightText?: InputMaybe<Scalars['Boolean']>;
  baseText?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  calendarDate?: InputMaybe<CalendarDate>;
  /** Source of the event being created. ie: Create Wedding, Vendor RFP */
  creationSource?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Float']>;
  enableTranslucentEffect?: InputMaybe<Scalars['Boolean']>;
  eventDisplayName?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<EventType>;
  exhibitId?: InputMaybe<Scalars['String']>;
  fianceeFirstName: Scalars['String'];
  fianceeLastName: Scalars['String'];
  font?: InputMaybe<Scalars['String']>;
  graphicAccent?: InputMaybe<Scalars['String']>;
  /** Tracking information for an Impact Radius Campaign */
  impactRadiusTracking?: InputMaybe<CreateEventImpactRadiusTrackingPayload>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  ownerFirstName: Scalars['String'];
  ownerLastName: Scalars['String'];
  paletteId?: InputMaybe<Scalars['String']>;
  paletteName?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
  theme?: InputMaybe<Scalars['String']>;
  tzid?: InputMaybe<Scalars['String']>;
  useSuggestedBackgroundColor?: InputMaybe<Scalars['Boolean']>;
  useWeddingColor?: InputMaybe<Scalars['Boolean']>;
  venue?: InputMaybe<EventLocationInput>;
};

export type CreateRegistryOrderInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
};

export type EmailMessageInput = {
  emailType: Scalars['String'];
  eventId: Scalars['String'];
  eventLink?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventPassword?: InputMaybe<Scalars['String']>;
  eventWebsite?: InputMaybe<Scalars['String']>;
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  greeting?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAppInstructions?: InputMaybe<Scalars['Boolean']>;
  includeEventPassword?: InputMaybe<Scalars['Boolean']>;
  includeWebsiteDetails?: InputMaybe<Scalars['Boolean']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  replyToEmail: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  sentByUserId?: InputMaybe<Scalars['String']>;
  sentForEventId?: InputMaybe<Scalars['String']>;
  sentForVendorId?: InputMaybe<Scalars['String']>;
  sentToPersonId?: InputMaybe<Scalars['String']>;
  sentToUserId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type EventFeaturePreferenceOptions = {
  considerThemeSupport?: InputMaybe<Scalars['Boolean']>;
};

export enum FormActionType {
  ADD_CONTACT_TO_GUEST_LIST = 'ADD_CONTACT_TO_GUEST_LIST',
  SEND_CONFIRMATION_EMAIL = 'SEND_CONFIRMATION_EMAIL',
  SET_ATTENDANCE = 'SET_ATTENDANCE',
}

/**
 * Machine-readable error codes returned in GraphQL error extensions.
 * Use these values to match on specific error conditions in client code.
 */
export enum FormServiceErrorCode {
  ANSWER_ATTENDANCE_ANSWER_REQUIRED = 'ANSWER_ATTENDANCE_ANSWER_REQUIRED',
  ANSWER_CONTACT_UPDATE_FAILED = 'ANSWER_CONTACT_UPDATE_FAILED',
  /** A shared party answer was aimed at another member's guest key; it must be written under the answerer's own */
  ANSWER_GROUP_FOREIGN_TARGET = 'ANSWER_GROUP_FOREIGN_TARGET',
  /** Could not determine which party member answers a shared question — retryable */
  ANSWER_GROUP_PARTY_UNRESOLVED = 'ANSWER_GROUP_PARTY_UNRESOLVED',
  /** A question answered once for the whole RSVP party is held by another member, who alone can change it */
  ANSWER_GROUP_SLOT_HELD = 'ANSWER_GROUP_SLOT_HELD',
  ANSWER_GUEST_KEY_REQUIRED = 'ANSWER_GUEST_KEY_REQUIRED',
  ANSWER_HISTORY_LIMIT_EXCEEDED = 'ANSWER_HISTORY_LIMIT_EXCEEDED',
  ANSWER_INVALID_APPROVAL_FLOW = 'ANSWER_INVALID_APPROVAL_FLOW',
  /** A clearedQuestionIds entry the write path cannot honor: no guestKey to scope it, the attendance question, or a question the same submission answers */
  ANSWER_INVALID_CLEAR = 'ANSWER_INVALID_CLEAR',
  ANSWER_INVALID_INPUT = 'ANSWER_INVALID_INPUT',
  ANSWER_NOT_FOUND = 'ANSWER_NOT_FOUND',
  /** The guest already belongs to a party; changing an existing one is an organizer action */
  ANSWER_PARTY_ALREADY_EXISTS = 'ANSWER_PARTY_ALREADY_EXISTS',
  /** Declaring your own party members is not enabled on this form */
  ANSWER_PARTY_FORMATION_DISABLED = 'ANSWER_PARTY_FORMATION_DISABLED',
  /** The party could not be created — retryable */
  ANSWER_PARTY_FORMATION_FAILED = 'ANSWER_PARTY_FORMATION_FAILED',
  /** Declaring your own party members is not supported on ticketed forms — a co-member cannot be issued a ticket */
  ANSWER_PARTY_FORMATION_TICKETING_UNSUPPORTED = 'ANSWER_PARTY_FORMATION_TICKETING_UNSUPPORTED',
  /** More party members were declared than the form's cap allows, counting the acting guest */
  ANSWER_PARTY_SIZE_LIMIT_EXCEEDED = 'ANSWER_PARTY_SIZE_LIMIT_EXCEEDED',
  ANSWER_SUBMISSION_FAILED = 'ANSWER_SUBMISSION_FAILED',
  ANSWER_TICKET_TYPE_REQUIRED = 'ANSWER_TICKET_TYPE_REQUIRED',
  /** Another order for this buyer email on this event has already secured funds, so checkout was refused */
  DUPLICATE_PAID_ORDER_FOR_EMAIL = 'DUPLICATE_PAID_ORDER_FOR_EMAIL',
  /** An attendance branching route names a step that does not exist in the form config */
  FORM_INVALID_BRANCHING = 'FORM_INVALID_BRANCHING',
  FORM_INVALID_FEE_RATE = 'FORM_INVALID_FEE_RATE',
  FORM_INVALID_INPUT = 'FORM_INVALID_INPUT',
  FORM_INVALID_SETTINGS = 'FORM_INVALID_SETTINGS',
  FORM_NO_EVENT = 'FORM_NO_EVENT',
  FORM_NOT_FOUND = 'FORM_NOT_FOUND',
  FORM_NOT_REGISTRATION_TYPE = 'FORM_NOT_REGISTRATION_TYPE',
  FORM_REGISTRATION_ALREADY_EXISTS = 'FORM_REGISTRATION_ALREADY_EXISTS',
  /** Google Wallet API error */
  GOOGLE_WALLET_API_ERROR = 'GOOGLE_WALLET_API_ERROR',
  /** Event date is not finalized */
  GOOGLE_WALLET_EVENT_DATE_NOT_FINALIZED = 'GOOGLE_WALLET_EVENT_DATE_NOT_FINALIZED',
  /** Google Wallet service failed to initialize */
  GOOGLE_WALLET_INIT_FAILED = 'GOOGLE_WALLET_INIT_FAILED',
  /** Invalid Google Wallet input */
  GOOGLE_WALLET_INVALID_INPUT = 'GOOGLE_WALLET_INVALID_INPUT',
  /** Google Wallet issuerId is required but not configured */
  GOOGLE_WALLET_NOT_CONFIGURED = 'GOOGLE_WALLET_NOT_CONFIGURED',
  /** Google Wallet is not enabled */
  GOOGLE_WALLET_NOT_ENABLED = 'GOOGLE_WALLET_NOT_ENABLED',
  /** Ticket is cancelled */
  GOOGLE_WALLET_TICKET_CANCELLED = 'GOOGLE_WALLET_TICKET_CANCELLED',
  /** Ticket data is missing and a Google Wallet pass cannot be generated */
  GOOGLE_WALLET_TICKET_DATA_MISSING = 'GOOGLE_WALLET_TICKET_DATA_MISSING',
  /** Ticket not found */
  GOOGLE_WALLET_TICKET_NOT_FOUND = 'GOOGLE_WALLET_TICKET_NOT_FOUND',
  /** Failed to download PKPass from storage */
  PKPASS_DOWNLOAD_FAILED = 'PKPASS_DOWNLOAD_FAILED',
  /** Event date is not finalized, cannot generate PKPass */
  PKPASS_EVENT_DATE_NOT_FINALIZED = 'PKPASS_EVENT_DATE_NOT_FINALIZED',
  /** PKPass is enabled in config but module initialization failed */
  PKPASS_INIT_FAILED = 'PKPASS_INIT_FAILED',
  /** eventId or ticketId is not a valid UUID for PKPass blob storage operations */
  PKPASS_INVALID_ID_FORMAT = 'PKPASS_INVALID_ID_FORMAT',
  /** Invalid input for PKPass operations (e.g. malformed UUID) */
  PKPASS_INVALID_INPUT = 'PKPASS_INVALID_INPUT',
  /** PKPass is not ready to generate passes (missing template, certificates, or barcode HMAC) */
  PKPASS_NOT_CONFIGURED = 'PKPASS_NOT_CONFIGURED',
  /** PKPass is not enabled or not fully operational */
  PKPASS_NOT_ENABLED = 'PKPASS_NOT_ENABLED',
  /** Azure ticket storage configuration is missing (misconfiguration) */
  PKPASS_STORAGE_CONFIG_MISSING = 'PKPASS_STORAGE_CONFIG_MISSING',
  /** PKPass blob storage client is not initialized */
  PKPASS_STORAGE_NOT_INITIALIZED = 'PKPASS_STORAGE_NOT_INITIALIZED',
  /** Ticket is cancelled, cannot download PKPass */
  PKPASS_TICKET_CANCELLED = 'PKPASS_TICKET_CANCELLED',
  /** Ticket not found for PKPass download (also covers wrong guestKey — IDOR prevention) */
  PKPASS_TICKET_NOT_FOUND = 'PKPASS_TICKET_NOT_FOUND',
  /** Download token has expired */
  PKPASS_TOKEN_EXPIRED = 'PKPASS_TOKEN_EXPIRED',
  /** Download token signature is invalid */
  PKPASS_TOKEN_INVALID = 'PKPASS_TOKEN_INVALID',
  REGISTRATION_INVALID_INPUT = 'REGISTRATION_INVALID_INPUT',
  REGISTRATION_INVALID_PAGINATION_INPUT = 'REGISTRATION_INVALID_PAGINATION_INPUT',
  REGISTRATION_INVALID_STATE = 'REGISTRATION_INVALID_STATE',
  REGISTRATION_NO_FORM = 'REGISTRATION_NO_FORM',
  REGISTRATION_NOT_FOUND = 'REGISTRATION_NOT_FOUND',
  REGISTRATION_PAYMENT_INCOMPLETE = 'REGISTRATION_PAYMENT_INCOMPLETE',
  /** Failed to cancel or refund payment via the payment service */
  TICKETING_CANCEL_OR_REFUND_FAILED = 'TICKETING_CANCEL_OR_REFUND_FAILED',
  /** No pending payment order exists for this guest and ticket type */
  TICKETING_NO_PENDING_PAYMENT_ORDER = 'TICKETING_NO_PENDING_PAYMENT_ORDER',
  TICKETING_ORDER_ALREADY_CANCELLED = 'TICKETING_ORDER_ALREADY_CANCELLED',
  TICKETING_ORDER_HAS_CHECKED_IN_TICKET = 'TICKETING_ORDER_HAS_CHECKED_IN_TICKET',
  TICKETING_ORDER_INVALID_INPUT = 'TICKETING_ORDER_INVALID_INPUT',
  TICKETING_ORDER_INVALID_STATE = 'TICKETING_ORDER_INVALID_STATE',
  TICKETING_ORDER_NOT_FOUND = 'TICKETING_ORDER_NOT_FOUND',
  /** Failed to cancel a Stripe payment intent via the payment service */
  TICKETING_PAYMENT_INTENT_CANCEL_FAILED = 'TICKETING_PAYMENT_INTENT_CANCEL_FAILED',
  /** Failed to capture a Stripe payment intent via the payment service */
  TICKETING_PAYMENT_INTENT_CAPTURE_FAILED = 'TICKETING_PAYMENT_INTENT_CAPTURE_FAILED',
  /** Failed to create a Stripe payment intent via the payment service */
  TICKETING_PAYMENT_INTENT_CREATION_FAILED = 'TICKETING_PAYMENT_INTENT_CREATION_FAILED',
  /** Payment service is unavailable (network error or unexpected upstream failure) */
  TICKETING_PAYMENT_SERVICE_UNAVAILABLE = 'TICKETING_PAYMENT_SERVICE_UNAVAILABLE',
  /** Failed to create payout account via the payment service */
  TICKETING_PAYOUT_ACCOUNT_CREATE_FAILED = 'TICKETING_PAYOUT_ACCOUNT_CREATE_FAILED',
  /** Payout account is not ready to accept payments (KYC incomplete or account not connected) */
  TICKETING_PAYOUT_ACCOUNT_NOT_READY = 'TICKETING_PAYOUT_ACCOUNT_NOT_READY',
  /** A promo code with this code already exists and is active */
  TICKETING_PROMO_CODE_ALREADY_ACTIVE = 'TICKETING_PROMO_CODE_ALREADY_ACTIVE',
  /** Promo code has reached its usage limit */
  TICKETING_PROMO_CODE_EXHAUSTED = 'TICKETING_PROMO_CODE_EXHAUSTED',
  /** Promo code fields are immutable after creation */
  TICKETING_PROMO_CODE_IMMUTABLE_FIELD = 'TICKETING_PROMO_CODE_IMMUTABLE_FIELD',
  /** Invalid promo code input */
  TICKETING_PROMO_CODE_INVALID_INPUT = 'TICKETING_PROMO_CODE_INVALID_INPUT',
  /** Maximum number of promo codes (50) has been reached for this event */
  TICKETING_PROMO_CODE_LIMIT_REACHED = 'TICKETING_PROMO_CODE_LIMIT_REACHED',
  /** Promo code not found */
  TICKETING_PROMO_CODE_NOT_FOUND = 'TICKETING_PROMO_CODE_NOT_FOUND',
  /** Promo code not found or is not deleted */
  TICKETING_PROMO_CODE_NOT_FOUND_OR_NOT_DELETED = 'TICKETING_PROMO_CODE_NOT_FOUND_OR_NOT_DELETED',
  /** This promo code was previously used and cannot be re-created */
  TICKETING_PROMO_CODE_PREVIOUSLY_USED = 'TICKETING_PROMO_CODE_PREVIOUSLY_USED',
  /** Too many promo code requests */
  TICKETING_PROMO_CODE_RATE_LIMITED = 'TICKETING_PROMO_CODE_RATE_LIMITED',
  /** New usage limit cannot be less than the current usage count */
  TICKETING_PROMO_CODE_USAGE_LIMIT_BELOW_COUNT = 'TICKETING_PROMO_CODE_USAGE_LIMIT_BELOW_COUNT',
  /** Order is in an invalid state for promo code replacement */
  TICKETING_PROMO_REPLACE_INVALID_STATE = 'TICKETING_PROMO_REPLACE_INVALID_STATE',
  /** No existing promo code on this order to replace */
  TICKETING_PROMO_REPLACE_NO_EXISTING_PROMO = 'TICKETING_PROMO_REPLACE_NO_EXISTING_PROMO',
  /** Cannot replace promo code while payment is pending */
  TICKETING_PROMO_REPLACE_PAYMENT_PENDING = 'TICKETING_PROMO_REPLACE_PAYMENT_PENDING',
  /** Failed to refund payment via the payment service */
  TICKETING_REFUND_FAILED = 'TICKETING_REFUND_FAILED',
  TICKETING_SALES_DATE_INVALID = 'TICKETING_SALES_DATE_INVALID',
  TICKETING_SOLD_OUT = 'TICKETING_SOLD_OUT',
  TICKETING_TICKET_CHECKIN_INVALID_QR = 'TICKETING_TICKET_CHECKIN_INVALID_QR',
  TICKETING_TICKET_CHECKIN_UNAUTHORIZED = 'TICKETING_TICKET_CHECKIN_UNAUTHORIZED',
  TICKETING_TICKET_INVALID_INPUT = 'TICKETING_TICKET_INVALID_INPUT',
  TICKETING_TICKET_INVALID_STATE = 'TICKETING_TICKET_INVALID_STATE',
  TICKETING_TICKET_NO_TYPE = 'TICKETING_TICKET_NO_TYPE',
  TICKETING_TICKET_NOT_FOUND = 'TICKETING_TICKET_NOT_FOUND',
  TICKETING_TICKET_ORDER_NOT_ACTIVE = 'TICKETING_TICKET_ORDER_NOT_ACTIVE',
  TICKETING_TICKET_PAYMENT_INCOMPLETE = 'TICKETING_TICKET_PAYMENT_INCOMPLETE',
  TICKETING_TICKET_SALES_ENDED = 'TICKETING_TICKET_SALES_ENDED',
  TICKETING_TICKET_SALES_NOT_STARTED = 'TICKETING_TICKET_SALES_NOT_STARTED',
  TICKETING_TICKET_SCAN_UNAUTHORIZED = 'TICKETING_TICKET_SCAN_UNAUTHORIZED',
  TICKETING_TICKET_TYPE_DUPLICATE_NAME = 'TICKETING_TICKET_TYPE_DUPLICATE_NAME',
  TICKETING_TICKET_TYPE_EVENT_NOT_FOUND = 'TICKETING_TICKET_TYPE_EVENT_NOT_FOUND',
  TICKETING_TICKET_TYPE_HAS_SALES = 'TICKETING_TICKET_TYPE_HAS_SALES',
  TICKETING_TICKET_TYPE_INVALID_INPUT = 'TICKETING_TICKET_TYPE_INVALID_INPUT',
  TICKETING_TICKET_TYPE_NOT_FOUND = 'TICKETING_TICKET_TYPE_NOT_FOUND',
  TICKETING_TICKET_TYPE_NOT_FREE = 'TICKETING_TICKET_TYPE_NOT_FREE',
  /** Cannot switch ticket type on a completed order — refund required first */
  TICKETING_TICKET_TYPE_SWITCH_NOT_SUPPORTED_FOR_COMPLETED = 'TICKETING_TICKET_TYPE_SWITCH_NOT_SUPPORTED_FOR_COMPLETED',
  TICKETING_TICKET_TYPE_UNAVAILABLE = 'TICKETING_TICKET_TYPE_UNAVAILABLE',
  TICKETING_TICKET_UNAUTHORIZED = 'TICKETING_TICKET_UNAUTHORIZED',
}

export type InviteNewVendorToEventPayload = {
  email?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export enum ItemDiscountPolicyClause {
  CANNOT_DROPSHIP = 'CANNOT_DROPSHIP',
  IS_EXTERNAL = 'IS_EXTERNAL',
  IS_NOT_A_CATALOG_ITEM = 'IS_NOT_A_CATALOG_ITEM',
  IS_NOT_A_GIFT = 'IS_NOT_A_GIFT',
  IS_NOT_NEEDED = 'IS_NOT_NEEDED',
  IS_NOT_SHIPPABLE = 'IS_NOT_SHIPPABLE',
  QUANTITY_EXCEEDS_LIMIT = 'QUANTITY_EXCEEDS_LIMIT',
  WAS_ADDED_AFTER_EVENT_DATE = 'WAS_ADDED_AFTER_EVENT_DATE',
}

export type PageComponentPayload = {
  sortOrder: Scalars['Float'];
  text?: InputMaybe<Scalars['String']>;
  type: ComponentType;
  url?: InputMaybe<Scalars['String']>;
};

export enum ProductCatalogItemFulfillmentMethod {
  default = 'default',
  email = 'email',
}

export enum ProductCatalogItemType {
  cash = 'cash',
  charity = 'charity',
  experience = 'experience',
  gift_card = 'gift_card',
  product = 'product',
  travel = 'travel',
}

export type PublishEventDesignDraftPayload = {
  eventDesignId: Scalars['ID'];
};

export enum RegistrationApprovalFlow {
  AUTOMATIC = 'AUTOMATIC',
  GUEST_LIST_APPROVAL = 'GUEST_LIST_APPROVAL',
}

export enum RegistryChecklistItemType {
  registryItem = 'registryItem',
}

export enum RegistryDiscountPolicyClause {
  BEFORE_EVENT_DATE = 'BEFORE_EVENT_DATE',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  NO_CATALOG_ITEM_ADDED_BEFORE_CUTOFF_DATE = 'NO_CATALOG_ITEM_ADDED_BEFORE_CUTOFF_DATE',
  NO_DROPSHIP_ORDER_BEFORE_EVENT_DATE = 'NO_DROPSHIP_ORDER_BEFORE_EVENT_DATE',
  NOT_AN_ADMIN = 'NOT_AN_ADMIN',
  PAST_POST_WEDDING_DISCOUNT_END_DATE = 'PAST_POST_WEDDING_DISCOUNT_END_DATE',
}

export enum RegistryFulfillmentStatusType {
  processing = 'processing',
  shipped = 'shipped',
}

export enum RegistryPayoutAccountWithdrawalStatus {
  failed = 'failed',
  pending = 'pending',
  succeeded = 'succeeded',
}

export type StationeryLayout = {
  cutMargin: Scalars['Float'];
  height: Scalars['Float'];
  safeZoneMargin: Scalars['Float'];
  width: Scalars['Float'];
};

export type StationeryProductChoiceInput = {
  attributeId: Scalars['ID'];
  attributeOptionId: Scalars['ID'];
};

export type StationeryProductInput = {
  choices: Array<StationeryProductChoiceInput>;
  productId: Scalars['ID'];
};

export type UpdateEventPayload = {
  website: Scalars['String'];
};

export enum WarehouseFulfillmentMethod {
  /** Standard Physical Item Shipping */
  default = 'default',
  /** E-Delivery */
  email = 'email',
  /**
   * Using the option of 'none' will trigger order fulfillment step to be skipped in commerce service for this item
   * avoiding unnecessary fees from Shopify and Logic Broker.  This is designed for features like Joy eCards that are
   * fulfilled with an automated email and do not need physical shipping, tracking, 3rd party vender interactions, returns, etc.
   */
  none = 'none',
  /** Joy Wallet / CC4$ Payout */
  payout = 'payout',
  /** Travel Fulfillment */
  travel = 'travel',
}

export enum WarehouseInventoryCheckResult {
  insufficientInventory = 'insufficientInventory',
  inventoryOK = 'inventoryOK',
  skuNotFound = 'skuNotFound',
  supplierProductNotFound = 'supplierProductNotFound',
}

export enum WarehouseTaxCode {
  cash_fund = 'cash_fund',
  default = 'default',
  /**
   * Digital Greeting Cards - Static text and/or images only  14111605A0003
   * An electronic greeting "card" typically sent via email that contains only static images or text
   * rather than an audio visual or audio only experience.
   */
  ecard_static = 'ecard_static',
  gift_card = 'gift_card',
  /**
   * Tax code: 82121500A0000
   * A charge for the printing, imprinting, lithographing, mimeographing, photocopying, and similar
   * reproductions of various articles including mailers, catalogs, letterhead, envelopes, business cards,
   * presentation folders, forms, signage, etc. The end result is the transfer of tangible personal property to the customer.
   */
  print_card = 'print_card',
  /** Yet TBD */
  travel_accommodation = 'travel_accommodation',
}

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    LocationInterface: ['EventLocation', 'Location', 'VendorLocation'],
    FavoriteResource: ['DesignLayout', 'Font', 'Theme'],
    DesignPreference: [
      'DesignPreferenceColor',
      'DesignPreferenceRange',
      'DesignPreferenceBoolean',
      'EventDesignPreferenceBoolean',
      'EventDesignPreferenceColorPointer',
      'EventDesignPreferenceRange',
      'EventDesignPreferenceColor',
    ],
    WebsiteLayoutAlohaOptions: ['WebsiteLayoutAlohaSettings'],
    WebsiteLayoutBrannanOptions: ['WebsiteLayoutBrannanSettings'],
    EventDesignPreference: ['EventDesignPreferenceBoolean', 'EventDesignPreferenceColorPointer', 'EventDesignPreferenceRange'],
    ProductCatalogCollectionDisplayInfoInterface: ['ProductCatalogCollectionDisplayInfoToCategory', 'ProductCatalogCollectionDisplayInfo'],
    ProductCatalogEntity: [
      'ProductCatalogEntityBrand',
      'ProductCatalogEntityCategory',
      'ProductCatalogEntityCuration',
      'ProductCatalogEntityItem',
      'ProductCatalogEntityItemGroup',
    ],
    ProductCatalogAsset: ['ProductCatalogPhotoAsset', 'ProductCatalogVideoAsset'],
    RatingReviewAsset: ['RatingReviewPhotoAsset', 'RatingReviewVideoAsset'],
    EventTravel: ['EventTravelBookingType', 'EventTravelList', 'EventTravelNote', 'Ferry', 'Flight', 'Hotel', 'RentalCar', 'RentalHome', 'Shuttle', 'Taxi', 'Tent', 'Train'],
    EventTravelShared: ['EventTravelBookingType', 'EventTravelList', 'EventTravelNote', 'Ferry', 'Flight', 'Hotel', 'RentalCar', 'RentalHome', 'Shuttle', 'Taxi', 'Tent', 'Train'],
    EventMedia: ['MediaPhoto', 'MediaVideo'],
    PagePhoto: ['DefaultPagePhoto', 'Photo'],
    Component: [
      'EventCountdownComponent',
      'EventDetailsComponent',
      'EventDisplayNameComponent',
      'GreetingMessageComponent',
      'JsonDataBlobComponent',
      'MediaGalleryComponent',
      'PhotoComponent',
      'PlacesMapComponent',
      'RsvpAndUnlockGuestDetailsButtonComponent',
      'TextComponent',
      'TravelMapComponent',
      'VideoComponent',
    ],
    RegistryPayoutAccountExternalAccount: ['RegistryPayoutAccountBankExternalAccount', 'RegistryPayoutAccountCardExternalAccount'],
    Connection: ['CollectionItemsConnection'],
    Edge: ['CollectionItemsEdge'],
    SalesOrderLine: [
      'SalesOrderCompensationLine',
      'SalesOrderChargeLine',
      'SalesOrderPostPurchaseFeeLine',
      'SalesOrderShippingAndHandlingLine',
      'SalesOrderTaxLine',
      'SalesOrderItemLine',
    ],
    CarbonWebsiteThemeControl: ['CarbonWebsiteThemeBooleanControl', 'CarbonWebsiteThemeRangeControl', 'CarbonWebsiteThemeSelectControl'],
    CheckTransitionalRegistryUrlResult: ['InvalidTransitionalRegistryUrlResult', 'ValidTransitionalRegistryUrlResult'],
    EventChecklistDtoResult: ['AuthenticationErrorType', 'BadRequestErrorType', 'EventChecklist', 'ForbiddenErrorType', 'InternalServerErrorType', 'NotFoundErrorType'],
    ErrorType: ['AuthenticationErrorType', 'BadRequestErrorType', 'ForbiddenErrorType', 'InternalServerErrorType', 'NotFoundErrorType'],
    CashFundsExternalAccount: ['CashFundsBankExternalAccount', 'CashFundsCardExternalAccount'],
    Email_Connection: ['EmailSearchResultsSummaryView'],
    Email_Edge: ['EmailSearchCollectionItemsEdge'],
    PostOfficeDraft: [
      'PostOfficeGenericEmailDraft',
      'PostOfficeGiftWrapEmailDraft',
      'PostOfficeGreetingCardEmailDraft',
      'PostOfficeReminderEmailDraft',
      'PostOfficeThankYouEmailDraft',
    ],
    Handle: ['Event'],
    ProductHeroContentMedia: ['ProductHeroImage', 'ProductHeroVideo'],
    ProductUniversalItemContainer: ['ProductExternalOfferContainer', 'ProductUniversalCatalogItemContainer', 'ProductUniversalProductContainer'],
    TravelReservationSearchResult: ['CarReservationSearchResult', 'HotelReservationSearchResult'],
    StationeryPricing: ['StationeryFlatFeePricing', 'StationeryTieredFlatFeePricing', 'StationeryTieredPricing'],
    StationeryProductShippingOption: ['StationeryProductShippingOptionV1'],
    StationeryShippingConstraint: ['StationeryAllowPoBoxShippingConstraint', 'StationeryCountryShippingConstraint', 'StationeryQuantityShippingConstraint'],
    TransitionalRegistryItem: ['TransitionalRegistryFund', 'TransitionalRegistryProduct'],
    TravelOfferComponent: ['TravelOfferAccommodationUnitsComponent'],
    AcceptCashFundContributionResult: ['CashFundContribution', 'CashFundGeneralError'],
    CashFundError: ['CashFundGeneralError'],
    addMediaToCollectionResponses: ['addMediaToCollectionResponse', 'addMediaToCollectionResponseError'],
    MutationResponse: [
      'addMediaToCollectionResponse',
      'addMediaToCollectionResponseError',
      'createMediaPhotosResponse',
      'websiteCreateOrUpdatePagePhotoPresentationResponse',
      'websiteCreateOrUpdatePagePhotoPresentationResponseError',
    ],
    ArchiveCashFundResult: ['ArchiveCashFundSuccess', 'CashFundGeneralError'],
    CarReservationCancelResult: ['CarReservationCancelFailure', 'CarReservationCancelSuccess'],
    CreateCashFundResult: ['CashFund', 'CashFundGeneralError'],
    CreateCashFundCheckoutSessionResult: ['CashFundCheckoutSession', 'CashFundGeneralError'],
    CreateCashFundPaymentIntentResult: ['CashFundGeneralError', 'CashFundPaymentIntent'],
    CreateCashFundSolicitationResult: ['CashFundGeneralError', 'CashFundSolicitation'],
    CreateCashFundsPayoutAccountSessionResult: ['CashFundGeneralError', 'CashFundsPayoutAccountSession'],
    ChecklistItemDtoResult: ['AuthenticationErrorType', 'BadRequestErrorType', 'ChecklistItem', 'ForbiddenErrorType', 'InternalServerErrorType', 'NotFoundErrorType'],
    ChecklistSubItemDtoResult: ['AuthenticationErrorType', 'BadRequestErrorType', 'ChecklistSubItem', 'ForbiddenErrorType', 'InternalServerErrorType', 'NotFoundErrorType'],
    CreateRegistryPaymentIntentResult: ['RegistryPaymentIntent', 'RegistryPaymentIntentError'],
    CreateRegistryPayoutAccountResult: ['RegistryErrorResult', 'RegistryPayoutAccount'],
    DuplicateCashFundResult: ['CashFund', 'CashFundGeneralError'],
    GetImageMetadataResult: ['FailedImageMetadataResponse', 'Photo'],
    InitCashFundsHostResult: ['CashFundGeneralError', 'CashFundsHost'],
    ManageCashFundSolicitationRecipientsResult: ['CashFundGeneralError', 'CashFundSolicitation'],
    ManageJoyCreditMutationResult: ['ManageJoyCreditResult', 'RegistryErrorResult'],
    ManagePayoutAccountItemResult: ['ManagePayoutAccountResult', 'RegistryErrorResult'],
    ReactivateCashFundResult: ['CashFund', 'CashFundGeneralError'],
    RecordPayoutIncentiveEngagementResult: ['CashFundGeneralError', 'PayoutIncentiveEngagement'],
    RefundCashFundContributionResult: ['CashFundContribution', 'CashFundGeneralError'],
    TravelOfferReservationRegenerateTokenResult: ['TravelOfferReservationCreateStripeNativeResult', 'TravelOfferReservationCreateVaulteraVaultResult'],
    ResendBookingConfirmationEmailResult: ['ResendBookingConfirmationEmailFailure', 'ResendBookingConfirmationEmailSuccess'],
    SendCashFundSolicitationEmailsResult: ['CashFundGeneralError', 'SendCashFundSolicitationEmailsSuccess'],
    SendCashFundSolicitationTestEmailResult: ['CashFundGeneralError', 'SendCashFundSolicitationTestEmailSuccess'],
    TravelOfferReservationCancelResult: ['TravelOfferReservationCancelFailure', 'TravelOfferReservationCancelSuccess'],
    TravelOfferReservationConfirmResult: ['TravelOfferReservationConfirmFailure', 'TravelOfferReservationConfirmSuccess'],
    TravelOfferReservationCreateResult: [
      'TravelOfferReservationCreateStripeNativeResult',
      'TravelOfferReservationCreateTravelWalletResult',
      'TravelOfferReservationCreateVaulteraVaultResult',
    ],
    UpdateCashFundResult: ['CashFund', 'CashFundGeneralError'],
    UpdateCashFundSolicitationResult: ['CashFundGeneralError', 'CashFundSolicitation'],
    uploadPhotosFromUrlsResponse: ['uploadPhotosFromUrlsResponseError', 'uploadPhotosFromUrlsResponseSuccess'],
    websiteCreateOrUpdatePagePhotoPresentationResponses: ['websiteCreateOrUpdatePagePhotoPresentationResponse', 'websiteCreateOrUpdatePagePhotoPresentationResponseError'],
    WithdrawCashFundsPayoutAccountResult: ['CashFundGeneralError', 'CashFundsPayoutAccountWithdrawal'],
    DesignFeature: [],
  },
};
export default result;
